export const truck = ['4833 3217', `
<g transform="translate(0.000000,3217.000000) scale(0.100000,-0.100000)"
fill="#304D72" stroke="none">
<path d="M1910 32145 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M5190 32145 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M8470 32145 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M11750 32145 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2
0 -9 -7 -16 -15z"/>
<path d="M15030 32145 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2
0 -9 -7 -16 -15z"/>
<path d="M18310 32145 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2
0 -9 -7 -16 -15z"/>
<path d="M21590 32145 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2
0 -9 -7 -16 -15z"/>
<path d="M24870 32145 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2
0 -9 -7 -16 -15z"/>
<path d="M28150 32145 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2
0 -9 -7 -16 -15z"/>
<path d="M31430 32145 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2
0 -9 -7 -16 -15z"/>
<path d="M34710 32145 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2
0 -9 -7 -16 -15z"/>
<path d="M37990 32145 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2
0 -9 -7 -16 -15z"/>
<path d="M41270 32145 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2
0 -9 -7 -16 -15z"/>
<path d="M44550 32145 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2
0 -9 -7 -16 -15z"/>
<path d="M47830 32145 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2
0 -9 -7 -16 -15z"/>
<path d="M1438 32118 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M1865 32120 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M4718 32118 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M5145 32120 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M7998 32118 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M8425 32120 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M11278 32118 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M11705 32120 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M14558 32118 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M14985 32120 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M17838 32118 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M18265 32120 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M21118 32118 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M21545 32120 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M24398 32118 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M24825 32120 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M27678 32118 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M28105 32120 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M30958 32118 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M31385 32120 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M34238 32118 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M34665 32120 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M37518 32118 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M37945 32120 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M40798 32118 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M41225 32120 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M44078 32118 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M44505 32120 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M47358 32118 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M47785 32120 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M1490 32107 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M1583 32113 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M1635 32110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M1676 32110 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M4770 32107 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M4863 32113 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M4915 32110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M4956 32110 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M8050 32107 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M8143 32113 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M8195 32110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M8236 32110 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M11330 32107 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M11423 32113 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M11475 32110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M11516 32110 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M14610 32107 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M14703 32113 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M14755 32110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M14796 32110 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M17890 32107 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M17983 32113 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M18035 32110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M18076 32110 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M21170 32107 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M21263 32113 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M21315 32110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M21356 32110 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M24450 32107 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M24543 32113 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M24595 32110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M24636 32110 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M27730 32107 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M27823 32113 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M27875 32110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M27916 32110 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M31010 32107 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M31103 32113 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M31155 32110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M31196 32110 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M34290 32107 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M34383 32113 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M34435 32110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M34476 32110 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M37570 32107 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M37663 32113 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M37715 32110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M37756 32110 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M40850 32107 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M40943 32113 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M40995 32110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M41036 32110 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M44130 32107 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M44223 32113 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M44275 32110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M44316 32110 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M47410 32107 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M47503 32113 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M47555 32110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M47596 32110 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M1556 32032 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M1616 32032 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M1676 32032 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M4836 32032 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M4896 32032 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M4956 32032 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M8116 32032 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M8176 32032 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M8236 32032 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M11396 32032 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M11456 32032 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M11516 32032 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M14676 32032 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M14736 32032 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M14796 32032 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M17956 32032 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M18016 32032 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M18076 32032 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M21236 32032 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M21296 32032 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M21356 32032 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M24516 32032 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M24576 32032 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M24636 32032 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M27796 32032 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M27856 32032 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M27916 32032 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M31076 32032 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M31136 32032 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M31196 32032 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M34356 32032 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M34416 32032 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M34476 32032 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M37636 32032 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M37696 32032 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M37756 32032 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M40916 32032 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M40976 32032 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M41036 32032 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M44196 32032 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M44256 32032 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M44316 32032 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M47476 32032 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M47536 32032 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M47596 32032 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M1738 32023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5018 32023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8298 32023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M11578 32023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M14858 32023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M18138 32023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M21418 32023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M24698 32023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M27978 32023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M31258 32023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M34538 32023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M37818 32023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M41098 32023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M44378 32023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47658 32023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1089 31792 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53 -40
0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M1995 31913 c13 -14 785 -524 873 -577 6 -4 12 -5 12 -3 0 3 -24 21
-52 40 -354 232 -467 306 -603 397 -172 113 -246 160 -230 143z"/>
<path d="M4369 31792 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53 -40
0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M5275 31913 c13 -14 785 -524 873 -577 6 -4 12 -5 12 -3 0 3 -24 21
-52 40 -354 232 -467 306 -603 397 -172 113 -246 160 -230 143z"/>
<path d="M7649 31792 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53 -40
0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M8555 31913 c13 -14 785 -524 873 -577 6 -4 12 -5 12 -3 0 3 -24 21
-52 40 -354 232 -467 306 -603 397 -172 113 -246 160 -230 143z"/>
<path d="M10929 31792 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53
-40 0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M11835 31913 c13 -14 785 -524 873 -577 6 -4 12 -5 12 -3 0 3 -24 21
-52 40 -354 232 -467 306 -603 397 -172 113 -246 160 -230 143z"/>
<path d="M14209 31792 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53
-40 0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M15115 31913 c13 -14 785 -524 873 -577 6 -4 12 -5 12 -3 0 3 -24 21
-52 40 -354 232 -467 306 -603 397 -172 113 -246 160 -230 143z"/>
<path d="M17489 31792 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53
-40 0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M18395 31913 c13 -14 785 -524 873 -577 6 -4 12 -5 12 -3 0 3 -24 21
-52 40 -354 232 -467 306 -603 397 -172 113 -246 160 -230 143z"/>
<path d="M20769 31792 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53
-40 0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M21675 31913 c13 -14 785 -524 873 -577 6 -4 12 -5 12 -3 0 3 -24 21
-52 40 -354 232 -467 306 -603 397 -172 113 -246 160 -230 143z"/>
<path d="M24049 31792 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53
-40 0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M24955 31913 c13 -14 785 -524 873 -577 6 -4 12 -5 12 -3 0 3 -24 21
-52 40 -354 232 -467 306 -603 397 -172 113 -246 160 -230 143z"/>
<path d="M27329 31792 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53
-40 0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M28235 31913 c13 -14 785 -524 873 -577 6 -4 12 -5 12 -3 0 3 -24 21
-52 40 -354 232 -467 306 -603 397 -172 113 -246 160 -230 143z"/>
<path d="M30609 31792 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53
-40 0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M31515 31913 c13 -14 785 -524 873 -577 6 -4 12 -5 12 -3 0 3 -24 21
-52 40 -354 232 -467 306 -603 397 -172 113 -246 160 -230 143z"/>
<path d="M33889 31792 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53
-40 0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M34795 31913 c13 -14 785 -524 873 -577 6 -4 12 -5 12 -3 0 3 -24 21
-52 40 -354 232 -467 306 -603 397 -172 113 -246 160 -230 143z"/>
<path d="M37169 31792 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53
-40 0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M38075 31913 c13 -14 785 -524 873 -577 6 -4 12 -5 12 -3 0 3 -24 21
-52 40 -354 232 -467 306 -603 397 -172 113 -246 160 -230 143z"/>
<path d="M40449 31792 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53
-40 0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M41355 31913 c13 -14 785 -524 873 -577 6 -4 12 -5 12 -3 0 3 -24 21
-52 40 -354 232 -467 306 -603 397 -172 113 -246 160 -230 143z"/>
<path d="M43729 31792 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53
-40 0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M44635 31913 c13 -14 785 -524 873 -577 6 -4 12 -5 12 -3 0 3 -24 21
-52 40 -354 232 -467 306 -603 397 -172 113 -246 160 -230 143z"/>
<path d="M47009 31792 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53
-40 0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M47915 31913 c19 -19 407 -274 411 -270 3 2 -84 63 -193 134 -206
135 -235 153 -218 136z"/>
<path d="M107 31139 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M3387 31139 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M6667 31139 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M9947 31139 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M13227 31139 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M16507 31139 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M19787 31139 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M23067 31139 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M26347 31139 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M29627 31139 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M32907 31139 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M36187 31139 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M39467 31139 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M42747 31139 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M46027 31139 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M28 31133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3050 31130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M3308 31133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6330 31130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M6588 31133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9610 31130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M9868 31133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M12890 31130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M13148 31133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M16170 31130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M16428 31133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M19450 31130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M19708 31133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M22730 31130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M22988 31133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M26010 31130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M26268 31133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M29290 31130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M29548 31133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M32570 31130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M32828 31133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M35850 31130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M36108 31133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39130 31130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M39388 31133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42410 31130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M42668 31133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M45690 31130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M45948 31133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M272 31074 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M3552 31074 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M6832 31074 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M10112 31074 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M13392 31074 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M16672 31074 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M19952 31074 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M23232 31074 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M26512 31074 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M29792 31074 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M33072 31074 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M36352 31074 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M39632 31074 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M42912 31074 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M46192 31074 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M225 31050 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M3505 31050 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M6785 31050 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M10065 31050 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M13345 31050 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M16625 31050 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M19905 31050 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M23185 31050 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M26465 31050 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M29745 31050 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M33025 31050 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M36305 31050 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M39585 31050 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M42865 31050 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M46145 31050 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M46 31041 c-3 -5 -16 -7 -29 -5 -20 4 -20 4 -2 -4 22 -10 71 -9 82 1
3 4 12 2 20 -5 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 7 -25
0 -4 -7 -12 -7 -25 0 -11 6 -21 6 -24 1z"/>
<path d="M274 31034 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z"/>
<path d="M3225 31040 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -14 13 -14 27 0
6 6 17 8 24 3 17 -10 120 -11 126 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17
7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1
-5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23 3
-6 -10 -64 -9 -74 0 -9 10 -21 9 -28 -3z"/>
<path d="M3554 31034 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M6505 31040 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -14 13 -14 27 0
6 6 17 8 24 3 17 -10 120 -11 126 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17
7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1
-5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23 3
-6 -10 -64 -9 -74 0 -9 10 -21 9 -28 -3z"/>
<path d="M6834 31034 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M9785 31040 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -14 13 -14 27 0
6 6 17 8 24 3 17 -10 120 -11 126 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17
7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1
-5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23 3
-6 -10 -64 -9 -74 0 -9 10 -21 9 -28 -3z"/>
<path d="M10114 31034 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M13065 31040 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -14 13 -14 27
0 6 6 17 8 24 3 17 -10 120 -11 126 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 8 6
17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16
-1 -5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23
3 -6 -10 -64 -9 -74 0 -9 10 -21 9 -28 -3z"/>
<path d="M13394 31034 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M16345 31040 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -14 13 -14 27
0 6 6 17 8 24 3 17 -10 120 -11 126 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 8 6
17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16
-1 -5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23
3 -6 -10 -64 -9 -74 0 -9 10 -21 9 -28 -3z"/>
<path d="M16674 31034 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M19625 31040 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -14 13 -14 27
0 6 6 17 8 24 3 17 -10 120 -11 126 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 8 6
17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16
-1 -5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23
3 -6 -10 -64 -9 -74 0 -9 10 -21 9 -28 -3z"/>
<path d="M19954 31034 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M22905 31040 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -14 13 -14 27
0 6 6 17 8 24 3 17 -10 120 -11 126 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 8 6
17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16
-1 -5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23
3 -6 -10 -64 -9 -74 0 -9 10 -21 9 -28 -3z"/>
<path d="M23234 31034 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M26185 31040 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -14 13 -14 27
0 6 6 17 8 24 3 17 -10 120 -11 126 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 8 6
17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16
-1 -5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23
3 -6 -10 -64 -9 -74 0 -9 10 -21 9 -28 -3z"/>
<path d="M26514 31034 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M29465 31040 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -14 13 -14 27
0 6 6 17 8 24 3 17 -10 120 -11 126 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 8 6
17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16
-1 -5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23
3 -6 -10 -64 -9 -74 0 -9 10 -21 9 -28 -3z"/>
<path d="M29794 31034 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M32745 31040 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -14 13 -14 27
0 6 6 17 8 24 3 17 -10 120 -11 126 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 8 6
17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16
-1 -5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23
3 -6 -10 -64 -9 -74 0 -9 10 -21 9 -28 -3z"/>
<path d="M33074 31034 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M36025 31040 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -14 13 -14 27
0 6 6 17 8 24 3 17 -10 120 -11 126 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 8 6
17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16
-1 -5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23
3 -6 -10 -64 -9 -74 0 -9 10 -21 9 -28 -3z"/>
<path d="M36354 31034 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M39305 31040 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -14 13 -14 27
0 6 6 17 8 24 3 17 -10 120 -11 126 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 8 6
17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16
-1 -5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23
3 -6 -10 -64 -9 -74 0 -9 10 -21 9 -28 -3z"/>
<path d="M39634 31034 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M42585 31040 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -14 13 -14 27
0 6 6 17 8 24 3 17 -10 120 -11 126 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 8 6
17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16
-1 -5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23
3 -6 -10 -64 -9 -74 0 -9 10 -21 9 -28 -3z"/>
<path d="M42914 31034 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M45865 31040 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -14 13 -14 27
0 6 6 17 8 24 3 17 -10 120 -11 126 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 8 6
17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16
-1 -5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23
3 -6 -10 -64 -9 -74 0 -9 10 -21 9 -28 -3z"/>
<path d="M46194 31034 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M3003 31028 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M3120 31036 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M3168 31033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6283 31028 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M6400 31036 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M6448 31033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9563 31028 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M9680 31036 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M9728 31033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M12843 31028 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M12960 31036 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M13008 31033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M16123 31028 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M16240 31036 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M16288 31033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M19403 31028 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M19520 31036 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M19568 31033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M22683 31028 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M22800 31036 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M22848 31033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M25963 31028 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M26080 31036 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M26128 31033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M29243 31028 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M29360 31036 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M29408 31033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M32523 31028 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M32640 31036 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M32688 31033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M35803 31028 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M35920 31036 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M35968 31033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39083 31028 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M39200 31036 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M39248 31033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42363 31028 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M42480 31036 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M42528 31033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M45643 31028 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M45760 31036 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M45808 31033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3196 30962 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M6476 30962 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M9756 30962 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M13036 30962 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M16316 30962 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M19596 30962 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M22876 30962 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M26156 30962 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M29436 30962 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M32716 30962 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M35996 30962 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M39276 30962 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M42556 30962 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M45836 30962 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M98 30953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3378 30953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6658 30953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9938 30953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M13218 30953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M16498 30953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M19778 30953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M23058 30953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M26338 30953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M29618 30953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M32898 30953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M36178 30953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39458 30953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42738 30953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M46018 30953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M616 30648 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6 0
93 -68 219 -152z"/>
<path d="M2429 30505 c-244 -162 -441 -295 -437 -295 7 0 182 114 672 438 126
84 225 152 219 152 -5 0 -210 -133 -454 -295z"/>
<path d="M3896 30648 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6
0 93 -68 219 -152z"/>
<path d="M5709 30505 c-244 -162 -441 -295 -437 -295 7 0 182 114 672 438 126
84 225 152 219 152 -5 0 -210 -133 -454 -295z"/>
<path d="M7176 30648 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6
0 93 -68 219 -152z"/>
<path d="M8989 30505 c-244 -162 -441 -295 -437 -295 7 0 182 114 672 438 126
84 225 152 219 152 -5 0 -210 -133 -454 -295z"/>
<path d="M10456 30648 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6
0 93 -68 219 -152z"/>
<path d="M12269 30505 c-244 -162 -441 -295 -437 -295 7 0 182 114 672 438
126 84 225 152 219 152 -5 0 -210 -133 -454 -295z"/>
<path d="M13736 30648 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6
0 93 -68 219 -152z"/>
<path d="M15549 30505 c-244 -162 -441 -295 -437 -295 7 0 182 114 672 438
126 84 225 152 219 152 -5 0 -210 -133 -454 -295z"/>
<path d="M17016 30648 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6
0 93 -68 219 -152z"/>
<path d="M18829 30505 c-244 -162 -441 -295 -437 -295 7 0 182 114 672 438
126 84 225 152 219 152 -5 0 -210 -133 -454 -295z"/>
<path d="M20296 30648 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6
0 93 -68 219 -152z"/>
<path d="M22109 30505 c-244 -162 -441 -295 -437 -295 7 0 182 114 672 438
126 84 225 152 219 152 -5 0 -210 -133 -454 -295z"/>
<path d="M23576 30648 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6
0 93 -68 219 -152z"/>
<path d="M25389 30505 c-244 -162 -441 -295 -437 -295 7 0 182 114 672 438
126 84 225 152 219 152 -5 0 -210 -133 -454 -295z"/>
<path d="M26856 30648 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6
0 93 -68 219 -152z"/>
<path d="M28669 30505 c-244 -162 -441 -295 -437 -295 7 0 182 114 672 438
126 84 225 152 219 152 -5 0 -210 -133 -454 -295z"/>
<path d="M30136 30648 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6
0 93 -68 219 -152z"/>
<path d="M31949 30505 c-244 -162 -441 -295 -437 -295 7 0 182 114 672 438
126 84 225 152 219 152 -5 0 -210 -133 -454 -295z"/>
<path d="M33416 30648 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6
0 93 -68 219 -152z"/>
<path d="M35229 30505 c-244 -162 -441 -295 -437 -295 7 0 182 114 672 438
126 84 225 152 219 152 -5 0 -210 -133 -454 -295z"/>
<path d="M36696 30648 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6
0 93 -68 219 -152z"/>
<path d="M38509 30505 c-244 -162 -441 -295 -437 -295 7 0 182 114 672 438
126 84 225 152 219 152 -5 0 -210 -133 -454 -295z"/>
<path d="M39976 30648 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6
0 93 -68 219 -152z"/>
<path d="M41789 30505 c-244 -162 -441 -295 -437 -295 7 0 182 114 672 438
126 84 225 152 219 152 -5 0 -210 -133 -454 -295z"/>
<path d="M43256 30648 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6
0 93 -68 219 -152z"/>
<path d="M45069 30505 c-244 -162 -441 -295 -437 -295 7 0 182 114 672 438
126 84 225 152 219 152 -5 0 -210 -133 -454 -295z"/>
<path d="M46536 30648 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6
0 93 -68 219 -152z"/>
<path d="M48115 30350 c-115 -77 -207 -140 -203 -140 9 0 418 269 418 275 0 8
2 9 -215 -135z"/>
<path d="M1379 30043 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M4659 30043 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M7939 30043 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M11219 30043 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M14499 30043 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M17779 30043 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M21059 30043 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M24339 30043 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M27619 30043 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M30899 30043 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M34179 30043 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M37459 30043 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M40739 30043 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M44019 30043 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M47299 30043 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M1670 30030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M4950 30030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M8230 30030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M11510 30030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M14790 30030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M18070 30030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M21350 30030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M24630 30030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M27910 30030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M31190 30030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M34470 30030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M37750 30030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M41030 30030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M44310 30030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M47590 30030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M1909 29953 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M5189 29953 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M8469 29953 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M11749 29953 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M15029 29953 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M18309 29953 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M21589 29953 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M24869 29953 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M28149 29953 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M31429 29953 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M34709 29953 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M37989 29953 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M41269 29953 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M44549 29953 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M47829 29953 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M1844 29938 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M5124 29938 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M8404 29938 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M11684 29938 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M14964 29938 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M18244 29938 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M21524 29938 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M24804 29938 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M28084 29938 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M31364 29938 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M34644 29938 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M37924 29938 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M41204 29938 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M44484 29938 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M47764 29938 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M1354 29923 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M4634 29923 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M7914 29923 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M11194 29923 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M14474 29923 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M17754 29923 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M21034 29923 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M24314 29923 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M27594 29923 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M30874 29923 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M34154 29923 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M37434 29923 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M40714 29923 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M43994 29923 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M47274 29923 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M1492 29914 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M1583 29923 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6 10
-4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M1636 29921 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M1735 29920 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M4772 29914 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M4863 29923 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6 10
-4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M4916 29921 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M5015 29920 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M8052 29914 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M8143 29923 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6 10
-4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M8196 29921 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M8295 29920 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M11332 29914 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M11423 29923 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6
10 -4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M11476 29921 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M11575 29920 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M14612 29914 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M14703 29923 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6
10 -4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M14756 29921 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M14855 29920 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M17892 29914 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M17983 29923 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6
10 -4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M18036 29921 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M18135 29920 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M21172 29914 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M21263 29923 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6
10 -4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M21316 29921 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M21415 29920 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M24452 29914 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M24543 29923 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6
10 -4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M24596 29921 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M24695 29920 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M27732 29914 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M27823 29923 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6
10 -4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M27876 29921 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M27975 29920 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M31012 29914 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M31103 29923 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6
10 -4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M31156 29921 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M31255 29920 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M34292 29914 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M34383 29923 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6
10 -4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M34436 29921 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M34535 29920 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M37572 29914 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M37663 29923 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6
10 -4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M37716 29921 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M37815 29920 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M40852 29914 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M40943 29923 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6
10 -4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M40996 29921 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M41095 29920 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M44132 29914 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M44223 29923 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6
10 -4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M44276 29921 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M44375 29920 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M47412 29914 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M47503 29923 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6
10 -4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M47556 29921 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M47655 29920 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M1556 29842 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M1616 29842 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M4836 29842 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M4896 29842 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M8116 29842 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M8176 29842 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M11396 29842 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M11456 29842 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M14676 29842 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M14736 29842 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M17956 29842 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M18016 29842 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M21236 29842 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M21296 29842 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M24516 29842 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M24576 29842 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M27796 29842 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M27856 29842 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M31076 29842 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M31136 29842 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M34356 29842 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M34416 29842 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M37636 29842 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M37696 29842 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M40916 29842 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M40976 29842 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M44196 29842 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M44256 29842 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M47476 29842 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M47536 29842 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M1738 29833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5018 29833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8298 29833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M11578 29833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M14858 29833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M18138 29833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M21418 29833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M24698 29833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M27978 29833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M31258 29833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M34538 29833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M37818 29833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M41098 29833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M44378 29833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47658 29833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M842 29441 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573 39
37 -66 -30 -443 -280z"/>
<path d="M1996 29721 c13 -13 842 -559 868 -572 54 -28 -29 28 -432 295 -385
254 -470 308 -436 277z"/>
<path d="M4122 29441 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573
39 37 -66 -30 -443 -280z"/>
<path d="M5276 29721 c13 -13 842 -559 868 -572 54 -28 -29 28 -432 295 -385
254 -470 308 -436 277z"/>
<path d="M7402 29441 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573
39 37 -66 -30 -443 -280z"/>
<path d="M8556 29721 c13 -13 842 -559 868 -572 54 -28 -29 28 -432 295 -385
254 -470 308 -436 277z"/>
<path d="M10682 29441 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573
39 37 -66 -30 -443 -280z"/>
<path d="M11836 29721 c13 -13 842 -559 868 -572 54 -28 -29 28 -432 295 -385
254 -470 308 -436 277z"/>
<path d="M13962 29441 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573
39 37 -66 -30 -443 -280z"/>
<path d="M15116 29721 c13 -13 842 -559 868 -572 54 -28 -29 28 -432 295 -385
254 -470 308 -436 277z"/>
<path d="M17242 29441 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573
39 37 -66 -30 -443 -280z"/>
<path d="M18396 29721 c13 -13 842 -559 868 -572 54 -28 -29 28 -432 295 -385
254 -470 308 -436 277z"/>
<path d="M20522 29441 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573
39 37 -66 -30 -443 -280z"/>
<path d="M21676 29721 c13 -13 842 -559 868 -572 54 -28 -29 28 -432 295 -385
254 -470 308 -436 277z"/>
<path d="M23802 29441 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573
39 37 -66 -30 -443 -280z"/>
<path d="M24956 29721 c13 -13 842 -559 868 -572 54 -28 -29 28 -432 295 -385
254 -470 308 -436 277z"/>
<path d="M27082 29441 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573
39 37 -66 -30 -443 -280z"/>
<path d="M28236 29721 c13 -13 842 -559 868 -572 54 -28 -29 28 -432 295 -385
254 -470 308 -436 277z"/>
<path d="M30362 29441 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573
39 37 -66 -30 -443 -280z"/>
<path d="M31516 29721 c13 -13 842 -559 868 -572 54 -28 -29 28 -432 295 -385
254 -470 308 -436 277z"/>
<path d="M33642 29441 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573
39 37 -66 -30 -443 -280z"/>
<path d="M34796 29721 c13 -13 842 -559 868 -572 54 -28 -29 28 -432 295 -385
254 -470 308 -436 277z"/>
<path d="M36922 29441 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573
39 37 -66 -30 -443 -280z"/>
<path d="M38076 29721 c13 -13 842 -559 868 -572 54 -28 -29 28 -432 295 -385
254 -470 308 -436 277z"/>
<path d="M40202 29441 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573
39 37 -66 -30 -443 -280z"/>
<path d="M41356 29721 c13 -13 842 -559 868 -572 54 -28 -29 28 -432 295 -385
254 -470 308 -436 277z"/>
<path d="M43482 29441 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573
39 37 -66 -30 -443 -280z"/>
<path d="M44636 29721 c13 -13 842 -559 868 -572 54 -28 -29 28 -432 295 -385
254 -470 308 -436 277z"/>
<path d="M46762 29441 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573
39 37 -66 -30 -443 -280z"/>
<path d="M47910 29726 c0 -4 378 -253 410 -271 47 -26 -28 27 -202 144 -186
123 -208 137 -208 127z"/>
<path d="M28 28943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3308 28943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6588 28943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9868 28943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M13148 28943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M16428 28943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M19708 28943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M22988 28943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M26268 28943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M29548 28943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M32828 28943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M36108 28943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39388 28943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42668 28943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M45948 28943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M220 28864 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M3500 28864 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M6780 28864 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M10060 28864 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M13340 28864 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M16620 28864 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M19900 28864 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M23180 28864 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M26460 28864 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M29740 28864 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M33020 28864 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M36300 28864 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M39580 28864 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M42860 28864 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M46140 28864 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M43 28848 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74 -3
3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6 11
-19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M3067 28849 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66 -12
80 5 15 18 12 18 -13 4z"/>
<path d="M3129 28848 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M3224 28849 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M3323 28848 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M6347 28849 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66 -12
80 5 15 18 12 18 -13 4z"/>
<path d="M6409 28848 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M6504 28849 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M6603 28848 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M9627 28849 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66 -12
80 5 15 18 12 18 -13 4z"/>
<path d="M9689 28848 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M9784 28849 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M9883 28848 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M12907 28849 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66
-12 80 5 15 18 12 18 -13 4z"/>
<path d="M12969 28848 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M13064 28849 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M13163 28848 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M16187 28849 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66
-12 80 5 15 18 12 18 -13 4z"/>
<path d="M16249 28848 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M16344 28849 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M16443 28848 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M19467 28849 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66
-12 80 5 15 18 12 18 -13 4z"/>
<path d="M19529 28848 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M19624 28849 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M19723 28848 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M22747 28849 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66
-12 80 5 15 18 12 18 -13 4z"/>
<path d="M22809 28848 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M22904 28849 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M23003 28848 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M26027 28849 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66
-12 80 5 15 18 12 18 -13 4z"/>
<path d="M26089 28848 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M26184 28849 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M26283 28848 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M29307 28849 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66
-12 80 5 15 18 12 18 -13 4z"/>
<path d="M29369 28848 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M29464 28849 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M29563 28848 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M32587 28849 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66
-12 80 5 15 18 12 18 -13 4z"/>
<path d="M32649 28848 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M32744 28849 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M32843 28848 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M35867 28849 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66
-12 80 5 15 18 12 18 -13 4z"/>
<path d="M35929 28848 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M36024 28849 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M36123 28848 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M39147 28849 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66
-12 80 5 15 18 12 18 -13 4z"/>
<path d="M39209 28848 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M39304 28849 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M39403 28848 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M42427 28849 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66
-12 80 5 15 18 12 18 -13 4z"/>
<path d="M42489 28848 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M42584 28849 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M42683 28848 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M45707 28849 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66
-12 80 5 15 18 12 18 -13 4z"/>
<path d="M45769 28848 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M45864 28849 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M45963 28848 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M23153 28725 c-379 -346 -593 -872 -593 -1455 0 -78 5 -183 10 -233
9 -76 103 -4532 100 -4707 -2 -85 28 -1352 32 -1355 5 -5 580 24 585 29 2 2
-1 262 -6 577 -21 1116 -42 2208 -50 2534 -7 326 -7 330 13 347 l21 17 -22 -6
c-25 -6 -32 11 -8 21 8 3 15 11 14 18 0 10 -2 10 -6 1 -13 -35 -21 -3 -22 90
0 56 -3 174 -6 262 -3 88 -10 336 -15 550 -20 767 -39 1246 -61 1491 -12 138
0 312 31 456 42 194 139 431 251 614 31 49 61 116 76 166 28 96 40 242 25 308
-6 24 -10 46 -8 47 1 1 38 -22 82 -51 217 -147 646 -427 649 -424 2 1 -52 40
-118 84 -221 148 -600 396 -611 400 -6 3 -20 24 -31 47 -10 23 -41 64 -67 90
-45 45 -55 76 -21 63 9 -4 13 -1 11 6 -6 16 -111 68 -151 74 -28 4 -40 -2
-104 -61z"/>
<path d="M3196 28772 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M3256 28772 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M6476 28772 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M6536 28772 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M9756 28772 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M9816 28772 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M13036 28772 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M13096 28772 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M16316 28772 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M16376 28772 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M19596 28772 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M19656 28772 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M22876 28772 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M22936 28772 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M26156 28772 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M26216 28772 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M29436 28772 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M29496 28772 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M32716 28772 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M32776 28772 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M35996 28772 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M36056 28772 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M39276 28772 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M39336 28772 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M42556 28772 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M42616 28772 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M45836 28772 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M45896 28772 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M98 28763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3378 28763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6658 28763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9938 28763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M13218 28763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M16498 28763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M19778 28763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M23058 28763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M26338 28763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M29618 28763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M32898 28763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M36178 28763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39458 28763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42738 28763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M46018 28763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M400 28606 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145 -95
265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M2610 28435 c-146 -97 -345 -228 -442 -293 -97 -64 -175 -118 -173
-120 2 -2 122 75 267 170 145 96 343 227 441 292 151 99 189 127 175 126 -2 0
-122 -79 -268 -175z"/>
<path d="M3680 28606 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145 -95
265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M5890 28435 c-146 -97 -345 -228 -442 -293 -97 -64 -175 -118 -173
-120 2 -2 122 75 267 170 145 96 343 227 441 292 151 99 189 127 175 126 -2 0
-122 -79 -268 -175z"/>
<path d="M6960 28606 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145 -95
265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M9170 28435 c-146 -97 -345 -228 -442 -293 -97 -64 -175 -118 -173
-120 2 -2 122 75 267 170 145 96 343 227 441 292 151 99 189 127 175 126 -2 0
-122 -79 -268 -175z"/>
<path d="M10240 28606 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145
-95 265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M12450 28435 c-146 -97 -345 -228 -442 -293 -97 -64 -175 -118 -173
-120 2 -2 122 75 267 170 145 96 343 227 441 292 151 99 189 127 175 126 -2 0
-122 -79 -268 -175z"/>
<path d="M13520 28606 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145
-95 265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M15730 28435 c-146 -97 -345 -228 -442 -293 -97 -64 -175 -118 -173
-120 2 -2 122 75 267 170 145 96 343 227 441 292 151 99 189 127 175 126 -2 0
-122 -79 -268 -175z"/>
<path d="M16800 28606 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145
-95 265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M19010 28435 c-146 -97 -345 -228 -442 -293 -97 -64 -175 -118 -173
-120 2 -2 122 75 267 170 145 96 343 227 441 292 151 99 189 127 175 126 -2 0
-122 -79 -268 -175z"/>
<path d="M20080 28606 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145
-95 265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M22290 28435 c-146 -97 -345 -228 -442 -293 -97 -64 -175 -118 -173
-120 2 -2 122 75 267 170 145 96 343 227 441 292 151 99 189 127 175 126 -2 0
-122 -79 -268 -175z"/>
<path d="M25570 28435 c-146 -97 -345 -228 -442 -293 -97 -64 -175 -118 -173
-120 2 -2 122 75 267 170 145 96 343 227 441 292 151 99 189 127 175 126 -2 0
-122 -79 -268 -175z"/>
<path d="M26640 28606 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145
-95 265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M28850 28435 c-146 -97 -345 -228 -442 -293 -97 -64 -175 -118 -173
-120 2 -2 122 75 267 170 145 96 343 227 441 292 151 99 189 127 175 126 -2 0
-122 -79 -268 -175z"/>
<path d="M29920 28606 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145
-95 265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M32130 28435 c-146 -97 -345 -228 -442 -293 -97 -64 -175 -118 -173
-120 2 -2 122 75 267 170 145 96 343 227 441 292 151 99 189 127 175 126 -2 0
-122 -79 -268 -175z"/>
<path d="M33200 28606 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145
-95 265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M35410 28435 c-146 -97 -345 -228 -442 -293 -97 -64 -175 -118 -173
-120 2 -2 122 75 267 170 145 96 343 227 441 292 151 99 189 127 175 126 -2 0
-122 -79 -268 -175z"/>
<path d="M36480 28606 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145
-95 265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M38690 28435 c-146 -97 -345 -228 -442 -293 -97 -64 -175 -118 -173
-120 2 -2 122 75 267 170 145 96 343 227 441 292 151 99 189 127 175 126 -2 0
-122 -79 -268 -175z"/>
<path d="M39760 28606 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145
-95 265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M41970 28435 c-146 -97 -345 -228 -442 -293 -97 -64 -175 -118 -173
-120 2 -2 122 75 267 170 145 96 343 227 441 292 151 99 189 127 175 126 -2 0
-122 -79 -268 -175z"/>
<path d="M43040 28606 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145
-95 265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M45250 28435 c-146 -97 -345 -228 -442 -293 -97 -64 -175 -118 -173
-120 2 -2 122 75 267 170 145 96 343 227 441 292 151 99 189 127 175 126 -2 0
-122 -79 -268 -175z"/>
<path d="M46320 28606 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145
-95 265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M48297 28280 c-126 -80 -385 -255 -382 -258 4 -4 415 266 415 273 0
7 -1 6 -33 -15z"/>
<path d="M1379 27853 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M4659 27853 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M7939 27853 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M11219 27853 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M14499 27853 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M17779 27853 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M21059 27853 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M24339 27853 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M27619 27853 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M30899 27853 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M34179 27853 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M37459 27853 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M40739 27853 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M44019 27853 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M47299 27853 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M1668 27833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4948 27833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8228 27833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M11508 27833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M14788 27833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M18068 27833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M21348 27833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M24628 27833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M27908 27833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M31188 27833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M34468 27833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M37748 27833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M41028 27833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M44308 27833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47588 27833 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1905 27760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M5185 27760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M8465 27760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M11745 27760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M15025 27760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M15780 27761 c-115 -37 -201 -152 -270 -363 l-32 -97 -27 19 c-65 45
-302 200 -323 210 -22 11 -22 10 -3 -5 11 -9 95 -65 186 -125 l166 -109 -23
-100 c-51 -226 -98 -655 -120 -1079 l-7 -134 -111 -74 c-61 -41 -107 -74 -103
-74 5 0 53 29 106 65 54 36 100 65 102 65 4 0 -27 -681 -33 -706 -2 -10 -27 2
-87 41 -46 31 -85 54 -88 52 -2 -2 37 -31 87 -63 l91 -59 -6 -90 c-3 -49 -19
-387 -36 -749 -19 -434 -34 -665 -41 -674 -6 -7 -31 -25 -55 -39 -24 -14 -42
-28 -39 -30 2 -3 25 9 51 27 26 18 48 30 50 28 3 -2 2 -65 -2 -141 l-6 -136
-89 -36 c-48 -19 -95 -35 -103 -35 -8 0 -15 -3 -15 -8 0 -7 -118 -58 -130 -56
-3 0 -11 -6 -18 -13 -10 -9 -19 -10 -32 -3 -13 7 -21 7 -25 0 -4 -6 -3 -10 2
-9 33 6 5 -11 -135 -80 -296 -147 -590 -320 -844 -498 -148 -103 -451 -339
-492 -382 -21 -22 -33 -28 -42 -20 -8 7 -14 7 -19 -1 -3 -6 -11 -8 -16 -4 -18
10 -80 10 -89 -1 -10 -12 88 -14 108 -2 26 17 10 -11 -28 -47 -24 -23 -45 -35
-52 -30 -7 4 -10 3 -5 -1 4 -5 -82 -99 -191 -209 -109 -111 -237 -246 -285
-302 -81 -95 -94 -106 -214 -174 -134 -77 -397 -250 -390 -256 2 -2 100 18
218 45 569 132 1728 359 1772 347 9 -2 67 -37 127 -78 97 -64 108 -74 88 -80
-87 -27 -977 -125 -1218 -134 -146 -6 -192 -12 -395 -55 -691 -148 -1176 -286
-1312 -375 -91 -59 -297 -273 -411 -425 -107 -143 -314 -458 -427 -649 -38
-63 -73 -121 -79 -127 -9 -10 -29 -1 -91 40 -123 82 -135 90 -135 83 0 -3 46
-36 103 -72 56 -37 104 -69 107 -71 2 -2 -16 -42 -40 -88 -39 -73 -49 -84 -76
-90 -20 -3 -34 -13 -37 -26 -4 -14 7 -188 13 -205 0 0 118 28 263 62 144 35
270 65 280 66 20 3 156 -81 156 -97 1 -5 -14 -27 -32 -47 l-32 -37 -118 34
c-181 53 -224 54 -396 10 -143 -36 -160 -36 -161 -2 -1 46 -197 -106 -222
-172 -2 -5 -61 -3 -133 5 -174 17 -412 17 -496 0 -127 -27 -207 -85 -251 -181
-21 -47 -23 -66 -28 -294 l-5 -243 -289 191 c-158 106 -290 190 -292 188 -3
-2 128 -91 291 -198 235 -155 295 -199 299 -219 3 -14 6 -218 8 -455 l3 -429
-76 -51 c-41 -27 -177 -117 -301 -200 -125 -82 -225 -151 -223 -154 2 -2 137
85 300 194 164 108 298 195 300 193 2 -2 23 -1268 20 -1275 0 -1 -88 56 -194
128 -196 130 -393 259 -421 274 -55 30 44 -38 313 -215 l307 -203 0 -192 0
-193 -37 -6 c-222 -40 -1238 -277 -1673 -391 -137 -36 -256 -65 -265 -65 -9 0
-63 32 -121 70 -57 39 -112 73 -122 76 -9 3 26 -22 78 -56 127 -84 146 -99
129 -104 -8 -3 -115 -32 -239 -66 -631 -173 -1348 -407 -1785 -582 -82 -33
-154 -61 -160 -62 -5 -1 -16 -5 -22 -9 -7 -5 -18 -5 -25 -1 -6 4 -8 3 -5 -3 6
-10 -129 -71 -145 -66 -5 2 -8 -2 -8 -8 0 -5 -4 -8 -9 -5 -5 4 -11 3 -13 -2
-1 -4 -38 -24 -80 -44 -69 -33 -88 -37 -191 -43 l-113 -8 -37 49 c-39 53 -151
166 -180 181 -15 8 -18 32 -22 218 -3 116 -9 234 -13 263 -5 28 -7 52 -5 52 1
0 102 -66 224 -146 121 -80 222 -144 224 -142 4 3 -403 276 -434 291 -14 7
-22 36 -35 125 -30 199 -34 212 -70 227 -57 24 -194 55 -282 64 -311 32 -440
-91 -460 -439 -3 -58 -1 -143 4 -189 9 -76 8 -88 -9 -120 -56 -104 3 -259 150
-396 151 -141 166 -158 145 -166 -10 -5 -55 -22 -99 -39 -181 -70 -320 -182
-380 -304 -33 -67 -66 -210 -81 -346 -3 -25 -12 -50 -20 -56 -10 -8 -11 -13
-4 -16 8 -2 -6 -111 -44 -353 -64 -404 -143 -936 -181 -1210 -14 -104 -29
-198 -33 -208 -6 -15 -61 18 -371 223 -200 133 -365 239 -367 237 -3 -2 158
-112 357 -243 199 -131 366 -241 371 -245 4 -3 -12 -156 -36 -340 -25 -183
-48 -361 -52 -394 l-6 -60 -137 -89 c-325 -214 -499 -331 -496 -334 2 -2 111
67 242 154 367 243 384 254 388 254 2 0 1 -8 -1 -17 -13 -58 -63 -571 -105
-1070 l-12 -142 -71 48 c-280 190 -499 330 -431 276 11 -9 128 -88 261 -175
228 -150 241 -160 237 -187 -15 -126 -55 -536 -64 -652 -7 -108 -7 -167 2
-235 6 -50 12 -102 13 -116 1 -14 8 -28 16 -32 9 -4 3 -6 -15 -6 -54 1 -228
-51 -311 -92 -97 -47 -167 -108 -211 -181 -35 -58 -63 -152 -63 -209 0 -19 -7
-48 -15 -63 -8 -15 -10 -25 -5 -22 6 4 10 -67 10 -189 0 -214 10 -394 41 -706
18 -192 83 -724 94 -780 5 -23 18 -30 105 -59 55 -18 100 -34 100 -36 0 -2
-47 -34 -105 -71 -57 -37 -103 -70 -101 -72 3 -2 44 23 93 56 48 32 98 64 111
71 20 11 152 -30 1113 -345 599 -197 1089 -361 1089 -365 0 -6 -107 -78 -608
-408 -68 -44 -119 -81 -114 -81 9 0 97 57 546 354 109 72 205 129 215 128 9
-2 486 -159 1061 -348 575 -190 1055 -347 1066 -349 12 -3 73 -23 135 -45 63
-22 121 -42 129 -44 449 -122 768 -181 1215 -226 308 -31 457 -39 885 -51 217
-6 396 -12 398 -14 2 -2 -144 -101 -325 -220 -457 -302 -452 -299 -448 -303 3
-3 151 94 667 434 l156 104 179 0 c98 0 268 5 378 10 110 5 230 10 266 12 l65
2 175 -115 c411 -274 681 -450 684 -447 4 4 3 5 -485 327 -317 209 -361 241
-331 241 61 0 450 30 721 56 597 56 1345 153 1805 233 102 18 111 18 123 3 7
-9 10 -22 8 -29 -3 -6 -2 -13 3 -15 4 -2 33 -52 65 -113 450 -849 1250 -1303
2359 -1340 l152 -5 -70 16 c-113 25 -247 72 -288 99 -20 14 -42 23 -47 20 -6
-4 -47 14 -93 39 -109 60 -139 81 -130 91 5 4 3 5 -4 2 -16 -10 -150 92 -262
199 -350 332 -613 820 -752 1391 -30 121 -30 127 -13 140 17 12 20 3 55 -134
123 -491 308 -871 588 -1205 77 -92 203 -214 283 -275 40 -30 51 -51 19 -33
-14 7 -22 7 -27 -2 -4 -6 -3 -8 4 -4 6 3 14 1 17 -5 4 -5 14 -8 22 -5 8 4 58
-21 116 -58 276 -172 520 -245 829 -248 l143 -1 -95 -12 -95 -12 67 -2 c93 -2
271 23 413 58 182 45 343 104 520 190 242 119 445 259 641 444 45 43 85 77 89
77 5 0 53 -30 107 -66 55 -36 102 -64 104 -62 2 2 -43 35 -101 72 l-104 68
107 127 c235 280 412 586 555 961 95 247 180 557 228 826 l24 131 92 61 c67
45 102 62 125 62 54 -1 457 -46 463 -52 3 -3 -1 -72 -9 -154 -8 -82 -13 -150
-11 -152 2 -3 388 80 856 182 l853 186 99 -65 c54 -37 101 -65 103 -63 2 2
-40 33 -94 67 l-97 64 785 172 c432 94 799 175 815 179 24 6 -613 -425 -686
-465 -11 -6 -19 -13 -16 -15 3 -3 139 83 303 192 165 108 334 220 377 248 l78
51 1259 276 1260 275 122 -14 122 -13 288 71 287 72 36 -22 c19 -12 35 -19 35
-16 0 4 -14 15 -30 25 l-30 18 727 183 c401 101 737 184 748 184 11 1 25 4 30
8 12 7 1607 410 1609 406 107 -169 238 -332 336 -416 l45 -38 420 -63 c231
-34 436 -64 455 -67 l35 -6 -46 44 c-67 61 -153 168 -217 267 -98 152 -244
464 -225 481 4 4 19 10 33 13 24 6 27 2 48 -56 40 -111 157 -339 232 -452 42
-63 113 -150 165 -203 l92 -93 -31 -23 c-17 -13 -95 -65 -173 -116 -79 -50
-143 -94 -143 -97 0 -6 3 -4 200 125 l174 114 581 -76 c350 -47 602 -85 635
-96 72 -24 160 -36 160 -22 0 6 17 14 38 17 224 35 405 157 580 393 251 339
425 880 473 1467 17 213 7 677 -20 870 -52 383 -141 693 -281 980 -147 302
-334 517 -540 620 -43 22 -73 29 -141 33 -397 22 -764 -356 -983 -1015 -40
-120 -38 -119 -89 -79 -17 13 -16 19 19 127 169 524 453 893 776 1006 97 35
245 42 350 19 324 -72 623 -414 813 -930 151 -409 232 -991 207 -1475 -9 -170
-17 -201 -45 -184 -12 7 -1 87 12 91 6 2 11 8 11 13 0 6 -4 8 -8 5 -5 -3 -9
111 -9 252 -1 460 -61 850 -188 1220 -66 194 -179 432 -240 507 -9 11 -4 0 10
-25 130 -220 251 -548 315 -856 58 -279 71 -416 77 -793 3 -200 2 -341 -3
-338 -5 3 -8 -12 -6 -34 3 -31 1 -39 -13 -39 -9 0 -13 -5 -10 -10 4 -6 11 -8
16 -4 22 13 -40 -390 -92 -599 -46 -180 -91 -316 -156 -467 -41 -94 -57 -128
-125 -250 l-20 -35 21 25 c33 40 135 245 184 370 101 255 167 536 212 905 5
42 10 51 27 52 19 2 19 -2 13 -60 -36 -331 -115 -669 -217 -926 -16 -40 -26
-76 -24 -79 5 -5 1219 -141 1265 -142 17 0 7 8 -33 30 -179 94 -351 291 -481
550 -54 108 -145 337 -145 365 0 14 2 14 23 0 16 -10 36 -48 61 -118 138 -372
358 -663 583 -769 164 -78 279 -76 444 7 53 27 74 33 84 25 9 -8 15 -8 20 0 3
6 11 7 17 4 7 -4 8 -2 4 5 -6 9 -11 9 -21 1 -10 -8 -15 -8 -20 1 -4 6 -2 15 4
19 43 26 127 106 182 173 247 300 416 770 474 1322 8 77 15 170 15 208 0 68 7
80 30 52 25 -31 -6 -358 -60 -625 -58 -291 -154 -556 -280 -780 -19 -33 -23
-45 -11 -30 38 46 170 323 211 445 50 145 92 310 120 465 23 131 50 369 50
449 0 44 3 52 16 47 9 -3 18 -6 20 -6 21 0 -38 -521 -72 -632 -5 -17 13 -18
290 -18 275 0 296 1 296 18 0 9 -11 80 -25 156 -14 77 -25 143 -25 147 0 4 10
5 23 2 21 -4 21 -3 -3 10 -24 15 -29 36 -144 714 -65 384 -121 703 -123 708
-2 6 -55 41 -117 78 l-113 68 -6 72 c-4 40 -12 167 -18 282 l-12 211 -414 244
c-228 135 -409 246 -401 247 11 2 390 33 573 47 33 3 641 53 1350 111 710 58
1302 104 1317 102 15 -2 29 -1 30 3 3 7 3027 255 3033 248 7 -7 -17 -393 -24
-396 -13 -5 -831 -549 -838 -557 -19 -19 60 31 437 281 221 146 403 264 404
262 2 -2 -10 -226 -25 -498 -15 -272 -28 -523 -29 -557 l0 -63 54 0 54 0 7
-62 c19 -176 102 -443 200 -645 36 -73 65 -135 65 -137 0 -3 11 -17 25 -32 14
-15 23 -34 20 -41 -2 -8 -1 -12 4 -9 4 3 31 -23 60 -58 83 -100 85 -101 277
-126 93 -12 177 -26 187 -31 10 -5 22 -7 27 -4 5 3 145 -13 312 -36 167 -23
330 -44 363 -46 l59 -6 -50 59 c-160 186 -275 433 -355 759 -35 145 -36 169
-7 189 22 16 23 16 35 -61 58 -344 234 -732 410 -906 l59 -57 419 -56 c246
-32 444 -63 477 -75 32 -10 67 -19 80 -19 30 0 26 -4 -151 -119 -84 -56 -149
-101 -143 -101 6 0 86 50 178 111 134 89 182 115 238 131 105 29 170 71 274
175 52 51 118 109 148 128 30 19 54 38 54 41 0 3 -11 -1 -25 -10 -14 -9 -37
-24 -52 -33 l-28 -18 16 25 c58 90 87 143 126 233 25 56 52 111 61 121 10 11
11 16 5 12 -17 -9 -17 -11 12 73 58 171 101 424 114 664 35 650 -141 1271
-445 1572 -80 79 -190 145 -245 146 -28 0 -31 2 -14 9 39 17 83 10 153 -25
139 -70 290 -244 390 -451 l39 -82 17 52 c25 80 111 250 167 332 58 84 173
197 240 236 38 22 65 28 165 37 202 19 205 18 289 -23 268 -132 481 -547 550
-1069 22 -175 21 -180 -32 -129 -26 24 -31 36 -37 102 -17 192 -94 474 -175
643 -78 164 -195 314 -306 394 -29 21 -30 22 -10 37 24 18 13 21 -15 4 -15
-10 -26 -9 -56 6 -21 9 -68 20 -105 23 -200 17 -402 -137 -554 -423 -20 -38
-41 -68 -46 -67 -4 2 -6 -3 -3 -10 2 -7 -11 -55 -31 -106 l-36 -92 30 -92 c96
-299 140 -630 128 -962 -7 -196 -17 -287 -53 -476 l-26 -136 23 -44 c25 -49
109 -191 118 -199 21 -18 74 -82 64 -76 -6 3 -14 2 -18 -4 -17 -28 -93 60
-163 188 -22 41 -42 70 -45 65 -2 -4 -12 -34 -21 -65 -9 -31 -22 -63 -29 -70
-8 -7 -12 -18 -10 -24 2 -6 -6 -32 -17 -59 -18 -42 -22 -46 -37 -34 -15 13
-15 12 -2 -8 12 -20 11 -28 -9 -68 -12 -25 -19 -45 -16 -45 11 0 470 -50 509
-55 l40 -6 -65 40 c-36 22 -64 44 -63 49 1 6 -8 13 -20 16 -12 3 -36 20 -52
37 -17 18 -25 29 -18 25 6 -3 14 -2 17 3 8 13 40 -4 97 -51 25 -21 76 -52 115
-70 63 -30 77 -33 164 -33 85 0 101 3 153 30 212 107 407 424 497 805 47 201
63 349 64 593 0 114 3 207 7 207 3 0 18 -9 31 -20 19 -14 27 -32 31 -71 4 -28
8 -53 9 -54 2 -1 94 -5 206 -7 188 -5 202 -4 202 13 0 26 -120 811 -125 820
-3 4 -25 20 -49 35 l-43 27 -7 90 c-3 50 -6 109 -6 132 l0 42 -200 133 c-110
73 -198 135 -195 138 4 4 643 61 698 62 13 0 16 6 13 23 -3 12 -8 123 -11 246
-7 223 -7 224 14 218 12 -3 24 -1 27 4 3 6 11 5 20 -2 10 -8 18 -8 27 0 8 6
17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16
-1 -5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -12 -19 -45 9 -45 39 0 15 -3 49 -6
75 -6 43 -9 46 -35 46 l-29 0 0 76 c0 89 -46 1570 -55 1753 -5 115 -4 123 12
117 17 -6 17 -5 1 8 -10 7 -18 23 -18 34 0 23 34 47 51 36 17 -10 119 -11 126
-2 2 5 10 5 17 -1 7 -6 17 -6 26 -1 8 5 19 5 25 0 6 -5 17 -5 25 2 12 8 12 9
-2 4 -10 -3 -19 -2 -22 2 -5 8 -57 8 -72 1 -13 -7 -109 -3 -122 5 -6 4 -21 2
-32 -4 -16 -9 -20 -8 -20 5 0 8 5 15 10 15 6 0 10 5 10 11 0 5 -5 7 -10 4 -6
-4 -10 5 -10 22 0 15 -15 485 -34 1043 -19 558 -35 1029 -36 1046 0 20 5 31
15 32 8 1 22 3 30 4 8 1 12 5 9 10 -3 4 -14 4 -24 -2 -12 -6 -21 -6 -25 -1 -3
5 -21 497 -40 1092 -33 1030 -34 1082 -18 1095 17 13 17 14 0 8 -16 -6 -18 0
-18 47 0 30 -6 221 -14 424 -7 204 -14 418 -14 478 -1 99 0 107 18 107 17 0
20 10 26 85 9 100 3 501 -7 511 -4 3 -100 34 -213 69 l-207 62 122 81 c67 45
118 82 114 82 -4 0 -62 -36 -129 -79 l-122 -80 -1824 551 -1824 551 -100 67
c-119 79 -175 113 -175 107 0 -2 50 -37 110 -77 61 -40 109 -74 108 -76 -2 -1
-545 161 -1208 362 -3669 1109 -4717 1429 -4740 1442 -28 18 -378 248 -644
424 -98 66 -180 117 -182 115 -3 -2 149 -105 336 -228 358 -235 475 -315 450
-307 -8 3 -359 110 -780 238 -421 127 -769 235 -773 240 -5 4 8 18 28 30 20
12 34 24 32 27 -3 2 -24 -9 -48 -25 -41 -28 -44 -29 -83 -16 -23 7 -383 117
-801 244 -1207 367 -1390 423 -1395 428 -7 6 3 13 345 238 170 112 305 204
300 204 -6 0 -158 -98 -340 -218 l-330 -218 -110 33 c-60 19 -225 71 -365 115
-140 45 -316 98 -390 120 -325 93 -780 165 -1260 198 -144 10 -145 9 -1360
-110 -668 -66 -1231 -122 -1251 -125 -33 -4 -51 5 -190 96 -85 56 -160 104
-169 106 -15 5 266 -183 285 -190 6 -3 7 -7 4 -11 -6 -6 -1569 -166 -1619
-166 -8 0 111 84 265 186 154 103 273 184 264 181 -9 -3 -136 -85 -284 -182
-147 -98 -279 -182 -294 -186 -38 -13 -1152 -119 -1165 -112 -6 4 -170 112
-365 241 -195 129 -362 236 -370 239 -16 6 661 -447 700 -468 11 -6 18 -13 15
-16 -4 -5 -751 -82 -793 -83 -9 0 -13 -20 -13 -64 l0 -65 33 -4 32 -4 -32 -1
c-30 -2 -33 -5 -33 -36 0 -18 3 -48 6 -66 l7 -32 51 6 c91 10 980 96 1000 96
16 0 17 -2 5 -17 -10 -12 -6 -11 16 4 27 19 74 24 475 57 770 62 903 69 1575
87 459 12 957 7 1145 -11 568 -55 883 -194 970 -426 18 -51 46 -221 37 -230
-1 -2 -74 44 -161 102 -87 58 -160 103 -162 101 -3 -2 69 -53 159 -112 l164
-108 6 -126 c12 -218 10 -261 -11 -261 -15 0 -712 106 -818 125 l-30 5 22 -87
c12 -49 29 -158 38 -243 9 -85 43 -380 76 -655 164 -1379 292 -2575 289 -2695
l-1 -35 -8 35 c-4 19 -20 176 -36 348 -15 171 -31 312 -36 312 -4 0 -9 -15 -9
-32 -1 -18 -8 26 -16 97 -33 302 -144 1303 -149 1340 -22 181 -109 913 -134
1130 -31 278 -41 340 -67 436 l-15 56 -77 12 c-54 8 -175 10 -406 5 l-330 -6
343 228 c188 125 340 229 338 231 -3 4 -196 -122 -562 -367 l-131 -88 -374 -6
c-206 -3 -528 -7 -717 -8 l-343 -3 -49 118 c-27 64 -43 114 -37 110 7 -4 86
-56 175 -116 90 -60 165 -107 167 -105 2 2 -79 58 -179 126 l-182 122 -34 77
c-18 43 -34 79 -36 81 -1 2 -48 8 -104 13 -75 7 -110 15 -130 29 -34 25 -54
26 -23 2 22 -16 9 -17 -280 -19 -166 -2 -348 -6 -404 -10 -88 -7 -100 -6 -90
6 10 12 6 11 -18 -1 -20 -11 -112 -25 -270 -42 -209 -22 -499 -63 -589 -82
l-29 -6 7 -282 c24 -1037 76 -3642 76 -3857 l0 -36 68 0 c86 1 159 -24 214
-72 l43 -38 225 -37 c124 -20 530 -86 902 -146 l677 -109 56 -37 c30 -20 54
-39 52 -41 -4 -3 -1577 188 -1671 203 l-40 6 73 45 c39 25 70 48 67 50 -2 3
-37 -18 -78 -45 -71 -48 -75 -49 -131 -44 l-58 5 7 -41 c5 -34 3 -42 -14 -51
-18 -10 -20 -6 -26 41 -15 114 -83 206 -184 250 -56 25 -66 25 -577 3 -247
-11 -398 -22 -432 -31 -73 -20 -145 -80 -179 -151 -25 -50 -29 -70 -29 -140 0
-46 -2 -83 -5 -83 -3 0 -13 7 -22 14 -13 10 -18 28 -18 68 0 101 49 214 116
267 l25 20 -33 5 c-18 3 -296 38 -618 77 -322 39 -592 73 -600 76 -8 4 -20 5
-27 4 -15 -2 -1638 197 -1681 207 l-33 7 59 96 c396 642 1080 1234 1877 1625
239 118 292 138 326 124 16 -7 29 -16 29 -20 0 -4 -33 -27 -72 -51 -549 -323
-1050 -808 -1361 -1316 -61 -99 -152 -272 -146 -277 2 -1 265 -44 584 -95 319
-51 587 -95 595 -98 8 -3 31 -7 50 -9 33 -2 1193 -188 1254 -200 l29 -6 -7
273 c-5 181 -11 276 -18 280 -6 4 -61 15 -122 25 -116 19 -431 26 -511 11
l-40 -7 30 17 c62 34 396 28 584 -12 36 -7 67 -12 69 -11 4 5 -65 3386 -70
3391 -2 2 -70 -13 -151 -34 l-146 -39 -88 58 c-48 32 -184 121 -302 199 -117
78 -215 140 -217 138 -3 -2 128 -91 291 -198 162 -107 295 -196 295 -199 0 -3
-55 -20 -122 -39 -491 -136 -1243 -413 -1801 -664 l-166 -74 -43 28 c-24 16
-47 29 -53 29 -5 0 11 -14 37 -31 l48 -31 -175 -83 c-986 -469 -1999 -1083
-3022 -1833 -117 -86 -211 -157 -209 -159 2 -2 59 6 127 18 95 16 251 62 659
194 1181 382 1256 404 1338 389 59 -10 117 -49 137 -91 20 -41 22 -180 9 -551
l-7 -183 -36 -25 -36 -24 -6 47 c-4 27 -18 89 -32 138 -31 107 -57 243 -57
295 0 21 -3 45 -6 54 -11 28 -65 18 -184 -34 -126 -56 -236 -86 -579 -160
-287 -62 -1084 -220 -1108 -220 -10 0 -52 23 -93 50 -41 27 -79 50 -83 50 -5
0 26 -23 68 -51 42 -28 74 -53 72 -55 -10 -10 -1423 -264 -1467 -264 -8 0 80
63 197 141 l212 140 328 50 c180 27 333 53 340 57 6 4 134 100 285 213 1202
905 2404 1623 3622 2164 260 115 683 285 909 366 81 29 145 54 143 56 -8 8
-893 -147 -1445 -253 -128 -24 -243 -42 -255 -39 -11 2 -14 2 -6 -2 8 -3 -78
-25 -190 -48 -149 -30 -209 -38 -219 -30 -11 7 -13 7 -8 -1 4 -7 -1 -14 -11
-16 -16 -5 -21 13 -45 176 l-26 181 42 54 c99 129 289 237 502 286 117 27
1014 150 1037 143 6 -2 -169 -122 -388 -267 -348 -230 -461 -307 -404 -276 23
13 210 135 538 352 161 107 299 196 305 199 14 5 792 96 1290 150 l347 39 0
65 0 66 -32 -3 c-18 -2 -231 -26 -473 -52 -243 -27 -455 -47 -473 -45 -20 2
-31 0 -27 -6 4 -6 -6 -10 -22 -10 -39 0 -809 -93 -1163 -141 -664 -89 -800
-128 -1008 -287 -63 -48 -145 -133 -170 -177 -4 -8 -30 -17 -57 -20 l-51 -7
-144 97 -145 97 -7 96 c-4 53 -6 97 -5 97 4 3 2505 247 2572 252 39 2 88 5
110 6 22 1 45 5 50 8 6 4 28 7 50 7 22 0 47 2 55 5 8 3 211 24 450 47 239 22
447 43 463 46 26 5 27 8 27 70 l0 65 -42 -6 c-99 -13 -1375 -136 -1398 -134
-14 1 -32 -1 -40 -4 -8 -3 -557 -59 -1220 -125 l-1205 -118 0 -111 1 -111
-106 70 c-58 39 -118 79 -133 90 -16 11 -31 18 -33 15 -2 -2 58 -45 134 -95
l139 -92 6 -151 c4 -84 7 -183 7 -220 l0 -68 33 -3 32 -3 7 -184 c4 -102 6
-186 4 -189 -3 -2 -132 -32 -288 -67 -344 -77 -725 -165 -1032 -240 -125 -30
-234 -55 -242 -55 -12 0 -51 24 -284 180 -100 67 -110 73 -110 66 0 -4 246
-168 343 -230 16 -10 27 -20 24 -22 -3 -3 -137 -39 -298 -80 -231 -59 -964
-253 -1063 -281 -19 -5 -19 1 -13 177 4 101 7 210 7 242 l0 59 100 64 c55 36
100 68 100 71 0 7 -9 1 -123 -74 -37 -25 -69 -43 -70 -41 -4 5 24 743 28 747
2 2 34 -16 71 -40 87 -55 102 -64 89 -51 -5 6 -44 33 -85 59 l-75 49 12 270
c19 437 57 1077 69 1172 4 36 11 45 52 72 26 17 42 31 37 31 -6 0 -27 -11 -48
-25 -45 -31 -43 -50 -17 197 20 202 35 295 52 336 6 15 12 34 14 42 2 8 23 69
47 135 94 256 115 414 67 509 -14 28 -41 63 -60 78 -66 52 -218 89 -280 69z
m13880 -1446 c47 -3 173 -15 280 -26 l195 -21 85 -56 c464 -306 581 -382 588
-382 4 0 -139 97 -317 215 -178 118 -320 215 -315 215 5 0 64 -9 131 -20 185
-30 394 -76 538 -119 226 -66 720 -223 728 -231 5 -4 -8 -20 -29 -34 -21 -14
-34 -26 -28 -26 6 0 28 13 50 28 l38 28 141 -44 c77 -23 532 -162 1010 -308
479 -146 921 -281 984 -301 l113 -35 -36 -24 c-20 -14 -36 -27 -36 -30 0 -6
16 2 55 31 l30 21 940 -286 c517 -157 959 -291 983 -298 38 -12 42 -15 30 -29
-12 -15 -11 -15 9 -2 19 12 31 10 95 -11 40 -13 78 -25 83 -26 28 -5 217 -64
228 -71 6 -4 22 -9 34 -11 18 -2 1960 -587 2063 -621 23 -7 13 -16 -117 -102
-78 -51 -140 -95 -139 -97 2 -2 69 40 149 92 l145 96 1043 -315 c574 -174
1087 -329 1139 -345 52 -16 393 -120 758 -230 364 -110 671 -204 681 -209 10
-6 21 -8 25 -6 3 3 4 2 1 -2 -5 -7 212 -153 228 -153 5 0 -42 34 -104 75 -63
41 -111 75 -107 75 4 0 467 -139 1030 -309 563 -170 1257 -380 1543 -466 286
-86 521 -158 522 -159 3 -2 -244 -165 -309 -204 l-38 -23 -1037 312 c-616 185
-1042 318 -1049 327 -7 9 -13 11 -17 5 -4 -7 -51 3 -126 25 -119 36 -120 36
-103 57 17 20 17 20 -4 2 -21 -17 -58 -16 -89 2 -5 3 -16 6 -23 7 -29 5 -2028
606 -2034 613 -5 4 66 56 157 116 91 59 163 110 161 112 -2 3 -81 -47 -175
-110 l-170 -114 -1645 494 -1645 494 -153 101 c-84 55 -191 126 -238 158 -101
67 -110 73 -110 66 0 -5 133 -94 385 -259 50 -33 83 -57 75 -55 -8 3 -786 236
-1727 519 -942 283 -1713 516 -1713 519 0 3 51 38 113 78 104 68 182 124 147
106 -8 -4 -75 -47 -148 -95 l-133 -87 -112 34 c-62 18 -521 156 -1020 306
-716 215 -906 275 -902 286 4 12 2 12 -8 3 -11 -8 -39 -4 -118 20 -57 17 -106
35 -109 40 -3 4 -14 8 -25 7 -11 -1 -126 31 -255 69 -129 39 -260 76 -290 82
-129 25 -280 33 -697 38 -446 5 -767 -3 -1263 -33 -400 -24 -420 -24 -520 13
-151 55 -364 94 -635 114 l-160 13 -113 74 c-61 42 -111 76 -109 78 3 3 1590
161 1702 170 33 2 182 17 330 33 149 16 299 28 335 26 36 -3 103 -7 150 -10z
m-2435 -291 c63 -42 115 -77 115 -78 0 0 -111 1 -247 3 -428 6 -1282 -20
-1753 -54 -113 -8 -234 -17 -270 -19 -80 -5 -509 -43 -644 -56 -54 -6 -112 -9
-130 -9 -29 1 524 61 679 73 77 7 2129 213 2132 215 2 0 55 -33 118 -75z
m-2987 -221 c-16 -2 -40 -2 -55 0 -16 2 -3 4 27 4 30 0 43 -2 28 -4z m-105
-10 c-13 -2 -35 -2 -50 0 -16 2 -5 4 22 4 28 0 40 -2 28 -4z m-110 -10 c-13
-2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z m-100 -10 c-13 -2 -33 -2
-45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z m-105 -10 c-10 -2 -28 -2 -40 0 -13
2 -5 4 17 4 22 1 32 -1 23 -4z m-100 -10 c-10 -2 -28 -2 -40 0 -13 2 -5 4 17
4 22 1 32 -1 23 -4z m-100 -10 c-10 -2 -28 -2 -40 0 -13 2 -5 4 17 4 22 1 32
-1 23 -4z m-100 -10 c-10 -2 -28 -2 -40 0 -13 2 -5 4 17 4 22 1 32 -1 23 -4z
m-105 -10 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z m7065 -33
l112 -13 0 -121 c0 -67 3 -170 6 -231 l6 -110 -341 -224 c-188 -123 -341 -226
-341 -228 0 -7 90 51 449 289 123 82 225 147 226 146 4 -4 33 -1422 30 -1426
-2 -3 -351 225 -595 388 -100 67 -110 73 -110 66 0 -4 549 -370 662 -441 l47
-30 1 -126 c0 -69 3 -227 7 -350 l6 -224 -244 -161 c-442 -292 -494 -327 -474
-320 19 7 136 83 520 337 104 70 191 126 193 124 4 -3 34 -1444 30 -1466 -2
-15 -74 29 -373 226 -203 135 -374 245 -379 245 -8 0 363 -248 640 -428 l111
-73 6 -151 c4 -83 7 -229 7 -325 l0 -173 -372 -246 c-205 -135 -377 -251 -383
-256 -28 -28 169 98 472 303 163 110 275 180 281 174 4 -4 14 -350 22 -770
l15 -764 -35 22 c-19 12 -192 125 -385 252 -401 264 -375 248 -375 241 0 -4
141 -99 643 -431 82 -53 150 -103 152 -109 2 -6 5 -138 8 -293 l4 -283 -396
-261 c-218 -144 -400 -266 -406 -272 -19 -20 72 39 435 279 l365 242 2 -52 c5
-107 33 -1549 30 -1552 -2 -2 -19 7 -38 20 -39 28 -767 508 -786 520 -7 4 -13
5 -13 2 0 -3 93 -67 208 -142 216 -143 611 -405 623 -414 4 -3 10 -124 13
-270 l7 -265 -48 -30 c-26 -16 -181 -117 -343 -224 -162 -107 -335 -221 -384
-253 -48 -32 -85 -58 -81 -58 11 0 87 49 470 302 411 272 385 257 385 221 0
-15 7 -327 15 -693 8 -366 15 -727 15 -803 l0 -137 -87 59 c-258 172 -779 514
-793 519 -13 4 217 -150 736 -494 167 -111 154 -78 154 -370 l0 -201 -67 -44
c-70 -45 -719 -471 -785 -517 -36 -23 -53 -42 -25 -26 20 11 392 256 642 421
126 84 231 150 234 147 3 -3 12 -358 21 -788 l15 -783 -98 -6 -99 -5 -353 234
c-194 129 -361 237 -372 240 -15 6 492 -334 660 -442 l49 -31 -362 -8 c-199
-4 -363 -5 -366 -3 -2 3 -27 1149 -55 2548 -48 2453 -49 2543 -32 2563 16 20
16 20 1 8 -16 -12 -18 -11 -18 10 1 13 -9 503 -21 1088 -19 873 -20 1066 -10
1069 11 4 11 6 0 13 -11 7 -17 164 -30 851 -18 913 -20 1002 -49 2458 -24
1176 -23 1075 -7 1062 9 -8 17 -8 27 0 13 8 12 9 -2 5 -40 -13 -37 -70 -60
1117 l-3 128 360 -5 c198 -3 411 -11 473 -17z m-11529 -716 c107 -71 121 -83
100 -88 -34 -7 -232 -27 -234 -24 -2 2 -6 50 -10 107 -6 86 -5 102 6 95 8 -4
70 -45 138 -90z m-129 -854 c46 -46 27 -64 -176 -170 -435 -227 -774 -407
-1011 -537 -287 -156 -377 -200 -558 -273 -185 -74 -213 -81 -825 -216 l-575
-126 -42 23 c-24 13 -43 26 -43 29 0 3 274 65 608 138 334 74 654 150 712 169
173 58 377 154 705 332 273 149 644 346 963 511 56 29 100 55 98 57 -9 9 -460
-88 -1110 -238 -98 -23 -99 -23 -132 -3 -19 10 -35 23 -36 29 -4 15 1015 247
1222 279 138 21 176 20 200 -4z m6961 -135 c41 -137 218 -854 284 -1150 224
-1008 383 -2017 412 -2625 3 -69 8 -155 10 -192 4 -64 4 -68 -17 -68 -18 0
-21 -4 -16 -27 23 -115 28 -166 16 -173 -8 -5 -9 -22 -5 -55 l8 -47 51 7 c161
21 366 31 366 17 0 -5 -66 -12 -147 -15 -82 -4 -177 -11 -212 -17 -35 -6 -65
-9 -67 -8 -1 2 -15 73 -29 158 -14 85 -29 158 -33 161 -4 3 -101 16 -217 28
-1365 143 -2376 244 -2383 236 -2 -2 2 -152 11 -332 8 -180 14 -329 12 -331
-10 -11 -35 16 -39 41 -3 18 -14 256 -26 531 -20 479 -20 499 -3 511 17 13 18
8 24 -73 4 -48 7 -127 8 -177 2 -141 -10 -129 154 -144 255 -22 1525 -151
1842 -186 171 -19 325 -35 343 -35 19 1 31 -3 29 -7 -3 -4 20 -8 51 -9 32 -1
99 -5 150 -9 l92 -8 0 42 c0 22 -5 41 -11 41 -5 0 -7 5 -4 10 8 13 -8 13 -21
0 -7 -7 -11 8 -13 47 -13 394 -118 1194 -241 1843 -22 113 -42 221 -45 240 -3
19 -8 36 -10 39 -3 2 3 10 13 18 16 12 16 13 0 7 -10 -3 -18 -3 -18 0 0 4 -21
105 -46 224 -120 572 -344 1481 -374 1517 -11 13 -8 15 19 15 36 0 36 -1 16
48 l-16 37 31 -30 c21 -20 37 -52 51 -100z m-8373 -165 c26 -16 44 -30 39 -30
-11 0 -1177 -275 -1342 -316 -258 -65 -585 -164 -660 -201 -16 -8 -83 -47
-147 -85 l-117 -70 -31 22 c-17 12 -28 26 -23 30 4 5 68 44 141 88 234 141
376 184 1587 471 275 65 501 119 503 120 1 1 23 -12 50 -29z m18720 -265 c-2
-3 -102 -43 -221 -89 -272 -107 -443 -180 -722 -312 l-219 -104 -39 26 c-21
14 -41 23 -44 20 -3 -2 9 -12 25 -20 17 -9 33 -20 36 -25 3 -5 -90 -61 -207
-124 -646 -348 -1154 -696 -1538 -1054 -117 -109 -289 -285 -289 -297 0 -3 30
14 68 37 81 52 375 228 417 250 30 15 33 14 84 -17 l53 -33 -78 -43 c-178 -97
-515 -305 -758 -468 -142 -95 -260 -171 -263 -168 -2 2 76 107 173 233 185
237 349 420 510 568 l94 87 48 -26 c26 -15 36 -19 23 -9 -68 49 -75 36 92 170
430 346 902 642 1507 947 194 98 486 234 612 286 32 13 57 25 55 26 -1 2 -86
-10 -187 -26 -416 -65 -830 -168 -1297 -322 -106 -35 -193 -63 -193 -62 0 1
43 30 95 64 52 34 95 65 95 67 0 6 -6 2 -136 -83 -68 -44 -146 -84 -200 -104
-426 -155 -1039 -430 -1413 -634 -57 -31 -106 -55 -108 -52 -8 8 175 245 264
343 141 153 384 365 666 577 71 53 127 96 125 96 -2 0 -76 -24 -163 -54 -216
-72 -548 -217 -788 -343 -122 -65 -204 -102 -214 -99 -9 4 -14 8 -12 10 2 2
92 52 199 111 266 146 587 287 907 400 147 51 287 100 311 109 23 8 42 12 42
7 0 -4 -57 -48 -127 -98 -297 -210 -605 -465 -809 -670 -216 -217 -216 -215
24 -96 265 131 538 252 827 368 235 94 599 227 613 223 4 -1 17 3 28 10 28 15
354 113 368 110 6 -1 20 3 31 9 33 18 356 98 570 142 262 52 423 76 745 111
281 29 326 33 318 25z m-12248 -230 c52 -9 343 -38 645 -65 678 -62 684 -63
740 -90 50 -24 106 -86 130 -143 12 -29 45 -163 45 -183 0 -2 -93 58 -207 134
-223 148 -283 186 -283 179 0 -2 112 -78 248 -168 l248 -163 87 -441 c48 -242
88 -450 90 -462 2 -18 -40 -49 -257 -193 -143 -95 -265 -174 -271 -177 -19 -7
-827 134 -1110 193 -166 35 -197 50 -234 115 -68 120 -95 290 -125 805 l-4 71
314 208 c173 115 314 210 314 212 0 8 -72 -37 -340 -216 l-285 -190 -8 112
c-5 62 -9 162 -10 222 -2 104 0 113 28 170 45 90 71 97 245 70z m-2066 -151
c8 -21 2 -29 -34 -44 -25 -10 -36 -10 -56 0 -13 7 -24 16 -24 19 0 7 76 38 96
40 7 0 15 -6 18 -15z m-6656 -69 c-7 -7 -92 -61 -188 -120 -197 -123 -556
-361 -565 -375 -11 -18 61 -7 270 41 71 17 300 68 510 114 l380 84 43 -26 c24
-13 42 -27 40 -29 -2 -2 -200 -47 -439 -99 -239 -53 -504 -112 -589 -130 -233
-52 -330 -47 -330 18 0 47 164 168 616 451 l197 124 34 -21 c28 -16 32 -22 21
-32z m16926 -333 c2 -4 -61 -48 -142 -97 -232 -143 -512 -348 -682 -499 -35
-31 -65 -54 -69 -51 -10 11 280 254 453 381 131 95 406 273 423 274 6 0 14 -3
17 -8z m3256 -166 c0 -3 -87 -67 -192 -142 -241 -172 -374 -272 -653 -490
-236 -184 -313 -250 -280 -239 11 4 97 34 190 67 203 71 584 188 820 252 337
90 839 201 953 210 24 2 46 6 49 10 3 3 14 1 24 -4 11 -6 20 -6 23 -1 4 5 0
12 -6 14 -7 3 -3 6 10 6 12 1 35 -6 50 -15 24 -15 25 -15 8 0 -11 9 -18 17
-15 19 11 10 474 70 699 91 672 65 1361 46 1905 -50 237 -42 243 -43 224 -55
-22 -14 -51 -10 -72 9 -16 13 -19 14 -15 2 9 -28 56 -36 90 -17 28 16 33 16
54 3 12 -9 24 -12 26 -7 2 5 64 -9 138 -30 74 -22 146 -42 159 -45 80 -17 292
-82 292 -89 0 -4 -121 -54 -268 -110 -280 -107 -795 -316 -790 -321 1 -1 79 6
172 16 297 33 580 51 920 57 l330 5 50 -33 50 -34 -325 -6 c-617 -12 -1095
-59 -1617 -159 -114 -21 -210 -37 -215 -34 -5 3 -15 0 -23 -6 -8 -7 -20 -10
-27 -7 -13 4 54 38 82 41 8 1 33 11 55 23 47 24 1103 463 1248 518 54 21 97
38 95 40 -2 1 -88 25 -193 53 -1242 335 -2934 199 -4690 -375 -182 -59 -431
-149 -574 -207 l-113 -45 -56 37 c-30 20 -56 40 -56 43 -3 23 584 509 842 698
40 29 71 55 69 58 -7 6 -260 -80 -404 -138 -199 -79 -404 -173 -632 -290
l-213 -110 -49 32 c-27 17 -49 33 -49 34 0 7 328 180 473 250 441 212 744 320
1182 421 251 57 245 56 245 50z m-13883 -582 c-3 -4 -51 -26 -107 -50 -164
-71 -342 -179 -444 -269 -36 -32 -31 -30 75 24 113 59 257 111 305 111 20 0 7
-14 -70 -72 -53 -39 -95 -73 -93 -74 2 -2 39 8 82 22 273 88 611 116 828 69
75 -16 93 -23 80 -35 -4 -5 -37 -1 -73 8 -50 13 -110 17 -265 16 -178 0 -214
-3 -328 -27 -134 -29 -274 -70 -395 -118 -40 -16 -75 -29 -79 -29 -11 0 49 59
114 113 35 28 61 52 59 55 -8 7 -187 -82 -274 -136 -59 -37 -88 -50 -99 -44
-12 7 2 26 68 93 95 96 187 162 339 243 58 31 98 56 89 56 -60 0 -365 -107
-508 -180 -39 -19 -61 -26 -61 -18 0 7 36 47 79 90 44 43 78 78 76 78 -2 0
-33 -14 -70 -30 -62 -28 -189 -107 -259 -161 -22 -17 -27 -19 -20 -6 13 23
102 89 183 136 74 43 246 114 262 109 6 -2 -22 -29 -62 -60 -41 -31 -85 -68
-98 -82 -24 -26 -22 -25 53 10 166 76 357 133 516 153 88 11 104 12 97 5z
m-5647 -108 c-136 -85 -369 -244 -365 -248 3 -3 -1 -5 -7 -5 -7 -1 -137 -22
-288 -47 -151 -25 -392 -63 -534 -85 l-260 -39 -125 81 -125 81 35 8 c91 19
1660 282 1714 287 5 1 -15 -14 -45 -33z m9836 -117 c32 -180 17 -255 -59 -290
-56 -25 -111 -23 -312 9 l-170 28 210 138 c116 76 232 153 259 172 27 18 51
32 53 30 2 -2 10 -41 19 -87z m-6630 -121 c-4 -95 -11 -321 -17 -503 -10 -338
-18 -413 -49 -476 -30 -58 -44 -65 -85 -39 l-36 22 25 27 c13 14 30 40 36 56
14 37 27 249 34 580 4 138 9 298 12 357 6 107 6 107 38 127 17 11 35 20 39 20
5 1 6 -77 3 -171z m26350 37 c118 -36 216 -65 219 -65 3 0 5 -74 5 -165 0 -91
-3 -165 -7 -165 -17 0 -783 234 -779 238 12 12 332 220 340 221 4 1 104 -28
222 -64z m-23201 25 c-3 -5 -25 -15 -50 -24 -27 -9 -43 -10 -39 -4 4 6 1 9 -7
6 -8 -3 -13 -11 -11 -17 1 -7 -2 -10 -7 -7 -5 3 -35 -10 -67 -29 -32 -19 -65
-35 -75 -35 -9 0 -32 -3 -50 -6 -43 -8 -29 7 26 29 22 8 77 31 123 51 46 20
80 31 77 26 -10 -16 8 -11 34 9 23 18 57 18 46 1z m18665 -15 c884 -65 1703
-245 2450 -538 287 -112 573 -246 565 -264 -3 -11 1 -13 15 -8 14 5 71 -21
193 -88 289 -159 547 -326 797 -515 142 -108 159 -122 144 -122 -6 0 -62 39
-125 86 -257 196 -602 410 -919 571 -657 334 -1426 580 -2200 702 -74 12 -146
24 -160 27 l-25 6 30 25 c31 26 18 22 -25 -7 -24 -17 -34 -17 -210 6 -256 32
-501 52 -795 65 -260 11 -273 13 -335 62 l-25 20 210 -7 c116 -3 302 -13 415
-21z m-6912 -167 c28 -18 51 -35 51 -38 1 -8 -339 -152 -350 -148 -8 3 230
218 242 218 4 0 29 -15 57 -32z m-13148 13 c0 -5 -7 -11 -15 -15 -15 -5 -20 5
-8 17 9 10 23 9 23 -2z m7383 -643 c37 -469 67 -1032 67 -1242 l0 -88 -62 6
c-229 24 -518 41 -1068 65 l-185 8 165 1 c197 2 490 -11 839 -38 139 -11 262
-20 272 -20 18 0 19 10 19 158 0 253 -44 1019 -76 1315 -3 32 -2 57 3 57 5 0
17 -100 26 -222z m-9293 -277 l34 -29 -39 -11 c-22 -6 -65 -11 -95 -12 -30 0
-73 -4 -95 -8 -27 -6 15 -9 137 -10 106 -1 179 -5 183 -11 3 -5 11 -10 16 -10
6 0 7 5 3 12 -5 8 62 10 277 5 391 -9 981 -36 999 -46 8 -5 29 -6 46 -4 53 8
1595 -99 1917 -133 l57 -6 0 76 c0 74 7 90 27 64 6 -7 17 -188 26 -403 14
-338 14 -392 2 -404 -8 -8 -17 -12 -20 -9 -3 3 -11 145 -19 315 -7 170 -15
314 -19 320 -3 5 -46 13 -94 16 -48 4 -259 20 -468 37 -496 39 -1371 99 -1443
100 -7 0 -10 5 -7 10 8 13 -8 13 -21 0 -6 -6 -64 -6 -163 0 -85 5 -307 14
-495 20 -187 6 -395 14 -461 18 -66 4 -248 3 -405 -1 -318 -8 -315 -8 -495
-90 -231 -105 -332 -127 -579 -127 -286 0 -790 -24 -1271 -61 -1074 -81 -2258
-238 -3490 -460 -154 -28 -291 -52 -305 -53 -14 -2 -32 -5 -40 -9 -8 -3 -202
-42 -430 -87 -228 -45 -545 -110 -703 -145 l-289 -63 -58 -57 c-39 -38 -63
-55 -72 -50 -50 29 -117 80 -111 85 25 22 1693 366 1721 355 8 -3 20 -1 26 4
24 20 975 183 1577 270 1261 184 2354 282 3394 306 167 4 275 11 325 22 l74
15 -23 19 c-16 14 -19 20 -10 23 8 3 32 10 54 17 22 6 92 35 156 64 201 92
426 153 564 154 63 0 74 -3 105 -28z m7333 -161 c10 0 17 -8 17 -20 0 -12 -7
-20 -17 -20 -10 0 -137 14 -283 32 l-265 32 -57 39 c-32 22 -58 41 -58 41 0 1
145 -21 323 -50 177 -29 330 -53 340 -54z m-7013 -292 c151 -11 287 -20 303
-19 15 1 27 -2 27 -6 0 -5 22 -7 49 -6 47 1 928 -68 1794 -141 225 -18 412
-38 417 -42 10 -11 31 -131 70 -388 27 -187 28 -200 12 -212 -9 -7 -18 -11
-19 -10 -1 1 -14 81 -28 176 -40 270 -63 393 -74 400 -6 3 -109 14 -228 24
-120 9 -508 42 -863 72 -355 30 -662 54 -683 54 -21 -1 -41 2 -46 5 -5 3 -69
7 -142 10 -73 3 -136 9 -139 13 -3 4 -43 8 -90 9 -47 0 -215 11 -375 23 -346
26 -500 29 -575 11 -135 -33 -242 -103 -315 -205 -78 -110 -91 -154 -151 -535
-30 -190 -58 -368 -60 -396 -3 -27 -12 -55 -20 -61 -9 -8 -11 -13 -4 -16 10
-3 -35 -302 -280 -1858 -67 -423 -83 -508 -100 -524 -11 -11 -21 -18 -23 -15
-2 2 11 99 29 214 366 2314 350 2206 352 2258 1 16 6 26 11 23 5 -4 7 2 4 12
-6 23 92 657 113 732 52 183 185 328 357 387 135 47 184 48 677 11z m-1752
-12 c143 -25 223 -74 243 -150 12 -45 5 -101 -57 -456 -43 -244 -40 -233 -66
-219 -11 6 -179 115 -372 243 -401 265 -376 249 -376 242 0 -7 731 -491 753
-499 6 -2 11 -14 10 -28 -2 -25 -139 -671 -149 -702 -3 -10 -139 -107 -302
-214 -263 -173 -352 -234 -302 -208 8 4 144 93 301 196 157 104 288 189 291
189 3 0 -1 -28 -9 -62 -231 -1018 -379 -1585 -457 -1743 -78 -158 -190 -259
-356 -322 -186 -70 -393 -93 -827 -93 l-287 0 -80 53 c-85 57 -242 158 -263
171 -7 4 -13 5 -13 3 0 -2 74 -53 165 -112 91 -60 164 -109 162 -109 -1 -1
-120 0 -264 2 -245 3 -262 4 -268 22 -3 10 -145 114 -315 230 -171 117 -310
213 -310 214 0 4 405 -35 419 -40 11 -4 10 -8 -5 -20 -17 -14 -16 -14 8 0 15
9 40 16 55 16 109 1 34 81 -107 115 -36 8 -178 26 -315 38 l-251 23 -133 93
c-128 89 -134 92 -199 98 -124 10 -303 -32 -394 -94 l-43 -29 -155 13 c-255
20 -529 27 -576 14 -55 -15 -94 -47 -94 -76 0 -29 -13 -28 455 -55 393 -23
1033 -67 1082 -74 25 -4 69 -38 183 -142 82 -75 150 -140 150 -145 0 -4 -33
-29 -72 -55 -40 -26 -109 -71 -153 -100 l-80 -53 -255 -16 c-285 -17 -645 -46
-945 -75 -110 -10 -267 -20 -349 -21 l-148 -3 -137 91 c-321 213 -391 258
-391 250 0 -2 115 -80 256 -173 l257 -169 -289 -7 c-524 -12 -985 -40 -1370
-83 -122 -14 -225 -25 -230 -25 -5 0 143 101 329 224 296 196 391 261 337 231
-71 -39 -690 -451 -686 -456 3 -3 -5 -6 -17 -7 -12 -1 -85 -13 -162 -27 -215
-41 -206 -40 -201 -24 3 8 30 97 62 199 84 276 268 873 325 1053 49 153 50
157 72 145 12 -6 154 -99 315 -206 161 -107 295 -193 296 -191 5 5 -36 32
-371 254 -139 91 -253 171 -253 177 0 12 172 552 284 893 l62 190 142 94 c78
52 140 96 138 98 -2 3 -65 -36 -140 -86 l-135 -91 59 168 c138 394 154 430
218 471 100 64 291 131 587 205 152 38 551 126 570 126 4 0 -88 -63 -205 -140
-252 -167 -257 -170 -246 -170 5 0 113 69 240 153 127 84 236 156 242 160 23
13 778 146 1184 207 932 141 1797 255 2685 354 346 39 469 50 775 70 103 7
388 -4 468 -18z m1722 -47 c151 -10 319 -22 373 -26 54 -3 100 -9 102 -13 2
-4 28 -5 56 -2 30 3 50 1 46 -4 -3 -5 -21 -9 -41 -8 -20 1 -34 -1 -32 -5 5 -8
109 -7 123 2 6 4 14 3 18 -3 3 -5 11 -10 16 -10 6 0 8 4 5 9 -3 5 9 7 27 6 17
-2 77 -6 132 -9 55 -4 429 -33 830 -66 402 -33 769 -63 818 -67 48 -3 91 -11
96 -17 5 -6 25 -114 44 -241 53 -340 51 -319 33 -334 -9 -8 -18 -12 -20 -10
-2 2 -11 56 -20 119 -9 63 -28 187 -43 276 l-25 161 -642 52 c-352 29 -820 67
-1039 84 -300 24 -395 35 -386 44 8 8 5 11 -14 10 -14 -1 -23 -5 -20 -9 2 -5
-3 -8 -12 -8 -9 0 -13 5 -10 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10 -3 -5 -20
-10 -37 -10 -22 0 -29 4 -25 15 5 12 2 12 -19 3 -19 -9 -33 -9 -55 -1 -16 7
-27 7 -23 2 3 -6 -13 -8 -43 -4 -115 13 -497 36 -593 36 -173 0 -295 -46 -390
-147 -96 -101 -113 -153 -170 -529 -28 -181 -54 -337 -57 -345 -2 -8 -7 -39
-9 -69 -4 -62 -5 -64 -31 -59 -19 3 -17 21 42 398 34 217 68 413 75 435 56
175 208 312 385 344 112 21 132 20 555 -10z m65 -328 c-12 -11 -785 -521 -790
-521 -14 0 75 291 112 365 53 106 97 131 283 159 55 8 404 6 395 -3z m75 -23
c-41 -70 -42 -99 -30 -852 6 -395 9 -720 7 -723 -3 -2 -200 124 -437 282 -238
157 -434 284 -436 282 -3 -3 719 -484 843 -562 l32 -20 1 -110 c0 -60 3 -180
6 -265 l7 -155 -379 -250 c-495 -328 -513 -339 -509 -344 2 -2 129 80 282 181
153 101 350 232 438 290 l160 105 7 -326 c3 -179 8 -515 11 -746 6 -461 5
-458 68 -530 83 -94 181 -119 447 -112 l192 5 0 -54 c0 -60 10 -53 -103 -74
-32 -7 -71 -9 -85 -6 -15 4 -22 3 -15 -2 10 -7 -566 -105 -842 -144 -126 -17
-416 -15 -505 5 -211 47 -321 132 -371 287 -26 82 -45 308 -42 500 3 196 26
420 44 431 12 7 12 9 1 9 -16 0 -17 -13 39 445 101 816 269 1892 302 1933 6 7
114 81 241 165 126 84 309 205 405 269 132 88 184 118 208 118 l32 0 -19 -32z
m3080 -105 c1 -16 14 -334 29 -708 16 -374 27 -682 25 -684 -3 -3 -12 3 -21
12 -15 15 -20 96 -45 699 -28 677 -28 708 3 708 5 0 9 -12 9 -27z m960 19 c0
-4 16 -6 35 -4 19 2 60 -4 90 -14 l57 -17 -7 -34 c-3 -19 -3 -48 0 -65 11 -50
26 -11 19 47 l-7 50 43 -36 c24 -19 56 -59 73 -87 33 -59 42 -139 52 -442 2
-91 11 -275 18 -410 8 -135 12 -250 10 -256 -2 -6 -15 -16 -29 -22 -24 -11
-24 -11 -18 26 5 32 2 38 -17 47 -13 6 -27 23 -32 38 -13 39 0 114 24 138 24
24 24 33 0 19 -42 -22 -71 16 -71 93 0 62 19 92 57 92 28 0 31 3 27 25 -2 14
-8 49 -13 79 -5 30 -8 60 -6 65 17 56 15 66 -9 76 -49 18 -60 165 -15 193 10
6 19 21 19 32 0 18 -2 17 -13 -5 -8 -17 -21 -25 -37 -25 -48 0 -77 106 -47
165 10 19 20 25 45 24 37 -2 39 5 13 37 l-19 24 -12 -27 c-34 -73 -100 -21
-100 78 0 30 -4 34 -40 45 -31 9 -43 10 -52 1 -15 -15 -51 -15 -65 -1 -16 16
-33 2 -33 -26 0 -13 -10 -31 -22 -39 -29 -20 -57 -3 -74 45 l-12 34 -1 -55
c-1 -61 -21 -100 -51 -100 -29 0 -50 39 -50 92 l0 48 -39 0 c-22 0 -43 -4 -46
-10 -3 -6 4 -10 18 -10 14 0 30 -7 37 -15 18 -22 25 -108 11 -134 -11 -19 -9
-21 13 -21 14 0 31 -9 40 -22 19 -27 21 -103 3 -138 -17 -34 -61 -39 -78 -9
-13 25 -16 103 -5 138 6 16 5 21 -3 17 -24 -15 -51 5 -62 46 -9 37 -8 59 7
110 4 13 0 15 -17 11 -15 -4 -26 0 -35 12 -16 22 -17 22 -31 -32 -10 -41 -9
-43 12 -43 35 0 50 -27 50 -91 0 -47 -5 -63 -21 -80 -46 -46 -91 11 -81 101 5
44 4 50 -12 50 -26 0 -42 23 -48 68 -5 34 -8 38 -28 34 -23 -4 -23 -4 -3 -24
16 -16 19 -30 16 -84 -2 -45 0 -63 8 -60 7 3 22 -2 34 -11 19 -14 21 -23 18
-83 -3 -58 -1 -66 13 -63 26 7 49 -36 49 -90 0 -27 -4 -56 -9 -65 -8 -15 -5
-18 17 -17 44 0 67 -75 42 -139 -8 -22 -7 -26 10 -26 10 0 26 -10 34 -22 18
-26 21 -109 6 -139 -9 -16 -7 -19 15 -19 19 0 28 -7 36 -27 11 -29 8 -106 -5
-136 -6 -13 -4 -16 6 -12 47 18 75 -89 41 -155 -19 -37 -45 -49 -68 -30 -22
18 -28 90 -12 136 13 38 12 41 -3 37 -31 -8 -50 24 -50 83 0 31 5 64 10 75 9
16 7 19 -14 19 -15 0 -30 8 -36 19 -13 25 -13 116 0 141 8 15 6 17 -10 13 -11
-3 -26 0 -34 6 -20 17 -29 83 -18 125 10 34 9 36 -13 36 -34 0 -48 32 -43 101
4 56 3 59 -19 59 -33 0 -46 34 -40 100 4 52 3 56 -16 56 -30 -1 -49 40 -44
100 3 48 2 50 -20 46 -22 -4 -63 -45 -63 -62 0 -5 8 -6 19 -3 35 9 53 -24 49
-92 -3 -55 -2 -61 13 -58 30 8 52 -40 47 -101 -3 -37 -1 -53 7 -50 37 15 68
-74 47 -136 -10 -28 -10 -31 8 -25 32 10 53 -35 48 -105 -4 -53 -2 -59 16 -62
41 -6 56 -84 30 -153 -5 -13 -4 -16 5 -11 26 16 51 -24 51 -81 0 -30 -5 -63
-10 -74 -9 -16 -7 -19 14 -19 15 0 30 -8 37 -21 11 -22 8 -112 -5 -141 -6 -14
-4 -18 12 -18 33 0 44 -24 40 -87 -2 -32 -8 -66 -12 -75 -6 -14 -4 -18 13 -18
11 0 25 -9 31 -19 15 -28 12 -96 -5 -137 -8 -19 -11 -33 -6 -30 4 3 17 -2 29
-10 31 -21 32 -94 2 -94 -15 0 -20 7 -20 28 l0 27 -20 -33 c-34 -56 -56 -12
-25 48 14 28 14 30 -3 30 -10 0 -23 5 -30 12 -17 17 -15 113 3 147 13 27 13
29 -4 24 -10 -2 -25 3 -35 12 -20 21 -22 109 -2 146 13 25 12 26 -7 21 -13 -3
-25 2 -33 13 -16 22 -19 118 -4 145 8 16 7 18 -4 14 -8 -3 -24 4 -35 15 -23
23 -29 90 -12 134 8 20 6 23 -12 23 -39 -2 -60 78 -37 138 9 24 7 26 -15 26
-34 0 -48 32 -43 101 4 50 2 59 -13 59 -35 0 -57 65 -41 123 9 30 8 34 -8 30
-34 -9 -52 25 -48 94 2 48 0 62 -10 58 -28 -10 -52 33 -52 92 0 60 -13 63 -29
7 -6 -21 -4 -33 6 -43 11 -10 14 -29 11 -71 -4 -50 -2 -57 13 -53 29 8 52 -40
47 -97 -4 -43 -2 -50 12 -50 10 0 23 -7 30 -15 14 -17 18 -79 8 -116 -6 -22
-4 -25 14 -25 33 1 50 -39 43 -101 -5 -48 -3 -53 15 -53 10 0 24 -9 30 -19 12
-24 13 -91 1 -124 -8 -20 -6 -23 12 -23 41 2 62 -90 33 -145 -12 -24 -12 -25
9 -22 12 3 27 -3 35 -12 17 -20 17 -103 1 -133 -10 -19 -9 -22 7 -22 11 0 26
-7 33 -16 16 -20 16 -112 0 -142 -10 -19 -9 -22 7 -22 31 0 42 -22 42 -81 0
-42 -5 -63 -21 -83 -25 -32 -54 -34 -70 -5 -11 22 -8 109 6 142 5 13 2 17 -14
17 -11 0 -25 9 -32 21 -11 22 -8 101 5 130 5 12 1 18 -17 23 -35 8 -49 82 -27
140 8 21 6 25 -13 28 -42 6 -57 83 -31 153 5 12 4 16 -3 12 -21 -13 -43 5 -53
43 -6 21 -8 44 -6 51 16 50 16 68 1 63 -38 -15 -66 60 -47 123 9 29 8 34 -4
29 -8 -3 -24 4 -36 16 -18 18 -20 29 -15 79 4 46 2 57 -9 52 -10 -4 -13 -29
-11 -109 2 -88 4 -104 18 -104 30 0 41 -27 37 -90 -3 -56 -2 -60 19 -60 29 0
46 -58 34 -112 -7 -29 -6 -38 4 -38 28 0 45 -31 45 -81 0 -28 -4 -59 -10 -69
-8 -15 -6 -17 9 -13 30 8 55 -38 48 -90 -2 -23 -8 -50 -12 -59 -5 -14 -2 -18
14 -18 37 0 52 -85 26 -152 -4 -10 1 -17 14 -21 41 -10 48 -84 17 -158 -5 -12
0 -18 18 -23 63 -16 36 -176 -29 -176 -19 0 -28 8 -36 28 -12 32 -4 98 16 128
13 20 12 21 -4 17 -46 -12 -66 68 -36 140 11 28 12 35 2 31 -42 -16 -71 74
-44 137 14 34 14 35 -6 35 -35 -1 -53 44 -41 103 10 48 9 50 -13 56 -28 7 -37
39 -31 105 5 44 3 49 -19 53 -21 4 -23 1 -23 -34 0 -21 4 -40 9 -43 14 -9 20
-60 11 -99 -6 -28 -5 -37 5 -37 39 0 61 -91 35 -140 -8 -15 -5 -19 15 -24 37
-9 46 -83 20 -149 -5 -13 -3 -16 8 -11 21 8 47 -33 47 -73 0 -25 -4 -33 -17
-33 -14 0 -15 -2 -4 -9 8 -5 11 -16 6 -30 -3 -12 -2 -21 4 -21 39 0 55 -93 26
-150 -15 -28 -14 -30 4 -30 42 0 55 -79 22 -143 l-19 -37 24 0 c17 0 25 -7 30
-26 6 -23 2 -88 -7 -123 -2 -8 8 -18 24 -23 23 -8 31 -7 42 8 12 17 11 19 -6
22 -41 7 -48 96 -13 164 9 17 11 27 5 24 -19 -12 -51 32 -51 72 0 42 26 100
53 116 15 9 22 6 39 -14 16 -20 19 -34 14 -74 -3 -27 -12 -59 -21 -72 -14 -23
-14 -24 4 -24 11 0 25 -10 32 -22 15 -27 5 -112 -17 -145 -9 -14 -12 -23 -6
-19 17 11 40 -4 47 -31 6 -24 7 -24 28 18 28 54 51 69 72 48 9 -9 17 -30 17
-47 1 -18 2 -32 4 -32 1 0 10 25 19 55 11 40 23 59 40 67 38 17 55 -4 56 -71
l1 -56 9 49 c10 64 28 105 50 116 23 13 25 13 43 -6 18 -17 21 -79 6 -118 -8
-22 -7 -26 8 -26 14 0 17 8 14 43 -7 89 36 169 82 151 33 -12 33 -102 0 -165
l-15 -29 36 0 c20 0 46 5 58 12 12 6 39 12 61 13 24 1 41 7 48 18 5 9 16 17
24 17 9 0 29 9 45 21 24 16 27 24 19 39 -19 35 -11 42 24 21 18 -12 37 -21 42
-21 5 0 -11 12 -35 26 -40 25 -43 29 -38 60 8 50 29 88 55 99 12 5 22 16 22
24 0 11 -4 11 -18 -2 -25 -22 -49 -21 -62 2 -13 26 -13 100 1 140 11 33 42 56
59 46 6 -4 10 10 10 32 l-1 38 -14 -32 c-10 -24 -21 -33 -38 -33 -36 0 -47 19
-47 79 0 85 38 140 77 115 17 -10 18 -4 15 104 -3 84 -9 129 -23 164 -25 64
-24 82 7 102 l25 17 -6 -34 c-5 -25 -2 -38 10 -51 15 -14 20 -68 35 -391 19
-400 18 -428 -25 -501 -32 -54 -75 -90 -151 -126 -58 -27 -74 -29 -245 -38
-101 -5 -218 -12 -260 -14 l-77 -5 4 42 c3 32 2 37 -5 22 -5 -11 -10 -30 -10
-42 -1 -20 -6 -23 -46 -23 -42 0 -45 2 -46 28 l-1 27 -11 -28 c-10 -25 -14
-27 -46 -21 -96 17 -191 86 -234 170 -13 25 -13 33 -1 54 7 14 13 38 14 54 l0
28 -19 -23 -18 -23 -7 58 c-5 38 -4 62 3 69 14 14 14 84 1 89 -11 3 -29 255
-30 401 0 63 1 68 19 62 17 -5 21 0 26 29 10 51 0 67 -14 23 -20 -60 -36 -40
-35 44 1 41 2 89 4 107 2 19 -1 37 -7 40 -6 4 -13 84 -17 187 -4 99 -10 239
-14 310 -8 164 -7 328 3 379 6 32 4 42 -10 52 -14 10 -16 21 -10 50 11 64 36
116 52 110 9 -4 16 4 20 25 4 21 17 38 42 53 20 12 45 27 56 34 38 23 66 32
121 38 l55 7 -6 -36 c-4 -20 -4 -45 0 -54 7 -17 8 -16 15 2 5 11 6 34 3 51 -4
30 -3 31 37 38 46 7 60 2 61 -22 0 -12 3 -11 9 6 8 17 17 22 48 22 21 0 80 3
130 6 l92 7 0 -29 c0 -36 19 -70 21 -39 1 11 1 30 0 42 -1 19 4 22 41 26 24 2
46 4 51 5 4 1 7 -2 7 -6z m-2385 -66 c215 -35 309 -77 400 -178 77 -86 94
-135 109 -320 14 -162 10 -192 -19 -168 -6 5 -17 5 -25 0 -9 -5 -19 -5 -26 1
-8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5 13 -11 23 -13 30
-6 6 6 14 6 23 -1 9 -8 17 -8 27 0 9 8 16 8 20 2 4 -6 13 -8 21 -4 8 3 15 1
15 -5 0 -5 16 -227 35 -493 39 -543 70 -1049 85 -1398 8 -186 8 -237 -2 -249
-11 -13 -11 -14 0 -8 19 12 10 -359 -11 -433 -40 -136 -127 -250 -229 -296
-31 -13 -117 -35 -203 -49 -82 -14 -303 -53 -490 -86 -187 -33 -343 -60 -347
-60 -5 0 -8 18 -8 40 0 22 5 40 10 40 23 0 307 31 332 36 42 8 111 76 142 139
35 72 64 187 73 295 l8 85 48 31 c26 17 51 35 55 39 8 10 -68 -34 -83 -47 -5
-4 -12 -8 -15 -8 -4 0 -10 98 -13 218 -4 119 -10 259 -13 311 l-7 94 58 -41
c32 -23 63 -42 69 -42 5 0 -20 21 -56 46 l-66 45 -6 82 c-5 72 -25 559 -41
1022 -3 83 -8 202 -11 266 l-6 115 96 64 c53 34 95 65 92 67 -2 2 -43 -21 -90
-53 -47 -31 -88 -55 -91 -53 -6 6 -28 646 -23 686 l3 32 98 -66 c54 -36 100
-64 102 -61 2 2 -43 34 -100 72 -118 77 -111 62 -118 243 l-3 92 25 -5 c15 -2
94 -15 176 -28z m2489 -18 c20 -28 21 -127 3 -152 -18 -25 -58 -17 -74 14 -15
30 -17 114 -3 141 14 26 55 24 74 -3z m3330 -20 c249 -11 261 -12 295 -36 l36
-24 -55 6 c-30 3 -122 8 -205 11 -82 3 -188 8 -234 12 l-84 6 7 -34 c36 -175
161 -1052 226 -1584 22 -181 42 -345 44 -362 5 -32 4 -32 -18 -18 -21 14 -25
35 -60 321 -35 285 -36 307 -21 324 16 17 16 18 -2 14 -17 -5 -20 5 -32 98
-34 282 -161 1127 -187 1251 -4 22 -2 27 13 27 10 0 135 -5 277 -12z m-3449
-28 c23 -25 31 -101 15 -140 -25 -61 -83 -43 -95 31 -16 93 33 161 80 109z
m4869 -41 c3 -2 28 -546 57 -1207 51 -1180 52 -1203 33 -1217 -23 -17 -16
-129 -59 880 -35 831 -37 874 -55 1275 -6 123 -15 227 -20 230 -5 3 -238 16
-517 29 -498 22 -547 27 -566 58 -5 8 1119 -40 1127 -48z m-4366 9 c6 -8 19
-215 32 -506 22 -481 22 -493 4 -507 -17 -12 -19 -11 -21 13 -4 42 -43 926
-43 972 0 41 9 50 28 28z m-624 -21 c37 -27 41 -140 5 -172 -23 -22 -57 -11
-70 22 -17 45 -11 121 11 143 23 23 30 24 54 7z m300 -89 c18 -26 22 -119 6
-149 -14 -26 -55 -24 -74 3 -18 26 -22 119 -6 149 14 26 55 24 74 -3z m-107
-65 c17 -41 13 -113 -7 -138 -7 -8 -23 -15 -37 -15 -32 0 -57 57 -50 117 6 52
21 73 54 73 18 0 28 -9 40 -37z m-1513 -10 c11 -51 95 -756 91 -761 -1 -1 -11
5 -23 15 -17 16 -24 48 -47 248 -14 127 -34 291 -44 365 -13 92 -15 139 -9
148 16 19 26 14 32 -15z m1104 15 c31 -40 23 -140 -13 -164 -29 -19 -50 -10
-65 27 -14 34 -8 112 10 134 15 18 54 20 68 3z m-1155 -80 c3 -29 22 -185 42
-347 20 -161 33 -296 30 -300 -4 -3 -14 3 -24 15 -12 16 -23 73 -40 220 -12
109 -30 256 -40 326 -17 126 -16 135 15 137 6 1 14 -22 17 -51z m1447 26 c16
-41 12 -125 -7 -146 -40 -45 -83 -4 -83 80 0 69 12 92 51 92 22 0 32 -6 39
-26z m-106 -93 c23 -107 -62 -183 -95 -84 -26 80 16 172 65 140 12 -8 25 -32
30 -56z m390 17 c24 -34 21 -133 -4 -158 -11 -11 -24 -20 -30 -20 -5 0 -19 9
-30 20 -16 16 -20 33 -20 81 0 33 5 69 10 80 14 26 55 24 74 -3z m-120 -40
c38 -60 26 -163 -20 -174 -43 -11 -59 16 -59 97 0 58 3 73 19 85 28 20 43 18
60 -8z m-394 -7 c12 -24 13 -116 1 -139 -8 -15 -5 -18 17 -17 35 0 54 -37 49
-95 -3 -25 -8 -53 -12 -62 -5 -14 -2 -18 13 -18 32 0 47 -28 46 -89 0 -72 -16
-101 -54 -101 -24 0 -30 6 -40 36 -12 35 -10 90 5 127 5 13 2 17 -13 17 -11 0
-25 7 -32 15 -17 21 -24 89 -12 124 10 28 9 31 -8 31 -30 0 -50 39 -50 95 0
30 6 60 16 73 19 27 60 29 74 3z m288 -61 c19 -37 10 -126 -16 -152 -19 -20
-22 -20 -45 -5 -37 24 -44 125 -12 176 12 20 58 8 73 -19z m-12613 -67 c65
-18 120 -35 122 -37 2 -1 -28 -88 -66 -192 -37 -104 -78 -220 -91 -257 -12
-38 -25 -66 -28 -63 -3 4 -8 77 -12 164 -6 143 -9 162 -34 214 -34 72 -100
131 -178 160 -67 24 -63 34 20 47 68 11 132 3 267 -36z m12495 18 c16 -30 12
-123 -6 -149 -36 -51 -84 -10 -84 73 0 30 6 60 16 73 19 27 60 29 74 3z m394
-33 c10 -14 16 -44 16 -78 0 -61 -19 -100 -50 -100 -31 0 -50 39 -50 100 0 61
19 100 50 100 10 0 26 -10 34 -22z m-113 -45 c19 -22 19 -134 0 -157 -20 -24
-63 -17 -79 14 -16 30 -11 122 7 144 17 21 55 20 72 -1z m-117 -55 c10 -13 16
-43 16 -73 0 -30 -6 -60 -16 -73 -20 -29 -60 -29 -76 1 -14 27 -14 118 2 146
14 28 55 27 74 -1z m1472 11 c8 -7 14 -7 14 -2 0 13 90 -1 127 -20 41 -22 79
-66 102 -117 21 -49 38 -140 25 -140 -16 0 -44 34 -44 55 0 58 -52 135 -111
165 -82 42 -233 34 -278 -14 -44 -47 -44 -60 5 -631 51 -601 51 -602 129 -674
69 -63 149 -77 225 -38 65 32 93 93 98 212 2 49 -10 276 -28 503 -18 227 -29
416 -26 419 4 4 13 0 21 -8 11 -11 22 -108 46 -409 35 -445 35 -587 2 -660
-44 -101 -144 -140 -271 -108 -60 15 -151 102 -175 168 -19 53 -112 1113 -102
1167 7 37 31 66 47 57 7 -4 8 -2 4 5 -4 6 -13 8 -19 4 -7 -3 -3 4 8 16 26 30
51 43 94 48 20 3 37 6 38 7 8 7 59 4 69 -5z m-6736 -18 c0 -28 -11 -52 -20
-46 -5 3 -12 0 -16 -6 -4 -7 -3 -9 4 -5 6 3 13 2 16 -3 9 -15 -293 -1933 -309
-1964 -8 -16 -10 -25 -3 -21 8 5 9 0 5 -17 -4 -13 -7 -36 -7 -51 0 -15 -7 -33
-15 -41 -8 -9 -11 -17 -6 -19 5 -2 -4 -91 -19 -198 -51 -356 -91 -814 -110
-1280 -6 -146 -14 -284 -18 -307 -6 -36 -9 -40 -23 -30 -14 11 -15 34 -7 207
12 287 36 655 58 905 36 392 85 739 104 728 8 -4 8 -3 0 6 -7 8 4 99 38 314
75 474 288 1835 288 1841 0 3 9 6 20 6 13 0 20 -7 20 -19z m5142 -38 c24 -21
25 -128 2 -161 -40 -57 -89 -5 -82 87 6 85 37 113 80 74z m1696 -17 c50 -26
102 -101 102 -146 0 -20 -1 -20 -25 -4 -14 9 -25 22 -25 30 0 7 -14 29 -31 48
-44 51 -138 67 -231 40 -39 -11 -38 -45 8 -591 42 -504 45 -530 70 -580 40
-81 132 -124 193 -91 79 41 83 125 37 698 -19 239 -33 436 -32 438 2 1 12 -5
23 -15 19 -17 23 -53 53 -456 35 -467 35 -569 4 -632 -30 -60 -64 -80 -139
-80 -84 0 -137 36 -177 115 -26 53 -28 74 -73 602 -44 517 -45 549 -30 582 9
19 26 37 38 41 12 5 31 12 42 16 29 12 161 2 193 -15z m-1410 -69 c18 -22 25
-90 13 -135 -9 -31 -18 -43 -36 -48 -35 -9 -53 10 -61 61 -11 75 13 135 55
135 10 0 23 -6 29 -13z m-110 -62 c7 -14 12 -43 12 -65 0 -82 -39 -125 -81
-91 -19 15 -22 27 -22 78 1 76 15 103 52 103 20 0 31 -7 39 -25z m-126 -42
c13 -12 18 -30 18 -69 0 -63 -15 -101 -43 -110 -34 -11 -57 28 -57 95 0 86 37
125 82 84z m-128 -39 c21 -8 39 -77 31 -117 -25 -118 -113 -94 -103 28 3 34
12 62 23 75 20 22 25 23 49 14z m-1285 -43 c15 -10 25 -87 76 -626 49 -521
125 -1521 125 -1642 0 -40 -2 -43 -19 -34 -15 9 -19 27 -25 113 -4 57 -18 266
-32 466 -25 353 -26 364 -8 378 18 14 18 14 0 12 -19 -3 -21 12 -43 272 -23
273 -88 946 -99 1028 -6 42 -1 49 25 33z m1699 -26 c15 -33 15 -107 0 -139
-19 -44 -70 -45 -84 -3 -12 37 -6 118 11 143 21 32 58 32 73 -1z m-1618 -29
c0 -1 15 -155 34 -342 19 -186 45 -462 57 -611 23 -270 23 -273 3 -288 -19
-16 -19 -16 2 -10 20 5 21 1 27 -87 4 -51 18 -257 32 -458 13 -201 27 -399 30
-440 l5 -75 -23 25 c-21 24 -23 41 -40 305 -36 566 -98 1311 -150 1801 l-22
211 22 -14 c13 -9 23 -16 23 -17z m1494 -2 c11 -11 16 -34 16 -77 0 -68 -18
-107 -50 -107 -34 0 -50 28 -50 86 0 92 42 141 84 98z m-126 -42 c19 -12 33
-72 26 -112 -21 -121 -112 -99 -102 25 6 73 39 110 76 87z m563 -630 c15 -334
26 -608 25 -609 -1 -2 -11 3 -21 11 -18 13 -21 54 -46 602 -23 528 -24 590
-11 601 9 7 18 11 21 8 2 -3 17 -279 32 -613z m-663 558 c17 -33 9 -126 -14
-151 -41 -46 -88 2 -81 83 7 89 63 128 95 68z m-118 -56 c14 -36 12 -89 -4
-128 -13 -31 -13 -33 4 -29 11 3 24 -4 34 -18 36 -52 6 -174 -44 -174 -49 0
-62 83 -25 168 5 13 2 17 -13 17 -32 0 -46 28 -46 86 1 65 24 104 59 104 18 0
28 -8 35 -26z m511 5 c9 -17 8 -25 -5 -38 -15 -14 -18 -14 -26 -1 -7 11 -11 9
-19 -11 -5 -15 -17 -29 -25 -32 -13 -5 -16 1 -16 26 0 66 64 105 91 56z m-121
-38 c16 -32 12 -69 -10 -81 -18 -10 -20 -8 -21 27 0 30 -2 34 -9 18 -5 -11 -9
-32 -9 -47 -1 -17 -9 -32 -22 -39 -21 -11 -21 -10 -17 49 2 33 10 67 17 76 18
22 58 20 71 -3z m128 -51 c-7 -75 -47 -110 -82 -74 -22 21 -20 57 4 72 18 11
20 10 20 -15 0 -22 2 -25 10 -13 5 8 10 24 10 34 0 16 25 44 39 46 2 0 1 -23
-1 -50z m-260 22 c17 -11 33 -72 25 -97 -6 -19 -31 -44 -45 -45 -4 0 -3 14 2
31 10 35 2 69 -11 47 -12 -18 -11 -75 1 -83 5 -3 19 -1 30 5 24 13 26 3 4 -28
-19 -27 -60 -29 -74 -3 -23 43 -7 143 27 169 20 14 24 14 41 4z m-112 -56 c26
-19 27 -120 1 -160 -26 -39 -68 -33 -80 11 -13 43 0 120 24 144 23 23 29 23
55 5z m-849 -4 c7 -5 16 -114 25 -347 13 -306 12 -341 -2 -352 -8 -6 -17 -9
-20 -7 -4 5 -28 525 -29 647 -1 66 3 74 26 59z m1099 -37 c-7 -28 -32 -55 -51
-55 -7 0 -21 7 -30 17 -16 15 -16 17 2 27 10 5 18 8 18 6 0 -2 13 9 30 24 31
29 41 22 31 -19z m143 -29 c17 -20 16 -119 -1 -153 -15 -33 -49 -41 -72 -18
-20 21 -21 103 -2 150 11 26 21 35 39 35 14 0 30 -6 36 -14z m-111 -56 c8 -16
11 -43 8 -74 -10 -88 -57 -124 -92 -71 -21 33 -14 128 12 156 23 26 55 21 72
-11z m-124 -32 c36 -51 5 -173 -44 -173 -35 0 -52 38 -46 99 9 86 55 124 90
74z m-114 -47 c29 -55 -4 -175 -48 -177 -26 -1 -46 28 -39 57 3 10 1 16 -4 13
-14 -8 1 77 17 104 18 28 59 29 74 3z m-126 -37 c22 -21 23 -129 1 -121 -8 4
-17 1 -21 -5 -4 -6 -3 -8 4 -4 19 12 24 -15 6 -35 -20 -22 -47 -25 -63 -6 -13
17 -2 31 13 17 7 -5 17 -5 26 2 12 8 12 9 -2 4 -10 -3 -20 -1 -23 5 -4 5 -11
6 -17 3 -7 -5 -9 13 -6 54 6 86 44 125 82 86z m11576 -9 c0 -2 -46 -39 -102
-81 -260 -196 -455 -362 -665 -567 l-151 -148 -81 53 c-44 29 -81 56 -81 60 0
18 489 353 705 483 110 66 358 205 368 205 4 0 7 -2 7 -5z m-11182 -75 c15
-29 8 -100 -14 -142 -16 -31 -53 -38 -74 -13 -17 21 -7 128 15 161 20 32 54
29 73 -6z m-623 -30 c9 -27 -3 -44 -20 -30 -10 8 -19 8 -34 1 -26 -14 -31 -14
-31 4 0 8 7 15 15 15 8 0 15 7 15 15 0 23 47 19 55 -5z m506 -7 c12 -32 5
-102 -14 -142 -16 -35 -61 -41 -78 -10 -15 29 -6 122 16 155 22 34 62 32 76
-3z m-129 -30 c51 -46 -6 -213 -63 -182 -38 20 -34 135 7 176 28 27 32 28 56
6z m-376 -6 c15 6 17 -8 8 -44 -4 -13 -10 -21 -14 -18 -5 3 -12 0 -16 -6 -5
-8 -3 -9 6 -4 10 6 11 2 7 -17 -5 -20 -3 -27 13 -31 31 -8 44 -53 31 -112 -7
-27 -19 -57 -27 -66 -15 -16 -14 -17 3 -13 33 8 48 -12 48 -63 -1 -68 -12
-100 -40 -119 -24 -16 -27 -15 -45 1 -24 21 -26 81 -6 138 8 20 10 37 6 37
-40 0 -53 99 -22 161 17 33 17 36 2 32 -28 -8 -50 24 -50 73 0 24 4 44 9 44 5
0 17 3 26 6 13 5 15 2 9 -22 -4 -16 -11 -32 -16 -35 -5 -3 -2 -9 7 -12 18 -7
27 10 29 54 1 16 5 24 10 19 5 -5 15 -6 22 -3z m80 -12 c17 17 44 20 44 5 0
-19 -23 -59 -38 -65 -8 -3 -22 0 -30 7 -13 11 -15 11 -8 -2 4 -8 0 -6 -8 4
-21 26 -22 67 -1 60 9 -4 16 0 16 7 1 8 4 4 6 -9 4 -20 6 -20 19 -7z m182 -27
c16 -16 15 -101 -2 -142 -17 -41 -51 -55 -74 -32 -22 21 -20 111 2 154 17 34
51 43 74 20z m-110 -119 c-4 -71 -24 -109 -58 -109 -28 0 -40 22 -40 77 0 64
21 110 52 115 41 7 50 -10 46 -83z m478 47 c15 -12 19 -26 18 -76 -1 -64 -24
-112 -56 -118 -58 -11 -66 130 -11 190 19 22 24 22 49 4z m-112 -48 c17 -24
20 -56 10 -106 -5 -27 -9 -30 -25 -21 -15 8 -18 18 -14 57 l5 47 -17 -37 c-15
-30 -21 -35 -35 -27 -13 7 -15 15 -8 40 11 36 37 69 56 69 7 0 20 -10 28 -22z
m-120 -34 c19 -19 21 -34 4 -34 -9 0 -9 -3 1 -9 23 -15 7 -101 -25 -129 -51
-44 -88 19 -64 109 19 72 52 96 84 63z m-110 -50 c11 -28 6 -104 -8 -139 -12
-29 -20 -35 -44 -35 -35 0 -42 13 -42 81 0 68 22 109 59 109 17 0 31 -6 35
-16z m168 -27 c7 -8 24 -19 37 -26 22 -12 22 -13 5 -32 -9 -10 -21 -19 -26
-19 -17 0 -48 41 -48 65 0 28 12 32 32 12z m-286 -8 c12 -21 6 -116 -10 -148
-13 -24 -23 -31 -46 -31 -23 0 -31 5 -36 26 -10 41 2 122 21 144 20 22 60 27
71 9z m-636 -833 c16 -401 27 -732 25 -735 -3 -3 -13 2 -21 11 -13 13 -20 125
-46 758 -30 729 -31 743 -12 757 23 17 17 112 54 -791z m1118 792 c7 -7 12
-27 12 -45 0 -36 0 -36 -60 4 -24 17 -25 17 -9 -2 11 -14 14 -28 8 -45 -10
-36 -10 -52 0 -45 5 3 12 19 16 35 6 26 9 29 27 19 22 -12 19 -45 -8 -87 -24
-36 -66 -27 -81 18 -10 30 -12 32 -12 10 -1 -14 -10 -40 -21 -58 -16 -27 -26
-33 -48 -30 -26 3 -27 6 -30 63 -3 80 20 130 62 130 24 0 31 -6 41 -35 l12
-34 6 34 c14 67 54 99 85 68z m3196 -62 c10 -69 74 -696 102 -1003 27 -289 27
-293 8 -314 -19 -22 -19 -22 2 -11 20 11 21 8 38 -213 29 -378 54 -730 52
-732 -1 -2 -12 4 -24 13 -17 12 -22 25 -22 62 0 164 -116 1471 -180 2039 -26
222 -26 227 -1 211 12 -7 22 -28 25 -52z m6944 -218 c42 -28 79 -52 81 -54 2
-2 -44 -54 -102 -116 -345 -370 -662 -811 -898 -1248 -45 -85 -88 -158 -94
-162 -5 -4 -16 -6 -23 -3 -7 3 -10 0 -7 -6 4 -6 13 -8 19 -6 7 3 -20 -69 -60
-159 -68 -151 -153 -371 -169 -437 l-7 -27 63 0 c150 0 1310 -49 1321 -56 7
-4 57 -36 111 -72 54 -35 100 -63 102 -61 2 3 -42 35 -98 72 -77 50 -96 67
-77 67 14 0 248 -10 520 -21 272 -11 504 -21 515 -21 16 0 2074 -76 2500 -93
66 -2 1092 -40 2280 -85 1188 -44 2192 -84 2230 -89 44 -5 -167 -9 -574 -9
-607 -1 -642 -1 -630 16 13 16 12 16 -7 -1 -20 -16 -111 -17 -1653 -17 -1549
0 -1633 1 -1620 18 13 16 12 16 -7 -1 -20 -16 -107 -17 -1587 -17 -862 0
-1594 3 -1627 7 -40 4 -57 9 -53 17 4 6 0 5 -9 -2 -12 -9 -291 -12 -1346 -10
l-1330 3 53 115 c52 112 55 116 117 157 332 219 730 485 717 481 -8 -3 -183
-117 -388 -252 -205 -136 -375 -246 -376 -244 -2 2 28 62 67 133 421 783 1024
1490 1807 2117 80 65 150 118 154 118 4 0 43 -23 85 -52z m-9818 -53 c1 -22 9
-215 19 -430 16 -328 16 -392 5 -404 -7 -8 -17 -12 -20 -8 -6 6 -42 714 -44
850 0 55 1 57 20 45 14 -9 20 -24 20 -53z m-10123 -164 c26 -22 62 -51 78 -65
l30 -26 -40 5 c-22 3 -121 12 -220 21 -99 8 -181 17 -183 18 -3 4 155 72 183
79 64 15 103 7 152 -32z m14500 -254 c6 -150 10 -273 9 -274 -1 -2 -11 3 -21
11 -17 12 -20 39 -29 269 -10 224 -9 256 4 265 8 5 17 8 20 5 3 -3 10 -127 17
-276z m-4911 191 l8 -33 3 38 c4 33 7 37 31 37 98 -1 223 -76 256 -154 8 -20
19 -36 24 -36 15 0 35 -52 44 -115 35 -241 33 -456 -3 -475 -16 -9 -19 -7 -20
17 -2 35 0 62 6 90 4 17 0 22 -17 25 -52 7 -79 137 -37 179 11 11 27 18 36 15
12 -5 14 0 9 31 -3 21 -9 69 -15 108 -6 51 -14 74 -30 86 -12 10 -28 32 -36
51 l-14 33 -1 -38 c0 -51 -15 -77 -45 -77 -33 0 -57 39 -63 101 -4 39 -1 54
14 71 19 21 19 21 -5 15 -16 -4 -36 1 -58 14 l-33 21 0 -24 c0 -66 -62 -76
-92 -16 l-17 33 0 -47 c-2 -103 -76 -105 -102 -2 -6 24 -15 44 -21 44 -5 0 -4
-8 2 -19 18 -34 12 -109 -10 -131 -17 -17 -24 -18 -41 -9 -27 14 -52 74 -47
116 4 33 3 33 -37 33 -29 0 -44 -5 -53 -20 -14 -24 -45 -26 -62 -5 -19 23 -30
18 -30 -14 0 -74 -68 -91 -96 -25 -8 19 -15 34 -17 34 -1 0 -2 -29 -2 -65 0
-61 1 -65 23 -65 31 0 56 -59 49 -117 -6 -52 -21 -73 -54 -73 -34 0 -57 58
-50 123 4 28 2 45 -3 42 -18 -11 -50 15 -58 48 -8 28 -10 23 -13 -41 -4 -68
-3 -72 17 -72 29 0 43 -19 50 -71 11 -82 -32 -137 -78 -100 -20 17 -23 28 -23
85 0 55 -3 66 -17 66 -24 0 -34 -55 -14 -75 20 -20 30 -76 22 -120 -6 -28 -4
-34 8 -29 29 11 56 -32 56 -89 0 -68 -21 -101 -62 -95 -28 4 -29 3 -23 -26 4
-17 13 -46 22 -65 11 -24 14 -51 10 -87 -4 -38 -2 -52 6 -48 41 15 72 -76 47
-140 -8 -22 -7 -26 10 -26 36 0 51 -28 49 -91 -2 -65 -20 -99 -49 -99 -38 0
-65 70 -37 99 10 11 9 12 -2 6 -11 -6 -12 -1 -7 29 6 32 5 36 -15 36 -19 0
-21 -4 -16 -30 4 -16 9 -59 13 -95 6 -57 5 -65 -9 -59 -14 5 -14 2 -4 -20 7
-14 20 -26 29 -26 10 0 22 -9 28 -19 13 -26 13 -107 -1 -133 -10 -18 -9 -20 5
-15 10 4 24 -1 36 -13 22 -22 27 -90 10 -134 -8 -22 -7 -26 10 -26 46 0 65
-85 32 -150 -21 -44 -59 -48 -80 -10 -14 28 -10 114 7 134 8 10 3 13 -20 13
-30 0 -31 -1 -24 -41 4 -23 8 -74 8 -113 0 -62 3 -74 19 -79 10 -3 21 -17 24
-30 7 -27 1 -98 -11 -126 -5 -14 -2 -18 14 -18 40 0 55 -78 27 -145 -14 -33
-14 -35 3 -35 33 0 44 -26 39 -90 -5 -69 -29 -104 -65 -97 -22 4 -23 2 -23
-72 0 -42 5 -107 11 -146 7 -38 11 -77 11 -85 0 -8 -2 -37 -3 -63 -1 -26 3
-53 9 -59 7 -7 12 -35 13 -62 l1 -51 9 45 c19 96 48 132 90 109 19 -10 21 -18
17 -70 -5 -71 -32 -114 -71 -114 -22 1 -24 -2 -15 -18 9 -17 11 -17 27 -3 41
37 74 9 70 -58 -2 -25 0 -48 4 -52 4 -4 7 13 7 37 0 48 25 106 52 123 23 14
47 -9 58 -55 l8 -34 1 30 c1 17 10 45 21 63 16 27 26 33 48 30 25 -3 27 -6 30
-60 3 -66 -18 -124 -49 -133 -24 -8 -49 11 -49 36 0 32 -17 30 -24 -3 -3 -17
-14 -40 -22 -50 -18 -19 -17 -20 35 -32 18 -3 29 2 43 20 24 30 51 31 70 2 14
-21 14 -21 36 16 18 31 27 37 50 34 22 -2 28 -9 32 -38 l5 -35 19 48 c21 55
55 79 81 57 21 -17 19 -67 -2 -79 -12 -7 -13 -10 -5 -11 8 0 27 10 44 21 l30
22 -7 -32 c-9 -43 1 -39 16 7 11 35 33 59 53 60 5 0 12 5 15 10 3 5 26 21 49
36 24 15 41 30 37 34 -3 4 -9 2 -13 -3 -9 -13 -53 -37 -58 -33 -2 2 4 14 12
27 11 15 24 21 42 19 22 -2 28 -9 32 -38 l5 -35 13 42 c7 25 24 50 41 63 27
18 31 19 45 4 9 -8 16 -23 16 -32 0 -9 9 2 19 25 22 48 55 71 76 53 12 -10 16
-5 21 29 4 26 14 46 25 52 17 9 19 6 19 -28 -1 -21 -9 -61 -18 -90 -20 -55
-118 -213 -134 -213 -5 0 -6 5 -3 11 4 6 -12 1 -35 -11 -47 -24 -163 -40 -294
-40 -77 0 -87 2 -82 16 3 9 9 28 12 42 l5 27 -15 -25 c-8 -14 -15 -35 -16 -47
0 -20 -5 -23 -45 -23 -42 0 -45 2 -46 28 l-1 27 -11 -27 c-10 -25 -16 -28 -54
-28 -34 0 -43 4 -44 18 0 13 -3 12 -11 -5 -6 -13 -20 -23 -32 -23 -39 0 -135
29 -171 52 -35 22 -36 24 -30 73 l5 50 -18 -39 -18 -40 -26 35 c-43 56 -68
116 -68 159 0 22 -4 40 -9 40 -12 0 -21 91 -12 132 5 19 4 43 -1 51 -5 9 -16
162 -24 341 l-16 324 21 21 c14 14 21 33 21 59 -1 35 -2 36 -15 18 -8 -11 -15
-24 -15 -29 0 -4 -5 -5 -11 -1 -8 5 -10 37 -6 110 4 57 3 105 -2 108 -7 5 -18
191 -27 481 -2 55 -7 165 -12 245 -7 116 -6 149 5 165 18 27 17 82 -3 93 -20
11 -36 302 -17 309 15 6 26 57 18 83 -4 13 -12 19 -21 16 -20 -8 -19 66 2 149
17 69 30 81 40 40 12 -49 27 -27 20 31 l-6 55 47 50 c31 32 66 56 99 69 l52
19 6 -39 c9 -59 30 -64 24 -6 -5 39 -3 46 12 46 10 0 32 3 49 6 26 5 31 3 31
-12 1 -18 2 -18 13 -2 11 14 43 18 193 25 98 5 182 7 185 6 4 -1 10 -17 15
-35z m-300 -59 c27 -30 27 -144 1 -164 -29 -21 -60 -4 -75 41 -32 94 21 182
74 123z m393 -19 c29 -15 46 -93 32 -140 -10 -35 -16 -40 -41 -40 -37 0 -60
40 -60 105 0 75 23 100 69 75z m-504 -50 c28 -31 32 -119 8 -149 -15 -19 -25
-23 -46 -17 -20 5 -29 16 -38 48 -26 98 24 176 76 118z m391 2 c33 -21 48
-144 22 -170 -22 -22 -57 -14 -73 18 -18 35 -20 131 -3 148 13 13 37 15 54 4z
m-109 -50 c33 -21 45 -138 17 -166 -42 -42 -88 4 -88 89 -1 70 30 103 71 77z
m-102 -62 c26 -28 32 -113 11 -145 -25 -38 -63 -34 -82 10 -40 96 14 198 71
135z m505 10 c40 -21 54 -131 21 -171 -16 -20 -22 -22 -44 -12 -43 20 -62 127
-31 171 17 24 27 27 54 12z m-94 -55 c21 -32 24 -126 5 -149 -22 -26 -58 -20
-76 14 -17 33 -20 112 -5 141 15 28 56 24 76 -6z m-517 -24 c47 -87 -4 -211
-62 -152 -31 31 -37 131 -9 159 23 23 57 20 71 -7z m408 -31 c18 -36 17 -125
-3 -144 -23 -23 -51 -20 -70 8 -20 31 -23 128 -4 151 19 23 62 15 77 -15z
m-521 -35 c19 -29 22 -112 4 -144 -16 -30 -60 -25 -77 9 -19 37 -16 120 4 142
23 25 50 23 69 -7z m393 6 c35 -35 39 -144 6 -171 -57 -47 -119 116 -65 170
25 25 35 25 59 1z m-105 -53 c19 -27 22 -138 4 -156 -19 -19 -55 -14 -72 10
-18 26 -22 119 -6 149 14 26 55 24 74 -3z m-400 -30 c10 -13 16 -43 16 -73 0
-56 -20 -95 -50 -95 -30 0 -50 39 -50 99 0 82 48 121 84 69z m-5165 -45 c-40
-296 -82 -791 -99 -1178 -15 -340 -17 -357 -39 -345 -15 8 -18 20 -15 82 2 40
9 172 14 293 14 298 45 694 75 959 20 179 28 221 42 232 28 21 30 17 22 -43z
m-3175 -59 l87 -81 -248 -5 c-136 -3 -249 -5 -251 -3 -1 1 64 45 145 97 121
78 151 93 164 84 9 -6 55 -47 103 -92z m9140 90 c21 -21 28 -51 24 -109 -2
-36 -8 -51 -25 -62 -20 -14 -24 -13 -48 11 -21 22 -25 34 -25 89 0 36 5 68 12
75 17 17 44 15 62 -4z m-528 -2 c39 -25 48 -138 14 -172 -23 -23 -30 -24 -54
-7 -21 15 -39 88 -30 125 12 48 43 72 70 54z m5201 -10 c19 -12 84 -1532 67
-1551 -8 -8 -17 -11 -21 -7 -6 6 -71 1360 -72 1519 -1 47 3 53 26 39z m-4797
-22 c21 -11 40 -60 40 -104 -1 -82 -60 -111 -93 -46 -23 45 -18 127 9 147 21
16 21 16 44 3z m-501 -44 c19 -22 24 -117 9 -146 -17 -32 -49 -36 -74 -9 -23
26 -27 126 -5 152 17 21 54 22 70 3z m396 -10 c28 -20 35 -139 10 -166 -24
-27 -40 -25 -64 6 -15 20 -21 41 -21 81 0 85 27 114 75 79z m-99 -71 c40 -97
-14 -198 -72 -134 -23 25 -26 127 -5 152 24 30 60 21 77 -18z m-405 3 c19 -35
15 -125 -7 -149 -23 -26 -55 -21 -71 11 -18 35 -16 111 3 138 20 29 60 29 75
0z m3289 7 c0 -3 -117 -64 -261 -135 -176 -89 -267 -129 -280 -125 -10 4 -19
10 -19 14 0 6 533 248 553 250 4 1 7 -1 7 -4z m-2220 -37 c0 -55 40 -911 43
-913 1 -1 362 157 801 351 732 323 801 352 820 339 18 -14 -42 -45 -797 -420
l-817 -406 0 -102 c0 -56 4 -107 8 -114 5 -8 389 178 1276 618 698 346 1271
628 1273 625 6 -6 42 15 -1222 -696 -638 -359 -1172 -659 -1187 -668 -26 -15
-29 -14 -116 43 l-89 59 -7 81 c-3 44 -6 184 -6 310 0 127 -5 380 -10 564 -10
330 -8 361 21 361 5 0 9 -15 9 -32z m-796 -1 c37 -27 41 -140 5 -172 -23 -22
-57 -11 -70 22 -17 45 -11 121 11 143 23 23 30 24 54 7z m543 -38 c13 -37 8
-116 -9 -136 -15 -19 -42 -16 -63 7 -12 14 -20 41 -23 79 -4 50 -1 62 17 80
28 28 62 15 78 -30z m-1615 -125 c3 -60 16 -307 29 -548 22 -430 22 -439 3
-453 -10 -7 -20 -10 -21 -6 -1 4 -7 116 -13 248 -15 334 -39 779 -45 844 l-6
54 23 -15 c21 -14 24 -26 30 -124z m689 109 c6 -16 9 -54 7 -85 -4 -55 -3 -58
19 -58 33 0 46 -33 40 -107 -4 -55 -3 -63 13 -63 10 0 23 -7 30 -15 17 -21 24
-89 12 -124 -10 -27 -9 -31 7 -31 22 0 44 -23 33 -35 -4 -5 -1 -5 6 -1 9 5 12
-7 12 -51 0 -64 -19 -103 -50 -103 -21 0 -50 25 -50 45 0 16 37 26 45 11 3 -8
7 -8 11 2 3 6 11 9 17 6 8 -5 8 -2 0 7 -7 7 -13 26 -13 43 0 35 -17 24 -22
-14 -2 -14 -10 -25 -18 -25 -19 0 -25 56 -10 86 8 15 9 19 1 15 -21 -14 -50 5
-62 41 -11 34 -9 78 6 116 5 13 3 16 -8 11 -9 -3 -25 4 -37 16 -19 19 -22 31
-18 90 3 58 1 66 -13 63 -43 -11 -68 115 -33 165 22 32 62 29 75 -5z m794 7
c12 -13 20 -42 23 -77 4 -50 2 -58 -19 -75 -13 -11 -18 -16 -10 -12 8 4 12 3
8 -3 -7 -11 -36 -11 -54 0 -19 12 -35 86 -28 123 6 36 28 64 49 64 7 0 21 -9
31 -20z m-505 -46 c15 -38 12 -107 -6 -132 -37 -54 -88 -5 -88 86 0 45 4 58
23 73 28 23 57 12 71 -27z m-932 3 c11 -12 28 -267 53 -781 11 -230 11 -240
-7 -253 -22 -16 -19 -47 -49 537 -8 168 -18 351 -22 408 -6 101 0 120 25 89z
m1326 -9 c24 -34 22 -140 -3 -162 -42 -38 -81 7 -81 92 0 53 21 92 50 92 10 0
26 -10 34 -22z m320 -3 c3 -8 8 -87 12 -175 7 -149 6 -160 -10 -154 -15 6 -17
0 -14 -47 2 -43 6 -53 19 -51 18 2 22 -45 35 -382 6 -135 5 -168 -6 -161 -18
11 -30 -13 -30 -64 0 -43 0 -44 -20 -26 -12 11 -20 31 -20 51 0 36 18 84 32
84 4 0 8 4 8 8 0 5 -13 7 -28 4 -40 -6 -55 18 -55 88 0 67 21 110 55 110 21 0
21 2 14 115 -5 96 -9 118 -26 135 -26 26 -28 133 -4 168 15 22 15 23 -8 17
-35 -9 -58 22 -65 89 -7 70 14 111 54 103 25 -5 25 -4 20 43 -4 33 -2 50 6 54
20 8 25 7 31 -9z m-833 -37 c14 -26 17 -92 6 -130 -6 -22 -4 -26 7 -22 8 3 24
-4 35 -15 16 -16 21 -34 21 -79 0 -63 -19 -102 -50 -102 -35 0 -53 43 -48 115
4 58 2 64 -16 67 -11 2 -26 14 -34 28 -16 30 -11 122 7 144 19 23 58 20 72 -6z
m405 -23 c30 -73 11 -155 -37 -155 -37 0 -53 30 -53 101 -1 63 14 89 51 89 18
0 28 -9 39 -35z m-122 -37 c18 -26 22 -119 6 -149 -14 -26 -55 -24 -74 3 -18
26 -22 119 -6 149 14 26 55 24 74 -3z m413 -58 c15 -30 17 -99 3 -134 -13 -35
-64 -37 -81 -4 -17 31 -16 133 1 153 19 23 62 15 77 -15z m-520 -10 c7 -14 13
-43 13 -65 0 -56 -19 -89 -53 -93 -24 -3 -30 2 -43 35 -18 42 -14 113 6 139
19 22 62 14 77 -16z m397 -22 c22 -31 22 -141 0 -163 -23 -22 -56 -15 -71 15
-7 14 -13 48 -13 77 0 44 4 55 26 72 33 26 39 26 58 -1z m-1010 -147 c17 -294
19 -451 6 -466 -7 -8 -16 -15 -20 -15 -4 0 -10 82 -14 183 -3 100 -9 238 -13
306 -6 122 -6 123 14 110 18 -11 21 -26 27 -118z m876 114 c0 -2 -12 -11 -27
-19 -16 -8 -22 -15 -15 -16 7 0 23 7 36 16 23 15 24 14 36 -22 25 -74 -15
-175 -58 -148 -30 19 -43 56 -39 111 4 57 19 83 48 83 11 0 19 -2 19 -5z
m-114 -43 c35 -23 47 -129 18 -170 -37 -53 -84 -10 -84 78 0 75 30 117 66 92z
m-101 -72 c33 -36 22 -150 -15 -170 -47 -25 -79 34 -67 121 9 68 45 89 82 49z
m515 0 c16 -16 20 -33 20 -81 0 -72 -12 -99 -45 -99 -36 0 -55 35 -55 102 0
45 5 63 20 78 11 11 25 20 30 20 6 0 19 -9 30 -20z m-103 -67 c16 -41 12 -115
-9 -140 -17 -21 -61 -12 -76 17 -16 30 -11 122 7 144 8 9 24 16 38 16 18 0 28
-9 40 -37z m-519 -6 c16 -33 10 -46 -13 -27 -8 7 -15 9 -15 4 0 -5 -4 -3 -9 5
-7 10 -11 5 -16 -17 -8 -39 3 -82 16 -61 5 8 9 26 9 42 0 25 2 26 20 15 12 -8
20 -23 19 -38 -1 -43 -12 -57 -42 -56 -16 1 -31 -3 -34 -8 -3 -5 -1 -6 5 -2 6
3 13 2 17 -4 3 -5 -1 -10 -10 -10 -17 0 -45 56 -45 90 0 12 7 20 18 21 15 0
15 1 0 7 -15 6 -15 10 -2 40 11 28 18 33 41 30 19 -2 32 -12 41 -31z m398 -29
c20 -39 15 -131 -9 -155 -27 -28 -65 -9 -77 39 -28 103 43 200 86 116z m-116
-44 c13 -33 13 -120 0 -145 -16 -29 -64 -25 -78 6 -15 32 -16 120 -2 146 16
30 68 26 80 -7z m-522 -36 c18 -18 15 -28 -8 -28 -25 0 -44 -44 -34 -80 6 -20
8 -21 11 -7 3 9 8 15 13 12 5 -3 5 9 -1 27 -5 18 -9 33 -9 34 0 1 12 2 26 2
25 0 26 -2 21 -47 -2 -25 -8 -54 -12 -63 -5 -14 -2 -18 13 -18 31 0 46 -28 46
-85 0 -92 -58 -139 -92 -75 -13 25 -11 98 3 132 5 12 1 17 -16 20 -32 4 -51
44 -46 95 8 74 51 115 85 81z m402 -3 c7 -9 10 -18 7 -22 -4 -3 -2 -12 4 -20
7 -8 9 -29 5 -54 -10 -61 -22 -79 -56 -79 -24 0 -30 6 -40 36 -12 34 -9 118 4
131 3 3 12 0 21 -7 11 -9 13 -23 9 -50 -3 -21 -2 -46 4 -55 8 -15 10 -12 16
17 3 20 3 43 0 53 -6 14 -4 16 7 11 8 -4 2 2 -13 14 -16 12 -28 26 -28 31 0
15 47 10 60 -6z m504 -1 c39 -15 43 -145 6 -179 -44 -40 -83 8 -77 97 4 76 25
100 71 82z m-642 -44 c52 0 50 -169 -2 -185 -30 -9 -49 6 -60 46 -10 36 -5
101 9 124 3 6 6 13 7 18 1 4 2 10 3 14 0 4 6 2 13 -5 7 -7 20 -12 30 -12z
m525 2 c52 -33 36 -192 -20 -192 -38 0 -52 26 -52 95 0 80 32 123 72 97z
m-11946 -35 c64 -31 102 -79 118 -147 10 -42 32 -285 47 -517 5 -78 4 -103 -5
-103 -8 0 -7 -5 3 -16 11 -11 16 -34 16 -77 0 -34 2 -80 5 -102 2 -22 -3 -7
-11 33 -11 48 -21 72 -31 72 -16 0 -523 -77 -567 -86 -22 -5 -27 -3 -20 7 7
12 5 12 -9 1 -13 -11 -741 -132 -793 -132 -29 0 79 341 153 480 80 152 158
236 264 284 116 53 393 121 734 181 194 33 184 29 149 66 -64 68 -158 87 -339
70 -66 -6 -196 -18 -288 -27 -192 -17 -329 -48 -420 -96 -74 -39 -165 -127
-191 -186 -10 -23 -23 -42 -28 -42 -5 0 5 27 23 61 82 153 264 244 542 270 62
6 164 17 227 24 63 8 171 13 240 12 114 -2 130 -4 181 -30z m11847 -32 c20
-43 15 -119 -9 -149 -24 -31 -40 -33 -63 -7 -21 23 -25 125 -7 160 17 31 64
28 79 -4z m-518 -4 c16 -30 12 -123 -6 -149 -20 -28 -60 -29 -75 -1 -14 27 -7
132 10 153 18 22 58 20 71 -3z m392 -28 c14 -12 18 -31 18 -78 0 -69 -5 -79
-29 -64 -12 8 -15 23 -13 62 5 63 -14 54 -20 -10 -3 -36 0 -43 20 -53 28 -12
25 -34 -5 -38 -32 -5 -53 34 -53 98 0 85 37 124 82 83z m-111 -49 c14 -17 18
-94 6 -136 -17 -62 -81 -56 -93 8 -8 44 0 110 16 129 16 20 54 19 71 -1z
m-113 -64 c18 -35 9 -128 -16 -153 -44 -44 -91 25 -76 111 13 71 64 95 92 42z
m506 -2 c10 -14 16 -44 16 -78 0 -65 -20 -100 -55 -100 -33 0 -45 27 -45 97 0
64 19 103 50 103 10 0 26 -10 34 -22z m-630 -40 c19 -26 21 -110 5 -141 -21
-40 -47 -47 -73 -21 -25 24 -22 138 4 164 26 26 45 25 64 -2z m524 -57 c3 -50
2 -52 -17 -41 -14 7 -21 21 -21 43 -1 30 -1 31 -13 10 -9 -17 -16 -19 -29 -12
-24 13 -23 25 7 55 24 24 28 25 48 11 17 -11 23 -26 25 -66z m-1034 37 c4 -19
158 -3807 156 -3845 -1 -34 242 5 435 69 269 90 501 247 642 432 56 75 127
220 148 303 9 35 21 158 28 278 l12 217 82 -54 c82 -53 82 -53 84 -98 0 -25 6
-162 13 -305 7 -143 12 -261 12 -261 -1 -1 -176 -118 -391 -259 -214 -142
-394 -262 -400 -267 -23 -24 53 25 402 255 202 134 374 247 382 252 11 6 12
-15 10 -122 -4 -125 -5 -132 -40 -201 -19 -40 -34 -72 -33 -72 2 0 128 14 281
30 152 17 281 30 286 30 4 0 5 132 1 294 l-6 293 31 5 c38 6 41 3 41 -39 0
-24 -5 -33 -17 -34 -16 -1 -16 -2 -2 -6 15 -3 18 -29 24 -186 3 -100 5 -229 3
-287 l-3 -105 -355 -37 -355 -38 -66 -35 c-36 -19 -88 -39 -115 -44 -27 -6
-294 -22 -594 -36 -300 -15 -619 -34 -710 -44 -91 -10 -167 -16 -169 -15 -7 7
-14 264 -7 264 4 0 20 -10 36 -22 24 -17 30 -30 30 -57 0 -20 3 -52 6 -72 l6
-35 109 12 c60 6 112 14 115 16 6 6 -94 2459 -100 2466 -7 6 -186 -98 -186
-108 0 -10 -253 157 -258 170 -2 4 7 11 19 15 21 7 22 10 16 117 -3 61 -8 112
-10 115 -3 2 -55 -21 -116 -51 -61 -31 -115 -56 -121 -56 -5 0 -54 28 -107 63
-116 75 -123 79 -123 74 0 -2 47 -35 105 -73 57 -38 105 -72 105 -75 0 -3
-490 -249 -1088 -547 l-1089 -542 -204 35 c-112 20 -217 38 -233 41 l-28 6 28
19 c37 24 25 25 -18 0 l-33 -18 -712 121 c-392 66 -713 123 -713 126 0 3 289
88 643 189 353 102 661 190 684 197 37 11 45 11 65 -5 32 -24 98 -64 98 -58 0
2 -22 19 -50 38 -27 19 -50 36 -50 39 0 3 478 142 1063 309 584 166 1072 307
1085 312 30 12 35 11 26 -3 -4 -7 1 -5 12 4 10 9 62 29 114 44 52 14 100 29
106 31 6 2 16 -15 22 -40 7 -25 14 -52 18 -60 5 -13 -112 -75 -573 -307 -318
-160 -573 -289 -566 -288 6 2 378 165 827 363 l816 359 -1 106 c0 58 -4 179
-8 270 -7 140 -6 168 7 183 8 9 18 15 20 12 3 -3 11 -130 17 -283 7 -173 15
-270 20 -258 5 11 4 137 -2 290 -9 243 -8 272 6 283 14 10 17 6 22 -30 4 -23
10 -151 14 -284 4 -134 10 -243 12 -243 2 0 13 5 24 10 17 10 19 22 19 130 l0
120 120 0 120 0 -1 103 c-1 56 -4 170 -8 252 -6 142 -3 164 21 165 4 0 10 -10
12 -22z m907 -24 c20 -25 18 -124 -4 -158 -53 -80 -114 39 -73 139 17 39 53
48 77 19z m-503 -74 c2 -29 -1 -65 -7 -81 -9 -25 -7 -29 8 -29 31 0 45 -29 45
-86 -1 -65 -24 -104 -59 -104 -19 0 -28 8 -36 28 -11 27 -8 102 6 135 5 12 2
17 -9 17 -50 0 -63 144 -16 182 20 16 25 17 44 5 16 -11 22 -27 24 -67z m572
13 c0 -13 5 -23 10 -23 6 0 10 7 10 15 0 13 3 13 20 3 22 -14 19 -45 -8 -65
-21 -17 -29 -16 -52 7 -14 14 -20 33 -20 65 0 43 1 44 20 33 11 -7 20 -23 20
-35z m-183 7 c16 -31 17 -87 2 -129 -13 -38 -52 -52 -77 -27 -24 23 -23 123 1
160 22 34 56 32 74 -4z m-123 -42 c20 -29 21 -110 1 -148 -11 -21 -23 -30 -40
-30 -33 0 -45 27 -45 97 0 64 19 103 50 103 10 0 26 -10 34 -22z m-12758 -59
c-22 -96 -36 -242 -45 -464 l-8 -200 -1 170 c-2 187 10 347 34 470 16 81 23
100 30 92 3 -2 -2 -33 -10 -68z m13268 45 c14 -14 23 -54 12 -54 -3 0 -22 9
-43 21 -21 11 -31 15 -23 7 11 -9 15 -28 12 -68 -2 -40 0 -51 7 -40 6 8 11 30
11 48 0 35 10 41 30 17 14 -17 8 -79 -11 -101 -17 -20 -57 -17 -69 5 -5 11
-10 40 -10 65 0 93 42 143 84 100z m-632 -31 c24 -21 25 -128 2 -161 -35 -51
-84 -10 -84 71 0 86 39 129 82 90z m502 1 c41 -16 40 -145 -2 -186 -16 -16
-23 -18 -41 -9 -11 6 -24 23 -27 37 -10 39 3 124 22 145 19 21 24 22 48 13z
m256 -54 c0 -48 -1 -50 -20 -38 -23 15 -23 15 -9 57 16 46 29 38 29 -19z
m3160 2 c0 -9 7 -118 15 -242 8 -124 22 -366 30 -539 15 -283 15 -315 1 -329
-9 -9 -17 -14 -20 -11 -2 2 -12 148 -21 324 -9 176 -23 421 -30 545 -20 301
-20 293 5 280 11 -6 20 -18 20 -28z m-3510 -28 c22 -66 -8 -164 -50 -164 -34
0 -53 44 -47 104 7 73 21 96 57 96 24 0 30 -6 40 -36z m313 -13 c35 -22 38
-27 33 -55 -18 -92 -19 -126 -2 -126 13 0 16 -13 16 -82 0 -46 4 -133 9 -193
19 -223 25 -523 11 -540 -7 -8 -16 -15 -21 -15 -5 0 -9 60 -10 133 -1 102 -3
124 -10 97 -24 -87 -48 -117 -83 -104 -24 9 -31 52 -18 113 17 78 56 113 90
79 9 -9 12 7 11 73 l-1 84 -15 -55 c-16 -61 -37 -90 -64 -90 -54 0 -51 153 4
198 21 17 54 1 60 -30 3 -13 2 47 -1 132 -3 110 -9 161 -19 177 -15 22 -14 95
2 153 5 20 2 27 -17 35 -12 6 -24 18 -26 29 -4 21 -2 20 51 -13z m-433 -21
c16 -39 7 -126 -16 -151 -21 -23 -47 -24 -65 -3 -20 24 -16 126 5 158 24 37
60 35 76 -4z m-509 -17 c14 -37 4 -121 -18 -145 -22 -25 -54 -19 -71 12 -17
32 -8 116 14 141 26 29 62 24 75 -8z m389 -24 c23 -42 0 -167 -32 -170 -49 -5
-58 9 -58 89 0 54 4 67 24 87 27 27 50 25 66 -6z m487 -7 c54 -34 28 -202 -31
-202 -55 0 -62 157 -9 198 19 14 24 14 40 4z m-613 -28 c11 -10 16 -34 16 -72
0 -71 -17 -106 -52 -110 -37 -4 -51 26 -46 101 4 47 9 64 27 78 28 23 35 23
55 3z m911 -55 c41 -28 75 -55 75 -59 0 -4 -10 -12 -22 -18 -28 -13 -17 -13
328 -12 l241 1 5 -163 c3 -90 5 -164 3 -166 -2 -2 -17 -4 -35 -4 -17 -1 -26
-4 -19 -8 6 -4 19 -5 29 -3 10 3 20 1 23 -4 3 -4 10 -321 16 -703 7 -382 14
-710 17 -727 5 -31 7 -33 45 -33 l40 0 -6 163 c-8 238 -26 1041 -26 1192 1 72
-2 208 -6 303 l-6 172 144 0 144 0 -45 -30 c-25 -16 -40 -30 -34 -30 6 0 29
13 51 29 l40 29 916 -7 c504 -4 918 -9 921 -12 3 -2 9 -133 15 -289 6 -157 14
-362 17 -456 l6 -170 -27 -18 c-15 -10 -30 -15 -33 -11 -6 6 -29 592 -31 786
l-1 87 -312 6 c-172 3 -625 8 -1005 10 l-693 4 0 -122 c0 -84 -4 -126 -12
-135 -8 -8 -8 -11 -2 -8 14 8 19 -139 35 -928 6 -302 12 -556 14 -562 3 -8 24
-13 57 -13 50 0 216 -25 225 -34 4 -4 -62 -42 -185 -106 -34 -18 -61 -34 -60
-35 2 -2 32 3 68 11 283 59 627 73 910 38 269 -34 570 -135 765 -258 67 -42
28 -29 -86 29 -304 156 -577 218 -961 219 -113 1 -204 4 -201 9 6 10 -4 9 -25
-2 -9 -6 -78 -17 -152 -26 -74 -9 -182 -26 -240 -38 l-105 -22 2 -242 c3 -225
2 -243 -15 -244 -14 -1 -14 -2 -1 -6 19 -5 29 -118 29 -348 0 -82 3 -166 6
-185 l6 -36 271 27 272 27 49 -29 c27 -17 50 -28 53 -26 2 3 -13 15 -34 27
l-38 23 40 8 c22 4 333 35 690 69 358 34 661 66 674 71 l24 10 -5 540 -6 540
32 -20 31 -20 8 -358 c7 -356 1 -730 -12 -752 -7 -11 -2105 -220 -2115 -211
-2 3 -8 155 -12 339 -6 285 -5 333 7 326 8 -5 7 0 -3 12 -16 17 -18 43 -18
214 0 107 -4 200 -9 208 -7 11 -15 11 -46 1 l-38 -13 7 -163 c7 -155 6 -163
-11 -158 -17 5 -17 5 0 -6 12 -8 17 -24 17 -58 0 -48 0 -48 -35 -50 -35 -3
-35 -2 -36 40 -1 24 -5 173 -8 333 l-6 290 -45 -3 c-72 -5 -205 -30 -344 -64
l-129 -32 7 -93 c3 -51 3 -93 0 -93 -15 0 -163 106 -164 117 0 7 -6 10 -14 7
-8 -3 -17 -1 -21 5 -3 6 -11 11 -18 11 -8 0 -8 -3 1 -12 9 -9 -15 -23 -104
-59 -63 -26 -180 -82 -259 -123 -80 -42 -145 -73 -145 -70 0 11 129 154 210
232 l75 74 -70 -35 c-124 -61 -341 -214 -502 -352 -24 -20 -43 -33 -43 -29 0
14 82 148 126 205 62 81 178 195 286 282 86 69 271 197 326 226 46 24 14 21
-69 -8 -228 -77 -462 -193 -672 -334 -49 -32 -91 -56 -94 -53 -11 11 73 131
149 212 91 96 82 98 -60 10 -119 -74 -196 -133 -292 -223 -44 -41 -80 -71 -80
-65 0 15 158 162 240 223 41 30 102 71 135 91 65 39 240 128 251 128 4 0 -52
-61 -125 -135 -72 -74 -131 -138 -131 -144 0 -5 48 20 108 56 147 89 320 175
327 163 9 -15 25 -12 19 4 -9 22 294 133 414 152 l42 7 0 433 0 434 41 26 c22
14 43 23 46 20 3 -3 18 -282 33 -621 15 -339 30 -619 33 -622 3 -3 52 6 109
20 110 28 234 51 336 62 l62 7 0 136 c0 147 -16 989 -25 1292 -3 102 -5 215
-5 253 l0 67 -282 0 -281 0 7 -162 c3 -90 9 -219 12 -288 l5 -125 -44 -26 -44
-27 -7 61 c-7 69 -8 777 -1 777 2 0 38 -23 80 -51z m-394 14 c14 -35 5 -118
-16 -150 -20 -31 -55 -27 -73 7 -15 30 -10 117 10 149 20 32 66 28 79 -6z
m-636 -7 c24 -18 25 -107 2 -152 -15 -29 -15 -30 6 -30 31 1 49 -39 43 -98 -9
-86 -55 -124 -90 -74 -19 27 -20 80 -2 131 13 34 12 37 -5 37 -51 0 -53 149
-2 188 21 15 25 15 48 -2z m516 -27 c17 -32 7 -134 -16 -159 -22 -24 -48 -26
-65 -5 -19 23 -16 130 4 160 21 31 61 33 77 4z m-5987 -354 c-6 -285 -9 -332
-23 -342 -14 -10 -16 -2 -19 70 -2 45 0 204 3 354 7 265 8 271 27 260 18 -12
19 -23 12 -342z m10855 30 c6 -170 14 -327 16 -348 5 -38 5 -38 -18 -22 -24
15 -24 17 -36 336 -13 308 -12 321 5 334 11 7 20 13 20 12 1 -1 7 -141 13
-312z m-5489 275 c14 -35 7 -103 -16 -137 -21 -33 -62 -30 -75 5 -13 33 -4
107 16 139 23 34 60 30 75 -7z m500 11 c15 -29 12 -118 -5 -151 -18 -35 -58
-41 -75 -11 -15 29 -12 118 5 151 18 35 58 41 75 11z m-5805 -316 c-7 -250
-10 -291 -24 -302 -14 -10 -16 -7 -19 20 -2 18 -1 159 3 314 7 277 8 282 27
270 19 -12 19 -20 13 -302z m5683 283 c16 -16 15 -126 -1 -158 -17 -34 -61
-39 -77 -9 -18 32 -8 134 15 159 20 23 45 26 63 8z m-1733 -60 c9 -54 25 -172
25 -189 0 -13 -28 -25 -117 -49 -65 -18 -124 -35 -132 -38 -10 -4 -12 -1 -7 9
5 10 4 10 -6 -1 -7 -9 -62 -29 -123 -46 l-110 -31 -9 24 c-4 13 -6 25 -5 26 2
1 17 9 33 17 16 8 31 21 34 29 2 7 -5 4 -17 -8 -40 -40 -55 -29 -73 57 -8 42
-14 78 -13 80 5 6 480 150 497 151 12 1 19 -9 23 -31z m2247 -3 c10 -35 1 -99
-18 -137 -16 -31 -53 -38 -74 -13 -17 21 -8 126 14 159 24 38 66 33 78 -9z
m-624 -5 c13 -27 9 -95 -10 -136 -17 -36 -48 -41 -71 -13 -16 20 -18 34 -14
82 8 90 62 129 95 67z m503 -27 c13 -34 3 -119 -17 -150 -19 -30 -59 -30 -75
-1 -15 28 -5 122 16 154 22 34 62 32 76 -3z m-120 -34 c15 -29 7 -121 -14
-153 -24 -36 -64 -35 -78 2 -13 33 -5 101 16 142 19 37 58 41 76 9z m-621 -30
c29 -53 -5 -164 -50 -164 -35 0 -53 42 -44 102 11 77 67 114 94 62z m501 -10
c17 -32 7 -134 -16 -159 -29 -32 -68 -23 -76 17 -8 43 7 122 28 145 22 24 50
23 64 -3z m-11626 -60 l7 -46 -119 -23 c-65 -12 -141 -24 -170 -25 -29 -2 -57
-6 -62 -9 -5 -4 -12 -2 -16 4 -9 15 -21 12 -41 -7 -13 -14 -191 -50 -733 -150
-394 -72 -717 -136 -719 -141 -1 -5 -141 -249 -311 -541 -259 -448 -314 -536
-346 -558 -22 -15 -36 -20 -33 -12 3 8 143 250 311 539 167 289 304 526 302
528 -4 5 -311 -20 -330 -28 -11 -4 -67 -80 -124 -169 -67 -104 -107 -158 -115
-153 -6 4 -56 37 -111 73 -112 73 -135 87 -120 72 6 -6 60 -43 120 -83 61 -40
111 -74 113 -76 2 -1 -165 -262 -370 -579 -205 -317 -373 -581 -373 -586 0 -6
-7 -14 -15 -19 -8 -5 -11 -10 -7 -10 5 0 32 15 60 34 29 18 153 73 277 121
124 48 230 92 237 97 6 5 37 54 67 108 41 71 66 104 91 119 19 11 35 18 35 15
0 -3 -36 -67 -80 -143 l-80 -137 -341 -133 c-187 -73 -342 -131 -344 -129 -2
2 14 33 37 68 l40 64 76 459 75 459 329 316 c182 174 348 329 370 344 21 15
60 34 86 42 42 13 1801 288 1819 284 5 0 15 1 23 5 8 3 51 10 95 17 44 6 95
14 114 17 27 5 32 3 26 -8 -7 -11 -4 -10 9 1 25 20 218 50 228 35 3 -5 9 -31
13 -56z m11505 26 c19 -23 9 -139 -14 -164 -22 -25 -49 -27 -66 -6 -19 23 -9
139 14 164 22 25 49 27 66 6z m-2330 -110 c13 -64 21 -117 19 -119 -6 -6 -514
-136 -531 -136 -11 0 -19 28 -32 115 -10 64 -17 117 -15 119 7 7 493 134 515
135 19 1 24 -10 44 -114z m2199 75 c53 -28 18 -200 -41 -200 -50 0 -51 159 -1
198 20 15 20 14 42 2z m517 -76 c15 -57 -16 -151 -52 -160 -31 -8 -41 0 -49
37 -18 82 30 183 75 159 11 -6 23 -22 26 -36z m-613 3 c23 -69 -24 -177 -71
-163 -38 13 -43 118 -7 173 23 34 65 29 78 -10z m479 -14 c36 -32 16 -165 -27
-185 -31 -14 -51 1 -60 43 -10 43 13 126 38 144 27 19 26 19 49 -2z m-607 -10
c14 -13 16 -29 12 -75 -3 -32 -12 -70 -21 -83 -16 -24 -15 -25 3 -25 34 0 44
-25 38 -93 -5 -50 -10 -66 -32 -84 -63 -55 -97 52 -48 150 13 25 12 27 -7 27
-44 0 -50 122 -8 175 23 29 40 32 63 8z m-11515 -3 c0 -5 -7 -10 -16 -10 -8 0
-12 5 -9 10 3 6 10 10 16 10 5 0 9 -4 9 -10z m12004 -26 c36 -36 7 -184 -37
-192 -33 -7 -47 17 -47 80 0 75 23 123 62 127 4 1 14 -6 22 -15z m-3077 -118
c13 -66 22 -121 20 -121 -13 -11 -523 -152 -528 -147 -7 8 -52 253 -47 257 11
8 497 133 513 132 17 -2 23 -18 42 -121z m2467 98 c19 -19 21 -96 2 -139 -11
-27 -11 -31 8 -40 16 -8 22 -22 24 -55 7 -92 -32 -155 -79 -129 -19 10 -21 18
-17 79 2 48 9 75 22 89 17 19 17 19 -1 15 -38 -10 -58 45 -42 115 16 72 50 99
83 65z m494 -16 c17 -17 15 -123 -3 -158 -9 -17 -17 -30 -19 -30 -3 0 -11 -3
-19 -6 -56 -21 -65 151 -10 194 21 15 36 15 51 0z m-128 -38 c43 -23 31 -156
-16 -187 -23 -14 -26 -14 -44 2 -32 29 -25 135 12 174 22 24 23 24 48 11z
m22114 -36 c7 -57 8 -494 1 -494 -6 0 -128 80 -445 290 -186 123 -261 170
-245 153 6 -6 165 -113 354 -238 188 -124 341 -228 339 -230 -2 -3 -458 -20
-1014 -39 -555 -19 -1056 -37 -1114 -40 -85 -4 -102 -3 -87 7 10 7 194 128
410 270 216 143 397 264 402 270 16 16 -58 -29 -220 -137 -332 -220 -582 -383
-610 -399 -25 -14 -94 -19 -439 -31 l-409 -14 -56 38 c-31 20 -144 95 -251
165 -107 71 -269 177 -359 237 -90 60 -165 107 -167 105 -3 -2 114 -82 258
-177 145 -96 328 -217 408 -269 98 -65 138 -97 125 -99 -15 -2 -3486 -124
-6170 -217 -88 -3 -970 -34 -1960 -69 -990 -35 -1802 -62 -1804 -60 -29 27
319 225 571 324 197 78 561 190 574 177 2 -2 -45 -37 -106 -77 -60 -40 -110
-75 -110 -77 0 -5 3 -3 132 80 60 38 106 72 103 76 -2 4 1 8 8 9 7 1 96 20
199 41 342 72 709 112 1210 131 l286 12 164 -108 c321 -211 378 -248 378 -241
0 3 -46 35 -102 72 -57 37 -172 113 -257 169 l-154 101 79 7 c43 5 439 19 879
33 440 13 841 27 890 30 l90 5 -215 -142 c-119 -79 -260 -171 -313 -206 -53
-35 -97 -66 -97 -68 0 -3 6 -2 13 2 21 12 407 265 519 340 l107 72 572 19 572
18 136 -90 c188 -124 533 -350 549 -359 6 -4 12 -5 12 -2 0 2 -44 33 -97 68
-75 48 -425 279 -570 375 -15 10 -5 12 57 13 41 0 550 16 1130 35 580 19 1056
33 1057 31 3 -3 -380 -258 -704 -470 -40 -26 -73 -50 -73 -52 0 -3 6 -2 13 2
41 25 180 116 469 307 l327 216 308 10 c376 13 307 11 2478 81 974 32 1813 58
1866 59 l96 1 7 -46z m-22214 -23 c23 -44 2 -143 -37 -168 -19 -13 -24 -12
-44 8 -19 19 -21 29 -16 76 3 30 13 65 22 79 19 29 60 32 75 5z m604 3 c11
-28 6 -104 -7 -137 -29 -69 -71 -73 -93 -7 l-11 33 -6 -40 c-9 -52 -47 -89
-76 -74 -44 24 -16 184 35 197 31 8 41 0 50 -39 l7 -32 12 43 c7 23 19 49 25
57 16 20 56 19 64 -1z m-3960 -114 c33 -181 33 -176 -5 -188 -64 -21 -520
-142 -533 -142 -7 0 -24 51 -43 133 -17 72 -30 133 -29 134 3 4 563 151 577
152 13 1 20 -18 33 -89z m3727 28 c14 -26 6 -106 -15 -146 -31 -59 -86 -42
-86 26 0 105 67 184 101 120z m-5886 -440 c-4 -238 -3 -469 2 -512 l8 -80 675
-102 c371 -57 684 -104 695 -106 14 -2 -33 -38 -150 -115 -93 -62 -166 -113
-160 -113 5 0 85 50 177 111 l168 112 390 -60 391 -59 211 103 c182 89 213
101 231 91 12 -6 93 -59 180 -116 l157 -105 -27 -17 c-16 -9 -87 -49 -159 -89
l-131 -73 -6 -122 c-15 -309 -124 -483 -327 -525 -65 -13 -140 -2 -210 31 -72
34 -159 131 -208 229 -38 77 -92 253 -92 300 0 11 -1 19 -2 19 -2 0 -408 90
-903 198 l-900 198 -3 -168 c-1 -92 -6 -168 -10 -168 -27 0 -32 31 -32 187 0
102 -4 163 -10 163 -6 0 -10 -58 -10 -155 0 -85 -4 -155 -8 -155 -26 0 -32 30
-32 172 0 81 -1 148 -3 148 -1 0 -155 34 -342 76 -187 41 -360 79 -385 84 -72
14 -2103 460 -2119 465 -8 3 -12 7 -10 9 2 2 351 -50 774 -115 872 -135 814
-126 879 -134 27 -3 90 -12 140 -21 50 -8 110 -17 133 -20 24 -4 241 -36 483
-73 l440 -67 0 411 c0 452 4 531 29 544 15 8 16 -33 13 -474 -3 -397 -2 -483
10 -487 11 -5 13 79 14 490 1 469 2 496 19 508 11 8 20 14 22 14 2 0 1 -195
-2 -432z m5769 406 c12 -31 5 -100 -14 -141 -15 -34 -24 -43 -45 -43 -39 0
-52 37 -37 107 6 31 19 64 28 74 21 23 60 25 68 3z m-114 -85 c0 -54 -18 -106
-43 -127 -24 -20 -54 -6 -62 31 -6 25 -9 28 -12 12 -9 -37 -34 -83 -49 -89
-33 -13 -54 12 -54 65 0 121 86 187 107 81 l7 -37 8 45 c9 56 49 96 79 80 15
-8 19 -21 19 -61z m5170 -2 c0 -29 14 -344 29 -702 25 -557 27 -652 15 -664
-7 -8 -16 -12 -20 -9 -5 6 -63 1249 -64 1381 0 65 1 67 20 57 16 -9 20 -21 20
-63z m-4582 -14 c3 -65 5 -62 -53 -109 -18 -15 -18 -15 8 0 28 17 38 7 13 -13
-20 -17 -66 -3 -66 19 0 11 -4 22 -10 25 -5 3 -10 -2 -10 -12 0 -10 -9 -33
-20 -50 -22 -36 -63 -45 -74 -17 -11 29 -6 93 10 134 28 69 93 63 95 -9 0 -18
4 -11 13 21 16 60 33 80 65 76 24 -3 26 -7 29 -65z m-10648 48 c0 -5 -4 -21
-10 -36 -18 -48 -180 -103 -180 -61 0 8 17 28 37 45 52 43 153 77 153 52z
m5879 -68 c35 -134 53 -214 48 -219 -6 -7 -600 -175 -602 -171 -4 5 -64 252
-62 254 1 1 74 22 162 47 l159 45 144 -95 c79 -52 146 -93 148 -91 2 2 -57 43
-131 92 -74 48 -135 91 -135 95 0 5 219 74 252 79 4 1 12 -16 17 -36z m3936
10 c14 -13 16 -28 12 -72 -9 -82 -55 -132 -92 -101 -28 23 -14 133 21 171 21
23 38 24 59 2z m-10090 -13 c-3 -5 -22 -14 -43 -20 -45 -12 -52 -12 -52 -2 0
5 17 13 38 19 50 14 64 15 57 3z m10689 -6 c12 -31 5 -100 -14 -141 -15 -34
-24 -43 -45 -43 -39 0 -52 37 -37 107 6 31 19 64 28 74 21 23 60 25 68 3z
m-116 -89 c3 -81 -20 -130 -63 -130 l-30 0 0 70 c0 87 21 128 63 123 26 -3 27
-6 30 -63z m-17643 -72 c156 -104 257 -170 303 -197 6 -4 12 -5 12 -3 0 3 -24
21 -52 40 -29 18 -127 83 -218 142 -91 59 -169 112 -175 118 -27 26 364 -28
561 -78 413 -104 686 -302 823 -597 51 -109 75 -191 67 -233 -4 -19 -10 -36
-14 -39 -4 -3 -48 22 -97 55 -49 32 -94 59 -100 59 -5 0 35 -29 89 -64 54 -36
100 -66 101 -68 2 -2 -5 -46 -15 -98 -95 -488 -345 -2705 -420 -3715 -14 -183
-17 -198 -35 -191 -8 3 -17 1 -20 -4 -4 -7 -13 -6 -25 0 -13 7 -21 7 -25 0 -4
-7 -12 -7 -25 0 -10 6 -21 6 -24 2 -6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4
12 2 20 -5 12 -10 14 -28 9 -98 -4 -47 -13 -197 -21 -335 -20 -343 -45 -483
-115 -631 -56 -121 -138 -194 -217 -194 -43 0 -1358 252 -1361 261 -2 4 -9 6
-16 3 -11 -4 -1205 222 -1846 350 -319 64 -411 97 -458 164 -42 59 -39 67 35
116 37 26 64 46 60 46 -5 0 -35 -18 -67 -40 -32 -22 -61 -40 -63 -40 -9 0 -16
136 -10 209 l6 79 29 -59 c39 -77 119 -164 180 -195 29 -15 80 -29 121 -34 55
-6 850 -157 1323 -251 37 -7 85 -32 172 -89 67 -44 125 -80 129 -80 4 0 -40
32 -100 72 -59 39 -106 73 -104 75 2 1 170 -28 373 -66 566 -107 1036 -190
1168 -207 188 -24 284 0 364 92 45 50 76 121 98 224 22 101 37 351 30 495 -13
274 45 1009 165 2105 24 214 32 240 71 219 11 -6 19 -5 23 1 5 8 11 7 21 -1
11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6 11 -19 14 -14 2
-28 0 -31 -5 -3 -4 -10 -5 -16 -1 -7 3 -31 6 -56 6 l-44 -1 6 42 c3 22 7 50 7
61 1 11 37 333 81 715 101 878 103 931 23 1052 -42 64 -99 89 -223 98 -496 39
-1941 74 -2757 68 -430 -3 -430 -3 -475 -27 -25 -13 -60 -34 -77 -48 -39 -28
-39 -32 -16 110 16 99 19 108 37 103 11 -3 26 0 33 5 6 6 18 7 24 3 17 -10
120 -11 126 -1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 7 7 16 8 23 2 6 -5 16 -5 25
2 12 8 12 9 -2 4 -10 -3 -20 0 -24 5 -4 8 -9 8 -17 0 -6 -6 -16 -7 -28 -1 -11
7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23 3 -6 -10 -60 -9 -76 1 -7 5
-17 4 -23 -2 -5 -5 -18 -7 -29 -5 -23 6 -26 45 -4 66 8 9 10 17 5 19 -6 2 -6
23 -1 58 8 51 13 59 77 118 188 172 426 285 687 326 111 18 177 25 177 20 0
-3 -84 -59 -407 -271 -29 -19 -53 -37 -53 -40 0 -2 6 -1 13 3 44 27 145 93
300 196 l177 118 258 3 c141 2 478 3 747 2 l490 -2 180 -120z m7001 96 c16
-27 -100 -106 -184 -124 -25 -5 -33 -3 -39 11 -18 48 196 156 223 113z m10514
1 c11 -7 15 -26 15 -67 -1 -92 -49 -157 -90 -123 -32 26 -9 157 32 188 20 14
23 15 43 2z m-10720 -10 c0 -15 -86 -67 -141 -85 -38 -13 -53 -14 -70 -5 -21
12 -21 12 -2 31 10 11 55 30 98 43 90 27 115 30 115 16z m9593 -79 l135 -90 6
-133 c3 -73 8 -244 11 -380 l6 -248 -33 -20 -33 -20 -6 93 c-4 50 -8 180 -9
287 -1 107 -5 244 -9 303 -6 101 -7 107 -24 95 -17 -12 -17 -35 -9 -408 7
-350 6 -397 -7 -414 -15 -17 -16 -17 -22 10 -4 16 -7 108 -8 205 -2 281 -13
569 -23 569 -5 0 -6 -175 -2 -409 l7 -409 -21 -11 -22 -12 -1 243 c-1 134 -5
316 -8 405 l-6 161 -630 -355 c-346 -195 -700 -394 -786 -442 l-157 -88 -172
113 c-95 62 -175 116 -178 119 -6 5 1836 923 1855 924 6 1 72 -39 146 -88z
m-9183 66 c0 -32 -113 -106 -188 -122 -43 -9 -54 16 -21 52 51 55 209 108 209
70z m10198 -19 c18 -18 14 -98 -8 -145 -15 -34 -24 -43 -45 -43 -39 0 -52 37
-37 107 17 80 56 115 90 81z m3825 -65 c4 -43 11 -244 17 -448 16 -557 16
-575 10 -575 -4 0 -13 6 -22 13 -13 10 -17 58 -22 332 -4 176 -11 412 -16 525
-9 197 -6 230 20 230 4 0 10 -35 13 -77z m-13947 10 c-8 -45 -33 -68 -82 -78
-74 -13 -68 26 12 81 66 45 78 44 70 -3z m5288 -120 c16 -71 29 -132 30 -137
1 -12 -627 -197 -635 -188 -9 10 -81 273 -76 278 3 3 629 171 647 173 3 1 19
-56 34 -126z m-6167 70 c10 -30 -133 -113 -194 -113 -78 0 -13 72 100 112 56
19 88 20 94 1z m14676 -85 c4 -57 9 -240 12 -408 3 -168 8 -324 11 -348 l5
-42 -34 20 -34 20 -7 158 c-3 86 -9 272 -12 413 l-7 256 24 16 c13 10 26 17
30 17 3 0 9 -46 12 -102z m-14466 77 c8 -23 -25 -54 -92 -86 -53 -25 -135 -39
-135 -23 0 30 70 82 148 110 49 18 71 17 79 -1z m200 -21 c2 -6 -4 -21 -14
-33 l-18 -22 -34 25 -34 25 24 10 c30 13 71 10 76 -5z m10821 7 c19 -12 10
-46 -12 -44 -9 0 -15 -1 -12 -5 3 -3 -9 -16 -26 -28 -17 -13 -33 -22 -36 -20
-9 10 21 77 41 91 25 17 27 18 45 6z m-10639 -20 c20 -13 7 -36 -40 -71 -46
-33 -75 -38 -105 -15 -10 8 -23 14 -29 14 -5 1 1 -8 14 -18 26 -20 22 -25 -26
-36 -90 -19 17 88 119 120 53 17 50 17 67 6z m-869 -6 c0 -11 -84 -46 -125
-52 -69 -9 -53 10 28 34 77 22 97 26 97 18z m608 -17 c32 -20 33 -22 16 -35
-27 -19 -125 -54 -143 -51 -30 6 -17 41 27 75 51 39 54 39 100 11z m412 -17
c-8 -5 -28 -11 -45 -15 -28 -6 -29 -5 -11 9 11 8 31 15 45 15 19 -1 22 -3 11
-9z m-1142 -73 c-4 -29 -90 -82 -159 -98 -54 -13 -74 -6 -63 23 12 33 141 96
197 97 24 0 28 -4 25 -22z m-218 2 c0 -17 -91 -70 -148 -86 -58 -17 -85 -13
-80 13 2 11 35 26 108 49 120 37 120 37 120 24z m436 -5 c9 -23 -11 -41 -88
-80 -81 -40 -138 -47 -138 -15 0 24 62 67 133 91 64 23 86 23 93 4z m204 -25
c0 -37 -133 -110 -201 -110 -94 0 77 128 174 129 20 1 27 -4 27 -19z m185 -19
c0 -14 -114 -50 -160 -51 -18 0 -18 1 3 16 30 21 123 54 142 51 8 -1 15 -9 15
-16z m-1227 -93 c-2 -17 -21 -31 -68 -55 -82 -40 -138 -51 -146 -28 -10 26 20
48 104 77 98 34 114 35 110 6z m232 -2 c0 -34 -141 -106 -207 -106 -34 0 -30
34 8 61 70 49 199 79 199 45z m210 -15 c0 -38 -117 -100 -187 -101 -77 0 -47
41 69 95 66 31 118 33 118 6z m210 -14 c0 -36 -127 -107 -192 -107 -48 0 -50
20 -5 54 72 55 197 89 197 53z m-1040 -97 c0 -39 -159 -114 -205 -96 -38 14 3
43 129 92 75 29 76 29 76 4z m34999 -52 c0 -35 2 -127 6 -205 8 -136 7 -143
-11 -143 -10 -1 -143 -11 -294 -24 -151 -13 -277 -22 -279 -20 -1 1 59 44 135
95 77 50 131 89 122 86 -10 -4 -75 -44 -145 -90 -71 -46 -133 -87 -140 -91 -9
-5 -1327 -117 -1653 -140 -36 -2 -508 -41 -1050 -85 -541 -45 -991 -80 -999
-79 -9 2 8 18 39 38 148 94 683 452 667 446 -10 -3 -183 -115 -385 -248 l-366
-243 -430 -36 -431 -35 -37 23 c-170 105 -695 463 -681 464 17 0 5877 345
5916 348 16 1 18 -7 16 -61z m-34779 38 c0 -35 -121 -96 -190 -96 -47 0 -50
12 -14 45 53 50 204 87 204 51z m220 -10 c0 -22 -54 -62 -115 -85 -97 -36
-146 -22 -92 26 61 56 207 97 207 59z m205 -16 c18 -30 -124 -110 -195 -110
-50 0 -53 19 -7 54 65 49 185 83 202 56z m195 -29 c0 -37 -131 -111 -195 -111
-97 0 68 128 168 129 20 1 27 -4 27 -18z m-1012 -83 c-6 -47 -218 -120 -218
-76 0 8 8 22 18 31 31 28 126 67 165 67 34 0 38 -3 35 -22z m220 -15 c-7 -36
-175 -111 -215 -96 -18 7 -16 27 5 46 58 53 218 91 210 50z m186 1 c38 -15 1
-60 -77 -94 -54 -24 -128 -31 -134 -13 -9 25 83 84 162 104 17 4 31 7 32 8 1
1 8 -2 17 -5z m216 -39 c0 -47 -201 -138 -233 -106 -9 10 -3 20 27 47 66 57
206 98 206 59z m190 -29 c0 -50 -211 -144 -235 -105 -12 18 56 74 119 98 62
24 116 27 116 7z m-995 -61 c0 -19 -56 -65 -80 -65 -6 0 -19 6 -29 13 -16 12
-16 14 4 39 30 39 105 48 105 13z m215 -18 c0 -20 -29 -43 -90 -71 -77 -35
-128 -43 -136 -22 -8 21 11 43 60 68 75 39 166 52 166 25z m190 -25 c0 -11 -8
-26 -18 -35 -29 -27 -127 -67 -168 -70 -87 -5 -28 64 89 104 69 24 97 24 97 1z
m554 -17 c-4 -8 -10 -15 -15 -15 -4 0 -6 7 -3 15 4 8 10 15 15 15 4 0 6 -7 3
-15z m28663 -143 c131 -87 296 -196 367 -242 71 -46 125 -85 120 -87 -16 -5
-2845 -234 -2863 -232 -9 1 -23 0 -31 -3 -12 -5 -3564 -294 -3645 -297 -11 -1
-514 -42 -1117 -93 l-1098 -91 -161 107 c-88 59 -163 106 -165 103 -2 -2 66
-51 152 -108 l157 -104 -394 -32 c-217 -17 -439 -36 -494 -43 -55 -7 -179 -14
-277 -17 l-176 -6 -16 30 c-14 29 -14 31 7 50 12 10 93 66 180 123 86 56 155
105 153 107 -5 5 -338 -215 -347 -229 -8 -12 -25 6 -69 70 l-35 52 -60 0 c-33
0 -490 11 -1015 26 l-954 26 -44 30 c-24 16 -46 28 -48 25 -3 -3 11 -15 30
-27 20 -12 36 -24 36 -27 0 -2 -46 -2 -102 2 -91 5 -112 10 -181 43 l-77 36
-163 -22 c-89 -12 -168 -22 -174 -22 -10 0 -13 28 -13 107 0 83 3 104 12 95
18 -18 53 -14 79 9 l24 21 -25 -16 c-30 -19 -64 -21 -78 -3 -8 9 -8 64 0 187
5 96 11 176 12 176 1 2 634 -44 646 -46 3 0 -4 -7 -14 -15 -27 -20 -6 -19 23
1 18 13 37 15 97 9 l74 -7 0 59 c0 47 4 61 20 71 19 12 20 10 20 -57 l0 -70
43 -5 c46 -6 456 -31 767 -46 107 -5 303 -8 435 -5 132 3 467 10 745 16 278 5
611 17 740 24 282 18 331 18 310 5 -8 -5 -10 -10 -4 -10 5 0 16 6 22 12 9 9
337 32 1159 80 l1146 66 119 -80 c66 -44 121 -78 123 -76 2 2 -48 37 -110 78
-62 41 -112 76 -111 77 4 4 1221 74 1240 71 13 -2 -37 -40 -150 -115 -93 -62
-166 -113 -162 -113 4 0 87 53 186 118 l180 117 848 49 849 49 254 -167 c139
-92 255 -166 256 -164 2 2 -106 75 -240 163 -134 88 -244 162 -244 165 -1 6
1829 114 1834 108 2 -2 -142 -100 -320 -218 -178 -118 -322 -216 -320 -218 1
-2 155 97 341 220 l337 222 526 32 c289 17 540 32 558 33 25 1 80 -32 270
-157z m-29732 142 c13 -5 14 -8 3 -15 -22 -14 -48 -11 -42 6 7 17 14 18 39 9z
m710 -5 c18 -28 -112 -105 -196 -116 -35 -5 -39 -3 -39 16 0 49 211 140 235
100z m11320 -669 c8 -354 15 -677 15 -717 l0 -73 -35 22 c-29 19 -35 29 -35
58 0 19 -7 296 -15 615 -19 775 -21 696 18 721 17 12 33 21 34 20 1 -1 9 -292
18 -646z m-11147 618 c-2 -17 -22 -32 -78 -60 -95 -47 -137 -56 -147 -32 -14
36 117 112 195 113 29 1 33 -2 30 -21z m-7170 -127 c233 -152 237 -155 228
-169 -7 -11 -244 -8 -325 4 l-34 5 6 60 c5 57 4 60 -16 57 -19 -3 -22 -11 -25
-53 -2 -27 -7 -54 -11 -58 -5 -5 -87 -5 -183 -1 -153 6 -175 9 -172 23 1 9 5
40 8 69 5 51 4 53 -17 50 -18 -2 -22 -10 -25 -43 -1 -22 -5 -51 -8 -64 l-5
-24 -150 6 -149 7 0 -24 c0 -23 1 -23 150 -31 l150 -7 -5 -36 c-6 -47 -25
-228 -25 -243 0 -8 -36 -9 -135 -4 l-135 7 0 -26 c0 -26 0 -26 84 -26 46 0
105 -3 131 -7 l47 -6 -6 -76 c-4 -42 -10 -100 -13 -128 l-6 -53 -148 7 c-145
6 -149 6 -149 -14 0 -27 24 -33 145 -33 55 0 111 -3 124 -7 23 -6 23 -8 17
-77 -4 -39 -9 -90 -12 -112 l-6 -41 -41 3 c-23 2 -90 5 -149 8 -106 4 -108 4
-108 -19 0 -21 6 -22 83 -28 45 -4 111 -7 147 -7 l66 0 -12 -117 c-7 -65 -13
-122 -13 -126 -1 -5 -68 -5 -151 -1 -146 7 -150 6 -150 -13 0 -26 24 -33 111
-33 36 0 93 -3 125 -6 l60 -6 -9 -72 c-4 -39 -7 -87 -7 -106 0 -62 -2 -63
-151 -51 -191 16 -189 16 -189 -14 0 -25 -14 -33 -25 -15 -3 6 -11 10 -18 10
-8 0 -8 -3 1 -12 7 -7 62 -12 149 -14 76 -2 158 -6 181 -9 39 -6 43 -9 39 -28
-3 -12 -9 -63 -13 -113 -3 -51 -10 -97 -14 -104 -7 -11 -39 -11 -167 -2 -205
16 -193 16 -193 -11 0 -23 2 -24 177 -36 98 -6 178 -13 179 -14 4 -5 -22 -226
-27 -232 -6 -5 -141 5 -281 20 -46 5 -48 5 -48 -20 0 -17 6 -25 18 -25 36 -1
304 -29 307 -32 5 -5 -22 -269 -28 -275 -3 -2 -71 3 -152 12 -201 21 -207 20
-203 -7 3 -22 11 -23 173 -40 94 -9 172 -17 175 -17 3 -1 1 -48 -4 -106 l-9
-105 -31 0 c-17 0 -89 7 -161 15 -175 20 -175 20 -175 -8 0 -22 5 -23 181 -41
l181 -19 -5 -36 c-3 -20 -9 -76 -13 -124 l-7 -88 -36 5 c-20 3 -81 10 -136 16
-55 6 -115 13 -132 16 -30 4 -33 3 -33 -21 0 -14 6 -25 13 -25 38 -2 307 -37
312 -41 6 -7 -19 -256 -27 -264 -3 -4 -64 1 -135 9 -166 21 -163 21 -163 -7 0
-21 6 -23 147 -40 80 -9 147 -18 148 -19 5 -6 -20 -227 -26 -232 -3 -4 -68 3
-143 14 -75 11 -146 20 -157 20 -19 0 -37 -25 -25 -37 3 -3 76 -16 162 -29 86
-13 159 -26 161 -28 3 -3 2 -18 -2 -35 -4 -20 -11 -29 -18 -24 -7 4 -7 0 1
-10 8 -9 12 -26 11 -39 -4 -24 0 -28 26 -28 10 0 15 10 15 29 0 31 -2 30 75
32 29 0 29 1 7 10 -13 5 -31 5 -40 0 -27 -13 -39 -3 -34 29 5 35 -1 35 162 14
157 -21 190 -38 190 -101 0 -35 3 -43 19 -43 15 0 19 10 23 50 3 28 7 52 9 55
3 2 79 -7 169 -20 91 -14 169 -25 174 -25 4 0 5 -34 1 -75 -6 -70 -5 -75 13
-75 20 0 32 38 32 108 0 39 -3 39 205 8 l150 -22 -3 -64 c-1 -36 -5 -75 -7
-87 -4 -19 -1 -23 18 -23 23 0 24 4 31 82 4 45 8 83 9 84 1 1 309 -42 325 -45
3 -1 -4 -84 -14 -153 -5 -33 -3 -38 14 -38 25 0 28 12 37 111 l6 75 176 -25
175 -25 -7 -93 c-7 -89 -6 -93 13 -93 19 0 21 9 28 91 l7 91 31 -6 c17 -2 91
-13 164 -22 l133 -18 -5 -25 c-3 -15 -8 -59 -11 -98 -7 -69 -6 -73 13 -73 18
0 21 8 27 58 14 134 14 134 43 128 15 -3 79 -12 142 -21 173 -23 157 -15 152
-82 -3 -32 -8 -67 -13 -79 -6 -18 -152 -124 -191 -139 -7 -3 -126 15 -263 40
-291 53 -1036 178 -1375 229 -159 25 -247 43 -272 56 -44 24 -59 26 -32 5 18
-15 18 -15 -6 -10 -14 2 -101 19 -195 35 -348 63 -597 134 -687 196 -69 48
-78 79 -78 263 l0 161 76 -50 c42 -28 81 -50 87 -50 5 0 -29 25 -76 56 -86 56
-87 56 -82 92 3 21 10 89 16 152 69 737 364 3028 409 3172 36 118 99 189 197
223 30 11 94 13 293 8 l255 -5 193 -127z m667 104 c336 -8 718 -18 851 -22
l241 -6 -219 -145 c-120 -80 -216 -147 -214 -150 3 -2 18 5 34 17 38 27 42 26
42 -5 l0 -25 -77 5 c-43 2 -124 5 -180 5 l-103 1 0 30 c0 23 -4 30 -20 30 -15
0 -20 -7 -20 -25 0 -24 -3 -25 -58 -25 -33 0 -107 3 -167 7 l-107 6 4 49 c5
45 4 48 -18 48 -22 0 -24 -4 -24 -48 l0 -48 -122 4 c-68 2 -148 7 -178 11
l-55 6 0 53 c1 48 -1 52 -22 52 -20 0 -23 -5 -23 -35 l0 -35 -197 131 c-109
72 -199 132 -200 133 -2 1 48 1 110 -1 61 -2 387 -10 722 -18z m5555 -4 c0
-13 -29 -41 -41 -41 -10 0 -5 13 14 38 11 14 27 16 27 3z m1080 4 c0 -3 -9
-24 -20 -46 -21 -40 -41 -52 -109 -68 -102 -23 -68 46 49 98 44 19 80 26 80
16z m-887 -21 c25 -26 -104 -102 -189 -112 -52 -5 -59 11 -20 47 47 44 187 87
209 65z m-4378 -18 c258 -8 382 -38 440 -108 28 -33 31 -61 15 -166 -5 -37
-19 -152 -30 -255 -12 -104 -30 -236 -41 -295 -38 -202 -49 -278 -79 -552 -18
-151 -33 -295 -36 -320 -94 -971 -243 -2473 -246 -2475 -2 -1 -28 -19 -58 -39
-49 -33 -55 -34 -58 -17 -3 15 -15 20 -70 26 -37 4 -69 9 -73 10 -5 4 20 277
26 284 3 2 43 -1 90 -6 79 -8 85 -7 91 10 3 10 4 20 1 23 -2 2 -43 9 -91 16
-84 10 -86 11 -85 37 1 54 25 260 31 266 14 14 101 -9 150 -41 29 -19 57 -34
62 -34 6 0 -14 16 -44 35 -31 19 -47 35 -37 35 10 0 17 8 17 19 0 21 -25 30
-80 31 -19 0 -42 6 -51 13 -15 12 -14 36 10 257 1 3 28 3 61 2 54 -3 60 -2 60
16 0 22 -25 32 -83 32 -32 0 -37 3 -33 18 2 9 7 53 11 97 11 141 7 134 76 128
60 -6 61 -5 57 18 -3 21 -9 25 -58 29 -47 4 -55 8 -54 25 1 11 7 80 14 153
l13 133 73 -6 c74 -7 74 -7 74 17 0 24 -4 26 -66 31 -36 2 -67 7 -70 10 -3 3
1 65 8 138 l13 134 54 -4 c37 -2 56 1 62 10 20 31 10 39 -52 39 l-61 0 6 48
c3 26 8 72 12 103 5 50 9 57 40 74 19 10 32 20 30 22 -2 3 -16 -3 -30 -13 -31
-20 -41 -14 -31 16 7 21 12 22 81 18 71 -5 74 -4 74 17 0 19 -7 23 -46 29 -26
3 -60 6 -76 6 -28 0 -29 0 -23 48 7 57 25 225 25 232 0 3 40 3 90 2 84 -4 90
-3 90 16 0 26 -18 32 -104 32 l-72 0 12 118 c7 64 13 126 13 137 1 19 7 20 91
17 l90 -4 0 26 c0 26 0 26 -86 26 l-87 0 7 83 c4 45 10 97 13 115 l5 33 89 -3
c85 -3 89 -2 89 18 0 18 -8 22 -52 28 -29 3 -69 6 -88 6 l-36 0 12 118 c7 64
13 123 13 131 1 12 20 13 106 8 l105 -7 0 24 c0 22 -4 23 -96 29 -54 4 -99 9
-102 12 -3 2 1 68 8 145 l13 141 88 -7 89 -7 0 27 0 26 -85 0 c-84 0 -85 0
-85 25 0 18 -5 25 -20 25 -13 0 -20 -7 -20 -20 0 -18 -7 -20 -58 -20 -33 0
-107 3 -165 7 l-107 6 0 44 c0 36 -3 43 -20 43 -16 0 -20 -7 -20 -32 0 -18 -4
-38 -8 -44 -5 -8 -52 -9 -160 -4 -84 4 -155 9 -157 11 -2 2 -5 21 -6 42 l-4
38 170 113 c162 108 172 113 215 110 25 -2 122 -6 215 -8z m16159 -617 c4
-347 6 -633 3 -635 -2 -2 -11 2 -20 9 -15 11 -17 73 -23 619 -7 611 -6 638 26
638 4 0 10 -284 14 -631z m-11598 596 c4 -8 1 -22 -6 -30 -10 -12 -16 -11 -45
8 -28 18 -31 23 -17 29 30 12 62 8 68 -7z m-70 -26 c19 -11 34 -22 34 -25 0
-8 -62 -35 -115 -49 -80 -20 -107 -6 -63 34 18 17 95 61 107 61 2 0 19 -9 37
-21z m11609 -1167 c-1 -1 -9 0 -17 3 -19 8 -28 250 -28 781 0 354 1 384 18
393 16 9 17 -23 24 -582 3 -326 5 -593 3 -595z m-11355 1155 c0 -16 -34 -49
-68 -66 -19 -10 -28 -9 -57 9 -19 12 -35 24 -35 26 0 3 19 14 43 24 49 23 117
27 117 7z m170 -40 c0 -21 -40 -54 -102 -82 l-58 -26 -31 22 c-35 25 -35 25
56 70 64 31 135 39 135 16z m16058 1 c17 -17 17 -855 0 -860 -6 -2 -14 -24
-18 -49 -4 -24 -8 173 -9 439 0 265 3 482 7 482 4 0 13 -5 20 -12z m-16370
-20 l36 -22 -30 -13 c-35 -15 -91 -17 -99 -3 -6 9 37 60 51 60 4 0 23 -10 42
-22z m-442 -23 c9 -23 -14 -45 -81 -77 -56 -26 -95 -35 -95 -22 0 3 14 25 30
49 24 35 39 46 73 53 61 14 67 14 73 -3z m924 -4 c0 -45 -212 -138 -234 -102
-16 25 36 68 120 101 66 26 114 26 114 1z m-740 -41 c0 -38 -124 -100 -201
-100 -50 0 -51 12 -2 54 28 23 139 65 176 65 20 1 27 -4 27 -19z m366 -18
c-31 -4 -41 2 -32 17 5 7 16 6 34 -2 l27 -12 -29 -3z m444 13 c0 -2 -10 -25
-22 -50 -18 -36 -29 -47 -58 -55 -52 -15 -70 -13 -70 9 0 22 12 33 81 71 53
29 69 35 69 25z m-635 -26 c19 -29 -116 -107 -192 -112 -31 -2 -38 1 -38 17 0
24 35 50 110 81 64 26 110 32 120 14z m161 -44 c9 -24 -15 -45 -91 -82 -74
-35 -145 -45 -145 -19 0 29 96 87 175 106 46 12 55 11 61 -5z m-6988 -11 l93
-6 -5 -41 c-3 -23 -11 -87 -16 -141 -6 -55 -12 -101 -13 -102 -4 -4 -348 14
-352 18 -2 2 2 64 10 138 8 74 15 138 15 142 0 7 45 5 268 -8z m13728 -235 c3
-118 7 -228 10 -244 3 -23 18 -41 54 -68 53 -40 60 -51 34 -61 -11 -4 -36 8
-70 34 -41 30 -54 48 -58 72 -3 18 -7 143 -10 278 l-6 244 21 -20 c19 -20 21
-35 25 -235z m25837 244 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18
-5z m-109 -23 c-149 -53 -289 -188 -409 -395 l-47 -80 5 52 c5 66 73 178 171
281 114 120 187 161 281 161 l50 0 -51 -19z m-38996 -6 c32 -5 33 -6 28 -47
-3 -23 -11 -87 -16 -141 -6 -55 -12 -100 -13 -101 -4 -2 -351 16 -353 18 -1 1
4 61 12 132 7 72 14 136 14 143 0 9 33 11 148 7 81 -4 162 -8 180 -11z m221
-44 c76 -49 95 -53 23 -5 -28 20 -52 37 -52 38 0 4 234 -4 238 -8 2 -2 -2 -49
-8 -105 -8 -74 -16 -107 -29 -119 -9 -9 -11 -12 -4 -7 19 13 25 3 17 -29 l-7
-28 -176 8 c-97 4 -177 8 -178 8 0 1 5 61 13 132 7 72 14 136 14 143 0 8 15
12 43 12 34 0 58 -9 106 -40z m6471 21 c0 -24 -45 -57 -119 -87 -63 -26 -121
-31 -121 -11 0 39 139 115 213 117 20 0 27 -5 27 -19z m6634 -26 c3 -11 6 -95
6 -186 0 -92 3 -179 6 -195 6 -29 56 -69 1180 -922 l203 -154 263 25 c145 14
283 24 308 23 25 -2 50 1 57 6 7 5 18 6 24 2 18 -11 70 -11 76 0 4 5 1 6 -5 2
-6 -3 -13 -2 -16 3 -6 9 13 11 147 14 31 1 57 5 57 9 0 4 12 7 28 6 25 -1
2101 195 2205 208 l47 6 0 139 c0 76 2 139 4 139 2 0 11 -3 20 -6 14 -5 16
-29 16 -160 0 -127 -3 -154 -14 -154 -8 0 -515 -47 -1126 -105 -611 -58 -1114
-105 -1116 -105 -3 0 -2 5 2 11 4 8 1 8 -12 1 -11 -5 -25 -7 -31 -5 -7 3 -13
0 -13 -6 0 -6 -15 -11 -32 -11 -22 0 -29 3 -20 9 10 6 7 10 -12 13 -15 3 -29
2 -32 -3 -2 -4 -12 -5 -22 -2 -14 5 -15 3 -5 -7 10 -10 15 -11 27 -1 9 8 16 8
20 2 9 -14 -7 -16 -458 -57 -337 -32 -402 -35 -420 -24 -11 7 -328 247 -703
532 l-682 518 -5 53 c-3 28 -7 136 -9 238 -3 175 -2 186 14 176 10 -6 20 -20
23 -32z m-12526 10 c2 -2 -2 -67 -9 -144 l-12 -141 -166 7 c-91 3 -166 6 -167
7 -1 1 5 55 12 121 7 66 13 131 13 144 l1 24 162 -7 c89 -3 163 -8 166 -11z
m196 -5 l51 0 -30 -20 c-16 -11 -26 -20 -22 -20 5 0 22 10 39 21 26 19 38 21
96 15 36 -4 68 -8 69 -10 5 -5 -20 -265 -26 -274 -6 -10 -338 2 -348 12 -5 5
15 250 23 275 3 10 16 12 51 7 25 -3 69 -6 97 -6z m4974 -12 c-7 -49 -238
-132 -238 -86 0 17 23 39 60 58 45 24 125 49 153 50 24 0 28 -4 25 -22z
m-4401 -12 c1 -1 -4 -62 -12 -136 -8 -74 -15 -138 -15 -142 0 -10 -83 -10
-221 -2 l-105 7 13 116 c6 64 12 129 12 144 l1 28 163 -7 c89 -4 163 -7 164
-8z m5283 2 c0 -6 -7 -7 -16 -4 -14 5 -15 4 -5 -8 10 -12 6 -19 -21 -39 -70
-54 -208 -88 -208 -53 0 21 60 64 124 90 57 23 126 31 126 14z m-4912 -22 c4
-4 -16 -225 -24 -263 -4 -22 -5 -22 -167 -16 -89 3 -163 6 -164 7 -1 1 4 62
12 136 8 74 15 139 15 144 0 9 319 1 328 -8z m4202 -6 c0 -34 -119 -97 -202
-107 -40 -5 -48 -3 -48 10 0 21 53 61 115 86 53 21 135 28 135 11z m154 -39
c13 -21 -10 -43 -78 -76 -119 -59 -209 -58 -143 2 57 52 204 102 221 74z m586
-11 c0 -6 -9 -29 -20 -50 -19 -37 -24 -40 -60 -40 -46 0 -52 16 -17 47 22 21
76 52 90 53 4 0 7 -5 7 -10z m-432 -51 c6 -34 -139 -108 -210 -109 -65 0 -46
36 42 80 95 49 162 60 168 29z m-713 -9 c9 -14 -11 -38 -48 -56 -38 -20 -42
-14 -21 30 18 36 54 50 69 26z m33111 -112 c-41 -62 -94 -151 -119 -198 -51
-95 -97 -208 -72 -175 103 133 138 172 183 207 29 22 55 39 57 36 3 -3 -20
-46 -51 -97 -125 -204 -234 -536 -259 -791 -4 -36 -9 -72 -12 -80 -10 -29 -2
-277 12 -385 22 -167 63 -301 154 -510 41 -94 84 -187 99 -218 9 -18 -35 14
-96 68 -147 134 -237 295 -292 522 -19 81 -20 94 -8 107 11 10 17 52 22 148 4
73 9 150 11 171 3 40 32 72 50 57 6 -5 17 -4 25 2 12 8 12 9 -2 4 -10 -3 -20
-1 -24 5 -4 6 -11 6 -20 -2 -8 -6 -17 -9 -20 -6 -3 3 4 149 15 326 l20 321 39
83 c21 45 58 114 82 152 50 82 261 365 272 365 4 0 -26 -51 -66 -112z m-32246
68 c0 -43 -199 -132 -238 -107 -44 27 110 119 201 120 26 1 37 -3 37 -13z
m-712 -18 c-4 -31 -119 -89 -188 -96 -46 -4 -52 -3 -48 13 1 10 14 26 28 37
38 28 141 67 178 68 29 0 33 -3 30 -22z m862 -31 c0 -36 -126 -106 -206 -115
-51 -5 -59 11 -21 45 62 58 227 108 227 70z m-700 -12 c0 -24 -77 -73 -148
-95 -59 -19 -102 -19 -102 -2 1 54 250 150 250 97z m-6461 -12 c5 -3 -17 -255
-22 -258 -4 -4 -350 14 -353 18 -4 4 16 225 22 245 3 9 41 11 176 6 95 -4 175
-8 177 -11z m272 -9 l134 -7 -12 -121 c-6 -67 -12 -125 -12 -130 -1 -7 -350 0
-358 7 -3 3 17 205 23 235 5 26 10 26 225 16z m538 -29 c10 -11 -18 -28 -32
-19 -7 5 -4 1 6 -9 17 -15 18 -26 13 -85 -4 -37 -9 -84 -12 -105 l-6 -38 -176
7 c-98 3 -178 7 -179 8 -3 2 17 207 23 235 l5 24 176 -7 c97 -3 179 -8 182
-11z m5795 6 c13 -20 -8 -41 -75 -76 -39 -20 -90 -38 -119 -42 -44 -5 -50 -4
-50 13 0 26 58 63 139 91 72 25 97 28 105 14z m-5637 -11 c17 0 34 -4 38 -10
3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 1 10 10 10 9 0 13 -4 10 -10 -3 -5 3
-10 14 -11 34 -1 81 -1 84 1 15 10 37 5 37 -8 0 -35 -13 -62 -29 -63 -13 -1
-13 -2 2 -6 16 -4 17 -13 11 -81 -4 -42 -9 -80 -13 -84 -7 -7 -317 4 -324 12
-3 4 10 138 25 249 1 10 11 12 42 6 23 -3 55 -6 73 -5z m173 -4 c0 -8 -60 -12
-72 -4 -8 4 4 8 30 8 23 0 42 -2 42 -4z m6019 -50 c-19 -38 -29 -47 -57 -52
-45 -9 -62 8 -36 37 18 20 106 70 112 64 2 -1 -7 -23 -19 -49z m-5582 30 c4
-3 -24 -257 -29 -261 -2 -2 -35 16 -72 41 -37 25 -70 44 -72 41 -3 -2 19 -20
48 -38 l53 -34 -50 -3 c-28 -2 -96 -1 -152 3 l-103 7 0 26 c0 34 19 203 24
218 3 7 59 9 178 6 95 -2 174 -5 175 -6z m362 -21 c5 -6 -17 -246 -24 -253 -2
-2 -75 -1 -162 3 l-159 7 12 122 c7 66 13 125 13 130 1 9 310 0 320 -9z m328
-11 l52 -5 -5 -42 c-2 -23 -9 -79 -13 -125 -5 -46 -11 -85 -13 -87 -5 -6 -316
10 -322 16 -5 5 11 193 20 236 4 21 7 21 117 17 61 -3 135 -7 164 -10z m3788
5 c10 -15 -24 -49 -70 -70 -22 -10 -41 -16 -43 -14 -6 6 37 83 50 88 23 9 57
7 63 -4z m705 -3 c0 -45 -233 -142 -255 -106 -21 34 131 118 218 119 26 1 37
-3 37 -13z m34259 -26 c60 -30 105 -74 150 -144 57 -91 102 -204 127 -321 35
-164 37 -190 38 -385 0 -270 -24 -409 -106 -608 -24 -58 -40 -80 -76 -107 -25
-20 -47 -33 -50 -31 -2 3 8 20 22 39 75 98 145 321 166 532 18 173 1 436 -36
559 -5 17 -4 19 7 9 7 -7 18 -13 24 -13 5 0 -2 10 -16 23 -16 13 -35 49 -49
92 -60 185 -172 322 -279 340 -24 4 -53 0 -82 -10 -24 -9 -55 -16 -70 -16 -30
1 -71 -39 -123 -121 -206 -326 -216 -1000 -20 -1354 48 -87 121 -167 142 -155
11 6 26 4 45 -6 16 -8 47 -18 70 -22 l42 -7 -31 -17 c-82 -43 -214 62 -299
237 -167 344 -166 919 1 1264 57 118 145 212 219 236 61 19 130 14 184 -14z
m-34121 -31 c4 -21 -43 -55 -117 -85 -65 -27 -131 -32 -131 -10 0 24 67 68
139 93 74 26 104 26 109 2z m-688 3 c0 -38 -149 -112 -226 -112 -42 0 -44 22
-4 52 62 46 230 90 230 60z m135 -67 c0 -15 -19 -30 -75 -58 -84 -42 -180 -61
-180 -35 0 29 62 68 160 99 68 23 95 21 95 -6z m695 6 c0 -34 -122 -98 -204
-108 -43 -5 -48 -4 -44 13 7 38 151 113 221 114 20 0 27 -5 27 -19z m32640
-83 c13 -29 31 -77 41 -105 17 -51 17 -53 -1 -63 -21 -11 -23 -10 -40 45 -7
22 -21 61 -32 88 -18 41 -24 47 -51 47 -119 0 -264 -183 -329 -417 -18 -64
-28 -84 -47 -93 -23 -10 -23 -10 -17 25 4 20 18 70 32 113 83 256 223 412 370
412 l52 0 22 -52z m-33180 28 c0 -35 -146 -105 -217 -106 -53 0 -57 19 -11 51
73 52 228 89 228 55z m7959 -486 c578 -440 647 -490 680 -490 20 0 146 11 281
24 135 13 262 23 283 22 20 0 38 1 40 4 2 5 2589 251 2625 250 9 0 12 38 12
157 0 156 0 156 20 138 19 -17 20 -29 18 -174 l-3 -155 -1235 -116 c-679 -64
-1251 -116 -1270 -115 -19 0 -42 -2 -50 -6 -8 -4 -170 -22 -360 -39 -190 -16
-358 -32 -375 -35 -27 -4 -98 47 -692 499 -491 373 -659 506 -650 515 6 6 16
11 22 11 5 0 300 -221 654 -490z m-7389 475 c0 -2 -10 -25 -22 -49 -21 -45
-39 -56 -90 -56 -54 0 -23 47 57 88 41 21 55 26 55 17z m-7157 -25 l60 0 -7
-92 c-4 -51 -10 -104 -13 -117 l-6 -24 -176 8 c-97 4 -177 8 -177 8 -1 1 3 53
9 116 l11 114 119 -7 c66 -3 147 -6 180 -6z m10762 0 c-28 -13 -286 -63 -292
-57 -2 3 9 13 26 23 16 10 28 21 26 24 -2 4 26 8 63 9 36 1 69 4 71 7 2 2 32
4 65 3 45 0 56 -3 41 -9z m-4735 -13 c0 -17 -25 -39 -67 -61 -39 -20 -43 -8
-13 42 15 25 27 32 50 32 18 0 30 -5 30 -13z m-5684 -3 l120 -7 -4 -36 c-8
-95 -10 -99 -74 -143 l-62 -41 -120 2 c-66 1 -121 3 -122 4 -1 2 23 221 25
225 2 4 115 2 237 -4z m6384 -4 c0 -35 -127 -100 -212 -107 -34 -4 -58 -2 -58
4 0 12 38 47 70 63 78 41 200 65 200 40z m3753 -11 c-18 -12 -31 -24 -29 -28
3 -4 -3 -7 -12 -8 -47 -3 -972 -206 -1389 -304 l-253 -59 -69 45 c-39 25 -72
49 -75 54 -5 8 619 135 964 195 366 64 765 123 850 125 l45 1 -32 -21z m-9863
0 c30 0 98 -3 150 -6 l96 -5 -12 -111 c-7 -62 -13 -113 -13 -114 -1 -4 -247 7
-306 13 l-50 5 3 52 4 52 74 49 c41 27 73 51 70 53 -2 3 -32 -14 -65 -36 -33
-23 -62 -41 -65 -41 -8 0 -7 64 0 85 5 11 14 14 33 11 14 -3 51 -6 81 -7z
m510 -19 c47 0 90 -4 97 -8 9 -5 9 -34 1 -117 l-11 -110 -131 6 c-72 4 -146 7
-165 8 l-34 1 7 93 c12 148 7 141 85 133 36 -3 104 -6 151 -6z m506 -24 c1 0
-3 -52 -9 -113 l-10 -113 -42 0 c-23 0 -104 3 -180 7 l-137 6 6 61 c4 34 9 85
12 115 l7 53 176 -7 c97 -4 177 -8 177 -9z m4532 -3 c-7 -38 -145 -103 -218
-103 -51 0 -53 21 -4 51 98 60 230 91 222 52z m691 8 c25 -16 3 -39 -74 -77
-74 -37 -185 -59 -185 -37 0 28 95 84 183 108 64 17 59 17 76 6z m-5014 -112
c117 -78 140 -98 137 -116 -3 -21 -5 -22 -150 -17 -81 3 -153 8 -161 10 -10 3
-12 21 -7 82 10 112 17 144 30 139 6 -3 74 -47 151 -98z m153 87 c3 -3 1 -42
-4 -87 l-9 -81 -125 82 c-69 45 -129 87 -135 92 -7 7 35 9 129 5 76 -4 141 -9
144 -11z m272 -6 c47 0 90 -4 96 -8 7 -5 7 -41 0 -116 l-9 -108 -141 6 c-78 4
-154 6 -169 7 -22 0 -27 4 -23 17 3 9 8 58 12 107 3 50 9 94 12 99 2 5 35 6
71 2 36 -3 104 -6 151 -6z m4040 -35 c0 -34 -153 -105 -225 -105 -47 0 -46 22
3 55 81 53 222 85 222 50z m694 6 c13 -21 -10 -43 -80 -77 -114 -54 -220 -58
-163 -5 55 51 227 109 243 82z m32856 -149 c52 -236 70 -615 41 -862 -13 -111
-46 -288 -56 -298 -3 -3 -12 1 -19 9 -12 12 -12 24 0 79 68 315 63 770 -10
1075 -21 87 -22 96 -7 105 22 12 28 -1 51 -108z m-39410 76 c0 -40 -14 -49
-66 -46 l-48 3 49 32 c59 39 65 40 65 11z m5998 5 c-5 -26 -147 -95 -209 -101
-45 -4 -51 -3 -47 13 1 10 14 26 28 37 74 55 236 91 228 51z m24025 2 c435
-92 791 -682 907 -1505 32 -226 50 -654 28 -676 -3 -2 -12 -2 -21 2 -13 5 -15
17 -10 72 11 140 -23 554 -63 756 -15 76 -15 80 2 94 18 13 18 14 -3 7 -19 -5
-23 -2 -23 14 0 39 -89 328 -138 449 -50 122 -135 285 -173 332 -14 17 -12 11
6 -20 118 -203 202 -415 271 -689 25 -101 25 -105 7 -119 -17 -13 -17 -13 2
-10 18 3 22 -7 37 -97 36 -212 53 -467 49 -708 -1 -54 -2 -56 -20 -45 -18 11
-19 26 -20 177 -3 488 -104 951 -287 1320 -105 212 -211 355 -344 463 -90 73
-190 123 -288 143 -64 14 -80 14 -143 1 -277 -58 -536 -340 -704 -766 -43
-110 -47 -116 -65 -95 -12 14 -7 32 29 123 225 561 591 856 964 777z m-23423
-10 c0 -3 -9 -23 -20 -45 -15 -30 -29 -41 -57 -49 -63 -18 -85 -15 -81 11 2
17 21 32 68 55 62 31 90 40 90 28z m-1160 -25 c13 -9 11 -14 -14 -36 -34 -30
-43 -25 -26 16 14 33 18 35 40 20z m695 -25 c0 -15 -19 -30 -76 -58 -85 -42
-179 -60 -179 -35 0 29 82 79 170 104 61 17 85 14 85 -11z m-6550 -28 c1 -1
-2 -38 -6 -81 -10 -86 -9 -84 -94 -134 -49 -29 -51 -29 -162 -23 -61 3 -113 8
-116 11 -3 4 16 214 22 239 1 4 353 -7 356 -12z m203 -12 c2 -2 -34 -28 -80
-58 -93 -61 -97 -60 -83 29 l6 44 77 -7 c42 -3 78 -7 80 -8z m5798 3 c18 -29
-114 -96 -209 -106 l-48 -5 13 27 c14 31 64 60 141 81 65 17 94 18 103 3z
m-5600 -11 c5 -5 -23 -237 -28 -243 -4 -3 -86 -3 -183 1 -148 7 -175 10 -171
22 4 8 6 32 6 54 0 38 2 40 103 109 l102 70 85 -6 c47 -3 85 -6 86 -7z m6294
-1 c0 -24 -63 -66 -137 -92 -85 -30 -123 -31 -123 -5 0 24 50 56 138 87 78 27
122 31 122 10z m-6000 -6 c47 0 90 -4 96 -8 9 -5 9 -37 0 -124 -7 -64 -15
-120 -18 -124 -4 -3 -85 -3 -180 1 l-174 7 13 116 c6 65 12 123 12 131 1 11
17 13 84 8 45 -4 120 -7 167 -7z m478 -25 c2 -2 -2 -60 -9 -129 l-12 -126 -56
0 c-31 0 -106 3 -166 6 l-111 7 13 116 c6 64 12 122 12 130 1 11 30 12 164 6
89 -4 163 -8 165 -10z m285 -11 l119 -6 -6 -42 c-3 -22 -8 -72 -11 -111 -11
-123 11 -111 -187 -101 -95 4 -175 10 -176 11 -2 2 2 61 8 132 l13 129 61 -3
c33 -1 114 -5 179 -9z m7187 -16 c29 -18 63 -42 77 -53 l24 -20 -198 -49
c-700 -173 -1303 -343 -1836 -518 -223 -74 -250 -81 -270 -68 -20 12 -21 12
-8 -3 11 -15 10 -18 -10 -25 -13 -5 -82 -31 -154 -57 -201 -74 -413 -159 -583
-236 -196 -88 -277 -113 -367 -113 -85 -1 -130 20 -151 69 -8 19 -14 39 -14
44 0 6 65 53 145 106 80 53 143 101 140 106 -3 5 2 6 11 2 13 -5 15 -3 9 8 -4
8 -5 11 0 7 4 -4 21 0 37 8 216 112 1503 466 2551 703 194 44 390 88 437 99
111 26 100 27 160 -10z m-2512 -1 c5 -26 -129 -87 -209 -94 -56 -5 -61 -4 -57
13 4 22 89 67 168 88 67 18 94 16 98 -7z m-4220 -3 c25 -4 32 -9 28 -22 -2 -9
-7 -53 -11 -97 -3 -44 -9 -95 -12 -112 l-5 -33 -62 0 c-33 0 -105 3 -160 7
l-99 6 7 81 c4 45 9 104 13 133 l6 52 131 -5 c72 -3 146 -7 164 -10z m4920 -1
c-6 -34 -127 -95 -218 -109 -36 -6 -40 -4 -40 14 0 25 48 56 134 88 76 29 129
31 124 7z m33887 -7 c60 -92 60 -491 -1 -583 -19 -30 -59 -30 -79 1 -27 40
-45 155 -45 287 0 199 32 319 85 319 15 0 31 -9 40 -24z m-38520 -65 l100 -67
-4 -64 c-2 -36 -6 -69 -9 -74 -4 -7 -322 0 -329 8 -3 2 15 188 23 234 5 32 5
32 62 31 53 0 63 -5 157 -68z m37 59 l80 0 -7 -52 c-4 -29 -9 -55 -10 -56 -4
-4 -154 94 -170 111 -7 7 -4 8 8 3 10 -3 55 -6 99 -6z m25095 -7 c-4 -3 -67
-9 -140 -12 -129 -6 -137 -8 -209 -44 -46 -22 -103 -62 -147 -103 l-71 -66 0
41 c0 37 4 44 53 80 105 78 149 94 282 101 181 10 239 11 232 3z m-21059 -30
c-7 -39 -154 -103 -235 -103 -78 0 -10 60 112 99 79 26 128 27 123 4z m618
-42 c-21 -45 -49 -61 -125 -68 -48 -5 -53 -4 -49 12 1 11 18 28 37 39 43 25
144 66 150 60 2 -2 -4 -21 -13 -43z m23218 27 c-4 -7 -36 -53 -70 -103 -82
-120 -171 -270 -226 -380 -52 -102 -109 -256 -80 -215 120 173 253 319 324
356 39 20 37 13 -32 -92 -57 -86 -152 -276 -196 -392 -15 -40 -30 -71 -33 -70
-35 17 -201 132 -201 140 0 23 110 221 184 332 92 136 317 434 329 435 5 1 5
-5 1 -11z m-30129 -67 c-6 -29 -9 -31 -53 -31 -26 0 -42 4 -36 9 20 19 88 60
92 56 2 -2 1 -17 -3 -34z m6435 24 c0 -30 -134 -92 -222 -102 -112 -13 -17 68
122 106 56 15 100 13 100 -4z m32865 -100 c-8 -44 -14 -96 -13 -115 0 -32 1
-31 8 11 4 26 17 67 28 93 17 37 26 46 46 46 18 0 30 -9 41 -31 58 -111 60
-455 3 -563 l-13 -26 -45 30 c-26 17 -48 41 -53 57 -5 16 -13 100 -17 188 l-8
160 3 -215 c3 -169 8 -236 24 -315 44 -215 124 -395 216 -489 70 -70 91 -78
122 -40 35 43 98 178 125 266 22 75 41 97 55 62 15 -41 -94 -296 -158 -367
l-37 -42 -57 29 c-129 67 -239 261 -295 522 -11 54 -24 132 -29 172 -6 64 -5
72 8 67 12 -4 12 -2 -1 9 -16 12 -18 32 -18 167 0 85 7 203 15 264 12 92 18
112 37 127 13 9 24 16 25 14 1 -1 -4 -38 -12 -81z m-33437 58 c-2 -10 -18 -27
-36 -40 -37 -24 -130 -58 -139 -50 -2 3 1 22 8 41 11 30 20 38 54 47 22 5 45
12 50 14 6 2 23 4 38 4 22 1 28 -3 25 -16z m712 -18 c0 -47 -258 -129 -267
-85 -7 30 147 98 225 99 31 1 42 -3 42 -14z m-6688 -41 l106 -6 -4 -31 c-2
-18 -8 -72 -13 -120 -5 -49 -10 -90 -12 -91 -8 -6 -178 7 -175 13 3 4 -11 5
-31 3 -22 -3 -38 0 -43 9 -7 10 -11 10 -24 0 -10 -8 -28 -11 -49 -7 l-33 6 12
118 c7 64 13 119 13 120 1 2 34 1 74 -2 39 -3 120 -8 179 -12z m6116 -1 c-10
-50 -268 -136 -268 -89 0 22 49 52 131 80 90 31 142 34 137 9z m712 -2 c0 -8
-231 -91 -253 -91 -23 0 0 22 48 44 89 42 205 69 205 47z m-6447 -17 l128 -6
-5 -27 c-3 -14 -8 -62 -11 -106 -10 -129 3 -119 -144 -111 -69 4 -149 9 -176
13 l-51 5 13 117 c6 64 12 120 12 124 1 5 25 6 54 3 28 -3 110 -8 180 -12z
m380 -20 l148 -6 -5 -27 c-3 -14 -8 -60 -11 -101 -3 -41 -9 -88 -12 -104 l-5
-29 -97 7 c-53 4 -132 9 -176 12 l-81 6 13 117 c6 64 12 122 12 129 1 9 11 11
34 8 17 -3 99 -8 180 -12z m515 -28 c1 -2 -3 -61 -10 -132 -12 -118 -15 -129
-33 -129 -11 0 -86 4 -167 9 -144 8 -148 9 -143 30 2 11 7 53 10 91 3 39 8 88
11 110 l6 40 161 -8 c89 -5 163 -10 165 -11z m4980 7 c-7 -35 -218 -116 -261
-100 -26 10 -10 35 37 59 101 52 231 76 224 41z m-4735 -19 l158 -6 -5 -37
c-3 -20 -8 -65 -11 -101 -3 -36 -8 -81 -11 -100 l-5 -35 -170 11 c-94 7 -173
15 -176 18 -3 3 0 64 7 135 12 125 13 131 34 126 11 -2 92 -7 179 -11z m418
-20 l105 -7 -14 -136 c-8 -75 -15 -137 -17 -139 -2 -3 -319 18 -321 22 -1 0 5
55 12 121 7 66 13 126 13 133 1 14 61 16 222 6z m4449 -4 c13 -9 11 -14 -12
-34 -58 -51 -248 -100 -248 -63 0 17 41 47 65 47 8 0 15 4 15 8 0 8 79 34 135
46 11 2 22 4 25 5 3 0 12 -4 20 -9z m-3973 -24 c3 -2 -26 -279 -30 -281 -7 -4
-316 21 -321 26 -5 5 10 207 19 254 4 19 9 20 167 12 90 -5 164 -10 165 -11z
m3407 -25 c3 -4 -3 -16 -12 -25 -19 -16 -80 -41 -87 -35 -2 2 3 19 10 37 12
27 19 32 49 32 19 0 37 -4 40 -9z m136 -51 c13 -9 11 -13 -10 -30 -31 -24 -48
-25 -72 -3 -18 16 -18 16 -12 0 3 -9 11 -17 17 -17 22 0 -9 -18 -58 -33 -76
-24 -128 -26 -133 -4 -4 22 78 62 170 82 79 17 80 17 98 5z m21793 -23 c-4 -7
-40 -60 -79 -117 -133 -197 -239 -391 -288 -530 -31 -85 -29 -84 43 21 65 97
187 228 248 268 25 17 49 29 51 26 3 -3 -16 -36 -42 -75 -61 -93 -134 -231
-186 -354 -44 -104 -120 -326 -120 -350 0 -7 -7 -19 -15 -26 -12 -10 -18 -10
-32 1 -16 13 -17 12 -4 -4 8 -10 20 -16 28 -13 10 4 12 -1 7 -22 -4 -15 -11
-29 -16 -30 -4 -2 -6 -7 -3 -12 3 -4 -4 -50 -15 -101 -43 -211 -54 -326 -54
-579 -1 -320 27 -499 121 -762 40 -116 204 -496 235 -545 11 -18 16 -33 12
-33 -16 0 -114 83 -190 162 -207 214 -313 444 -381 828 -32 182 -43 525 -23
730 13 133 18 148 62 171 11 6 17 13 15 16 -3 2 -17 -3 -32 -13 l-27 -17 7 39
c58 339 175 640 348 897 95 140 318 435 330 436 4 1 4 -5 0 -12z m-21698 -36
c-8 -7 -67 -27 -192 -66 -7 -3 -13 0 -13 5 0 14 148 65 200 69 8 1 10 -2 5 -8z
m-6112 -27 c70 -4 129 -9 131 -13 5 -9 -20 -241 -27 -248 -4 -3 -75 0 -159 6
-84 6 -162 11 -174 11 -19 0 -20 3 -12 83 4 45 10 98 12 117 3 19 5 41 6 49 0
10 11 12 48 8 26 -3 104 -9 175 -13z m372 -25 c88 -6 161 -12 162 -13 3 -3
-25 -247 -30 -252 -10 -10 -321 17 -336 29 -10 9 -12 30 -7 97 10 124 16 150
35 150 9 0 88 -5 176 -11z m25759 -6 c12 -42 28 -155 22 -161 -8 -7 -818 -133
-824 -128 -2 2 35 29 82 60 47 31 86 59 86 62 0 7 -8 2 -115 -70 -77 -52 -100
-63 -160 -72 -38 -6 -71 -10 -73 -9 -5 5 -25 206 -20 210 7 7 730 96 799 98
37 1 65 5 63 9 -4 6 29 11 108 16 18 1 28 -4 32 -15z m-25334 -24 c74 -6 135
-11 136 -12 3 -5 -25 -250 -29 -253 -3 -3 -84 1 -181 7 -152 11 -176 15 -172
28 2 9 7 52 11 96 11 146 11 145 59 145 23 0 103 -5 176 -11z m363 -25 c76 -4
139 -10 142 -13 5 -9 -19 -248 -25 -255 -3 -2 -78 1 -168 7 l-163 11 5 25 c3
14 7 58 11 96 11 135 15 147 39 142 11 -3 83 -9 159 -13z m12057 -33 c217 -33
444 -94 642 -171 l56 -22 7 -132 c4 -72 5 -157 3 -189 l-3 -58 -50 35 c-48 32
-656 434 -682 450 -7 4 -13 5 -13 2 0 -3 87 -63 193 -132 415 -274 567 -375
567 -380 0 -2 -21 -47 -47 -99 -35 -69 -52 -95 -63 -91 -8 3 -71 26 -139 51
-266 99 -450 135 -726 142 -226 6 -345 -7 -542 -58 -729 -187 -1424 -842
-1957 -1842 -38 -69 -62 -105 -69 -100 -7 4 -118 76 -247 161 -129 85 -242
157 -250 159 -8 3 101 -71 243 -165 141 -94 257 -173 257 -175 0 -2 -31 -69
-69 -148 -70 -146 -154 -341 -187 -436 -15 -42 -23 -53 -40 -53 -34 0 -644
-39 -701 -45 l-52 -5 44 130 c110 319 235 627 375 916 125 259 327 618 377
668 10 10 151 105 313 211 162 107 304 201 315 210 19 15 19 15 -5 4 -22 -11
-101 -63 -444 -291 -49 -33 -106 -71 -128 -84 l-39 -25 52 78 c269 401 626
770 981 1016 183 126 354 218 563 302 253 101 462 152 785 189 19 2 150 3 290
1 196 -2 286 -8 390 -24z m-11678 8 l166 -12 -4 -31 c-2 -17 -9 -76 -14 -130
-6 -55 -12 -101 -13 -102 -2 -2 -332 22 -346 25 -4 1 6 136 16 214 3 26 11 47
17 47 6 0 86 -5 178 -11z m411 -28 c59 -5 110 -11 114 -14 3 -3 -1 -62 -7
-131 l-13 -126 -46 0 c-53 0 -272 18 -276 22 -2 2 20 236 24 256 1 4 96 1 204
-7z m382 -27 l110 -7 -3 -46 -4 -46 -121 -80 c-116 -77 -122 -80 -171 -76 -28
1 -52 4 -54 6 -2 1 3 62 9 135 l13 132 55 -6 c31 -3 106 -8 166 -12z m28163
-81 c60 -60 103 -123 152 -221 71 -142 136 -369 156 -547 3 -33 8 -63 11 -68
2 -4 -7 -2 -20 4 -21 9 -25 22 -36 92 -24 161 -76 341 -136 473 -54 118 -155
254 -188 254 -33 0 -159 -186 -203 -300 -21 -56 -18 -52 -38 -44 -22 9 -20 22
15 100 57 129 191 304 231 304 5 0 30 -21 56 -47z m-16213 -160 c150 -119 481
-451 602 -604 144 -182 261 -354 363 -534 l34 -60 -34 23 c-19 13 -56 37 -82
53 -29 19 -59 50 -78 82 -29 48 -31 50 -26 19 7 -38 12 -40 -89 29 -66 44
-364 328 -347 330 4 1 11 1 15 0 5 -1 6 3 2 9 -5 8 -11 8 -19 1 -9 -7 -28 3
-67 35 -29 25 -53 48 -52 53 1 4 -3 8 -10 8 -7 0 -68 43 -137 94 -69 52 -170
125 -226 161 l-101 67 -6 128 c-9 160 -9 257 -1 277 7 19 87 -34 259 -171z
m10709 125 c22 -170 18 -258 -14 -258 -5 0 -11 53 -15 119 -4 65 -10 123 -14
128 -4 6 -293 -30 -746 -93 -697 -98 -742 -103 -770 -88 -27 14 -28 14 -11 0
11 -9 18 -16 15 -17 -2 0 -433 -60 -956 -133 -524 -73 -955 -135 -958 -138 -3
-3 -1 -146 5 -318 5 -173 8 -315 7 -317 -2 -1 -11 3 -21 10 -16 12 -19 45 -28
336 -5 177 -8 324 -6 326 5 5 3434 482 3474 484 30 1 32 -1 38 -41z m4653 31
c7 -7 0 -45 -24 -127 -84 -289 -123 -561 -130 -912 -6 -276 8 -474 47 -708 19
-111 78 -360 95 -405 7 -16 5 -16 -19 -6 -30 14 -40 43 -81 224 -66 295 -90
562 -82 913 9 374 53 666 143 955 25 78 31 86 51 66z m-10867 -4 c0 -2 -7 -19
-16 -37 -12 -25 -56 -60 -182 -142 -358 -235 -530 -351 -527 -354 3 -3 246
155 583 380 101 67 102 68 88 36 -7 -18 -51 -114 -96 -213 l-82 -180 11 -60
c6 -33 7 -62 3 -66 -11 -9 -739 -82 -762 -76 -13 3 -18 1 -13 -5 4 -8 -5 -9
-26 -5 -18 4 -40 3 -50 -2 -9 -5 -55 -12 -101 -16 -47 -3 -355 -35 -685 -70
-330 -36 -610 -65 -621 -65 -15 0 -96 80 -278 276 -142 152 -255 278 -252 281
2 3 677 76 1498 163 821 87 1496 159 1501 159 4 1 7 -1 7 -4z m20775 -46 c15
-23 -38 -3 -53 20 l-16 24 31 -17 c18 -9 35 -21 38 -27z m-37130 -77 l-7 -65
-75 7 c-42 3 -89 6 -106 6 -26 0 -16 9 79 74 122 82 120 82 109 -22z m-2319
55 c4 -6 -23 -227 -29 -233 -3 -4 -84 -1 -178 6 l-171 14 6 85 c4 47 9 102 12
121 l6 35 176 -13 c97 -7 177 -14 178 -15z m38149 -53 c0 -62 -2 -67 -27 -80
l-28 -15 0 81 0 80 28 0 c27 0 27 -1 27 -66z m-37886 -37 l123 -82 -4 -47 c-3
-27 -7 -51 -10 -53 -3 -3 -80 1 -172 10 -91 8 -170 15 -174 15 -4 0 -2 53 4
118 7 64 13 120 13 123 1 4 22 4 49 2 38 -4 71 -21 171 -86z m5251 88 c0 -5
-238 -165 -257 -172 -7 -3 -13 2 -13 10 0 26 71 79 165 123 89 43 105 48 105
39z m-5189 -20 l76 -6 -5 -57 c-2 -31 -7 -60 -11 -64 -5 -5 -197 114 -219 137
-3 3 14 3 39 0 24 -2 78 -7 120 -10z m29554 -153 c-3 -10 -19 -61 -35 -115
-92 -307 -133 -599 -129 -905 l2 -173 -96 -65 c-53 -35 -97 -67 -97 -70 0 -7
8 -2 98 58 103 69 99 69 107 1 24 -205 85 -419 188 -658 103 -242 125 -293
142 -324 12 -24 12 -31 3 -31 -7 -1 -2 -7 12 -15 14 -8 20 -14 14 -15 -16 0
-49 27 -49 42 0 7 -8 12 -18 12 -9 -1 -14 2 -12 7 3 4 -9 16 -26 25 -75 38
-226 224 -301 370 -87 168 -154 414 -184 670 -20 173 -14 574 10 728 33 203
80 386 136 534 l31 81 105 -70 c81 -55 104 -75 99 -87z m-29285 133 c58 -3
128 -8 155 -11 l51 -6 -12 -121 c-7 -67 -13 -124 -13 -127 -1 -3 -43 -2 -93 3
-90 8 -95 10 -175 63 -77 52 -81 57 -78 87 17 135 15 127 38 123 12 -3 69 -8
127 -11z m38307 -90 c45 -364 169 -707 333 -923 80 -106 78 -125 -3 -24 -175
217 -299 529 -351 887 -9 61 -19 123 -21 138 -4 23 -1 28 12 25 14 -2 20 -23
30 -103z m-37881 60 c73 -4 136 -10 142 -14 9 -6 -9 -245 -19 -256 -4 -3 -322
24 -325 28 -2 2 21 229 25 256 1 2 11 1 24 -2 12 -3 81 -9 153 -12z m427 -31
l117 -7 0 -34 c0 -41 -20 -227 -25 -232 -4 -4 -257 16 -315 25 l-36 5 13 117
c6 64 12 123 12 131 1 11 13 12 59 7 31 -3 110 -9 175 -12z m395 -30 l92 -7 0
-33 c0 -29 -6 -38 -42 -60 -24 -15 -86 -56 -140 -91 -74 -49 -105 -63 -133
-63 l-37 0 5 43 c4 23 9 74 12 112 11 125 6 118 83 112 37 -4 109 -9 160 -13z
m26352 -56 c69 -155 132 -386 164 -603 26 -175 51 -555 37 -555 -3 0 -13 6
-22 13 -13 10 -17 42 -22 172 -13 345 -85 703 -190 938 -28 63 -32 67 -63 67
-166 0 -351 -210 -454 -515 -22 -66 -31 -80 -48 -81 -12 -1 -22 2 -22 7 0 21
68 195 107 274 77 155 170 262 273 315 62 32 87 38 151 39 l56 1 33 -72z
m-25942 26 c60 -7 57 7 40 -162 l-11 -123 -41 6 c-23 2 -95 10 -161 16 -66 6
-122 13 -124 15 -2 2 1 52 7 111 9 93 14 109 34 125 13 10 18 18 13 18 -6 0
-16 -5 -23 -12 -9 -9 -12 -8 -12 5 0 15 11 17 113 12 61 -3 136 -8 165 -11z
m-1690 -129 c-5 -4 -138 15 -138 20 0 3 0 21 0 40 l0 35 70 -46 c39 -26 69
-48 68 -49z m40722 46 c-61 -78 -120 -117 -191 -126 l-44 -6 28 16 c16 9 25
21 21 27 -4 6 -3 8 3 5 6 -4 55 23 109 58 55 36 101 65 102 65 2 0 -10 -18
-28 -39z m-16376 12 c9 -35 18 -383 11 -460 l-7 -79 -546 -88 c-301 -48 -659
-105 -797 -128 -1767 -285 -1829 -294 -1853 -280 -12 8 -21 17 -19 19 6 5
2480 403 2532 407 22 1 47 5 55 9 8 3 143 26 298 51 156 24 286 47 289 50 11
11 14 201 6 349 -8 139 -4 167 18 167 4 0 10 -8 13 -17z m-22990 -87 l-7 -86
-51 1 c-28 1 -82 4 -121 8 l-70 6 124 83 c68 45 126 80 128 78 2 -2 1 -43 -3
-90z m-2089 43 c77 -6 141 -12 142 -13 2 -1 -28 -280 -30 -282 -5 -5 -343 29
-348 35 -4 3 0 60 7 126 7 66 13 128 13 138 1 16 7 18 39 13 20 -3 100 -11
177 -17z m30258 -14 c12 -5 9 -23 -15 -103 -172 -580 -80 -1353 203 -1692 59
-71 64 -70 133 18 122 160 208 393 251 686 20 138 29 402 18 529 -5 53 -6 97
-3 97 3 0 13 -7 23 -14 17 -13 25 -72 8 -61 -5 3 -13 1 -16 -5 -4 -6 -1 -9 6
-8 20 5 27 -39 28 -172 3 -468 -115 -892 -309 -1113 -77 -87 -91 -84 -185 31
-128 154 -231 446 -266 754 -12 99 -11 109 5 127 16 18 16 19 -1 17 -17 -1
-18 12 -17 199 1 128 7 242 18 318 22 152 83 397 100 397 2 0 11 -2 19 -5z
m-29870 -19 c82 -8 150 -16 151 -18 3 -3 -24 -282 -27 -284 -4 -4 -347 33
-351 37 -3 3 1 65 9 139 8 74 15 136 15 138 0 4 58 1 203 -12z m342 -31 c79
-6 97 -11 149 -42 l58 -36 -5 -46 c-4 -25 -9 -78 -13 -116 l-6 -71 -175 17
c-96 10 -176 19 -179 22 -4 4 8 142 22 245 5 41 7 43 32 38 15 -3 68 -8 117
-11z m7435 -19 c47 -9 99 -20 115 -24 38 -11 45 -44 13 -67 -13 -10 -16 -15
-7 -12 13 4 7 -24 -28 -136 -46 -144 -64 -180 -83 -161 -7 7 6 61 40 169 28
87 47 162 43 166 -36 34 -461 60 -666 41 -106 -10 -121 -10 -145 6 -26 16 -26
16 -13 -1 7 -9 12 -17 10 -17 -35 -3 -354 -62 -358 -66 -3 -4 10 -4 29 -1 19
3 117 11 216 18 164 11 184 10 205 -5 30 -20 49 -21 23 -1 -17 14 -5 15 136
13 182 -3 198 -10 224 -84 27 -80 13 -243 -20 -230 -8 3 -25 1 -39 -4 -16 -6
-26 -6 -31 1 -4 6 -11 6 -20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6 14
-15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 33 0 36 13 44 1 27 -40 -10 -24
-18 -31 -30 -27 -13 5 -14 4 -5 -7 20 -25 -81 -150 -303 -377 -267 -272 -393
-436 -500 -648 -45 -90 -93 -229 -102 -300 -4 -29 -10 -54 -14 -57 -3 -2 -60
32 -126 75 -65 44 -123 80 -129 80 -5 0 50 -39 123 -86 l132 -86 0 -42 c0 -22
7 -72 15 -110 8 -38 14 -71 12 -72 -1 -1 -22 -12 -47 -24 -147 -73 -322 -219
-421 -348 -26 -35 -68 -102 -92 -150 -44 -85 -92 -210 -84 -218 6 -6 325 12
552 31 175 15 568 55 572 59 1 1 59 182 129 401 70 220 129 405 131 412 2 6
-2 13 -10 15 -10 2 45 187 227 759 225 709 241 757 262 755 12 0 21 -3 20 -6
-2 -3 -178 -557 -391 -1232 -358 -1129 -391 -1227 -416 -1242 l-27 -16 14 47
c18 59 18 62 -3 57 -10 -2 -108 -13 -218 -24 -628 -62 -1250 -83 -1782 -60
l-223 10 -76 50 c-42 28 -78 49 -81 47 -2 -2 26 -23 62 -47 36 -24 64 -44 62
-46 -9 -9 -560 45 -727 72 -52 9 -113 18 -135 20 -22 3 -85 14 -140 25 -55 10
-103 19 -107 19 -4 0 -28 -41 -54 -91 -48 -98 -48 -108 6 -110 14 0 34 -4 44
-8 17 -6 15 -9 -12 -20 -28 -12 -121 -8 -145 6 -4 3 34 84 84 181 342 657 738
1229 1142 1648 140 146 295 289 303 281 3 -3 -19 -27 -48 -53 -285 -260 -540
-553 -791 -906 -106 -150 -289 -425 -304 -458 -4 -8 -23 -42 -43 -75 -90 -147
-191 -338 -183 -345 9 -9 104 -30 131 -30 12 1 57 74 147 236 130 234 130 234
160 229 122 -23 194 -27 309 -16 150 14 316 50 326 71 4 8 17 66 29 129 46
241 158 504 297 698 66 93 235 288 264 306 12 7 39 -6 109 -52 51 -33 98 -61
103 -61 6 0 -32 27 -83 61 -52 34 -98 64 -102 68 -4 4 88 96 205 203 342 315
405 408 276 408 -65 0 -255 -62 -383 -125 -76 -37 -241 -152 -372 -260 -18
-14 -33 -22 -33 -17 0 23 253 211 420 312 396 239 1118 471 1645 529 55 6 114
13 130 15 76 10 494 -3 575 -18z m-7224 -12 c-3 -9 -6 -20 -6 -24 0 -5 -16 0
-35 11 -19 12 -35 23 -35 25 0 2 18 4 41 4 33 0 40 -3 35 -16z m276 -11 c49
-3 90 -9 92 -12 2 -3 -3 -64 -11 -136 -8 -71 -15 -136 -15 -142 -1 -13 -59
-19 -70 -8 -3 3 -41 8 -84 10 -44 2 -101 7 -127 11 l-48 6 6 67 c11 120 16
144 28 132 6 -6 16 -11 21 -11 6 0 0 7 -12 16 -22 15 -27 38 -15 69 5 15 16
17 76 11 39 -4 110 -9 159 -13z m20208 -33 c0 -17 -7 -34 -17 -40 -17 -11 -17
-11 0 -6 16 5 17 -11 17 -245 0 -235 -1 -251 -17 -245 -17 6 -17 5 0 -8 15
-12 17 -34 17 -208 l0 -195 -27 -6 c-151 -28 -5506 -769 -5524 -764 -49 13
-60 30 -99 172 -21 77 -63 215 -94 307 -60 179 -62 188 -44 170 7 -7 17 -12
22 -12 6 0 -4 12 -21 28 -23 21 -42 60 -82 168 -28 78 -51 151 -51 163 0 41
31 58 136 70 510 62 820 96 824 91 3 -3 244 24 535 62 292 37 554 70 582 72
29 3 65 9 79 12 16 4 25 3 21 -2 -3 -6 3 -10 13 -10 10 0 16 4 14 8 -6 10 -21
8 809 113 412 52 776 99 810 105 79 13 77 13 77 -5 0 -10 9 -15 28 -14 15 0
452 56 972 123 520 68 962 124 983 125 35 1 37 -1 37 -29z m-19891 5 c91 -9
167 -17 169 -20 6 -6 -19 -279 -27 -287 -5 -6 -340 20 -349 27 -3 3 12 166 24
253 3 23 8 42 12 42 4 0 81 -7 171 -15z m25635 -5 l32 -19 -28 -113 c-24 -100
-65 -324 -83 -459 -5 -41 -11 -51 -45 -73 -22 -15 -40 -23 -40 -18 0 22 32
268 46 347 17 104 76 355 82 355 3 0 19 -9 36 -20z m-25221 -31 c67 -7 123
-13 125 -14 4 -3 -28 -288 -33 -293 -8 -8 -306 21 -312 30 -9 16 19 272 31
280 15 10 48 10 189 -3z m350 -31 c121 -10 147 -15 147 -27 -1 -34 -29 -284
-33 -287 -4 -4 -319 25 -324 29 -1 2 4 63 12 137 8 74 15 141 15 148 0 15 1
15 183 0z m28018 -108 c46 -25 84 -160 95 -337 l6 -98 -104 -67 c-156 -102
-142 -112 -135 98 7 226 31 335 85 397 18 20 26 21 53 7z m-30368 -21 c107 -9
150 -16 154 -26 5 -14 -11 -201 -18 -207 -2 -2 -78 5 -169 15 -91 10 -169 19
-174 19 -8 0 0 152 11 198 4 18 11 22 27 19 11 -3 88 -11 169 -18z m415 -40
l142 -12 0 -26 c0 -34 -18 -193 -23 -197 -3 -3 -264 22 -322 31 l-30 5 11 108
c6 59 12 109 13 111 0 2 16 1 34 -2 17 -3 96 -11 175 -18z m370 -35 c92 -9
169 -18 171 -20 4 -4 -17 -216 -23 -221 -6 -6 -340 29 -347 36 -9 9 13 221 23
221 5 0 84 -7 176 -16z m353 -34 c157 -15 189 -20 189 -31 0 -6 -4 -8 -8 -5
-4 2 -14 1 -22 -4 -9 -5 -20 -4 -30 3 -10 7 -10 5 2 -8 14 -15 20 -16 32 -6
13 11 17 11 21 -1 6 -14 -11 -187 -18 -195 -2 -2 -77 4 -166 13 l-163 17 6 31
c3 17 8 68 12 114 6 69 9 82 24 82 10 0 64 -4 121 -10z m270 -30 c6 0 7 -6 3
-12 -6 -10 -5 -10 7 -1 16 13 77 14 85 2 3 -5 -3 -6 -13 -2 -15 5 -16 3 -5 -8
9 -10 15 -10 24 -1 8 8 15 9 25 1 8 -7 18 -8 26 -2 6 5 18 8 25 7 6 -1 36 -2
65 -3 28 -1 57 -5 64 -9 9 -6 9 -33 1 -117 -6 -61 -12 -112 -14 -114 -2 -2
-82 5 -179 15 -169 17 -176 19 -171 38 6 27 21 198 18 210 -2 5 4 6 13 2 9 -3
21 -6 26 -6z m24776 0 c56 -20 56 -18 44 -475 -6 -230 -14 -422 -18 -425 -5
-4 -199 -41 -433 -84 -234 -42 -433 -80 -443 -82 -17 -5 -17 6 -11 223 4 125
8 229 9 231 2 2 64 -38 140 -87 75 -50 141 -91 147 -91 5 0 -56 43 -136 96
l-146 97 1 141 c1 212 10 291 36 318 19 19 73 30 400 84 208 34 378 63 379 63
1 1 15 -4 31 -9z m1642 -53 c-14 -44 -16 -57 -39 -181 -23 -127 -26 -187 -5
-111 30 113 59 155 106 155 82 0 131 -168 131 -450 0 -226 -26 -367 -78 -430
-48 -57 -107 -32 -139 60 -31 87 -38 137 -45 325 -8 189 -8 189 -5 -65 4 -326
26 -474 111 -732 41 -123 107 -259 164 -335 38 -49 39 -53 21 -63 -16 -8 -24
-4 -49 28 -127 162 -227 448 -274 782 -20 147 -17 605 5 750 23 148 57 293 70
302 23 14 35 -3 26 -35z m-25870 3 c57 -6 110 -10 118 -10 14 0 15 -13 9 -87
-4 -49 -9 -103 -13 -121 l-6 -33 -76 6 c-64 6 -86 13 -136 44 -83 52 -85 53
-85 48 0 -3 23 -19 50 -37 28 -18 49 -34 47 -37 -2 -2 -30 0 -62 3 l-57 7 6
71 c4 39 10 93 13 119 l6 48 41 -6 c22 -3 88 -10 145 -15z m322 -30 c57 -5
122 -12 144 -15 l41 -6 -12 -115 c-6 -63 -13 -117 -16 -120 -3 -2 -78 3 -167
12 -155 17 -162 18 -157 38 2 12 8 62 11 111 4 50 9 93 12 98 5 9 20 9 144 -3z
m-2268 -52 l128 -12 -5 -31 c-3 -16 -8 -69 -12 -118 -4 -48 -11 -90 -16 -93
-5 -3 -86 2 -180 12 l-170 18 6 76 c4 41 9 97 13 124 l6 48 51 -5 c28 -4 109
-12 179 -19z m357 -38 c58 -5 119 -12 136 -15 l30 -5 -12 -121 c-7 -67 -14
-123 -16 -125 -2 -2 -80 5 -173 16 -94 11 -172 20 -175 20 -3 0 0 53 6 118 7
64 13 121 13 126 1 4 20 6 44 2 23 -3 89 -10 147 -16z m380 -40 c179 -18 180
-18 180 -49 0 -24 -16 -38 -128 -114 l-128 -85 -63 5 c-60 6 -62 7 -57 32 3
14 8 60 11 101 10 127 12 131 48 125 18 -3 79 -9 137 -15z m235 -40 c-8 -14 8
-13 22 1 10 10 128 3 263 -17 l36 -5 -13 -126 c-7 -69 -14 -127 -15 -128 -4
-3 -320 33 -324 38 -4 4 19 225 25 245 1 1 4 2 7 2 3 0 2 -4 -1 -10z m659 -56
l58 -6 -6 -47 c-3 -25 -9 -83 -12 -128 -6 -76 -9 -83 -28 -82 -40 0 -325 35
-330 40 -3 3 20 250 23 255 1 0 199 -21 295 -32z m28822 -81 c-14 -197 -61
-333 -117 -333 -45 0 -98 123 -102 235 l-2 50 109 73 c60 39 112 72 114 72 3
0 2 -44 -2 -97z m-29540 60 c-2 -16 -8 -58 -11 -94 l-6 -65 -67 8 c-37 4 -87
11 -111 14 l-43 6 118 78 c66 43 120 79 122 79 2 1 1 -11 -2 -26z m12209 -6
c351 -67 641 -202 900 -419 402 -337 707 -867 854 -1483 44 -181 44 -181 33
-170 -6 6 -20 55 -32 110 -169 755 -564 1369 -1093 1697 -268 167 -585 261
-912 272 -135 5 -135 1 0 -13 75 -8 71 -8 -70 -10 -233 -2 -402 -36 -612 -125
-86 -37 -105 -42 -120 -31 -15 11 -10 16 42 43 111 55 286 111 435 138 100 18
464 12 575 -9z m2073 -139 c6 -34 10 -63 9 -65 -2 -1 -26 30 -54 70 -28 39
-66 92 -84 116 l-33 44 75 -52 76 -52 11 -61z m-13328 142 c47 -6 107 -13 135
-16 57 -6 56 -5 46 -23 -7 -11 -14 -10 -37 4 l-29 17 23 -20 c12 -11 27 -22
33 -24 8 -3 8 -32 0 -108 -6 -57 -13 -106 -16 -108 -2 -3 -71 3 -152 12 -82 9
-152 16 -157 16 -8 0 -4 75 11 208 7 60 1 59 143 42z m19780 -112 c0 -72 3
-98 13 -98 6 1 60 9 119 19 101 16 110 16 133 1 25 -17 23 -17 -112 -39 -76
-12 -150 -24 -165 -27 l-28 -6 0 136 c0 134 0 136 20 124 18 -11 20 -24 20
-110z m5468 2 c-15 -177 -3 -642 22 -830 24 -179 57 -350 99 -502 l29 -108
-30 18 c-16 9 -35 24 -42 32 -29 33 -102 372 -131 610 -19 149 -32 652 -20
774 6 71 8 75 43 99 20 14 38 24 39 23 1 -1 -3 -53 -9 -116z m-24694 48 c7
-10 -19 -218 -26 -218 -7 0 -258 161 -306 196 -2 1 -1 15 2 31 l7 29 161 -18
c88 -9 161 -18 162 -20z m10594 35 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0
27 -2 18 -5z m65 -10 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z
m-13138 -59 c83 -9 151 -17 152 -18 4 -3 -26 -268 -30 -273 -3 -2 -79 5 -170
17 -92 11 -170 20 -175 20 -4 0 -2 53 4 118 7 64 13 127 13 140 1 20 5 23 29
18 15 -3 95 -12 177 -22z m2305 -104 c82 -55 150 -106 150 -113 0 -11 -31 -10
-152 4 -84 10 -159 18 -166 18 -10 1 -12 11 -8 39 3 20 8 63 11 95 4 31 8 57
11 57 2 0 71 -45 154 -100z m-1945 65 c208 -24 191 -18 187 -67 -4 -43 -4 -43
-131 -126 l-126 -83 -60 7 c-33 3 -61 7 -62 8 -1 1 22 236 27 274 0 4 37 2
165 -13z m15140 -175 c36 -75 44 -104 59 -216 10 -71 16 -142 14 -159 -3 -26
-6 -23 -22 30 -29 99 -101 262 -176 399 -38 70 -70 130 -70 132 0 2 34 -20 76
-48 72 -49 79 -57 119 -138z m-14871 141 c17 -6 16 -9 -9 -25 -31 -20 -36 -18
-28 12 6 24 8 24 37 13z m209 -22 c124 -14 113 7 95 -177 l-11 -124 -26 5
c-14 3 -95 13 -179 23 l-154 18 6 51 c3 27 8 77 12 110 6 58 8 62 48 88 29 20
49 26 71 23 17 -3 78 -11 138 -17z m11276 9 c17 -11 9 -18 -83 -72 -418 -249
-796 -651 -1100 -1169 -51 -86 -59 -96 -76 -87 -18 10 -16 16 31 98 304 521
698 944 1103 1183 55 33 101 59 103 59 2 0 12 -5 22 -12z m-10913 -50 l114
-12 0 -30 c0 -16 -5 -81 -11 -143 -10 -92 -15 -113 -28 -113 -39 0 -297 34
-304 40 -8 7 9 236 19 269 3 10 16 12 51 7 25 -3 97 -11 159 -18z m379 -44
c71 -8 131 -16 132 -18 5 -4 -25 -278 -31 -283 -5 -5 -338 35 -344 42 -4 4 16
226 24 263 4 21 9 23 47 17 23 -3 100 -12 172 -21z m-1048 -71 c-5 -49 -10
-89 -11 -90 -4 -5 -206 21 -206 26 0 5 217 151 224 151 1 0 -2 -39 -7 -87z
m28136 -51 c-9 -269 -40 -514 -94 -733 -29 -116 -34 -128 -62 -144 -29 -17
-30 -17 -23 0 17 45 57 199 75 290 32 158 51 325 61 530 5 105 10 192 10 194
0 2 8 -3 18 -13 16 -14 18 -29 15 -124z m-26730 82 c73 -9 134 -18 136 -20 2
-2 -2 -69 -9 -148 -13 -139 -14 -145 -34 -141 -12 2 -84 12 -161 21 -77 9
-141 17 -142 17 0 1 5 61 13 132 7 72 14 136 14 143 0 16 24 15 183 -4z m402
-46 l110 -11 -14 -149 c-12 -123 -17 -148 -30 -148 -45 2 -301 37 -307 42 -6
7 13 249 22 277 3 10 17 12 57 7 28 -3 102 -11 162 -18z m-2415 -53 c69 -8
141 -17 160 -21 l36 -5 -13 -112 c-7 -62 -14 -117 -15 -122 -1 -7 -26 -7 -74
-1 -45 6 -71 13 -67 19 4 7 -1 8 -13 3 -10 -4 -59 -2 -108 5 l-88 12 6 86 c10
126 16 151 35 151 9 0 73 -7 141 -15z m452 -56 c64 -6 122 -15 129 -19 9 -6 9
-35 -1 -126 -6 -66 -13 -120 -15 -122 -4 -5 -334 41 -343 47 -6 4 9 210 17
239 1 2 22 1 49 -1 26 -3 100 -11 164 -18z m11590 -156 c-262 -278 -439 -494
-587 -718 -86 -129 -182 -305 -200 -365 -5 -16 40 25 125 113 144 150 299 288
429 381 86 61 260 156 287 156 10 0 -8 -27 -47 -71 -183 -202 -374 -463 -484
-661 -41 -73 -51 -86 -66 -78 -12 7 -21 5 -30 -8 -12 -15 -12 -16 2 -4 24 18
43 -7 25 -34 -7 -10 -39 -75 -70 -143 -267 -579 -389 -1138 -373 -1711 16
-562 147 -966 503 -1556 70 -115 156 -258 191 -319 36 -60 81 -132 100 -159
27 -37 32 -51 22 -57 -17 -10 -83 26 -249 137 -366 242 -624 521 -793 859 -41
82 -147 348 -147 367 1 7 79 64 175 127 96 63 175 116 175 118 0 8 -60 -29
-205 -126 l-150 -101 -13 38 c-28 78 -82 323 -102 462 -22 151 -43 496 -31
517 4 8 88 -42 250 -148 134 -88 245 -159 246 -157 2 2 -108 77 -246 168
l-249 165 0 81 c0 255 72 653 177 967 l45 137 139 92 c77 50 138 93 135 95 -2
2 -59 -33 -126 -77 -67 -45 -124 -79 -126 -77 -7 7 61 160 134 302 124 241
292 473 528 728 115 125 725 709 733 701 2 -2 -55 -65 -127 -141z m-11222 111
c85 -9 158 -20 163 -23 4 -4 2 -64 -5 -134 l-12 -128 -25 5 c-14 3 -93 15
-176 27 -82 11 -151 22 -153 23 -1 2 3 60 10 129 10 107 14 126 27 123 9 -3
86 -12 171 -22z m400 -50 c74 -9 136 -17 138 -19 2 -1 -3 -62 -9 -135 l-13
-132 -25 5 c-14 3 -88 13 -163 23 -126 16 -138 20 -138 38 0 11 5 71 12 133
l11 114 26 -5 c14 -3 87 -13 161 -22z m370 -44 c85 -11 157 -20 160 -20 3 0 0
-53 -6 -117 -7 -65 -13 -127 -13 -139 l-1 -20 -172 24 c-95 13 -175 26 -177
28 -2 2 2 62 9 134 10 108 15 130 29 130 9 0 86 -9 171 -20z m385 -46 c77 -10
141 -18 143 -19 3 -3 -15 -198 -23 -251 l-5 -31 -156 23 c-86 12 -158 24 -160
27 -4 4 14 205 22 245 5 27 3 27 179 6z m389 -49 c66 -8 121 -17 123 -19 5 -4
-23 -275 -28 -280 -4 -4 -263 30 -305 39 -20 4 -20 7 -8 122 7 65 13 128 13
141 1 21 4 23 44 18 23 -4 96 -13 161 -21z m24140 -16 c72 -16 139 -32 149
-35 14 -4 17 -17 17 -74 l0 -68 -92 -21 c-325 -73 -747 -161 -771 -161 -16 0
-125 18 -242 40 -117 22 -216 40 -220 40 -12 0 8 75 24 87 77 60 82 61 354
111 147 27 267 45 267 40 0 -12 24 -10 38 5 12 12 259 63 316 66 16 0 88 -13
160 -30z m-26334 -19 c0 -5 -6 -10 -14 -10 -8 0 -18 5 -21 10 -3 6 3 10 14 10
12 0 21 -4 21 -10z m19384 -99 c5 -7 -43 -1064 -48 -1067 0 0 -255 -46 -566
-102 l-564 -102 -39 26 c-21 14 -40 24 -42 22 -2 -2 9 -12 26 -23 16 -11 29
-22 29 -25 0 -3 -249 -50 -553 -104 -303 -55 -561 -102 -572 -104 -11 -2 67
53 173 123 106 70 191 130 188 132 -2 2 -93 -56 -202 -129 l-199 -132 -285
-52 c-157 -29 -286 -51 -288 -49 -4 4 88 1148 92 1153 7 6 321 52 331 48 6 -2
131 -83 277 -180 147 -97 271 -176 275 -176 4 0 -111 79 -257 176 -146 97
-266 179 -268 183 -2 5 2387 381 2470 388 10 1 20 -2 22 -6z m-16801 -275
c-17 -116 -41 -173 -93 -220 -68 -61 -134 -69 -298 -33 l-104 23 86 57 c47 31
88 57 91 57 3 0 5 -7 5 -15 0 -8 9 -15 19 -15 15 0 21 8 23 33 3 29 15 40 142
125 76 51 140 92 141 90 2 -2 -3 -47 -12 -102z m-149 35 c28 -6 27 -7 -43 -54
l-71 -47 0 29 c0 16 3 42 6 59 6 28 8 30 43 25 20 -3 49 -8 65 -12z m25966
-303 c-22 -57 -56 -130 -75 -163 -41 -75 -112 -165 -129 -165 -35 0 -206 116
-206 140 0 5 9 12 20 15 16 5 32 -4 65 -34 25 -23 60 -49 79 -58 34 -16 36
-16 56 8 36 42 109 171 141 249 26 64 74 128 87 115 2 -2 -15 -50 -38 -107z
m-15421 82 c457 -58 814 -436 1024 -1085 107 -330 159 -753 127 -1035 -12
-113 -41 -275 -51 -291 -6 -10 -11 -10 -22 -1 -12 10 -11 25 4 104 24 127 39
270 39 375 0 271 -68 653 -163 914 -32 87 -33 97 -18 107 14 11 13 12 -6 7
-14 -4 -23 -2 -23 5 0 7 -27 67 -59 134 -153 311 -343 521 -576 637 -144 71
-230 91 -390 92 -256 0 -521 -88 -770 -256 -116 -79 -341 -303 -415 -414 -54
-81 -75 -98 -86 -68 -7 18 79 141 176 253 312 357 809 572 1209 522z m-2219
-220 c12 -7 2 -34 -59 -156 -85 -171 -163 -361 -216 -524 -25 -76 -46 -123
-62 -138 -14 -13 -27 -21 -29 -19 -7 6 65 225 123 372 54 140 211 475 222 475
3 0 13 -4 21 -10z m2208 -19 c105 -54 152 -193 101 -299 -17 -35 -32 -49 -67
-64 -39 -18 -50 -19 -85 -8 -70 21 -126 101 -147 209 -26 140 76 224 198 162z
m14282 -74 c10 -33 54 -148 97 -256 5 -11 2 -11 -15 -2 -12 7 -22 9 -22 7 0
-3 11 -11 24 -18 15 -8 44 -49 72 -103 63 -119 117 -203 193 -297 59 -73 68
-98 36 -98 -21 0 -110 105 -190 225 -84 125 -183 326 -244 492 -52 143 -52
151 -2 118 28 -19 41 -37 51 -68z m-14952 -166 c83 -43 122 -112 122 -218 0
-52 -6 -77 -23 -108 -75 -133 -252 -118 -330 29 -32 61 -31 166 3 224 47 83
146 115 228 73z m1259 -92 c44 -16 83 -59 114 -124 23 -48 29 -74 29 -128 0
-59 -3 -71 -25 -92 -78 -79 -220 50 -233 212 -9 112 35 162 115 132z m-1958
-223 c10 -12 3 -30 -33 -93 -257 -446 -391 -1226 -301 -1755 9 -51 18 -102 22
-113 4 -16 3 -17 -7 -8 -7 6 -18 9 -24 7 -27 -10 -58 250 -58 486 1 368 62
739 175 1060 42 117 192 430 206 430 5 0 14 -6 20 -14z m7839 -32 l252 -37 0
-57 c0 -32 3 -71 6 -87 l6 -29 -448 -86 -447 -87 -211 139 c-116 77 -209 140
-206 141 3 0 172 34 375 74 204 41 381 72 395 70 14 -1 139 -20 278 -41z
m-4534 -104 c49 -358 50 -737 1 -1210 -8 -80 -17 -155 -20 -167 -5 -20 0 -22
67 -30 l72 -8 -82 -54 c-45 -30 -84 -52 -87 -50 -2 3 7 90 20 194 38 304 50
491 49 795 -1 283 -3 310 -50 635 -3 27 -2 35 4 25 5 -8 17 -67 26 -130z
m-7496 16 c-12 -37 -30 -46 -88 -45 -19 1 -27 3 -17 6 9 2 17 9 17 15 0 5 -15
1 -32 -10 -36 -21 -41 -21 -643 -72 -967 -81 -1353 -87 -1970 -30 -204 19
-575 64 -644 79 l-34 7 25 16 c23 15 34 16 119 3 316 -48 674 -81 1029 -96
196 -9 269 -15 281 -25 8 -8 20 -14 25 -14 5 0 1 7 -8 14 -15 11 12 14 175 20
320 11 795 46 1395 102 150 13 277 22 282 19 5 -3 27 6 47 20 49 33 53 32 41
-9z m11154 -144 c106 -71 202 -134 213 -140 16 -9 17 -12 5 -16 -8 -2 -449
-88 -979 -190 -712 -138 -966 -183 -972 -175 -4 7 -10 33 -14 57 -12 82 -15
84 -131 131 -60 25 -113 47 -117 51 -5 4 19 24 52 45 60 36 74 39 899 200 460
89 840 163 844 164 4 0 94 -57 200 -127z m-19280 58 c66 -15 943 -197 1022
-211 14 -3 -8 -22 -77 -68 -53 -35 -97 -66 -97 -68 0 -5 9 0 106 64 45 29 88
55 95 58 8 3 514 -96 1124 -219 611 -123 1130 -227 1155 -231 109 -18 187 -64
228 -134 l27 -46 0 -282 0 -283 -27 -27 c-57 -57 -136 -45 -856 122 -24 6 -29
2 486 342 78 52 142 96 142 99 0 7 -9 1 -110 -66 -47 -32 -132 -88 -190 -126
-58 -37 -163 -107 -235 -154 l-130 -86 -875 197 c-481 109 -875 198 -875 199
0 1 -13 4 -29 6 -55 6 -1071 235 -1094 246 -12 6 -34 36 -49 66 -23 47 -27 71
-31 167 -4 96 12 285 24 285 2 0 68 -42 146 -93 164 -107 168 -110 168 -104 0
3 -70 50 -155 106 -85 56 -155 107 -155 114 0 7 11 36 25 64 43 85 91 98 237
63z m11117 -197 c-39 -159 -78 -395 -106 -643 -13 -120 -17 -240 -18 -530 0
-393 5 -466 51 -749 18 -116 22 -157 13 -167 -6 -8 -15 -14 -19 -14 -8 0 -44
213 -66 391 -10 78 -17 257 -21 483 l-5 358 23 -7 c23 -7 23 -6 5 7 -17 14
-18 24 -12 119 24 356 112 841 159 880 12 10 24 18 27 19 3 0 -11 -66 -31
-147z m2604 14 c74 -34 177 -132 228 -218 78 -130 129 -317 129 -471 l0 -79
-42 29 c-57 38 -68 44 -68 38 0 -3 25 -23 56 -43 l57 -38 -7 -73 c-9 -112 -42
-226 -97 -340 -60 -125 -148 -221 -244 -268 -55 -26 -69 -29 -165 -29 -95 0
-110 3 -158 27 -111 58 -197 152 -259 287 -40 86 -78 227 -88 327 l-7 70 56
37 c31 20 56 40 56 43 0 6 -11 0 -69 -39 l-44 -30 6 109 c9 147 38 258 99 384
41 86 64 118 122 176 104 104 178 135 306 130 56 -2 90 -9 133 -29z m-1195
-109 c75 -50 109 -160 81 -261 -15 -54 -84 -122 -138 -137 -140 -37 -272 80
-258 230 7 86 52 155 122 187 48 22 145 12 193 -19z m4802 2 c-51 -39 -67 -44
-100 -30 -17 7 -28 15 -25 19 7 7 100 28 130 30 18 0 18 -1 -5 -19z m-2672
-127 c12 -29 16 -68 16 -168 0 -144 -15 -205 -53 -205 -35 0 -56 78 -56 205 0
83 5 122 18 158 24 60 51 64 75 10z m-10234 -37 c-4 -10 14 -18 68 -30 190
-43 572 -93 888 -117 85 -6 156 -13 158 -14 2 -2 -29 -78 -68 -170 -135 -316
-370 -929 -370 -965 0 -6 -4 -10 -10 -10 -5 0 -10 5 -10 12 0 6 -3 8 -6 5 -4
-4 -2 -13 4 -20 8 -10 0 -47 -33 -148 -24 -74 -48 -153 -55 -176 -8 -32 -16
-43 -30 -43 -11 0 -20 6 -20 13 0 13 26 101 37 127 3 8 8 24 10 35 20 108 266
769 442 1184 34 79 61 145 61 147 0 2 -20 4 -45 4 -125 0 -694 71 -893 111
-57 11 -105 19 -107 17 -2 -2 -21 -123 -41 -268 -20 -146 -38 -267 -41 -269
-2 -3 -11 2 -19 11 -14 14 -13 39 20 274 41 294 43 304 56 304 5 0 7 -6 4 -14z
m-123 -1043 c-34 -246 -63 -457 -64 -467 -2 -16 11 -24 68 -42 87 -27 74 -30
-25 -4 -57 15 -76 16 -82 7 -4 -7 -8 -7 -8 -2 -1 17 131 959 136 974 4 12 7
12 21 -2 15 -15 12 -50 -46 -464z m8102 194 c67 -28 127 -122 127 -197 0 -152
-168 -256 -307 -189 -159 77 -158 298 2 382 37 20 134 22 178 4z m2191 -53
c11 -28 6 -117 -9 -181 -29 -122 -76 -191 -111 -162 -36 29 -5 240 48 327 21
35 61 44 72 16z m179 -167 c-33 -120 -76 -241 -128 -359 -49 -110 -147 -289
-172 -314 -10 -9 -18 -23 -19 -30 -3 -18 -91 -139 -170 -234 -88 -106 -274
-285 -374 -358 -288 -214 -549 -294 -790 -244 -498 103 -957 585 -1124 1180
-30 105 -31 112 -12 112 19 0 33 -20 39 -55 10 -58 79 -241 132 -351 197 -407
545 -723 911 -829 48 -14 120 -28 159 -32 143 -12 349 52 525 163 35 22 63 33
76 29 14 -3 28 3 40 18 l19 22 -23 -19 c-12 -11 -25 -16 -30 -12 -4 4 2 15 14
24 12 10 58 46 103 81 99 78 285 270 361 373 30 41 74 88 98 103 24 15 41 29
38 32 -2 3 -16 -3 -31 -13 -24 -16 -22 -10 20 57 134 207 247 470 315 726 9
38 13 41 29 31 18 -11 18 -14 -6 -101z m-10366 -513 c-3 -3 -12 -4 -19 -1 -8
3 -5 6 6 6 11 1 17 -2 13 -5z m8390 -134 c24 -10 51 -33 62 -51 23 -37 36 -98
24 -110 -8 -8 -253 149 -253 162 0 24 116 23 167 -1z m-29 -109 c62 -41 112
-80 112 -86 0 -21 -58 -102 -88 -124 -74 -52 -168 -65 -236 -31 -57 28 -79 63
-84 131 -4 48 0 65 24 109 16 29 46 64 69 80 38 27 41 28 65 12 15 -10 76 -50
138 -91z m1355 74 c25 -25 29 -70 12 -137 -20 -79 -42 -116 -80 -137 -58 -32
-100 -61 -89 -61 5 0 32 14 60 31 l49 31 -30 -32 c-59 -63 -107 -63 -126 0
-31 103 89 318 178 320 6 0 18 -7 26 -15z m-683 -313 c39 -29 55 -93 41 -157
-25 -113 -157 -204 -204 -141 -6 7 -7 4 -3 -6 8 -28 -19 -22 -56 11 -28 25
-32 35 -36 93 -3 51 0 73 16 104 55 106 167 151 242 96z m-975 -1062 c14 -15
15 -20 4 -20 -19 1 -50 25 -42 33 10 11 19 8 38 -13z m698 -687 c-7 -2 -21 -2
-30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z"/>
<path d="M28744 26177 c-66 -45 -209 -140 -316 -212 -108 -71 -195 -131 -193
-133 3 -3 567 365 623 407 15 11 23 20 17 20 -5 -1 -64 -38 -131 -82z"/>
<path d="M31240 25659 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M35855 24560 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M35794 24465 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9
-60 0 -29 10 -30 10 -13 -3z"/>
<path d="M35960 24470 c-7 -4 -20 -6 -29 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 18 -3 8 -7 20 -8 27 -4 9 6 5 10 -12 14 -14 4 -30 3 -35 -1 -6 -4 -16
-4 -24 0 -7 4 -30 5 -51 1 -23 -4 -43 -3 -49 3 -7 7 -15 6 -26 -3 -13 -10 -21
-11 -34 -3 -10 6 -24 8 -31 3z"/>
<path d="M35996 24392 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M36056 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M36116 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M36178 24383 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42379 22393 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M42910 22315 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20
-6z"/>
<path d="M42860 22294 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7
-43 10 -24 24 -38 27 -20 4z"/>
<path d="M42489 22278 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M42584 22278 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M42682 22277 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10
-8 17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27
2 -11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M42738 22193 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M29724 24488 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M29790 22315 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20
-6z"/>
<path d="M29739 22297 c25 -31 46 -38 67 -21 18 14 18 15 -2 5 -18 -8 -28 -6
-50 11 -20 16 -25 17 -15 5z"/>
<path d="M29806 20095 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M26148 22268 c5 -5 16 -8 23 -6 8 3 3 7 -10 11 -17 4 -21 3 -13 -5z"/>
<path d="M34538 23263 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M36000 22206 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M36178 22193 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M38140 21500 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M12595 19770 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M19950 20120 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M16686 20095 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M16187 20089 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 22 -14 53
-12 76 5 22 17 17 19 -9 4z"/>
<path d="M16337 20089 c-9 -5 -23 -7 -30 -3 -9 5 -9 4 -1 -5 9 -10 17 -10 33
-1 12 6 27 8 33 4 16 -10 119 -11 125 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 10
8 17 7 25 -1 9 -9 15 -9 25 1 10 11 9 13 -5 8 -10 -3 -20 -2 -24 4 -4 6 -11 6
-20 -2 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -13 -7 -24 0 -12 6 -22 5 -28 -1 -8 -8 -13 -7 -17 0 -9 13 -16 13
-39 0z"/>
<path d="M16637 20089 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M16260 20076 c7 -7 14 -6 21 1 9 9 7 12 -9 10 -14 -1 -18 -5 -12 -11z"/>
<path d="M16316 20012 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M16436 20012 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M16498 20003 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M15585 19579 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M13610 19787 c0 -3 84 -61 188 -130 103 -68 281 -186 395 -262 114
-75 210 -136 212 -133 4 4 34 -16 -420 285 -373 247 -375 248 -375 240z"/>
<path d="M11219 19093 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M14499 19093 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M11510 19080 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M14790 19080 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M11705 18980 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M14985 18980 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M11267 18969 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M11320 18973 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M11494 18966 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0
8 8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M14547 18969 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M14600 18973 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M14774 18966 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0
8 8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M11516 18892 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M14796 18892 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M11578 18883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M14858 18883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M11836 18771 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283
-384 254 -471 309 -436 277z"/>
<path d="M13962 18491 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560
40 37 -67 -31 -443 -280z"/>
<path d="M15116 18771 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283
-384 254 -471 309 -436 277z"/>
<path d="M12890 17990 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M13148 17993 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M16170 17990 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M16428 17993 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M13045 17930 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M13385 17930 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M16325 17930 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M16665 17930 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M13345 17910 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M16625 17910 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M13000 17900 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3
10 6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M13165 17900 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2
4 -6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10
8 -16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M16280 17900 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3
10 6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M16445 17900 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2
4 -6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10
8 -16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M12840 17890 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20
-4z"/>
<path d="M13385 17890 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M16120 17890 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20
-4z"/>
<path d="M16665 17890 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M13036 17822 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M13156 17822 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M16316 17822 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M16436 17822 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M13218 17813 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M16498 17813 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M12335 17409 c-476 -315 -504 -333 -499 -338 1 -2 115 71 251 161
136 91 335 222 441 292 165 109 203 136 189 136 -1 0 -173 -113 -382 -251z"/>
<path d="M13520 17656 c0 -3 87 -62 193 -132 105 -70 304 -201 440 -292 136
-90 250 -163 251 -161 5 5 -22 23 -489 331 -413 273 -395 261 -395 254z"/>
<path d="M15615 17409 c-476 -315 -504 -333 -499 -338 1 -2 115 71 251 161
136 91 335 222 441 292 165 109 203 136 189 136 -1 0 -173 -113 -382 -251z"/>
<path d="M16800 17656 c0 -7 321 -219 325 -214 2 2 -54 41 -123 88 -152 102
-202 133 -202 126z"/>
<path d="M11219 16903 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M11508 16883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M11278 16788 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22
57 -20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M11705 16790 c10 -11 23 -20 28 -20 6 0 0 9 -13 20 -13 11 -25 20
-28 20 -3 0 3 -9 13 -20z"/>
<path d="M14985 16790 c10 -11 23 -20 28 -20 6 0 0 9 -13 20 -13 11 -25 20
-28 20 -3 0 3 -9 13 -20z"/>
<path d="M14556 16785 c-24 -18 -57 -19 -76 -2 -12 10 -12 9 -1 -5 18 -24 53
-23 82 2 28 22 23 26 -5 5z"/>
<path d="M11332 16775 c14 -15 21 -16 30 -7 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -24 22 -41 12 -8 -5 -20 -4 -29 3 -9 7 -9 4 2 -8z"/>
<path d="M11423 16783 c-7 -2 -13 -9 -13 -14 0 -6 6 -7 13 -2 6 4 23 6 37 5
23 -1 23 -1 5 7 -23 11 -26 11 -42 4z"/>
<path d="M11510 16779 l-25 -8 25 2 c14 1 31 -2 38 -7 8 -5 18 -4 24 2 7 7 17
8 29 2 12 -7 20 -6 24 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4 -10 -3
-19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -3 -23 2 -9 4 -27 4 -41 0z"/>
<path d="M14805 16780 c-3 -5 -13 -7 -23 -4 -14 5 -14 4 -2 -4 9 -7 19 -7 25
-2 7 6 16 5 23 -2 9 -9 15 -9 24 0 7 7 17 8 29 2 12 -7 20 -6 24 0 5 7 11 8
19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4 -10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1
-4 -3 -15 -2 -25 3 -11 7 -20 7 -24 0z"/>
<path d="M14614 16768 c10 -6 22 -6 26 -2 5 5 -3 10 -18 11 -22 1 -24 0 -8 -9z"/>
<path d="M11396 16702 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M11456 16702 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M11516 16702 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M14676 16702 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M14736 16702 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M14796 16702 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M11578 16693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M14858 16693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M18265 16790 c10 -11 23 -20 28 -20 6 0 0 9 -13 20 -13 11 -25 20
-28 20 -3 0 3 -9 13 -20z"/>
<path d="M18079 16772 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24
0 7 7 17 8 29 2 12 -7 20 -6 24 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2
4 -10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -15 -2 -24 3 -13 7 -22 5 -31
-8z"/>
<path d="M18076 16702 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M18138 16693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M18395 16583 c10 -10 708 -473 821 -544 103 -65 82 -43 -28 29 -56
38 -222 147 -368 243 -383 253 -447 294 -425 272z"/>
<path d="M19419 15823 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M19710 15810 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M19450 15799 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M23100 19616 c0 -25 5 -48 10 -51 6 -4 10 11 10 39 0 25 -4 48 -10
51 -6 4 -10 -11 -10 -39z"/>
<path d="M22987 19562 c-8 -38 2 -79 14 -60 11 17 11 59 0 76 -6 10 -10 5 -14
-16z"/>
<path d="M22707 19563 c-11 -10 -8 -73 3 -73 6 0 10 18 10 40 0 41 -2 45 -13
33z"/>
<path d="M22875 19478 c-4 -20 -3 -44 3 -54 8 -15 11 -13 16 12 4 17 3 41 -2
55 -9 23 -10 23 -17 -13z"/>
<path d="M22598 19464 c-5 -4 -8 -25 -8 -48 0 -28 3 -37 11 -29 6 6 9 27 7 48
-2 20 -6 33 -10 29z"/>
<path d="M23565 19437 c-9 -23 3 -89 16 -82 11 7 11 52 -1 80 -7 18 -8 19 -15
2z"/>
<path d="M22766 19404 c-10 -25 -7 -74 4 -74 6 0 10 20 10 45 0 47 -4 55 -14
29z"/>
<path d="M23047 19391 c-6 -26 3 -72 14 -65 12 7 12 71 0 78 -5 3 -11 -3 -14
-13z"/>
<path d="M22658 19314 c-5 -4 -8 -26 -8 -48 1 -33 3 -38 11 -23 11 19 8 83 -3
71z"/>
<path d="M22828 19254 c-5 -4 -8 -25 -8 -48 0 -28 3 -37 11 -29 6 6 9 27 7 48
-2 20 -6 33 -10 29z"/>
<path d="M23625 19238 c-4 -15 -3 -40 3 -55 l10 -28 11 28 c9 22 8 34 -3 55
l-14 27 -7 -27z"/>
<path d="M22536 19186 c-3 -14 -3 -32 1 -42 6 -16 7 -16 14 2 11 27 11 64 0
64 -5 0 -12 -11 -15 -24z"/>
<path d="M22707 19138 c-4 -12 -3 -34 0 -47 6 -23 7 -24 14 -6 11 28 11 75 0
75 -5 0 -11 -10 -14 -22z"/>
<path d="M22876 19063 c-4 -18 -3 -40 3 -50 8 -16 10 -14 16 10 4 16 3 38 -2
50 -10 21 -11 20 -17 -10z"/>
<path d="M22596 19055 c-9 -24 -7 -65 3 -65 12 0 21 52 12 69 -6 10 -9 10 -15
-4z"/>
<path d="M22768 18997 c-12 -29 -10 -83 3 -70 6 6 9 28 7 49 -2 29 -5 34 -10
21z"/>
<path d="M22646 18884 c-4 -21 -3 -41 3 -47 6 -6 12 3 17 27 4 22 2 42 -3 47
-7 7 -13 -2 -17 -27z"/>
<path d="M22938 18914 c-5 -4 -8 -25 -8 -48 0 -28 3 -37 11 -29 6 6 9 27 7 48
-2 20 -6 33 -10 29z"/>
<path d="M22817 18829 c-10 -35 -8 -69 2 -69 14 0 22 46 13 71 l-9 23 -6 -25z"/>
<path d="M23617 18816 c-10 -25 -9 -86 2 -86 13 0 20 48 12 78 -6 22 -8 24
-14 8z"/>
<path d="M22531 18793 c-7 -18 -10 -41 -6 -50 6 -17 7 -17 16 0 6 9 9 32 7 50
l-3 32 -14 -32z"/>
<path d="M22707 18750 c-7 -18 -10 -38 -8 -65 2 -19 2 -19 12 -2 6 9 9 32 7
50 -3 20 -6 27 -11 17z"/>
<path d="M22980 18693 c0 -35 3 -44 10 -33 13 20 13 80 0 80 -5 0 -10 -21 -10
-47z"/>
<path d="M22541 18674 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M22866 18664 c-10 -25 -7 -74 4 -74 6 0 10 20 10 45 0 47 -4 55 -14
29z"/>
<path d="M22586 18655 c-9 -25 -7 -67 3 -61 12 8 19 52 11 66 -5 8 -9 6 -14
-5z"/>
<path d="M23656 18595 c-4 -14 -3 -37 0 -52 l7 -27 13 37 c13 37 10 67 -6 67
-4 0 -11 -11 -14 -25z"/>
<path d="M22745 18560 c-8 -36 5 -63 16 -34 11 27 11 64 0 64 -5 0 -12 -13
-16 -30z"/>
<path d="M23026 18534 c-4 -14 -4 -35 0 -47 7 -22 7 -22 15 -2 11 28 11 75 0
75 -5 0 -12 -12 -15 -26z"/>
<path d="M22638 18507 c-5 -10 -8 -33 -8 -50 1 -27 2 -29 11 -14 6 9 9 32 7
50 -2 25 -5 28 -10 14z"/>
<path d="M22918 18494 c-5 -4 -8 -26 -8 -48 1 -33 3 -38 11 -23 11 19 8 83 -3
71z"/>
<path d="M22796 18415 c-9 -25 -7 -81 3 -69 14 15 21 58 12 72 -7 11 -10 10
-15 -3z"/>
<path d="M22675 18319 c-6 -28 -1 -48 10 -37 3 2 8 19 11 36 8 42 -12 43 -21
1z"/>
<path d="M22958 18317 c-5 -10 -8 -35 -8 -55 1 -30 2 -34 11 -19 6 9 9 34 7
55 -2 28 -5 32 -10 19z"/>
<path d="M22837 18238 c-10 -34 -8 -74 2 -62 14 15 21 58 12 72 -6 10 -10 8
-14 -10z"/>
<path d="M22714 18155 c-6 -34 -1 -55 11 -43 3 3 9 22 12 42 8 48 -14 48 -23
1z"/>
<path d="M22998 18130 c-4 -14 -8 -38 -8 -55 1 -25 2 -27 11 -12 6 9 9 34 7
55 -3 33 -4 35 -10 12z"/>
<path d="M22607 18110 c-12 -34 -14 -58 -7 -71 6 -8 11 0 15 24 8 39 2 74 -8
47z"/>
<path d="M22878 18067 c-5 -10 -8 -33 -8 -50 1 -27 2 -29 11 -14 6 9 9 32 7
50 -2 25 -5 28 -10 14z"/>
<path d="M22760 18005 c0 -9 -4 -14 -9 -10 -5 3 -12 1 -16 -5 -3 -5 -1 -10 4
-10 6 0 11 -12 11 -27 0 -34 16 -19 25 24 3 18 2 34 -4 38 -6 3 -11 -1 -11
-10z"/>
<path d="M22580 17900 c1 -48 7 -103 15 -125 17 -47 19 -103 5 -139 -5 -15 -6
-26 0 -26 35 0 52 -77 29 -137 -9 -24 -7 -30 10 -42 12 -7 21 -20 21 -27 0 -8
5 -14 10 -14 6 0 10 8 10 18 0 9 7 29 14 45 14 25 13 27 -4 27 -29 0 -43 35
-35 89 4 25 11 53 16 62 6 13 4 18 -11 22 -37 10 -48 92 -19 149 7 13 4 17
-14 20 -33 5 -46 66 -26 122 14 39 14 42 -3 42 -16 0 -18 -10 -18 -86z"/>
<path d="M23648 17960 c-4 -14 -8 -38 -8 -55 1 -25 2 -27 11 -12 6 9 9 34 7
55 -3 33 -4 35 -10 12z"/>
<path d="M22647 17953 c-3 -4 -8 -26 -12 -47 -6 -27 -4 -37 3 -32 12 7 28 74
19 82 -3 3 -7 2 -10 -3z"/>
<path d="M22750 17900 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M22785 17804 c-6 -34 -1 -54 10 -42 3 3 9 22 12 42 7 48 -13 48 -22
0z"/>
<path d="M22672 17755 c-7 -24 -8 -43 -2 -49 5 -5 11 6 15 27 10 52 0 69 -13
22z"/>
<path d="M23668 17757 c-5 -10 -8 -35 -7 -55 0 -35 1 -35 10 -12 6 13 9 38 7
55 -2 24 -4 26 -10 12z"/>
<path d="M22822 17647 c-7 -16 -12 -40 -11 -55 1 -26 1 -26 15 7 8 18 13 43
11 55 -3 19 -4 19 -15 -7z"/>
<path d="M22702 17587 c-16 -45 -11 -72 7 -39 7 13 11 35 9 50 -3 26 -4 25
-16 -11z"/>
<path d="M23682 17538 c-8 -21 -12 -46 -9 -55 6 -27 29 34 25 66 -3 24 -4 23
-16 -11z"/>
<path d="M22841 17452 c-6 -24 -10 -49 -8 -55 7 -19 28 44 25 72 -3 22 -6 20
-17 -17z"/>
<path d="M23332 17431 c-6 -19 -12 -43 -11 -55 0 -16 4 -13 15 13 8 18 14 43
12 55 -3 17 -6 15 -16 -13z"/>
<path d="M22722 17405 c-7 -24 -8 -43 -2 -49 5 -5 11 6 15 27 10 52 0 69 -13
22z"/>
<path d="M23212 17381 c-6 -19 -12 -43 -11 -55 0 -16 4 -13 15 13 8 18 14 43
12 55 -3 17 -6 15 -16 -13z"/>
<path d="M23091 17331 c-7 -23 -10 -45 -7 -48 9 -10 27 39 24 65 -3 24 -5 22
-17 -17z"/>
<path d="M21059 19093 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M21350 19080 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M21107 18969 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M21160 18973 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M21356 18892 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M21418 18883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M21059 16903 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M21348 16883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M21118 16788 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22
57 -20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M21545 16790 c10 -11 23 -20 28 -20 6 0 0 9 -13 20 -13 11 -25 20
-28 20 -3 0 3 -9 13 -20z"/>
<path d="M21172 16775 c14 -15 21 -16 30 -7 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -24 22 -41 12 -8 -5 -20 -4 -29 3 -9 7 -9 4 2 -8z"/>
<path d="M21263 16783 c-7 -2 -13 -9 -13 -14 0 -6 6 -7 13 -2 6 4 23 6 37 5
23 -1 23 -1 5 7 -23 11 -26 11 -42 4z"/>
<path d="M21350 16779 l-25 -8 25 2 c14 1 31 -2 38 -7 8 -5 18 -4 24 2 7 7 17
8 29 2 12 -7 20 -6 24 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4 -10 -3
-19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -3 -23 2 -9 4 -27 4 -41 0z"/>
<path d="M21236 16702 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M21296 16702 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M21356 16702 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M21418 16693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M23390 19558 c0 -26 5 -50 10 -53 13 -8 13 65 0 85 -7 11 -10 2 -10
-32z"/>
<path d="M23275 19521 c-9 -30 4 -89 16 -70 11 18 11 60 0 78 -7 11 -10 9 -16
-8z"/>
<path d="M23160 19431 c0 -22 4 -42 9 -45 10 -7 18 29 13 62 -6 37 -22 25 -22
-17z"/>
<path d="M23450 19361 c0 -22 5 -43 10 -46 6 -4 10 10 10 34 0 22 -4 43 -10
46 -6 4 -10 -10 -10 -34z"/>
<path d="M23335 19337 c-4 -16 -3 -43 2 -60 l10 -32 7 35 c4 19 3 46 -2 60
l-10 25 -7 -28z"/>
<path d="M22935 19318 c-4 -16 -4 -40 0 -55 l7 -28 10 28 c6 17 6 37 0 55
l-10 27 -7 -27z"/>
<path d="M23220 19245 c0 -25 5 -45 10 -45 6 0 10 20 10 45 0 25 -4 45 -10 45
-5 0 -10 -20 -10 -45z"/>
<path d="M23105 19218 c-4 -16 -4 -40 0 -55 7 -28 7 -28 18 -6 7 16 7 33 0 55
l-10 33 -8 -27z"/>
<path d="M23510 19166 c0 -25 5 -46 10 -46 6 0 10 18 10 39 0 22 -4 43 -10 46
-6 4 -10 -12 -10 -39z"/>
<path d="M23397 19164 c-10 -10 -9 -82 2 -88 5 -3 11 4 15 17 6 27 -6 82 -17
71z"/>
<path d="M22990 19114 c0 -27 4 -43 10 -39 6 3 10 24 10 46 0 21 -4 39 -10 39
-5 0 -10 -21 -10 -46z"/>
<path d="M23044 18965 c-3 -14 -3 -37 1 -52 7 -26 8 -26 15 -8 12 28 12 73 0
80 -5 3 -12 -6 -16 -20z"/>
<path d="M23095 18776 c-5 -22 -3 -42 3 -48 14 -14 26 46 14 69 -9 15 -11 11
-17 -21z"/>
<path d="M23277 19088 c-8 -30 3 -83 14 -66 11 17 11 75 0 82 -5 3 -11 -4 -14
-16z"/>
<path d="M23160 19005 c0 -25 5 -45 10 -45 6 0 10 20 10 45 0 25 -4 45 -10 45
-5 0 -10 -20 -10 -45z"/>
<path d="M23567 19013 c-11 -10 -8 -81 3 -88 6 -4 10 13 10 44 0 52 -1 56 -13
44z"/>
<path d="M23445 18957 c-4 -16 -3 -43 2 -60 l10 -32 7 35 c4 19 3 46 -2 60
l-10 25 -7 -28z"/>
<path d="M23328 18895 c-3 -14 -3 -37 0 -51 6 -34 22 -11 22 33 0 39 -16 52
-22 18z"/>
<path d="M23217 18863 c-11 -10 -8 -83 3 -83 6 0 10 20 10 45 0 46 -2 50 -13
38z"/>
<path d="M23495 18748 c-4 -20 -2 -44 3 -54 9 -16 11 -13 17 18 4 20 2 44 -3
54 -9 16 -11 13 -17 -18z"/>
<path d="M23378 18705 c-3 -14 -3 -37 0 -52 5 -25 6 -25 13 -8 11 28 11 85 0
85 -5 0 -11 -11 -13 -25z"/>
<path d="M23268 18674 c-5 -4 -8 -28 -8 -53 0 -32 3 -42 11 -34 5 5 9 29 7 53
-2 23 -6 38 -10 34z"/>
<path d="M23147 18609 c-10 -35 -8 -69 2 -69 14 0 22 46 13 71 l-9 23 -6 -25z"/>
<path d="M23548 18570 c-9 -18 -11 -37 -9 -70 1 -22 3 -23 12 -7 6 9 9 34 7
55 -2 22 -6 31 -10 22z"/>
<path d="M23428 18527 c-12 -30 -10 -93 3 -80 5 5 9 30 7 54 -2 31 -5 39 -10
26z"/>
<path d="M23307 18476 c-10 -25 -9 -76 2 -76 12 0 20 50 12 74 -7 18 -8 18
-14 2z"/>
<path d="M23185 18408 c-4 -21 -4 -46 0 -55 6 -15 10 -12 18 15 7 22 7 39 0
55 -10 21 -11 20 -18 -15z"/>
<path d="M23079 18375 c-13 -21 -18 -61 -9 -75 7 -11 10 -8 15 12 8 30 3 78
-6 63z"/>
<path d="M23118 18195 c-13 -21 -20 -83 -9 -89 6 -4 13 8 16 28 8 38 3 77 -7
61z"/>
<path d="M23226 18218 c-9 -34 -7 -68 3 -68 8 0 21 47 21 76 0 22 -17 16 -24
-8z"/>
<path d="M23618 18167 c-12 -30 -10 -93 3 -80 5 5 9 30 7 54 -2 31 -5 39 -10
26z"/>
<path d="M23496 18118 c-9 -35 -7 -80 4 -73 14 9 24 75 13 86 -7 7 -12 2 -17
-13z"/>
<path d="M23374 18056 c-7 -41 5 -71 17 -40 11 28 11 74 -1 74 -5 0 -12 -15
-16 -34z"/>
<path d="M23269 18045 c-12 -20 -17 -61 -9 -80 6 -17 9 -14 15 17 7 39 3 80
-6 63z"/>
<path d="M23148 17997 c-5 -10 -8 -35 -8 -55 1 -30 2 -34 11 -19 6 9 9 34 7
55 -2 28 -5 32 -10 19z"/>
<path d="M23526 17908 c-3 -13 -5 -36 -5 -53 l1 -30 13 35 c16 41 18 70 6 70
-5 0 -11 -10 -15 -22z"/>
<path d="M23411 17876 c-6 -17 -10 -41 -8 -55 l3 -26 13 29 c6 17 10 41 8 55
l-3 26 -13 -29z"/>
<path d="M23292 17825 c-14 -49 -15 -65 -2 -65 11 0 24 60 18 87 -3 12 -8 5
-16 -22z"/>
<path d="M22936 17694 c-3 -9 -6 -30 -6 -47 1 -38 14 -21 25 31 7 33 -8 46
-19 16z"/>
<path d="M22962 17507 c-7 -16 -12 -40 -11 -55 1 -26 1 -26 15 7 8 18 13 43
11 55 -3 19 -4 19 -15 -7z"/>
<path d="M23172 17775 c-7 -24 -8 -43 -2 -49 11 -11 23 32 18 65 -3 20 -6 18
-16 -16z"/>
<path d="M23058 17747 c-5 -10 -8 -33 -7 -50 0 -31 1 -31 10 -7 5 13 9 36 7
50 -3 21 -4 22 -10 7z"/>
<path d="M23551 17712 c-7 -13 -11 -37 -9 -55 l4 -32 12 43 c15 51 11 77 -7
44z"/>
<path d="M23311 17621 c-8 -29 -9 -47 -2 -54 6 -6 12 2 16 26 11 57 0 78 -14
28z"/>
<path d="M23198 17597 c-5 -10 -8 -33 -8 -50 1 -27 2 -29 11 -14 6 9 9 32 7
50 -2 25 -5 28 -10 14z"/>
<path d="M23078 17550 c-4 -14 -8 -36 -8 -50 1 -22 2 -23 11 -7 6 9 9 32 7 50
-3 31 -3 31 -10 7z"/>
<path d="M23450 17470 c-6 -11 -10 -33 -8 -48 3 -24 5 -22 17 17 14 47 9 65
-9 31z"/>
<path d="M32330 16046 c0 -6 66 -46 76 -46 5 0 -8 11 -28 25 -36 24 -48 30
-48 21z"/>
<path d="M32539 15823 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M32570 15799 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M32602 15720 c-15 -25 -59 -26 -84 -3 -22 20 -24 11 -2 -11 22 -22
67 -20 89 4 10 11 16 22 14 25 -3 2 -10 -5 -17 -15z"/>
<path d="M32656 15698 c3 -4 11 -5 19 -1 21 7 19 12 -4 10 -11 0 -18 -5 -15
-9z"/>
<path d="M34851 14925 c-78 -54 -71 -60 8 -8 69 46 78 53 66 53 -6 0 -39 -20
-74 -45z"/>
<path d="M23279 17015 c-4 -33 2 -69 12 -79 11 -13 11 51 -1 79 l-9 20 -2 -20z"/>
<path d="M23164 16939 c3 -17 6 -35 6 -40 0 -5 5 -9 10 -9 11 0 13 39 4 64
-11 29 -27 17 -20 -15z"/>
<path d="M22768 16929 c-5 -32 2 -69 13 -69 12 0 11 61 0 79 -7 11 -10 9 -13
-10z"/>
<path d="M23574 16891 c2 -24 9 -48 15 -54 18 -18 13 56 -5 79 -14 18 -15 16
-10 -25z"/>
<path d="M22836 16760 c-4 -14 -3 -37 2 -50 l10 -25 7 28 c4 16 3 38 -3 50
-10 22 -10 22 -16 -3z"/>
<path d="M22726 16674 c-4 -16 -3 -41 3 -55 l9 -24 7 27 c4 15 3 40 -3 55 l-9
28 -7 -31z"/>
<path d="M23710 16518 c0 -36 11 -68 21 -62 10 6 12 45 3 68 -9 24 -24 19 -24
-6z"/>
<path d="M22680 16406 c0 -25 5 -46 10 -46 6 0 10 18 10 39 0 22 -4 43 -10 46
-6 4 -10 -12 -10 -39z"/>
<path d="M22687 16011 c-3 -15 -3 -39 0 -51 6 -22 7 -23 14 -4 11 27 11 72 0
78 -5 3 -11 -7 -14 -23z"/>
<path d="M22748 15860 c-12 -28 -15 -70 -7 -76 13 -8 21 19 17 58 -3 20 -6 27
-10 18z"/>
<path d="M22678 15590 c-12 -26 -13 -38 -5 -48 15 -19 29 9 25 51 l-4 32 -16
-35z"/>
<path d="M22695 15479 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M22730 15403 c0 -35 3 -44 10 -33 13 20 13 80 0 80 -5 0 -10 -21 -10
-47z"/>
<path d="M22774 15246 c-4 -23 -2 -42 4 -48 7 -7 13 0 18 26 4 23 2 42 -4 48
-7 7 -13 0 -18 -26z"/>
<path d="M22742 14835 c-7 -24 -8 -43 -2 -49 11 -11 23 32 18 65 -3 20 -6 18
-16 -16z"/>
<path d="M22730 14698 c0 -19 2 -20 10 -8 13 19 13 30 0 30 -5 0 -10 -10 -10
-22z"/>
<path d="M22778 14670 c-4 -14 -8 -38 -8 -55 1 -25 2 -27 11 -12 6 9 9 34 7
55 -3 33 -4 35 -10 12z"/>
<path d="M22842 14081 c-17 -48 -15 -72 4 -38 8 16 14 38 12 50 -3 19 -5 17
-16 -12z"/>
<path d="M23780 13971 c-6 -17 -10 -36 -8 -43 3 -7 10 4 17 25 16 46 9 60 -9
18z"/>
<path d="M23087 13967 c-4 -10 -7 -31 -6 -45 l0 -27 10 25 c5 13 8 33 7 45 -3
19 -4 19 -11 2z"/>
<path d="M22971 13933 c-7 -17 -11 -42 -9 -55 3 -19 7 -15 17 20 15 53 10 77
-8 35z"/>
<path d="M23661 13914 c-6 -21 -9 -40 -7 -42 2 -2 9 13 16 33 7 20 10 39 7 42
-3 3 -10 -12 -16 -33z"/>
<path d="M23719 13925 c-3 -16 -10 -39 -14 -50 -7 -19 -7 -19 9 -4 12 11 16
28 14 50 l-3 34 -6 -30z"/>
<path d="M23550 13891 c-6 -17 -10 -36 -8 -43 3 -7 10 4 17 25 16 46 9 60 -9
18z"/>
<path d="M23488 13845 c-2 -19 0 -35 4 -35 4 0 8 16 8 35 0 19 -2 35 -4 35 -2
0 -6 -16 -8 -35z"/>
<path d="M23596 13858 c-9 -34 -8 -38 9 -38 12 0 14 7 9 28 -9 36 -10 37 -18
10z"/>
<path d="M23056 16902 c-8 -24 2 -72 15 -72 12 0 11 61 0 79 -7 11 -10 9 -15
-7z"/>
<path d="M23460 16858 c0 -37 14 -66 24 -50 8 13 -4 71 -15 78 -5 3 -9 -10 -9
-28z"/>
<path d="M22945 16840 c-10 -16 4 -82 16 -75 11 8 12 55 0 74 -6 10 -10 10
-16 1z"/>
<path d="M23350 16801 c0 -22 5 -43 10 -46 6 -4 10 10 10 34 0 22 -4 43 -10
46 -6 4 -10 -10 -10 -34z"/>
<path d="M23236 16782 c-8 -13 4 -71 15 -78 5 -3 9 10 9 28 0 37 -14 66 -24
50z"/>
<path d="M23125 16727 c-4 -10 -3 -32 2 -50 9 -27 11 -29 18 -14 4 10 3 32 -2
50 -9 27 -11 29 -18 14z"/>
<path d="M23640 16713 c0 -29 12 -63 21 -63 10 0 12 41 3 64 -8 21 -24 20 -24
-1z"/>
<path d="M23530 16670 c0 -37 18 -80 21 -50 3 31 -3 65 -12 75 -5 5 -9 -4 -9
-25z"/>
<path d="M23010 16638 c0 -44 15 -69 24 -40 8 24 -2 72 -15 72 -5 0 -9 -15 -9
-32z"/>
<path d="M23419 16645 c-2 -37 3 -70 12 -79 12 -13 12 65 -1 84 -8 13 -10 12
-11 -5z"/>
<path d="M22900 16573 c0 -21 5 -45 10 -53 7 -11 10 -2 10 32 0 26 -4 50 -10
53 -6 4 -10 -9 -10 -32z"/>
<path d="M23301 16573 c0 -16 4 -37 8 -48 8 -20 8 -20 15 2 8 25 -2 73 -15 73
-5 0 -9 -12 -8 -27z"/>
<path d="M23190 16523 c0 -21 5 -45 10 -53 7 -11 10 -2 10 32 0 26 -4 50 -10
53 -6 4 -10 -9 -10 -32z"/>
<path d="M22790 16485 c0 -25 5 -45 10 -45 6 0 10 20 10 45 0 25 -4 45 -10 45
-5 0 -10 -20 -10 -45z"/>
<path d="M23600 16475 c0 -22 5 -47 10 -55 7 -11 10 -4 10 25 0 22 -5 47 -10
55 -7 11 -10 4 -10 -25z"/>
<path d="M23078 16482 c-7 -26 2 -72 13 -72 11 0 11 61 0 78 -6 11 -9 9 -13
-6z"/>
<path d="M23480 16438 c0 -36 11 -68 21 -62 10 6 12 45 3 68 -9 24 -24 19 -24
-6z"/>
<path d="M22965 16418 c-4 -16 -4 -40 0 -55 7 -28 7 -28 18 -6 7 16 7 33 0 55
l-10 33 -8 -27z"/>
<path d="M23370 16383 c0 -21 5 -45 10 -53 7 -11 10 -2 10 32 0 26 -4 50 -10
53 -6 4 -10 -9 -10 -32z"/>
<path d="M23255 16360 c-10 -16 4 -82 16 -75 11 8 12 55 0 74 -6 10 -10 10
-16 1z"/>
<path d="M22857 16354 c-10 -10 -9 -72 2 -78 5 -3 11 4 13 17 5 28 -5 71 -15
61z"/>
<path d="M23140 16271 c0 -22 4 -42 9 -45 10 -7 18 29 13 62 -6 37 -22 25 -22
-17z"/>
<path d="M23663 16261 c4 -31 1 -53 -6 -61 -7 -7 1 -6 20 4 32 16 52 36 36 36
-5 0 -15 -6 -22 -12 -11 -11 -12 -9 -7 9 8 26 -2 73 -16 73 -7 0 -9 -18 -5
-49z"/>
<path d="M22740 16234 c0 -27 4 -43 10 -39 6 3 10 24 10 46 0 21 -4 39 -10 39
-5 0 -10 -21 -10 -46z"/>
<path d="M22800 16070 c0 -22 5 -40 10 -40 6 0 10 18 10 40 0 22 -4 40 -10 40
-5 0 -10 -18 -10 -40z"/>
<path d="M22855 15922 c-8 -39 3 -82 16 -61 11 18 11 60 0 78 -7 10 -11 5 -16
-17z"/>
<path d="M23547 16259 c-7 -27 2 -79 14 -79 11 0 11 71 0 88 -6 10 -10 8 -14
-9z"/>
<path d="M23027 16239 c-8 -28 3 -80 14 -73 11 7 11 65 0 82 -6 10 -10 8 -14
-9z"/>
<path d="M23430 16193 c0 -21 5 -45 10 -53 7 -11 10 -2 10 32 0 26 -4 50 -10
53 -6 4 -10 -9 -10 -32z"/>
<path d="M23725 16107 c-4 -9 -4 -34 0 -55 7 -35 8 -36 18 -15 7 16 7 33 0 55
-8 27 -12 30 -18 15z"/>
<path d="M23757 15459 c-3 -12 -3 -36 0 -53 5 -26 7 -27 14 -11 11 28 11 85 0
85 -5 0 -11 -10 -14 -21z"/>
<path d="M22917 16184 c-10 -10 -9 -72 2 -78 5 -3 12 5 15 18 7 27 -6 71 -17
60z"/>
<path d="M22970 15971 c0 -22 5 -43 10 -46 6 -4 10 12 10 39 0 25 -4 46 -10
46 -5 0 -10 -18 -10 -39z"/>
<path d="M23315 16170 c-10 -16 4 -82 16 -75 11 8 12 55 0 74 -6 10 -10 10
-16 1z"/>
<path d="M23200 16091 c0 -22 5 -43 10 -46 6 -4 10 12 10 39 0 25 -4 46 -10
46 -5 0 -10 -18 -10 -39z"/>
<path d="M23607 16069 c-7 -27 2 -79 14 -79 11 0 11 71 0 88 -6 10 -10 8 -14
-9z"/>
<path d="M23086 16053 c-8 -36 1 -76 15 -68 11 7 11 52 0 80 -7 18 -9 16 -15
-12z"/>
<path d="M23490 15991 c0 -22 5 -43 10 -46 6 -4 10 12 10 39 0 25 -4 46 -10
46 -5 0 -10 -18 -10 -39z"/>
<path d="M23374 15977 c-9 -26 5 -94 17 -76 11 18 11 60 -1 79 -8 12 -10 12
-16 -3z"/>
<path d="M23260 15900 c0 -32 4 -49 10 -45 6 3 10 24 10 45 0 21 -4 42 -10 45
-6 4 -10 -13 -10 -45z"/>
<path d="M23147 15884 c-10 -10 -9 -66 2 -82 6 -10 10 -5 14 17 7 33 -4 77
-16 65z"/>
<path d="M23660 15841 c0 -22 5 -43 10 -46 6 -4 10 12 10 39 0 25 -4 46 -10
46 -5 0 -10 -18 -10 -39z"/>
<path d="M23547 15836 c-10 -25 -8 -68 2 -85 14 -21 25 47 13 78 -7 21 -10 22
-15 7z"/>
<path d="M23426 15776 c-8 -31 2 -78 15 -70 11 7 11 65 0 82 -6 10 -10 7 -15
-12z"/>
<path d="M23310 15705 c0 -25 5 -45 10 -45 6 0 10 20 10 45 0 25 -4 45 -10 45
-5 0 -10 -20 -10 -45z"/>
<path d="M22845 15498 c-4 -21 -4 -46 0 -55 12 -28 27 39 16 69 -8 21 -9 21
-16 -14z"/>
<path d="M23717 15676 c-10 -25 -9 -74 2 -80 14 -9 23 46 13 74 -7 20 -9 21
-15 6z"/>
<path d="M23080 15641 c0 -5 -8 -12 -17 -14 -17 -4 -17 -5 0 -6 10 0 16 -5 12
-11 -3 -5 -3 -21 1 -35 5 -20 9 -23 15 -13 12 18 11 75 -1 83 -5 3 -10 2 -10
-4z"/>
<path d="M23595 15622 c-8 -39 3 -82 16 -61 11 18 11 60 0 78 -7 10 -11 5 -16
-17z"/>
<path d="M10666 15181 c19 -18 455 -303 459 -300 3 4 -34 30 -288 198 -150 99
-200 129 -171 102z"/>
<path d="M23478 15578 c-2 -13 -1 -36 1 -52 5 -39 21 -13 21 37 0 40 -17 51
-22 15z"/>
<path d="M22968 15584 c-5 -4 -8 -25 -8 -48 0 -28 3 -37 11 -29 6 6 9 27 7 48
-2 20 -6 33 -10 29z"/>
<path d="M23247 15499 c-10 -35 -8 -79 2 -79 14 0 23 53 13 80 l-9 24 -6 -25z"/>
<path d="M23126 15435 c-4 -14 -3 -37 0 -52 7 -25 8 -25 15 -8 11 28 11 73 0
79 -5 3 -12 -5 -15 -19z"/>
<path d="M23648 15444 c-5 -4 -8 -28 -8 -53 0 -32 3 -42 11 -34 5 5 9 29 7 53
-2 23 -6 38 -10 34z"/>
<path d="M23018 15404 c-5 -4 -8 -28 -8 -53 1 -36 3 -42 11 -28 11 19 8 93 -3
81z"/>
<path d="M22350 14781 l0 -70 88 39 c80 36 87 41 90 69 l3 31 -90 0 -91 0 0
-69z"/>
<path d="M22448 14524 l-88 -44 0 -115 0 -115 95 48 96 47 -7 110 c-4 60 -7
111 -8 111 0 1 -40 -18 -88 -42z"/>
<path d="M21418 14503 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M22263 14438 c-22 -10 -22 -14 -16 -122 3 -61 7 -112 8 -114 1 -1 10
0 19 4 14 5 16 24 16 125 0 65 -1 119 -2 118 -2 0 -13 -5 -25 -11z"/>
<path d="M20764 14269 c-168 -111 -387 -256 -631 -416 -29 -19 -53 -37 -53
-40 0 -2 6 -1 13 3 73 45 857 561 872 575 27 26 -21 -3 -201 -122z"/>
<path d="M22183 14333 c4 -38 7 -89 7 -115 0 -27 5 -48 10 -48 11 0 14 132 4
193 -11 66 -27 42 -21 -30z"/>
<path d="M19787 13619 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M19450 13610 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M19708 13613 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M19952 13554 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M19905 13530 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M19625 13520 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -14 13 -14 27
0 6 6 17 8 24 3 17 -10 120 -11 126 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 8 6
17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16
-1 -5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23
3 -6 -10 -64 -9 -74 0 -9 10 -21 9 -28 -3z"/>
<path d="M19954 13514 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M19403 13508 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M19520 13516 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M19568 13513 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M19596 13442 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M19778 13433 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M23406 15345 c-9 -24 -7 -73 3 -79 13 -8 24 61 13 80 -8 15 -10 15
-16 -1z"/>
<path d="M22898 15337 c-12 -30 -10 -93 3 -80 5 5 9 30 7 54 -2 31 -5 39 -10
26z"/>
<path d="M22936 15145 c-9 -24 -7 -75 3 -75 13 0 22 59 12 77 -7 13 -9 13 -15
-2z"/>
<path d="M23286 15284 c-9 -34 2 -73 15 -53 11 18 12 79 0 79 -5 0 -12 -12
-15 -26z"/>
<path d="M23178 15264 c-5 -4 -8 -28 -8 -53 1 -36 3 -42 11 -28 11 19 8 93 -3
81z"/>
<path d="M23058 15207 c-12 -30 -10 -93 3 -80 5 5 9 30 7 54 -2 31 -5 39 -10
26z"/>
<path d="M23567 15189 c-10 -36 -9 -85 2 -73 13 14 20 57 12 78 -7 18 -8 18
-14 -5z"/>
<path d="M23446 15138 c-9 -34 -7 -68 4 -68 13 0 24 70 13 81 -7 7 -12 2 -17
-13z"/>
<path d="M23765 14597 c-11 -57 0 -78 14 -28 8 29 9 47 2 54 -6 6 -12 -2 -16
-26z"/>
<path d="M23781 14392 c-7 -24 -10 -49 -8 -55 6 -17 29 60 24 80 -2 11 -8 1
-16 -25z"/>
<path d="M23331 15095 c-6 -16 -9 -41 -5 -55 l6 -25 10 25 c5 13 7 38 6 55
l-4 30 -13 -30z"/>
<path d="M22814 15066 c-7 -41 5 -71 17 -40 11 28 11 74 -1 74 -5 0 -12 -15
-16 -34z"/>
<path d="M23218 15067 c-5 -10 -8 -35 -8 -55 1 -30 2 -34 11 -19 6 9 9 34 7
55 -2 28 -5 32 -10 19z"/>
<path d="M23716 15025 c-9 -25 -7 -75 3 -75 13 0 24 71 13 82 -6 6 -12 3 -16
-7z"/>
<path d="M23098 15017 c-5 -10 -8 -37 -7 -60 0 -38 1 -40 10 -17 6 13 9 40 7
60 -2 27 -5 31 -10 17z"/>
<path d="M24214 14895 c11 -8 24 -15 30 -15 5 0 1 7 -10 15 -10 8 -23 14 -29
14 -5 0 -1 -6 9 -14z"/>
<path d="M24628 14693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M24636 14512 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M23875 13257 c-49 -29 -124 -76 -166 -104 -63 -42 -78 -49 -95 -40
-16 9 -17 8 -7 -5 11 -13 0 -25 -69 -78 -45 -35 -115 -95 -156 -134 -78 -75
-171 -181 -136 -156 213 150 435 280 478 280 9 0 25 -6 36 -12 19 -12 14 -19
-78 -111 l-97 -98 60 26 c33 15 101 43 150 63 50 19 106 42 127 50 l36 15 7
151 c4 83 5 164 4 179 l-4 28 -90 -54z m-52 -228 c-27 -27 -33 -30 -53 -19
-12 6 -19 15 -15 18 10 11 89 40 94 36 3 -3 -9 -18 -26 -35z"/>
<path d="M24710 12970 c0 -55 3 -100 8 -100 4 0 22 9 40 20 32 20 32 20 32
100 l0 80 -40 0 -40 0 0 -100z"/>
<path d="M24858 13011 l4 -61 88 48 c49 26 85 50 82 54 -4 4 -46 10 -92 14
l-85 7 3 -62z"/>
<path d="M23596 14978 c-9 -34 -7 -68 3 -68 10 0 21 34 21 68 0 12 -4 22 -9
22 -5 0 -11 -10 -15 -22z"/>
<path d="M22977 14958 c-10 -35 -8 -84 2 -72 13 14 21 68 12 83 -6 9 -10 6
-14 -11z"/>
<path d="M23004 14745 c-6 -34 -1 -55 11 -43 3 3 9 22 12 42 8 48 -14 48 -23
1z"/>
<path d="M23488 14955 c-12 -21 -18 -71 -9 -84 7 -11 11 -6 16 21 7 39 3 79
-7 63z"/>
<path d="M22854 14875 c-8 -44 2 -57 16 -21 13 34 13 56 0 56 -5 0 -12 -16
-16 -35z"/>
<path d="M23368 14907 c-5 -10 -8 -35 -8 -55 1 -30 2 -34 11 -19 6 9 9 34 7
55 -2 28 -5 32 -10 19z"/>
<path d="M23248 14867 c-12 -30 -10 -93 3 -80 5 5 9 30 7 54 -2 31 -5 39 -10
26z"/>
<path d="M21350 14700 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M21095 14690 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M21428 14693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M21170 14587 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M21263 14593 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M23746 14814 c-3 -9 -6 -30 -5 -47 l1 -32 13 30 c16 35 19 65 6 65
-5 0 -12 -7 -15 -16z"/>
<path d="M23127 14809 c-10 -35 -8 -81 2 -75 13 8 22 66 12 83 -6 12 -9 11
-14 -8z"/>
<path d="M23631 14776 c-6 -17 -10 -41 -8 -55 l3 -26 13 29 c6 17 10 41 8 55
l-3 26 -13 -29z"/>
<path d="M23512 14728 c-8 -21 -12 -46 -10 -55 7 -31 30 23 26 60 l-3 32 -13
-37z"/>
<path d="M22891 14705 c-8 -19 -9 -36 -3 -50 9 -18 10 -16 17 17 10 50 0 71
-14 33z"/>
<path d="M23398 14707 c-5 -10 -8 -35 -7 -55 0 -35 1 -35 10 -12 6 13 9 38 7
55 -2 24 -4 26 -10 12z"/>
<path d="M11508 14693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M11278 14598 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M11330 14587 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M23278 14660 c-4 -14 -8 -38 -8 -55 1 -25 2 -27 11 -12 6 9 9 34 7
55 -3 33 -4 35 -10 12z"/>
<path d="M23155 14597 c-11 -57 0 -78 14 -28 8 29 9 47 2 54 -6 6 -12 -2 -16
-26z"/>
<path d="M23652 14567 c-7 -16 -12 -40 -11 -55 1 -26 1 -26 15 7 8 18 13 43
11 55 -3 19 -4 19 -15 -7z"/>
<path d="M23042 14567 c-7 -16 -12 -40 -11 -55 1 -26 1 -26 15 7 8 18 13 43
11 55 -3 19 -4 19 -15 -7z"/>
<path d="M23532 14525 c-14 -49 -15 -65 -2 -65 11 0 24 60 18 87 -3 12 -8 5
-16 -22z"/>
<path d="M22922 14518 c-8 -21 -12 -46 -9 -55 6 -27 29 34 25 66 -3 24 -4 23
-16 -11z"/>
<path d="M22948 14345 c-15 -49 -17 -74 -9 -80 11 -6 25 54 19 82 -4 17 -5 17
-10 -2z"/>
<path d="M23418 14497 c-5 -10 -8 -33 -8 -50 1 -27 2 -29 11 -14 6 9 9 32 7
50 -2 25 -5 28 -10 14z"/>
<path d="M22806 14475 c-4 -16 -9 -35 -11 -42 -2 -7 0 -15 5 -18 12 -7 23 35
18 66 -4 22 -5 22 -12 -6z"/>
<path d="M22828 14290 c-4 -14 -8 -36 -8 -50 1 -22 2 -23 11 -7 6 9 9 32 7 50
-3 31 -3 31 -10 7z"/>
<path d="M23298 14457 c-5 -10 -8 -33 -8 -50 1 -27 2 -29 11 -14 6 9 9 32 7
50 -2 25 -5 28 -10 14z"/>
<path d="M23176 14408 c-3 -13 -6 -36 -6 -53 1 -38 15 -16 25 38 8 40 -8 53
-19 15z"/>
<path d="M32907 13619 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M36187 13619 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M32570 13610 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M32828 13613 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M35855 13610 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M36108 13613 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M33072 13554 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M33025 13530 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M32655 13513 c11 -13 18 -14 27 -5 9 9 15 9 26 0 10 -9 18 -9 33 0
11 7 25 10 31 6 17 -11 118 -12 124 -2 3 5 12 4 20 -3 10 -8 18 -8 27 0 8 6
17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -24 5 -4 7 -10 7
-18 0 -7 -6 -17 -6 -26 -1 -9 5 -19 5 -27 -2 -9 -7 -17 -7 -26 0 -7 6 -18 8
-24 4 -15 -9 -55 -8 -71 2 -7 4 -18 4 -24 -1 -19 -11 -37 -12 -44 -2 -3 5 -12
5 -23 -1 -11 -6 -22 -6 -30 0 -6 6 -4 2 4 -7z"/>
<path d="M33074 13514 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M32523 13508 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M23062 14368 c-8 -21 -12 -46 -9 -55 6 -27 29 34 25 66 -3 24 -4 23
-16 -11z"/>
<path d="M23661 14341 c-7 -23 -10 -45 -7 -48 9 -10 27 39 24 65 -3 24 -5 22
-17 -17z"/>
<path d="M23551 14327 c-6 -16 -11 -40 -10 -55 1 -22 4 -19 15 18 16 51 12 80
-5 37z"/>
<path d="M23432 14281 c-6 -19 -12 -43 -11 -55 0 -16 4 -13 15 13 8 18 14 43
12 55 -3 17 -6 15 -16 -13z"/>
<path d="M16120 13510 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20
-4z"/>
<path d="M16320 13446 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M16498 13433 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M23312 14238 c-8 -21 -12 -46 -9 -55 6 -27 29 34 25 66 -3 24 -4 23
-16 -11z"/>
<path d="M23201 14225 c-1 -5 -5 -27 -10 -47 -5 -21 -5 -38 0 -38 10 0 23 64
16 82 -3 7 -6 9 -6 3z"/>
<path d="M23080 14170 c-6 -11 -10 -33 -8 -48 3 -24 5 -22 17 17 14 47 9 65
-9 31z"/>
<path d="M23787 14197 c-4 -10 -7 -31 -6 -45 l0 -27 10 25 c5 13 8 33 7 45 -3
19 -4 19 -11 2z"/>
<path d="M23671 14153 c-7 -17 -11 -42 -9 -55 3 -19 7 -15 17 20 15 53 10 77
-8 35z"/>
<path d="M22962 14131 c-6 -19 -12 -43 -11 -55 0 -16 4 -13 15 13 8 18 14 43
12 55 -3 17 -6 15 -16 -13z"/>
<path d="M23551 14102 c-6 -24 -10 -49 -8 -55 7 -19 28 44 25 72 -3 22 -6 20
-17 -17z"/>
<path d="M23438 14077 c-5 -10 -8 -31 -8 -45 1 -24 2 -25 11 -9 6 10 9 30 7
45 -2 23 -4 24 -10 9z"/>
<path d="M3387 13619 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M6667 13619 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M3308 13613 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6330 13610 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M6588 13613 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3552 13554 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M6832 13554 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M3505 13530 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M6785 13530 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M3554 13514 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M6505 13520 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -14 13 -14 27 0
6 6 17 8 24 3 17 -10 120 -11 126 -1 3 4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17
7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1
-5 -8 -13 -8 -26 -1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -10 6 -21 7 -23 3
-6 -10 -64 -9 -74 0 -9 10 -21 9 -28 -3z"/>
<path d="M6834 13514 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M6283 13508 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M6400 13516 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M6448 13513 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3196 13442 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M6476 13442 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M3378 13433 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6658 13433 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6780 11344 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M6658 11243 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6655 9240 c27 -12 43 -12 25 0 -8 5 -22 9 -30 9 -10 0 -8 -3 5 -9z"/>
<path d="M6494 9134 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4 -10
16 -18 15 -42 -4z"/>
<path d="M6410 9128 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20 -9z"/>
<path d="M6476 9062 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M6596 9062 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M6658 9053 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5020 8130 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z"/>
<path d="M23322 14041 c-6 -19 -12 -43 -11 -55 0 -16 4 -13 15 13 8 18 14 43
12 55 -3 17 -6 15 -16 -13z"/>
<path d="M23201 13992 c-6 -24 -10 -49 -8 -55 7 -19 28 44 25 72 -3 22 -6 20
-17 -17z"/>
<path d="M45643 13508 c7 -4 21 -8 32 -8 11 0 25 4 32 8 6 4 -8 7 -32 7 -24 0
-38 -3 -32 -7z"/>
<path d="M45760 13516 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M45808 13513 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M43269 13121 c134 -89 245 -160 247 -158 5 5 -449 305 -474 314 -9 3
93 -67 227 -156z"/>
<path d="M27619 12523 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M30899 12523 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M34179 12523 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M37459 12523 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M27910 12510 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M31190 12510 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M34470 12510 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M37750 12510 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M28149 12433 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M31429 12433 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M34709 12433 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M28084 12418 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M31364 12418 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M34644 12418 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M30874 12403 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M34154 12403 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M27732 12394 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M27823 12403 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6
10 -4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M27876 12401 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M27975 12400 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M31012 12394 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M31103 12403 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6
10 -4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M31156 12401 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M31255 12400 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M34292 12394 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M34383 12403 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6
10 -4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M34436 12401 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M34535 12400 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M27796 12322 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M27856 12322 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M31076 12322 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M31136 12322 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M34356 12322 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M34416 12322 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M27978 12313 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M31258 12313 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M34538 12313 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M34065 12200 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5
0 -13 -4 -16 -10z"/>
<path d="M3308 11423 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3196 11252 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M3256 11252 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M2980 9151 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42 17
-9 8 -16 11 -16 5z"/>
<path d="M3290 9141 c0 -12 4 -13 50 -15 17 0 30 3 30 7 0 5 -12 7 -28 6 -15
-2 -33 0 -40 4 -6 5 -12 4 -12 -2z"/>
<path d="M3380 9142 c0 -15 32 -24 43 -13 7 7 15 7 22 1 6 -5 16 -5 25 2 12 8
12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -11 -9 -17 -9 -29 1 -9 7
-15 8 -15 2z"/>
<path d="M3196 9062 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M3316 9062 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M3378 9053 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6347 11329 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66 -12
80 5 15 18 12 18 -13 4z"/>
<path d="M19740 11326 c0 -9 30 -14 35 -6 4 6 -3 10 -14 10 -12 0 -21 -2 -21
-4z"/>
<path d="M4950 12510 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M4530 12190 c-14 -11 -20 -20 -15 -20 6 0 21 9 35 20 14 11 21 20 15
20 -5 0 -21 -9 -35 -20z"/>
<path d="M4772 12394 c11 -11 21 -14 26 -9 4 6 6 9 3 8 -2 -1 -13 3 -25 9 -20
10 -20 10 -4 -8z"/>
<path d="M4825 12390 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M4850 12389 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M4836 12322 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M4896 12322 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M34660 11626 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21
-21 13z"/>
<path d="M34690 11586 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21
-21 13z"/>
<path d="M9930 11430 c8 -5 22 -10 30 -10 13 0 13 1 0 10 -8 5 -22 10 -30 10
-13 0 -13 -1 0 -10z"/>
<path d="M30899 10333 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M30958 10218 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M3680 11087 c0 -3 12 -12 26 -22 15 -9 23 -12 20 -6 -7 11 -46 35
-46 28z"/>
<path d="M15730 10915 c-146 -97 -345 -228 -442 -293 -97 -64 -175 -118 -173
-120 2 -2 122 75 267 170 145 96 343 227 441 292 151 99 189 127 175 126 -2 0
-122 -79 -268 -175z"/>
<path d="M14499 10333 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M14788 10313 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M15025 10240 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M14558 10218 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M14987 10219 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M14612 10205 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1
14 6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11
6 -20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M14754 10208 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4
7 12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1
6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M15039 10203 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M14676 10132 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M14736 10132 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M14796 10132 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M14858 10123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M18320 10210 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M20475 10823 c16 -17 486 -325 490 -321 2 1 -52 40 -118 84 -267 178
-393 258 -372 237z"/>
<path d="M21059 10333 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M31895 10760 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5
0 -13 -4 -16 -10z"/>
<path d="M11219 10333 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M11745 10240 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M11278 10218 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M10943 9902 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M9579 9253 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M9940 9240 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"/>
<path d="M10110 9170 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M9540 9151 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42 17
-9 8 -16 11 -16 5z"/>
<path d="M9774 9134 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4 -10
16 -18 15 -42 -4z"/>
<path d="M9836 9142 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4 10
-8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M10084 9136 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8 -40
-2 -20 10 -20 10 -1 -5z"/>
<path d="M9690 9128 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20 -9z"/>
<path d="M9756 9062 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M9876 9062 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M9938 9053 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8990 8605 c-245 -162 -442 -295 -437 -295 4 0 78 47 165 104 554
365 735 486 727 486 -6 0 -210 -133 -455 -295z"/>
<path d="M7939 8143 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M8230 8130 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M8308 8123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8129 8053 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M8465 8050 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M8404 8038 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M7900 8031 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M8049 8018 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18 1
7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M8239 8013 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9 16
-11 15 -27 -5z"/>
<path d="M8289 8012 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24 0
7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12 6
-16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M8116 7942 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M8176 7942 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M8298 7933 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4659 10333 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M24320 10460 c-327 -43 -763 -100 -969 -126 l-373 -48 5 -53 c4 -40
2 -53 -8 -53 -7 0 -294 -39 -637 -86 -343 -47 -633 -83 -645 -81 -12 2 -21 1
-18 -3 2 -3 -186 -32 -418 -64 -232 -31 -438 -60 -457 -63 -30 -4 -22 4 60 56
94 61 138 95 91 71 -12 -6 -64 -39 -115 -73 l-91 -61 -349 -48 c-276 -38 -351
-46 -358 -36 -5 7 -7 32 -5 55 3 24 1 40 -4 37 -5 -3 -9 11 -9 30 0 31 -3 36
-22 36 -78 0 -874 -102 -885 -113 -11 -10 -2 -43 47 -177 33 -91 61 -172 63
-180 1 -8 5 -19 9 -25 12 -20 110 -332 138 -438 18 -66 38 -119 49 -131 20
-19 32 -18 2768 365 l2748 385 3 452 c2 359 0 452 -10 451 -7 -1 -281 -36
-608 -79z"/>
<path d="M21356 10132 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M4948 10313 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4620 10221 c0 -5 7 -12 16 -15 14 -5 15 -4 4 9 -14 17 -20 19 -20 6z"/>
<path d="M4680 10200 l-25 -8 27 -1 c15 -1 30 4 33 9 7 11 0 11 -35 0z"/>
<path d="M4940 10196 c7 -7 14 -6 21 1 9 9 7 12 -9 10 -14 -1 -18 -5 -12 -11z"/>
<path d="M4896 10132 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M4956 10132 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M5018 10123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M31263 9785 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"/>
<path d="M14499 8143 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M14790 8130 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M14868 8123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M14689 8053 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M14460 8031 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M14609 8018 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18 1
7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M14799 8013 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M14676 7942 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M14736 7942 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M29725 9160 c-4 -6 -3 -9 2 -8 4 1 21 -6 36 -16 28 -19 28 -19 50 5
l22 23 -23 -19 c-22 -18 -23 -18 -52 3 -17 13 -31 18 -35 12z"/>
<path d="M29461 9141 c-8 -5 -21 -7 -30 -4 -13 4 -14 3 -2 -5 10 -7 21 -7 33
-1 10 6 24 7 30 3 7 -4 8 -3 4 4 -9 14 -16 15 -35 3z"/>
<path d="M29515 9140 c-3 -5 3 -11 14 -11 64 -4 83 -3 88 4 3 4 11 3 19 -4 10
-8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1
-24 5 -4 6 -11 6 -20 -2 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1 -4 -7 -12 -7
-25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M29436 9062 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M29556 9062 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M29618 9053 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M29071 8870 c-24 -17 -40 -30 -35 -30 5 0 29 14 54 30 25 16 41 30
35 30 -5 0 -30 -14 -54 -30z"/>
<path d="M22110 8605 c-245 -162 -442 -295 -437 -295 4 0 78 47 165 104 554
365 735 486 727 486 -6 0 -210 -133 -455 -295z"/>
<path d="M21059 8143 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M21350 8130 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M21428 8123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M21249 8053 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M21585 8050 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M21524 8038 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M21020 8031 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M21169 8018 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18 1
7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M21359 8013 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M21409 8012 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24 0
7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12 6
-16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M21236 7942 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M21296 7942 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M21418 7933 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M14790 5940 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M3055 7040 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3308 7043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3484 6968 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M2994 6945 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M3161 6950 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31 -2
11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3 4
11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M3196 6872 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M3256 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M3316 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M3378 6863 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3671 6706 c2 -2 15 -9 29 -15 24 -11 24 -11 6 3 -16 13 -49 24 -35
12z"/>
<path d="M16175 7040 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M16428 7043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M16604 6968 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M16114 6945 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M16281 6950 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M16316 6872 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M16376 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M16436 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M16498 6863 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M15198 6183 c-48 -31 -86 -59 -84 -61 4 -3 148 89 171 109 21 20 -4
6 -87 -48z"/>
<path d="M16139 4873 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M18305 27760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M21585 27760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M24865 27760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M28145 27760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M31425 27760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M34705 27760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M37985 27760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M41265 27760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M44545 27760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M47825 27760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M1438 27738 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M1867 27739 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M4718 27738 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M5147 27739 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M7998 27738 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M8427 27739 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M11278 27738 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M11707 27739 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M14558 27738 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M14987 27739 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M17838 27738 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M18267 27739 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M21118 27738 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M21547 27739 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M24398 27738 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M24827 27739 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M27678 27738 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M28107 27739 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M30958 27738 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M31387 27739 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M34238 27738 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M34667 27739 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M37518 27738 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M37947 27739 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M40798 27738 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M41227 27739 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M44078 27738 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M44507 27739 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M47358 27738 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M47787 27739 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M1492 27725 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1 14
6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11 6
-20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M1634 27728 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4 7
12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1 6
-6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M1919 27723 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M4772 27725 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1 14
6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11 6
-20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M4914 27728 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4 7
12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1 6
-6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M5199 27723 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M8052 27725 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1 14
6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11 6
-20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M8194 27728 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4 7
12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1 6
-6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M8479 27723 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M11332 27725 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1
14 6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11
6 -20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M11474 27728 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4
7 12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1
6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M11759 27723 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M14612 27725 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1
14 6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11
6 -20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M14754 27728 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4
7 12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1
6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M15039 27723 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M17892 27725 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1
14 6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11
6 -20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M18034 27728 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4
7 12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1
6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M18319 27723 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M21172 27725 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1
14 6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11
6 -20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M21314 27728 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4
7 12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1
6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M21599 27723 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M24452 27725 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1
14 6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11
6 -20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M24594 27728 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4
7 12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1
6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M24879 27723 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M27732 27725 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1
14 6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11
6 -20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M27874 27728 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4
7 12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1
6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M28159 27723 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M31012 27725 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1
14 6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11
6 -20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M31154 27728 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4
7 12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1
6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M31439 27723 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M34292 27725 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1
14 6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11
6 -20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M34434 27728 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4
7 12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1
6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M34719 27723 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M37572 27725 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1
14 6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11
6 -20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M37714 27728 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4
7 12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1
6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M37999 27723 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M40852 27725 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1
14 6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11
6 -20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M40994 27728 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4
7 12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1
6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M41279 27723 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M44132 27725 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1
14 6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11
6 -20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M44274 27728 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4
7 12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1
6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M44559 27723 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M47412 27725 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1
14 6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11
6 -20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M47554 27728 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4
7 12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1
6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M47839 27723 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M1556 27652 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M1616 27652 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M1676 27652 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M4836 27652 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M4896 27652 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M4956 27652 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M8116 27652 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M8176 27652 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M8236 27652 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M11396 27652 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M11456 27652 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M11516 27652 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M14676 27652 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M14736 27652 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M14796 27652 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M17956 27652 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M18016 27652 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M18076 27652 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M21236 27652 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M21296 27652 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M21356 27652 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M24516 27652 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M24576 27652 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M24636 27652 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M27796 27652 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M27856 27652 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M27916 27652 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M31076 27652 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M31136 27652 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M31196 27652 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M34356 27652 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M34416 27652 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M34476 27652 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M37636 27652 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M37696 27652 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M37756 27652 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M40916 27652 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M40976 27652 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M41036 27652 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M44196 27652 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M44256 27652 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M44316 27652 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M47476 27652 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M47536 27652 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M47596 27652 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M1738 27643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5018 27643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8298 27643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M11578 27643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M14858 27643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M18138 27643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M21418 27643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M24698 27643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M27978 27643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M31258 27643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M34538 27643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M37818 27643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M41098 27643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M44378 27643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47658 27643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1103 27422 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M2005 27525 c25 -20 827 -550 854 -565 11 -5 23 -10 26 -10 7 0 -77
56 -380 255 -82 54 -222 146 -310 205 -154 102 -239 154 -190 115z"/>
<path d="M4383 27422 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M5285 27525 c25 -20 827 -550 854 -565 11 -5 23 -10 26 -10 7 0 -77
56 -380 255 -82 54 -222 146 -310 205 -154 102 -239 154 -190 115z"/>
<path d="M7663 27422 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M8565 27525 c25 -20 827 -550 854 -565 11 -5 23 -10 26 -10 7 0 -77
56 -380 255 -82 54 -222 146 -310 205 -154 102 -239 154 -190 115z"/>
<path d="M10943 27422 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M11845 27525 c25 -20 827 -550 854 -565 11 -5 23 -10 26 -10 7 0 -77
56 -380 255 -82 54 -222 146 -310 205 -154 102 -239 154 -190 115z"/>
<path d="M14223 27422 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M17503 27422 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M18405 27525 c25 -20 827 -550 854 -565 11 -5 23 -10 26 -10 7 0 -77
56 -380 255 -82 54 -222 146 -310 205 -154 102 -239 154 -190 115z"/>
<path d="M20783 27422 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M21685 27525 c28 -23 830 -552 857 -566 54 -27 -13 19 -252 177 -140
92 -327 215 -415 274 -154 102 -238 154 -190 115z"/>
<path d="M24063 27422 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M24965 27525 c25 -20 827 -550 854 -565 11 -5 23 -10 26 -10 7 0 -77
56 -380 255 -82 54 -222 146 -310 205 -154 102 -239 154 -190 115z"/>
<path d="M27343 27422 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M28245 27525 c25 -20 827 -550 854 -565 11 -5 23 -10 26 -10 7 0 -77
56 -380 255 -82 54 -222 146 -310 205 -154 102 -239 154 -190 115z"/>
<path d="M30623 27422 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M31525 27525 c25 -20 827 -550 854 -565 11 -5 23 -10 26 -10 7 0 -77
56 -380 255 -82 54 -222 146 -310 205 -154 102 -239 154 -190 115z"/>
<path d="M33903 27422 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M34805 27525 c25 -20 827 -550 854 -565 11 -5 23 -10 26 -10 7 0 -77
56 -380 255 -82 54 -222 146 -310 205 -154 102 -239 154 -190 115z"/>
<path d="M37183 27422 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M38085 27525 c25 -20 827 -550 854 -565 11 -5 23 -10 26 -10 7 0 -77
56 -380 255 -82 54 -222 146 -310 205 -154 102 -239 154 -190 115z"/>
<path d="M40463 27422 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M41365 27525 c25 -20 827 -550 854 -565 11 -5 23 -10 26 -10 7 0 -77
56 -380 255 -82 54 -222 146 -310 205 -154 102 -239 154 -190 115z"/>
<path d="M43743 27422 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M44645 27525 c25 -20 827 -550 854 -565 11 -5 23 -10 26 -10 7 0 -77
56 -380 255 -82 54 -222 146 -310 205 -154 102 -239 154 -190 115z"/>
<path d="M47023 27422 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M47925 27525 c25 -20 327 -219 375 -246 65 -38 -3 11 -176 125 -165
110 -246 159 -199 121z"/>
<path d="M3019 26773 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M6299 26773 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M9579 26773 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M12859 26773 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M16139 26773 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M19419 26773 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M25979 26773 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M29259 26773 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M32539 26773 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M35819 26773 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M39099 26773 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M42379 26773 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M45659 26773 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M100 26760 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"/>
<path d="M3380 26760 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M6660 26760 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M9940 26760 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M13220 26760 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M16500 26760 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M19780 26760 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M26340 26760 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M29620 26760 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M32900 26760 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M36180 26760 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M39460 26760 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M42740 26760 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M46020 26760 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M270 26690 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M3550 26690 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M6830 26690 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M10110 26690 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M13390 26690 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M16670 26690 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M19950 26690 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M23230 26690 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M26510 26690 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M29790 26690 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M33070 26690 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M36350 26690 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M39630 26690 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M42910 26690 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M46190 26690 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M23175 26680 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M2980 26671 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42 17
-9 8 -16 11 -16 5z"/>
<path d="M6260 26671 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42 17
-9 8 -16 11 -16 5z"/>
<path d="M9540 26671 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42 17
-9 8 -16 11 -16 5z"/>
<path d="M12820 26671 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42
17 -9 8 -16 11 -16 5z"/>
<path d="M16100 26671 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42
17 -9 8 -16 11 -16 5z"/>
<path d="M19380 26671 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42
17 -9 8 -16 11 -16 5z"/>
<path d="M25940 26671 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42
17 -9 8 -16 11 -16 5z"/>
<path d="M29220 26671 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42
17 -9 8 -16 11 -16 5z"/>
<path d="M32500 26671 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42
17 -9 8 -16 11 -16 5z"/>
<path d="M35780 26671 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42
17 -9 8 -16 11 -16 5z"/>
<path d="M39060 26671 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42
17 -9 8 -16 11 -16 5z"/>
<path d="M42340 26671 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42
17 -9 8 -16 11 -16 5z"/>
<path d="M45620 26671 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42
17 -9 8 -16 11 -16 5z"/>
<path d="M13 26657 c17 -14 71 -16 84 -4 3 4 12 2 20 -4 9 -8 17 -8 26 0 8 6
17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1 -32 -3 -3 -5 -14 -5
-24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -14 -7
-28 1 -20 9 -21 9 -4 -4z"/>
<path d="M244 26656 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8 -40
-2 -20 10 -20 10 -1 -5z"/>
<path d="M3214 26654 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4 -10
16 -18 15 -42 -4z"/>
<path d="M3276 26662 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4 10
-8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M3524 26656 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8 -40
-2 -20 10 -20 10 -1 -5z"/>
<path d="M6494 26654 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4 -10
16 -18 15 -42 -4z"/>
<path d="M6556 26662 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4 10
-8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M6804 26656 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8 -40
-2 -20 10 -20 10 -1 -5z"/>
<path d="M9774 26654 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4 -10
16 -18 15 -42 -4z"/>
<path d="M9836 26662 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4 10
-8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M10084 26656 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8
-40 -2 -20 10 -20 10 -1 -5z"/>
<path d="M13054 26654 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4
-10 16 -18 15 -42 -4z"/>
<path d="M13116 26662 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4
10 -8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M13364 26656 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8
-40 -2 -20 10 -20 10 -1 -5z"/>
<path d="M16334 26654 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4
-10 16 -18 15 -42 -4z"/>
<path d="M16396 26662 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4
10 -8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M16644 26656 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8
-40 -2 -20 10 -20 10 -1 -5z"/>
<path d="M19614 26654 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4
-10 16 -18 15 -42 -4z"/>
<path d="M19676 26662 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4
10 -8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M19924 26656 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8
-40 -2 -20 10 -20 10 -1 -5z"/>
<path d="M23241 26661 c-8 -5 -21 -7 -30 -4 -11 3 -10 1 3 -7 14 -10 21 -9 34
4 18 18 15 21 -7 7z"/>
<path d="M26174 26654 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4
-10 16 -18 15 -42 -4z"/>
<path d="M26236 26662 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4
10 -8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M26484 26656 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8
-40 -2 -20 10 -20 10 -1 -5z"/>
<path d="M29454 26654 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4
-10 16 -18 15 -42 -4z"/>
<path d="M29516 26662 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4
10 -8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M29764 26656 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8
-40 -2 -20 10 -20 10 -1 -5z"/>
<path d="M32734 26654 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4
-10 16 -18 15 -42 -4z"/>
<path d="M32796 26662 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4
10 -8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M33044 26656 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8
-40 -2 -20 10 -20 10 -1 -5z"/>
<path d="M36014 26654 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4
-10 16 -18 15 -42 -4z"/>
<path d="M36076 26662 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4
10 -8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M36324 26656 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8
-40 -2 -20 10 -20 10 -1 -5z"/>
<path d="M39294 26654 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4
-10 16 -18 15 -42 -4z"/>
<path d="M39356 26662 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4
10 -8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M39604 26656 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8
-40 -2 -20 10 -20 10 -1 -5z"/>
<path d="M42574 26654 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4
-10 16 -18 15 -42 -4z"/>
<path d="M42636 26662 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4
10 -8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M42884 26656 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8
-40 -2 -20 10 -20 10 -1 -5z"/>
<path d="M45854 26654 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4
-10 16 -18 15 -42 -4z"/>
<path d="M45916 26662 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4
10 -8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M46164 26656 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8
-40 -2 -20 10 -20 10 -1 -5z"/>
<path d="M3130 26648 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20 -9z"/>
<path d="M6410 26648 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20 -9z"/>
<path d="M9690 26648 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20 -9z"/>
<path d="M12970 26648 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20
-9z"/>
<path d="M16250 26648 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20
-9z"/>
<path d="M19530 26648 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20
-9z"/>
<path d="M26090 26648 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20
-9z"/>
<path d="M29370 26648 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20
-9z"/>
<path d="M32650 26648 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20
-9z"/>
<path d="M35930 26648 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20
-9z"/>
<path d="M39210 26648 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20
-9z"/>
<path d="M42490 26648 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20
-9z"/>
<path d="M45770 26648 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20
-9z"/>
<path d="M36 26582 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M3196 26582 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M3316 26582 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M6476 26582 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M6596 26582 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M9756 26582 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M9876 26582 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M13036 26582 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M13156 26582 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M16316 26582 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M16436 26582 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M19596 26582 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M19716 26582 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M26156 26582 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M26276 26582 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M29436 26582 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M29556 26582 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M32716 26582 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M32836 26582 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M35996 26582 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M36116 26582 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M39276 26582 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M39396 26582 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M42556 26582 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M42676 26582 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M45836 26582 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M45956 26582 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M98 26573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3378 26573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6658 26573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9938 26573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M13218 26573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M16498 26573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M19778 26573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M26338 26573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M29618 26573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M32898 26573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M36178 26573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39458 26573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42738 26573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M46018 26573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M675 26229 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5 0
121 -86 280 -191z"/>
<path d="M2430 26125 c-245 -162 -442 -295 -437 -295 4 0 78 47 165 104 554
365 735 486 727 486 -6 0 -210 -133 -455 -295z"/>
<path d="M3955 26229 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5
0 121 -86 280 -191z"/>
<path d="M5710 26125 c-245 -162 -442 -295 -437 -295 4 0 78 47 165 104 554
365 735 486 727 486 -6 0 -210 -133 -455 -295z"/>
<path d="M7235 26229 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5
0 121 -86 280 -191z"/>
<path d="M8990 26125 c-245 -162 -442 -295 -437 -295 4 0 78 47 165 104 554
365 735 486 727 486 -6 0 -210 -133 -455 -295z"/>
<path d="M10515 26229 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5
0 121 -86 280 -191z"/>
<path d="M12270 26125 c-245 -162 -442 -295 -437 -295 4 0 78 47 165 104 554
365 735 486 727 486 -6 0 -210 -133 -455 -295z"/>
<path d="M13795 26229 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5
0 121 -86 280 -191z"/>
<path d="M17075 26229 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5
0 121 -86 280 -191z"/>
<path d="M18830 26125 c-245 -162 -442 -295 -437 -295 4 0 78 47 165 104 554
365 735 486 727 486 -6 0 -210 -133 -455 -295z"/>
<path d="M20355 26229 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5
0 121 -86 280 -191z"/>
<path d="M22110 26125 c-245 -162 -442 -295 -437 -295 4 0 78 47 165 104 554
365 735 486 727 486 -6 0 -210 -133 -455 -295z"/>
<path d="M33475 26229 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5
0 121 -86 280 -191z"/>
<path d="M35230 26125 c-245 -162 -442 -295 -437 -295 4 0 78 47 165 104 554
365 735 486 727 486 -6 0 -210 -133 -455 -295z"/>
<path d="M36755 26229 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5
0 121 -86 280 -191z"/>
<path d="M38510 26125 c-245 -162 -442 -295 -437 -295 4 0 78 47 165 104 554
365 735 486 727 486 -6 0 -210 -133 -455 -295z"/>
<path d="M40035 26229 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5
0 121 -86 280 -191z"/>
<path d="M41790 26125 c-245 -162 -442 -295 -437 -295 4 0 78 47 165 104 554
365 735 486 727 486 -6 0 -210 -133 -455 -295z"/>
<path d="M43315 26229 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5
0 121 -86 280 -191z"/>
<path d="M45070 26125 c-245 -162 -442 -295 -437 -295 4 0 78 47 165 104 554
365 735 486 727 486 -6 0 -210 -133 -455 -295z"/>
<path d="M46595 26229 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5
0 121 -86 280 -191z"/>
<path d="M48115 25970 c-115 -77 -206 -140 -202 -140 10 0 417 268 417 275 0
8 4 11 -215 -135z"/>
<path d="M1379 25663 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M4659 25663 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M7939 25663 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M11219 25663 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M14499 25663 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M17779 25663 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M21059 25663 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M27619 25663 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M34179 25663 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M37459 25663 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M40739 25663 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M44019 25663 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M47299 25663 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M1670 25650 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M4950 25650 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M8230 25650 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M11510 25650 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M14790 25650 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M18070 25650 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M24630 25650 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M27910 25650 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M34470 25650 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M37750 25650 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M41030 25650 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M44310 25650 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M47590 25650 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M1748 25643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5028 25643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8308 25643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M11588 25643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M14868 25643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M18148 25643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M24370 25639 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M24708 25643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M27988 25643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M34548 25643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M37828 25643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M41108 25643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M44388 25643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47668 25643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1569 25573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M4849 25573 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M8129 25573 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M11409 25573 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M14689 25573 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M17969 25573 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M24529 25573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M27809 25573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M34369 25573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M37649 25573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M40929 25573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M44209 25573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M47489 25573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M1905 25570 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M5185 25570 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M8465 25570 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M11745 25570 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M15025 25570 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M18305 25570 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M24865 25570 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M28145 25570 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M34705 25570 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M37985 25570 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M41265 25570 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M44545 25570 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M47825 25570 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M1844 25558 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M5124 25558 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M8404 25558 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M11684 25558 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M14964 25558 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M18244 25558 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M24804 25558 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M28084 25558 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M34644 25558 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M37924 25558 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M41204 25558 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M44484 25558 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M47764 25558 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M1340 25551 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M4620 25551 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M7900 25551 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M11180 25551 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M14460 25551 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M17740 25551 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M24300 25551 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M27580 25551 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M34140 25551 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M37420 25551 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M40700 25551 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M43980 25551 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M47260 25551 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M1489 25538 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18 1
7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M1679 25533 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M1729 25532 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24 0
7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12 6
-16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M4769 25538 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18 1
7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M4959 25533 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M5009 25532 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24 0
7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12 6
-16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M8049 25538 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18 1
7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M8239 25533 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M8289 25532 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24 0
7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12 6
-16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M11329 25538 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18
1 7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M11519 25533 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M11569 25532 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24
0 7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12
6 -16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M14609 25538 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18
1 7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M14799 25533 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M14849 25532 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24
0 7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12
6 -16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M17889 25538 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18
1 7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M18079 25533 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M18129 25532 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24
0 7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12
6 -16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M24449 25538 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18
1 7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M24639 25533 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M24689 25532 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24
0 7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12
6 -16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M27729 25538 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18
1 7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M27919 25533 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M27969 25532 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24
0 7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12
6 -16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M34289 25538 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18
1 7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M34479 25533 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M34529 25532 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24
0 7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12
6 -16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M37569 25538 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18
1 7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M37759 25533 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M37809 25532 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24
0 7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12
6 -16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M40849 25538 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18
1 7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M41039 25533 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M41089 25532 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24
0 7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12
6 -16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M44129 25538 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18
1 7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M44319 25533 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M44369 25532 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24
0 7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12
6 -16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M47409 25538 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18
1 7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M47599 25533 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M47649 25532 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24
0 7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12
6 -16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M1556 25462 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M1616 25462 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M4836 25462 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M4896 25462 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M8116 25462 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M8176 25462 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M11396 25462 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M11456 25462 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M14676 25462 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M14736 25462 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M17956 25462 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M18016 25462 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M24516 25462 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M24576 25462 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M27796 25462 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M27856 25462 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M34356 25462 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M34416 25462 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M37636 25462 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M37696 25462 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M40916 25462 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M40976 25462 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M44196 25462 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M44256 25462 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M47476 25462 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M47536 25462 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M1738 25453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5018 25453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8298 25453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M11578 25453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M14858 25453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M18138 25453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M24698 25453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M27978 25453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M34538 25453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M37818 25453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M41098 25453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M44378 25453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47658 25453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1250 25330 c-14 -10 -207 -139 -430 -286 -353 -232 -468 -310 -410
-279 37 21 859 562 875 576 17 17 -10 8 -35 -11z"/>
<path d="M1996 25341 c15 -14 837 -555 874 -576 55 -30 -42 37 -290 201 -157
103 -352 232 -433 286 -132 87 -180 116 -151 89z"/>
<path d="M4530 25330 c-14 -10 -207 -139 -430 -286 -353 -232 -468 -310 -410
-279 37 21 859 562 875 576 17 17 -10 8 -35 -11z"/>
<path d="M5276 25341 c15 -14 837 -555 874 -576 55 -30 -42 37 -290 201 -157
103 -352 232 -433 286 -132 87 -180 116 -151 89z"/>
<path d="M7810 25330 c-14 -10 -207 -139 -430 -286 -353 -232 -468 -310 -410
-279 37 21 859 562 875 576 17 17 -10 8 -35 -11z"/>
<path d="M8556 25341 c15 -14 837 -555 874 -576 55 -30 -42 37 -290 201 -157
103 -352 232 -433 286 -132 87 -180 116 -151 89z"/>
<path d="M11090 25330 c-14 -10 -207 -139 -430 -286 -353 -232 -468 -310 -410
-279 37 21 859 562 875 576 17 17 -10 8 -35 -11z"/>
<path d="M11836 25341 c15 -14 837 -555 874 -576 55 -30 -42 37 -290 201 -157
103 -352 232 -433 286 -132 87 -180 116 -151 89z"/>
<path d="M14370 25330 c-14 -10 -207 -139 -430 -286 -353 -232 -468 -310 -410
-279 37 21 859 562 875 576 17 17 -10 8 -35 -11z"/>
<path d="M17650 25330 c-14 -10 -207 -139 -430 -286 -353 -232 -468 -310 -410
-279 37 21 859 562 875 576 17 17 -10 8 -35 -11z"/>
<path d="M24219 25333 c-13 -15 -12 -15 9 -4 23 12 28 21 13 21 -5 0 -15 -7
-22 -17z"/>
<path d="M37330 25330 c-14 -10 -207 -139 -430 -286 -353 -232 -468 -310 -410
-279 37 21 859 562 875 576 17 17 -10 8 -35 -11z"/>
<path d="M38076 25341 c15 -14 837 -555 874 -576 55 -30 -42 37 -290 201 -157
103 -352 232 -433 286 -132 87 -180 116 -151 89z"/>
<path d="M40610 25330 c-14 -10 -207 -139 -430 -286 -353 -232 -468 -310 -410
-279 37 21 859 562 875 576 17 17 -10 8 -35 -11z"/>
<path d="M41356 25341 c15 -14 837 -555 874 -576 55 -30 -42 37 -290 201 -157
103 -352 232 -433 286 -132 87 -180 116 -151 89z"/>
<path d="M43890 25330 c-14 -10 -207 -139 -430 -286 -353 -232 -468 -310 -410
-279 37 21 859 562 875 576 17 17 -10 8 -35 -11z"/>
<path d="M44636 25341 c15 -14 837 -555 874 -576 55 -30 -42 37 -290 201 -157
103 -352 232 -433 286 -132 87 -180 116 -151 89z"/>
<path d="M47170 25330 c-14 -10 -207 -139 -430 -286 -353 -232 -468 -310 -410
-279 37 21 859 562 875 576 17 17 -10 8 -35 -11z"/>
<path d="M47915 25342 c18 -17 408 -272 412 -269 4 4 -392 269 -411 276 -7 2
-8 0 -1 -7z"/>
<path d="M28 24563 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3055 24560 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M3308 24563 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6335 24560 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M6588 24563 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9615 24560 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M9868 24563 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M12895 24560 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M13148 24563 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M16175 24560 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M16428 24563 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M19455 24560 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M19708 24563 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39135 24560 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M39388 24563 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42415 24560 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M42668 24563 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M45695 24560 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M45948 24563 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M204 24488 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M3484 24488 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M6764 24488 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M10044 24488 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M13324 24488 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M16604 24488 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M39564 24488 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M42844 24488 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M46124 24488 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M25 24469 c-21 -5 -24 -7 -10 -9 58 -5 77 -5 82 3 2 4 11 3 19 -4 11
-9 18 -9 26 -1 7 7 16 8 23 2 6 -5 16 -5 25 2 12 8 12 9 -2 4 -10 -3 -20 -1
-24 5 -4 7 -10 6 -18 0 -7 -6 -15 -8 -19 -5 -8 9 -67 10 -102 3z"/>
<path d="M2994 24465 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M3161 24470 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M6274 24465 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M6441 24470 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M9554 24465 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M9721 24470 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M12834 24465 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9
-60 0 -29 10 -30 10 -13 -3z"/>
<path d="M13001 24470 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M16114 24465 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9
-60 0 -29 10 -30 10 -13 -3z"/>
<path d="M16281 24470 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M39074 24465 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9
-60 0 -29 10 -30 10 -13 -3z"/>
<path d="M39241 24470 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M42354 24465 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9
-60 0 -29 10 -30 10 -13 -3z"/>
<path d="M42521 24470 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M45634 24465 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9
-60 0 -29 10 -30 10 -13 -3z"/>
<path d="M45801 24470 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M36 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M3196 24392 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M3256 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M3316 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M6476 24392 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M6536 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M6596 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M9756 24392 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M9816 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M9876 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M13036 24392 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M13096 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M13156 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M16316 24392 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M16376 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M16436 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M39276 24392 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M39336 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M39396 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M42556 24392 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M42616 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M42676 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M45836 24392 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M45896 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M45956 24392 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M98 24383 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3378 24383 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6658 24383 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9938 24383 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M13218 24383 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M16498 24383 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39458 24383 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42738 24383 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M46018 24383 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M400 24226 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2
-5 10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M2779 24167 c-208 -140 -749 -496 -769 -507 -12 -6 -20 -14 -17 -16
5 -5 178 107 665 430 194 129 232 156 219 156 -2 0 -46 -29 -98 -63z"/>
<path d="M3680 24226 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2
-5 10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M6059 24167 c-208 -140 -749 -496 -769 -507 -12 -6 -20 -14 -17 -16
5 -5 178 107 665 430 194 129 232 156 219 156 -2 0 -46 -29 -98 -63z"/>
<path d="M6960 24226 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2
-5 10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M9339 24167 c-208 -140 -749 -496 -769 -507 -12 -6 -20 -14 -17 -16
5 -5 178 107 665 430 194 129 232 156 219 156 -2 0 -46 -29 -98 -63z"/>
<path d="M10240 24226 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2
-5 10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M12619 24167 c-208 -140 -749 -496 -769 -507 -12 -6 -20 -14 -17 -16
5 -5 178 107 665 430 194 129 232 156 219 156 -2 0 -46 -29 -98 -63z"/>
<path d="M13520 24226 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2
-5 10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M38854 24163 c-55 -38 -155 -104 -223 -147 -67 -43 -120 -81 -117
-83 4 -5 446 285 446 293 0 7 -4 5 -106 -63z"/>
<path d="M39760 24226 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2
-5 10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M42139 24167 c-208 -140 -749 -496 -769 -507 -12 -6 -20 -14 -17 -16
5 -5 178 107 665 430 194 129 232 156 219 156 -2 0 -46 -29 -98 -63z"/>
<path d="M43040 24226 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2
-5 10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M45419 24167 c-208 -140 -749 -496 -769 -507 -12 -6 -20 -14 -17 -16
5 -5 178 107 665 430 194 129 232 156 219 156 -2 0 -46 -29 -98 -63z"/>
<path d="M46320 24226 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2
-5 10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M48118 23783 c-114 -76 -205 -139 -203 -141 4 -4 415 266 415 273 0
8 4 11 -212 -132z"/>
<path d="M1379 23473 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M4659 23473 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M7939 23473 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M11219 23473 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M14499 23473 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M40739 23473 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M44019 23473 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M47299 23473 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M1670 23460 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M1730 23460 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M4950 23460 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M5010 23460 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M8230 23460 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M8290 23460 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M11510 23460 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M11570 23460 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M14790 23460 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M14850 23460 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M41030 23460 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M41090 23460 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M44310 23460 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M44370 23460 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M47590 23460 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M47650 23460 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M1905 23380 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M5185 23380 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M8465 23380 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M11745 23380 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M15025 23380 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M41265 23380 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M44545 23380 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M47825 23380 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M1438 23358 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22 57
-20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M1859 23367 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45
16 -20 15 -24 16 -14 4z"/>
<path d="M4718 23358 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22 57
-20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M5139 23367 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45
16 -20 15 -24 16 -14 4z"/>
<path d="M7998 23358 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22 57
-20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M8419 23367 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45
16 -20 15 -24 16 -14 4z"/>
<path d="M11278 23358 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22
57 -20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M11699 23367 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45
16 -20 15 -24 16 -14 4z"/>
<path d="M14558 23358 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22
57 -20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M40798 23358 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22
57 -20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M41219 23367 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45
16 -20 15 -24 16 -14 4z"/>
<path d="M44078 23358 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22
57 -20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M44499 23367 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45
16 -20 15 -24 16 -14 4z"/>
<path d="M47358 23358 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22
57 -20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M47779 23367 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45
16 -20 15 -24 16 -14 4z"/>
<path d="M1497 23343 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M1583 23353 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8 18
-2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M1679 23349 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1 4
7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M4777 23343 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M4863 23353 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8 18
-2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M4959 23349 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1 4
7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M8057 23343 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M8143 23353 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8 18
-2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M8239 23349 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1 4
7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M11337 23343 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M11423 23353 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8
18 -2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M11519 23349 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1
4 7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M14617 23343 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M14703 23353 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8
18 -2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M14799 23349 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1
5 8 11 7 20 0 8 -7 20 -8 27 -4 7 5 24 8 38 7 l25 -2 -25 8 c-14 4 -30 4 -37
-2 -9 -6 -18 -5 -27 2 -10 8 -16 9 -21 1 -4 -6 -12 -7 -24 -1 -11 6 -22 6 -32
0z"/>
<path d="M40857 23343 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M40943 23353 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8
18 -2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M41039 23349 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1
4 7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M44137 23343 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M44223 23353 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8
18 -2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M44319 23349 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1
4 7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M47417 23343 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M47503 23353 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8
18 -2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M47599 23349 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1
4 7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M1556 23272 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M4836 23272 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M8116 23272 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M11396 23272 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M14676 23272 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M40916 23272 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M44196 23272 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M47476 23272 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M1738 23263 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5018 23263 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8298 23263 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M11578 23263 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M41098 23263 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M44378 23263 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47658 23263 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1073 23022 c-114 -76 -267 -177 -339 -224 -299 -197 -345 -228 -337
-228 5 0 45 23 89 52 171 111 790 521 799 529 31 29 -28 -7 -212 -129z"/>
<path d="M1995 23153 c6 -6 170 -116 365 -245 475 -314 512 -338 524 -338 6 0
2 6 -9 12 -11 6 -198 129 -415 273 -392 259 -484 318 -465 298z"/>
<path d="M4353 23022 c-114 -76 -267 -177 -339 -224 -299 -197 -345 -228 -337
-228 5 0 45 23 89 52 171 111 790 521 799 529 31 29 -28 -7 -212 -129z"/>
<path d="M5275 23153 c6 -6 170 -116 365 -245 475 -314 512 -338 524 -338 6 0
2 6 -9 12 -11 6 -198 129 -415 273 -392 259 -484 318 -465 298z"/>
<path d="M7633 23022 c-114 -76 -267 -177 -339 -224 -299 -197 -345 -228 -337
-228 5 0 45 23 89 52 171 111 790 521 799 529 31 29 -28 -7 -212 -129z"/>
<path d="M8555 23153 c6 -6 170 -116 365 -245 475 -314 512 -338 524 -338 6 0
2 6 -9 12 -11 6 -198 129 -415 273 -392 259 -484 318 -465 298z"/>
<path d="M10913 23022 c-114 -76 -267 -177 -339 -224 -299 -197 -345 -228
-337 -228 5 0 45 23 89 52 171 111 790 521 799 529 31 29 -28 -7 -212 -129z"/>
<path d="M11835 23153 c6 -6 170 -116 365 -245 475 -314 512 -338 524 -338 6
0 2 6 -9 12 -11 6 -198 129 -415 273 -392 259 -484 318 -465 298z"/>
<path d="M14193 23022 c-114 -76 -267 -177 -339 -224 -300 -197 -345 -228
-337 -228 5 0 57 31 114 68 267 175 765 505 774 513 31 29 -28 -7 -212 -129z"/>
<path d="M43713 23022 c-114 -76 -267 -177 -339 -224 -299 -197 -345 -228
-337 -228 5 0 45 23 89 52 171 111 790 521 799 529 31 29 -28 -7 -212 -129z"/>
<path d="M44635 23153 c6 -6 170 -116 365 -245 475 -314 512 -338 524 -338 6
0 2 6 -9 12 -11 6 -198 129 -415 273 -392 259 -484 318 -465 298z"/>
<path d="M46993 23022 c-114 -76 -267 -177 -339 -224 -299 -197 -345 -228
-337 -228 5 0 45 23 89 52 171 111 790 521 799 529 31 29 -28 -7 -212 -129z"/>
<path d="M47915 23153 c10 -10 376 -252 405 -268 44 -23 -22 24 -170 122 -172
114 -252 164 -235 146z"/>
<path d="M3019 22393 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M6299 22393 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M9579 22393 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M12859 22393 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M45659 22393 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M270 22315 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20 -6z"/>
<path d="M3550 22315 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20
-6z"/>
<path d="M6830 22315 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20
-6z"/>
<path d="M10110 22315 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20
-6z"/>
<path d="M46190 22315 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20
-6z"/>
<path d="M220 22294 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7
-43 10 -24 24 -38 27 -20 4z"/>
<path d="M3500 22294 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7
-43 10 -24 24 -38 27 -20 4z"/>
<path d="M6780 22294 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7
-43 10 -24 24 -38 27 -20 4z"/>
<path d="M10060 22294 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7
-43 10 -24 24 -38 27 -20 4z"/>
<path d="M46140 22294 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7
-43 10 -24 24 -38 27 -20 4z"/>
<path d="M2980 22291 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M6260 22291 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M9540 22291 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M12820 22291 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M45620 22291 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M42 22277 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10 -8
17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27 2
-11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M3129 22278 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M3224 22278 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M3322 22277 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10
-8 17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27
2 -11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M6409 22278 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M6504 22278 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M6602 22277 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10
-8 17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27
2 -11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M9689 22278 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M9784 22278 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M9882 22277 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10
-8 17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27
2 -11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M12969 22278 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M13064 22278 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M45769 22278 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M45864 22278 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M45962 22277 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10
-8 17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27
2 -11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M3196 22202 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M3256 22202 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M6476 22202 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M6536 22202 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M9756 22202 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M9816 22202 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M13036 22202 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M13096 22202 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M45836 22202 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M45896 22202 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M98 22193 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3378 22193 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6658 22193 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9938 22193 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M46018 22193 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M595 21903 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 78 -57 194 -134z"/>
<path d="M2495 21789 c-506 -334 -504 -333 -500 -337 3 -3 239 151 689 449
115 77 205 139 200 139 -5 0 -180 -113 -389 -251z"/>
<path d="M3875 21903 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 79 -57 194 -134z"/>
<path d="M5775 21789 c-506 -334 -504 -333 -500 -337 3 -3 239 151 689 449
115 77 205 139 200 139 -5 0 -180 -113 -389 -251z"/>
<path d="M7155 21903 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 79 -57 194 -134z"/>
<path d="M9055 21789 c-506 -334 -504 -333 -500 -337 3 -3 239 151 689 449
115 77 205 139 200 139 -5 0 -180 -113 -389 -251z"/>
<path d="M10435 21903 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 79 -57 194 -134z"/>
<path d="M12335 21789 c-506 -334 -504 -333 -500 -337 3 -3 239 151 689 449
115 77 205 139 200 139 -5 0 -180 -113 -389 -251z"/>
<path d="M20195 21956 c128 -86 180 -119 160 -99 -16 17 -254 173 -273 180 -9
3 42 -33 113 -81z"/>
<path d="M46515 21903 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 79 -57 194 -134z"/>
<path d="M48220 21660 c-58 -39 -151 -100 -207 -137 -56 -37 -101 -69 -99 -71
4 -4 416 266 416 273 0 8 1 8 -110 -65z"/>
<path d="M1380 21285 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M4660 21285 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M7940 21285 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M11220 21285 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8
5z"/>
<path d="M21060 21285 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8
5z"/>
<path d="M47300 21285 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8
5z"/>
<path d="M1670 21270 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M4950 21270 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M8230 21270 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M11510 21270 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M47590 21270 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M1910 21195 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M5190 21195 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M8470 21195 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M11750 21195 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2
0 -9 -7 -16 -15z"/>
<path d="M21590 21195 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2
0 -9 -7 -16 -15z"/>
<path d="M47830 21195 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2
0 -9 -7 -16 -15z"/>
<path d="M1844 21178 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M5124 21178 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M8404 21178 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M11684 21178 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22
-12 2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M21524 21178 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22
-12 2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M47764 21178 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22
-12 2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M1340 21172 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M4620 21172 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M7900 21172 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M11180 21172 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M21020 21172 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M47260 21172 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M1480 21163 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M1686 21161 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M1729 21152 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M4760 21163 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M4966 21161 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M5009 21152 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M8040 21163 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M8246 21161 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M8289 21152 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M11320 21163 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7
4 20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M11526 21161 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M11569 21152 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M21160 21163 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7
4 20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M21366 21161 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M21409 21152 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M47400 21163 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7
4 20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M47606 21161 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M47649 21152 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M1556 21082 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M1676 21082 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M4836 21082 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M4956 21082 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M8116 21082 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M8236 21082 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M11396 21082 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M11516 21082 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M21236 21082 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M21356 21082 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M47476 21082 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M47596 21082 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M1738 21073 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5018 21073 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8298 21073 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M11578 21073 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M21418 21073 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47658 21073 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1194 20912 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M1990 20967 c0 -3 84 -60 188 -127 103 -68 204 -135 225 -149 157
-106 427 -284 452 -297 65 -35 -3 12 -300 208 -170 113 -359 237 -418 276
-113 75 -147 96 -147 89z"/>
<path d="M4474 20912 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M5270 20967 c0 -3 84 -60 188 -127 103 -68 204 -135 225 -149 157
-106 427 -284 452 -297 65 -35 -3 12 -300 208 -170 113 -359 237 -418 276
-113 75 -147 96 -147 89z"/>
<path d="M7754 20912 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M8550 20967 c0 -3 84 -60 188 -127 103 -68 204 -135 225 -149 157
-106 427 -284 452 -297 65 -35 -3 12 -300 208 -170 113 -359 237 -418 276
-113 75 -147 96 -147 89z"/>
<path d="M11034 20912 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472
303 21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M47114 20912 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472
303 21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M47910 20967 c0 -4 328 -221 395 -261 79 -48 -8 14 -165 118 -173
115 -230 150 -230 143z"/>
<path d="M28 20183 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3308 20183 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6588 20183 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9868 20183 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M45948 20183 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M286 20095 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14 0z"/>
<path d="M3566 20095 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M6846 20095 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M10126 20095 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M46206 20095 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M97 20093 c-3 -5 -27 -8 -54 -7 -31 2 -41 0 -28 -5 23 -9 72 -8 82 2
3 4 12 2 20 -5 10 -8 17 -8 25 0 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10 9 12
-5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -11 -9 -17 -9 -28 0 -8 7 -17 8
-19 4z"/>
<path d="M237 20089 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M2994 20085 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M3132 20085 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M3376 20093 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M3517 20089 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M6274 20085 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M6412 20085 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M6656 20093 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M6797 20089 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M9554 20085 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M9692 20085 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M9936 20093 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M10077 20089 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M45772 20085 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M46016 20093 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M46157 20089 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M36 20012 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M3196 20012 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M3316 20012 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M6476 20012 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M6596 20012 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M9756 20012 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M9876 20012 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M45836 20012 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M45956 20012 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M98 20003 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3378 20003 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6658 20003 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9938 20003 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M46018 20003 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M400 19846 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M2465 19579 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M3680 19846 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M5745 19579 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M6960 19846 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M9025 19579 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M46320 19846 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M48118 19403 c-114 -76 -205 -139 -203 -142 5 -4 415 267 415 274 0
8 1 9 -212 -132z"/>
<path d="M1379 19093 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M4659 19093 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M7939 19093 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M47299 19093 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M1670 19080 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M4950 19080 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M8230 19080 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M47590 19080 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M1865 18980 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M5145 18980 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M8425 18980 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M47785 18980 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M1427 18969 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M1480 18973 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M1654 18966 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M4707 18969 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M4760 18973 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M4934 18966 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M7987 18969 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M8040 18973 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M8214 18966 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M47347 18969 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M47400 18973 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M47574 18966 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0
8 8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M1676 18892 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M4956 18892 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M8236 18892 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M47596 18892 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M1738 18883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5018 18883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8298 18883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47658 18883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M842 18491 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560 40
37 -67 -31 -443 -280z"/>
<path d="M1996 18771 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283 -384
254 -471 309 -436 277z"/>
<path d="M4122 18491 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560
40 37 -67 -31 -443 -280z"/>
<path d="M5276 18771 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283 -384
254 -471 309 -436 277z"/>
<path d="M7402 18491 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560
40 37 -67 -31 -443 -280z"/>
<path d="M46762 18491 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560
40 37 -67 -31 -443 -280z"/>
<path d="M47916 18771 c9 -9 375 -249 404 -266 50 -28 -30 29 -202 144 -175
116 -233 151 -202 122z"/>
<path d="M28 17993 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3050 17990 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M3308 17993 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6330 17990 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M6588 17993 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M45948 17993 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M265 17930 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3205 17930 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M3545 17930 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M6485 17930 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M6825 17930 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M45845 17930 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M46185 17930 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M225 17910 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M3505 17910 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M6785 17910 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M46145 17910 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M45 17900 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 9
7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2 4
-6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10 8
-16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M3160 17900 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3
10 6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M3325 17900 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2
4 -6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10
8 -16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M6440 17900 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3
10 6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M6605 17900 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2
4 -6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10
8 -16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M45854 17894 c-18 -14 -18 -15 4 -4 16 8 27 8 35 1 9 -7 17 -6 27 1
12 8 12 9 -2 4 -10 -3 -20 -1 -23 4 -9 14 -18 12 -41 -6z"/>
<path d="M45965 17900 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2
4 -6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10
8 -16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M265 17890 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M3000 17890 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20
-4z"/>
<path d="M3545 17890 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M6280 17890 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20
-4z"/>
<path d="M6825 17890 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M46185 17890 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M36 17822 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M3196 17822 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M3316 17822 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M6476 17822 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M6596 17822 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M45836 17822 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M45956 17822 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M98 17813 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3378 17813 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6658 17813 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M46018 17813 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M400 17656 c0 -3 87 -62 193 -132 105 -70 304 -201 440 -292 136 -90
250 -163 251 -161 5 5 -22 23 -489 331 -413 273 -395 261 -395 254z"/>
<path d="M2495 17409 c-476 -315 -504 -333 -499 -338 1 -2 115 71 251 161 136
91 335 222 441 292 165 109 203 136 189 136 -1 0 -173 -113 -382 -251z"/>
<path d="M3680 17656 c0 -3 87 -62 193 -132 105 -70 304 -201 440 -292 136
-90 250 -163 251 -161 5 5 -22 23 -489 331 -413 273 -395 261 -395 254z"/>
<path d="M5775 17409 c-476 -315 -504 -333 -499 -338 1 -2 115 71 251 161 136
91 335 222 441 292 165 109 203 136 189 136 -1 0 -173 -113 -382 -251z"/>
<path d="M6960 17656 c0 -3 87 -62 193 -132 105 -70 304 -201 440 -292 136
-90 250 -163 251 -161 5 5 -22 23 -489 331 -413 273 -395 261 -395 254z"/>
<path d="M46320 17656 c0 -3 87 -62 193 -132 105 -70 304 -201 440 -292 136
-90 250 -163 251 -161 5 5 -22 23 -489 331 -413 273 -395 261 -395 254z"/>
<path d="M48118 17213 c-113 -76 -205 -139 -203 -142 5 -4 415 267 415 274 0
8 1 9 -212 -132z"/>
<path d="M1379 16903 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M4659 16903 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M7939 16903 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M47299 16903 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M1668 16883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4948 16883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8228 16883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47588 16883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1438 16788 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22 57
-20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M1865 16790 c10 -11 23 -20 28 -20 6 0 0 9 -13 20 -13 11 -25 20 -28
20 -3 0 3 -9 13 -20z"/>
<path d="M4718 16788 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22 57
-20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M5145 16790 c10 -11 23 -20 28 -20 6 0 0 9 -13 20 -13 11 -25 20 -28
20 -3 0 3 -9 13 -20z"/>
<path d="M7998 16788 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22 57
-20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M8425 16790 c10 -11 23 -20 28 -20 6 0 0 9 -13 20 -13 11 -25 20 -28
20 -3 0 3 -9 13 -20z"/>
<path d="M47358 16788 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22
57 -20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M47785 16790 c10 -11 23 -20 28 -20 6 0 0 9 -13 20 -13 11 -25 20
-28 20 -3 0 3 -9 13 -20z"/>
<path d="M1492 16775 c14 -15 21 -16 30 -7 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -24 22 -41 12 -8 -5 -20 -4 -29 3 -9 7 -9 4 2 -8z"/>
<path d="M1583 16783 c-7 -2 -13 -9 -13 -14 0 -6 6 -7 13 -2 6 4 23 6 37 5 23
-1 23 -1 5 7 -23 11 -26 11 -42 4z"/>
<path d="M1670 16779 l-25 -8 25 2 c14 1 31 -2 38 -7 8 -5 18 -4 24 2 7 7 17
8 29 2 12 -7 20 -6 24 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4 -10 -3
-19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -3 -23 2 -9 4 -27 4 -41 0z"/>
<path d="M4772 16775 c14 -15 21 -16 30 -7 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -24 22 -41 12 -8 -5 -20 -4 -29 3 -9 7 -9 4 2 -8z"/>
<path d="M4863 16783 c-7 -2 -13 -9 -13 -14 0 -6 6 -7 13 -2 6 4 23 6 37 5 23
-1 23 -1 5 7 -23 11 -26 11 -42 4z"/>
<path d="M4950 16779 l-25 -8 25 2 c14 1 31 -2 38 -7 8 -5 18 -4 24 2 7 7 17
8 29 2 12 -7 20 -6 24 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4 -10 -3
-19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -3 -23 2 -9 4 -27 4 -41 0z"/>
<path d="M8052 16775 c14 -15 21 -16 30 -7 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -24 22 -41 12 -8 -5 -20 -4 -29 3 -9 7 -9 4 2 -8z"/>
<path d="M8143 16783 c-7 -2 -13 -9 -13 -14 0 -6 6 -7 13 -2 6 4 23 6 37 5 23
-1 23 -1 5 7 -23 11 -26 11 -42 4z"/>
<path d="M8230 16779 l-25 -8 25 2 c14 1 31 -2 38 -7 8 -5 18 -4 24 2 7 7 17
8 29 2 12 -7 20 -6 24 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4 -10 -3
-19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -3 -23 2 -9 4 -27 4 -41 0z"/>
<path d="M47412 16775 c14 -15 21 -16 30 -7 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -24 22 -41 12 -8 -5 -20 -4 -29 3 -9 7 -9 4 2 -8z"/>
<path d="M47503 16783 c-7 -2 -13 -9 -13 -14 0 -6 6 -7 13 -2 6 4 23 6 37 5
23 -1 23 -1 5 7 -23 11 -26 11 -42 4z"/>
<path d="M47590 16779 l-25 -8 25 2 c14 1 31 -2 38 -7 8 -5 18 -4 24 2 7 7 17
8 29 2 12 -7 20 -6 24 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4 -10 -3
-19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -3 -23 2 -9 4 -27 4 -41 0z"/>
<path d="M1556 16702 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M1616 16702 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M1676 16702 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M4836 16702 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M4896 16702 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M4956 16702 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M8116 16702 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M8176 16702 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M8236 16702 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M47476 16702 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M47536 16702 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M47596 16702 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M1738 16693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5018 16693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8298 16693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47658 16693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1195 16532 c-49 -32 -205 -134 -345 -227 -140 -93 -302 -199 -358
-237 -110 -72 -131 -94 -28 -29 92 57 810 532 821 542 22 20 -5 5 -90 -49z"/>
<path d="M1995 16583 c10 -10 708 -473 821 -544 103 -65 82 -43 -28 29 -56 38
-222 147 -368 243 -383 253 -447 294 -425 272z"/>
<path d="M4475 16532 c-49 -32 -205 -134 -345 -227 -140 -93 -302 -199 -358
-237 -110 -72 -131 -94 -28 -29 92 57 810 532 821 542 22 20 -5 5 -90 -49z"/>
<path d="M5275 16583 c10 -10 708 -473 821 -544 103 -65 82 -43 -28 29 -56 38
-222 147 -368 243 -383 253 -447 294 -425 272z"/>
<path d="M7755 16532 c-49 -32 -205 -134 -345 -227 -140 -93 -302 -199 -358
-237 -110 -72 -131 -94 -28 -29 92 57 810 532 821 542 22 20 -5 5 -90 -49z"/>
<path d="M47115 16532 c-49 -32 -205 -134 -345 -227 -140 -93 -302 -199 -358
-237 -110 -72 -131 -94 -28 -29 92 57 810 532 821 542 22 20 -5 5 -90 -49z"/>
<path d="M47915 16583 c8 -9 365 -245 403 -267 6 -4 12 -5 12 -2 0 4 -130 91
-310 208 -98 63 -119 75 -105 61z"/>
<path d="M3019 15823 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M6299 15823 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M107 15809 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M3387 15809 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M6667 15809 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M46027 15809 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M28 15803 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3050 15799 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M3308 15803 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6330 15799 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M6588 15803 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M45948 15803 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M270 15745 c-8 -9 -8 -15 -2 -15 12 0 26 19 19 26 -2 2 -10 -2 -17
-11z"/>
<path d="M3550 15745 c-8 -9 -8 -15 -2 -15 12 0 26 19 19 26 -2 2 -10 -2 -17
-11z"/>
<path d="M6830 15745 c-8 -9 -8 -15 -2 -15 12 0 26 19 19 26 -2 2 -10 -2 -17
-11z"/>
<path d="M46190 15745 c-8 -9 -8 -15 -2 -15 12 0 26 19 19 26 -2 2 -10 -2 -17
-11z"/>
<path d="M3205 15740 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M6485 15740 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M205 15730 c-4 -6 -3 -9 2 -8 4 1 21 -6 36 -16 28 -19 28 -19 50 4
l22 22 -27 -16 c-25 -17 -28 -16 -47 3 -24 24 -27 25 -36 11z"/>
<path d="M3082 15720 c-15 -25 -59 -26 -84 -3 -22 20 -24 11 -2 -11 22 -22 67
-20 89 4 10 11 16 22 14 25 -3 2 -10 -5 -17 -15z"/>
<path d="M3485 15730 c-4 -6 -3 -9 2 -8 4 1 21 -6 36 -16 28 -19 28 -19 50 4
l22 22 -27 -16 c-25 -17 -28 -16 -47 3 -24 24 -27 25 -36 11z"/>
<path d="M6362 15720 c-15 -25 -59 -26 -84 -3 -22 20 -24 11 -2 -11 22 -22 67
-20 89 4 10 11 16 22 14 25 -3 2 -10 -5 -17 -15z"/>
<path d="M6765 15730 c-4 -6 -3 -9 2 -8 4 1 21 -6 36 -16 28 -19 28 -19 50 4
l22 22 -27 -16 c-25 -17 -28 -16 -47 3 -24 24 -27 25 -36 11z"/>
<path d="M46125 15730 c-4 -6 -3 -9 2 -8 4 1 21 -6 36 -16 28 -19 28 -19 50 4
l22 22 -27 -16 c-25 -17 -28 -16 -47 3 -24 24 -27 25 -36 11z"/>
<path d="M94 15708 c-2 -3 -25 -4 -51 -2 -26 3 -45 2 -42 -1 11 -10 89 -13 95
-4 4 6 10 6 18 0 7 -6 17 -6 26 -1 8 5 19 5 25 0 6 -5 17 -5 25 2 13 8 12 9
-2 5 -9 -3 -19 -3 -22 0 -8 9 -67 9 -72 1z"/>
<path d="M3217 15709 c-9 -5 -23 -7 -30 -3 -9 5 -9 4 -1 -5 9 -10 17 -10 33
-1 12 6 26 8 32 4 17 -10 119 -11 126 -2 2 5 10 5 17 -1 7 -6 17 -6 26 -1 8 5
19 5 25 0 6 -5 17 -5 25 2 12 8 12 9 -2 4 -10 -3 -19 -2 -22 2 -5 8 -57 8 -72
1 -13 -7 -113 -3 -121 4 -8 9 -15 8 -36 -4z"/>
<path d="M6497 15709 c-9 -5 -23 -7 -30 -3 -9 5 -9 4 -1 -5 9 -10 17 -10 33
-1 12 6 26 8 32 4 17 -10 119 -11 126 -2 2 5 10 5 17 -1 7 -6 17 -6 26 -1 8 5
19 5 25 0 6 -5 17 -5 25 2 12 8 12 9 -2 4 -10 -3 -19 -2 -22 2 -5 8 -57 8 -72
1 -13 -7 -113 -3 -121 4 -8 9 -15 8 -36 -4z"/>
<path d="M3136 15698 c3 -4 11 -5 19 -1 21 7 19 12 -4 10 -11 0 -18 -5 -15 -9z"/>
<path d="M6416 15698 c3 -4 11 -5 19 -1 21 7 19 12 -4 10 -11 0 -18 -5 -15 -9z"/>
<path d="M36 15632 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M3196 15632 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M3256 15632 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M3316 15632 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M6476 15632 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M6536 15632 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M6596 15632 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M45896 15632 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M45956 15632 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M98 15623 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3378 15623 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6658 15623 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M46018 15623 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M690 15270 c544 -361 591 -392 595 -389 4 5 -27 26 -494 334 -206
136 -382 250 -390 253 -9 3 121 -86 289 -198z"/>
<path d="M2495 15219 c-474 -313 -504 -333 -500 -338 2 -2 68 40 147 92 79 52
280 185 447 296 167 110 300 201 295 201 -5 0 -180 -113 -389 -251z"/>
<path d="M5775 15219 c-474 -313 -504 -333 -500 -338 2 -2 68 40 147 92 79 52
280 185 447 296 167 110 300 201 295 201 -5 0 -180 -113 -389 -251z"/>
<path d="M46610 15270 c544 -361 591 -392 595 -389 4 5 -27 26 -494 334 -206
136 -382 250 -390 253 -9 3 121 -86 289 -198z"/>
<path d="M48118 15023 c-113 -76 -205 -139 -203 -141 4 -5 415 266 415 273 0
8 2 10 -212 -132z"/>
<path d="M1379 14713 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M4659 14713 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M47299 14713 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M1670 14700 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M4950 14700 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M47590 14700 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M1410 14689 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M1748 14693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4690 14689 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M5028 14693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47330 14689 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M47668 14693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1910 14625 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M47830 14625 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2
0 -9 -7 -16 -15z"/>
<path d="M1438 14598 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M1865 14600 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M4718 14598 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M47358 14598 c-22 -22 -56 -23 -80 -1 -10 9 -18 11 -18 5 0 -14 32
-32 58 -32 20 0 71 35 62 42 -3 3 -13 -4 -22 -14z"/>
<path d="M47785 14600 c10 -11 29 -19 44 -19 26 2 26 2 -2 6 -16 3 -31 11 -34
19 -3 8 -10 14 -16 14 -5 0 -2 -9 8 -20z"/>
<path d="M1490 14587 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M1583 14593 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M1635 14590 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M1676 14590 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M4770 14587 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M4860 14590 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10
5z"/>
<path d="M47410 14587 c11 -12 23 -15 45 -9 21 6 25 10 14 14 -9 3 -22 2 -30
-2 -8 -5 -20 -4 -29 3 -13 10 -13 9 0 -6z"/>
<path d="M47503 14593 c-7 -2 -13 -9 -13 -15 0 -6 6 -6 15 2 8 6 20 8 26 4 8
-4 9 -3 5 4 -8 13 -13 14 -33 5z"/>
<path d="M47555 14590 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M47596 14590 c-13 -4 -16 -9 -9 -13 7 -4 15 -3 18 3 5 8 11 7 21 -1
11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5
25 2 12 8 12 9 -2 4 -10 -3 -20 -1 -24 5 -4 6 -11 6 -20 -2 -10 -8 -18 -8 -27
0 -10 8 -17 7 -25 -1 -8 -8 -15 -8 -24 -1 -7 6 -22 7 -32 3z"/>
<path d="M1556 14512 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M1616 14512 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M1676 14512 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M47476 14512 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M47536 14512 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M47596 14512 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M1738 14503 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47658 14503 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1089 14272 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53 -40
0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M1995 14393 c13 -14 785 -524 873 -577 6 -4 12 -5 12 -3 0 3 -24 21
-52 40 -354 232 -467 306 -603 397 -172 113 -246 160 -230 143z"/>
<path d="M47009 14272 c-170 -112 -477 -315 -636 -419 -29 -19 -53 -37 -53
-40 0 -2 6 -1 13 3 73 45 857 561 872 575 26 25 -18 -2 -196 -119z"/>
<path d="M47915 14393 c19 -19 407 -274 411 -270 3 2 -84 63 -193 134 -206
135 -235 153 -218 136z"/>
<path d="M107 13619 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M46027 13619 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M28 13613 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M272 13554 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M46192 13554 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M225 13530 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M46145 13530 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
<path d="M46 13521 c-3 -5 -16 -7 -29 -5 -20 4 -20 4 -2 -4 22 -10 71 -9 82 1
3 4 12 2 20 -5 10 -8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 7 -25
0 -4 -7 -12 -7 -25 0 -11 6 -21 6 -24 1z"/>
<path d="M274 13514 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z"/>
<path d="M46194 13514 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M98 13433 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M46018 13433 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M616 13128 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6 0
93 -68 219 -152z"/>
<path d="M2429 12985 c-244 -162 -441 -295 -437 -295 7 0 182 114 672 438 126
84 225 152 219 152 -5 0 -210 -133 -454 -295z"/>
<path d="M46536 13128 c490 -324 665 -438 672 -438 11 0 -880 590 -891 590 -6
0 93 -68 219 -152z"/>
<path d="M48115 12830 c-115 -77 -207 -140 -203 -140 9 0 418 269 418 275 0 8
2 9 -215 -135z"/>
<path d="M1379 12523 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M47299 12523 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M1670 12510 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M47590 12510 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M1909 12433 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M47829 12433 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M1844 12418 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M47764 12418 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 19 -15 30 -17 44
-9 10 5 19 12 19 15 0 2 -9 0 -20 -6 -15 -8 -24 -6 -40 10 -23 23 -26 24 -36
8z"/>
<path d="M1354 12403 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M47274 12403 c24 -29 57 -29 87 -2 l24 21 -25 -16 c-32 -21 -58 -20
-84 2 -21 17 -21 17 -2 -5z"/>
<path d="M1492 12394 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M1583 12403 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6 10
-4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M1636 12401 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M1735 12400 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M47412 12394 c14 -14 21 -15 30 -6 8 8 15 9 25 1 8 -7 13 -8 13 -1 0
14 -28 23 -35 12 -4 -6 -14 -6 -28 1 -21 11 -21 11 -5 -7z"/>
<path d="M47503 12403 c-7 -2 -13 -10 -13 -16 0 -8 3 -8 11 0 6 6 18 9 27 6
10 -4 13 -2 8 5 -8 13 -13 14 -33 5z"/>
<path d="M47556 12401 c-11 -17 43 -19 56 -2 10 13 10 14 -2 4 -9 -8 -19 -9
-31 -3 -10 6 -20 6 -23 1z"/>
<path d="M47655 12400 c-3 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2
9 7 16 7 24 -1 8 -8 15 -8 25 0 8 7 18 8 22 4 5 -4 5 -1 1 6 -6 10 -11 10 -22
1 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1z"/>
<path d="M1556 12322 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M1616 12322 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M37636 12322 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M37696 12322 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M47476 12322 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M47536 12322 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M1738 12313 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M37818 12313 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47658 12313 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M842 11921 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573 39
37 -66 -30 -443 -280z"/>
<path d="M36922 11921 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573
39 37 -66 -30 -443 -280z"/>
<path d="M38076 12201 c13 -13 842 -559 868 -572 54 -28 -29 28 -432 295 -385
254 -470 308 -436 277z"/>
<path d="M46762 11921 c-406 -271 -478 -320 -426 -293 26 14 855 561 869 573
39 37 -66 -30 -443 -280z"/>
<path d="M47910 12206 c0 -4 378 -253 410 -271 47 -26 -28 27 -202 144 -186
123 -208 137 -208 127z"/>
<path d="M34946 12102 c15 -14 692 -460 717 -473 55 -28 -22 24 -356 245 -313
207 -398 260 -361 228z"/>
<path d="M32220 11456 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21
-21 13z"/>
<path d="M28 11423 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M36108 11423 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39388 11423 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M45948 11423 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M220 11344 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M36300 11344 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M39580 11344 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M46140 11344 c27 -31 47 -35 72 -13 l23 20 -27 -16 c-25 -15 -28 -15
-47 4 -24 24 -39 28 -21 5z"/>
<path d="M43 11328 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74 -3
3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6 11
-19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M32320 11336 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21
-21 13z"/>
<path d="M35867 11329 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66
-12 80 5 15 18 12 18 -13 4z"/>
<path d="M35929 11328 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M36024 11329 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M36123 11328 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M39147 11329 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66
-12 80 5 15 18 12 18 -13 4z"/>
<path d="M39209 11328 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M39304 11329 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M39403 11328 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M45707 11329 c-11 -6 -33 -8 -50 -5 -23 4 -28 3 -17 -4 23 -15 66
-12 80 5 15 18 12 18 -13 4z"/>
<path d="M45769 11328 c10 -13 18 -15 31 -8 9 5 21 6 25 2 5 -4 5 -1 1 6 -5 8
-13 9 -25 2 -12 -6 -22 -5 -31 3 -12 10 -12 9 -1 -5z"/>
<path d="M45864 11329 c-4 -8 -3 -10 5 -5 6 4 19 2 27 -5 10 -8 18 -9 25 -2 6
6 5 10 -3 10 -7 0 -20 4 -29 7 -10 4 -20 2 -25 -5z"/>
<path d="M45963 11328 c-2 -5 -10 -5 -16 -2 -7 4 -9 4 -5 -1 11 -12 67 -14 74
-3 3 5 12 4 20 -3 11 -9 18 -9 26 -1 7 7 17 8 29 2 10 -6 20 -6 23 -1 3 5 -6
11 -19 14 -14 2 -28 0 -31 -5 -3 -4 -10 -6 -15 -2 -16 9 -80 11 -86 2z"/>
<path d="M35996 11252 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M36056 11252 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M39276 11252 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M39336 11252 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M45836 11252 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M45896 11252 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M98 11243 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M36178 11243 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39458 11243 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M46018 11243 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M400 11086 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145 -95
265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M35525 10990 c-82 -55 -147 -100 -143 -100 10 0 298 188 298 195 0 8
0 9 -155 -95z"/>
<path d="M36480 11086 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145
-95 265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M38690 10915 c-146 -97 -345 -228 -442 -293 -97 -64 -175 -118 -173
-120 2 -2 122 75 267 170 145 96 343 227 441 292 151 99 189 127 175 126 -2 0
-122 -79 -268 -175z"/>
<path d="M39760 11086 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145
-95 265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M45447 11045 c-37 -25 -67 -48 -67 -51 0 -6 5 -3 83 48 49 33 66 48
54 48 -1 0 -33 -20 -70 -45z"/>
<path d="M46320 11086 c0 -3 80 -58 178 -122 97 -65 295 -196 440 -292 145
-95 265 -172 267 -170 4 3 -96 71 -550 370 -356 234 -335 221 -335 214z"/>
<path d="M48297 10760 c-126 -80 -385 -255 -382 -258 4 -4 415 266 415 273 0
7 -1 6 -33 -15z"/>
<path d="M1379 10333 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M37459 10333 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M40739 10333 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M47299 10333 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3
-6 0 -17 -8 -24 -17z"/>
<path d="M1668 10313 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M37748 10313 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47588 10313 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1905 10240 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M37985 10240 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M47825 10240 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M1438 10218 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M1867 10219 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M37518 10218 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M37947 10219 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M40798 10218 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M47358 10218 c-22 -22 -61 -24 -78 -3 -7 9 -15 13 -18 10 -9 -9 31
-34 54 -35 22 0 74 34 64 42 -3 3 -13 -4 -22 -14z"/>
<path d="M47787 10219 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M1492 10205 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1 14
6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11 6
-20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M1634 10208 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4 7
12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1 6
-6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M1919 10203 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M37572 10205 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1
14 6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11
6 -20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M37714 10208 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4
7 12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1
6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M37999 10203 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21
-13z"/>
<path d="M40852 10205 c13 -14 21 -16 29 -8 6 6 19 9 28 6 13 -4 14 -3 1 5
-10 8 -18 8 -27 0 -9 -7 -18 -7 -30 3 -17 12 -17 12 -1 -6z"/>
<path d="M47412 10205 c14 -15 20 -16 32 -6 9 8 16 8 20 2 5 -7 15 -7 32 -1
14 6 31 7 37 4 9 -5 9 -4 1 5 -8 8 -18 9 -37 2 -18 -7 -28 -7 -33 0 -4 6 -11
6 -20 -2 -11 -9 -18 -8 -31 2 -17 12 -17 12 -1 -6z"/>
<path d="M47554 10208 c-4 -7 -4 -10 1 -6 4 4 16 3 26 -2 12 -7 20 -7 24 0 4
7 12 7 25 0 13 -7 21 -7 25 0 5 8 11 7 21 -1 10 -8 18 -8 27 0 8 6 17 7 23 1
6 -6 15 -5 24 1 13 9 12 10 -2 5 -10 -3 -20 -1 -23 4 -4 7 -13 6 -25 0 -10 -6
-21 -7 -23 -3 -6 9 -64 9 -73 0 -4 -3 -15 -2 -25 3 -12 7 -20 6 -25 -2z"/>
<path d="M47839 10203 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M1556 10132 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M1616 10132 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M1676 10132 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M37636 10132 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M37696 10132 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M37756 10132 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M40916 10132 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M47476 10132 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M47536 10132 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M47596 10132 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M1738 10123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M37818 10123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47658 10123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1103 9902 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M37183 9902 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M38085 10005 c25 -20 827 -550 854 -565 11 -5 23 -10 26 -10 7 0 -77
56 -380 255 -82 54 -222 146 -310 205 -154 102 -239 154 -190 115z"/>
<path d="M40463 9902 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M44645 10005 c25 -20 827 -550 854 -565 11 -5 23 -10 26 -10 7 0 -77
56 -380 255 -82 54 -222 146 -310 205 -154 102 -239 154 -190 115z"/>
<path d="M47023 9902 c-98 -65 -245 -163 -328 -217 -312 -205 -387 -255 -380
-255 13 0 50 24 453 290 422 279 452 299 440 300 -3 0 -87 -53 -185 -118z"/>
<path d="M47925 10005 c25 -20 327 -219 375 -246 65 -38 -3 11 -176 125 -165
110 -246 159 -199 121z"/>
<path d="M41536 9892 c5 -5 68 -47 139 -94 72 -47 226 -149 343 -227 118 -77
218 -141 224 -141 9 0 -68 52 -377 254 -82 54 -189 125 -237 157 -47 33 -90
59 -94 59 -4 0 -4 -4 2 -8z"/>
<path d="M35819 9253 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M39099 9253 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M42379 9253 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M45659 9253 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M100 9240 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"/>
<path d="M36180 9240 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M39460 9240 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M42740 9240 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M46020 9240 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M270 9170 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M36350 9170 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M39630 9170 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M42910 9170 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M46190 9170 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M35780 9151 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42 17
-9 8 -16 11 -16 5z"/>
<path d="M39060 9151 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42 17
-9 8 -16 11 -16 5z"/>
<path d="M42340 9151 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42 17
-9 8 -16 11 -16 5z"/>
<path d="M45620 9151 c0 -16 38 -33 63 -28 19 4 18 4 -5 6 -15 0 -34 8 -42 17
-9 8 -16 11 -16 5z"/>
<path d="M13 9137 c17 -14 71 -16 84 -4 3 4 12 2 20 -4 9 -8 17 -8 26 0 8 6
17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1 -32 -3 -3 -5 -14 -5
-24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -14 -7
-28 1 -20 9 -21 9 -4 -4z"/>
<path d="M244 9136 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8 -40
-2 -20 10 -20 10 -1 -5z"/>
<path d="M36014 9134 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4 -10
16 -18 15 -42 -4z"/>
<path d="M36076 9142 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4 10
-8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M36324 9136 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8 -40
-2 -20 10 -20 10 -1 -5z"/>
<path d="M39294 9134 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4 -10
16 -18 15 -42 -4z"/>
<path d="M39356 9142 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4 10
-8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M39604 9136 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8 -40
-2 -20 10 -20 10 -1 -5z"/>
<path d="M42574 9134 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4 -10
16 -18 15 -42 -4z"/>
<path d="M42636 9142 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4 10
-8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M42884 9136 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8 -40
-2 -20 10 -20 10 -1 -5z"/>
<path d="M45854 9134 c-18 -14 -18 -15 4 -4 12 6 28 8 34 4 7 -4 8 -3 4 4 -10
16 -18 15 -42 -4z"/>
<path d="M45916 9142 c-6 -9 -1 -10 57 -15 21 -1 41 1 44 6 2 4 11 3 19 -4 10
-8 18 -8 27 0 8 6 17 7 23 1 5 -5 15 -5 23 -1 9 6 5 10 -13 13 -15 3 -29 1
-32 -3 -3 -5 -14 -5 -24 1 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0 -13 7 -21 7
-25 0 -4 -7 -12 -7 -25 0 -10 6 -21 6 -24 2z"/>
<path d="M46164 9136 c25 -20 30 -20 47 1 13 15 12 15 -6 6 -13 -8 -26 -8 -40
-2 -20 10 -20 10 -1 -5z"/>
<path d="M35930 9128 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20 -9z"/>
<path d="M39210 9128 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20 -9z"/>
<path d="M42490 9128 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20 -9z"/>
<path d="M45770 9128 c0 -11 28 -10 35 1 3 6 -4 9 -15 8 -11 -1 -20 -5 -20 -9z"/>
<path d="M36 9062 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M35996 9062 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M36116 9062 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M39276 9062 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M39396 9062 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M42556 9062 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M42676 9062 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M45836 9062 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M45956 9062 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M98 9053 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M36178 9053 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39458 9053 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42738 9053 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M46018 9053 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M675 8709 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5 0
121 -86 280 -191z"/>
<path d="M35230 8605 c-245 -162 -442 -295 -437 -295 4 0 78 47 165 104 554
365 735 486 727 486 -6 0 -210 -133 -455 -295z"/>
<path d="M36755 8709 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5
0 121 -86 280 -191z"/>
<path d="M38510 8605 c-245 -162 -442 -295 -437 -295 4 0 78 47 165 104 554
365 735 486 727 486 -6 0 -210 -133 -455 -295z"/>
<path d="M40035 8709 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5
0 121 -86 280 -191z"/>
<path d="M41790 8605 c-245 -162 -442 -295 -437 -295 4 0 78 47 165 104 554
365 735 486 727 486 -6 0 -210 -133 -455 -295z"/>
<path d="M43315 8709 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5
0 121 -86 280 -191z"/>
<path d="M45070 8605 c-245 -162 -442 -295 -437 -295 4 0 78 47 165 104 554
365 735 486 727 486 -6 0 -210 -133 -455 -295z"/>
<path d="M46595 8709 c543 -359 604 -399 612 -399 11 0 -880 590 -892 590 -5
0 121 -86 280 -191z"/>
<path d="M48115 8450 c-115 -77 -206 -140 -202 -140 10 0 417 268 417 275 0 8
4 11 -215 -135z"/>
<path d="M34689 8253 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M34649 8203 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M1379 8143 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M37459 8143 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M40739 8143 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M44019 8143 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M47299 8143 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M1670 8130 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M37750 8130 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M41030 8130 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M44310 8130 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M47590 8130 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M1748 8123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M37828 8123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M41108 8123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M44388 8123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47668 8123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1569 8053 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M37649 8053 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M40929 8053 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M44209 8053 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M47489 8053 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M34705 8050 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M37985 8050 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M41265 8050 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M44545 8050 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M47825 8050 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M34644 8038 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M37924 8038 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M41204 8038 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M44484 8038 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M47764 8038 c-4 -7 -3 -10 1 -5 5 4 16 0 26 -9 10 -9 28 -14 41 -11
20 4 20 4 -5 6 -15 0 -30 8 -33 16 -7 18 -20 19 -30 3z"/>
<path d="M1340 8031 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M37420 8031 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M40700 8031 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M43980 8031 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M47260 8031 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M1489 8018 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18 1
7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M1679 8013 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9 16
-11 15 -27 -5z"/>
<path d="M1729 8012 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24 0
7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12 6
-16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M34479 8013 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M34529 8012 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24 0
7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12 6
-16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M37569 8018 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18 1
7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M37759 8013 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M37809 8012 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24 0
7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12 6
-16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M40849 8018 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18 1
7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M41039 8013 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M41089 8012 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24 0
7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12 6
-16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M44129 8018 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18 1
7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M44319 8013 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M44369 8012 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24 0
7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12 6
-16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M47409 8018 c7 -10 17 -15 22 -12 16 9 100 11 105 2 3 -5 11 -4 18 1
7 6 17 7 21 3 5 -4 6 -2 2 3 -5 11 -134 12 -144 1 -3 -3 -13 0 -22 7 -14 11
-14 10 -2 -5z"/>
<path d="M47599 8013 c-12 -16 -12 -17 2 -6 9 7 20 9 24 5 5 -4 5 -1 1 6 -9
16 -11 15 -27 -5z"/>
<path d="M47649 8012 c-12 -15 -12 -16 2 -5 12 10 18 10 27 1 9 -9 15 -9 24 0
7 7 16 8 23 2 6 -5 16 -5 25 2 13 8 12 9 -1 5 -9 -3 -21 -1 -27 5 -6 6 -12 6
-16 -1 -5 -8 -13 -8 -26 -1 -13 7 -21 5 -31 -8z"/>
<path d="M1556 7942 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M1616 7942 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M34416 7942 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M37636 7942 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M37696 7942 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M40916 7942 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M40976 7942 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M44196 7942 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M44256 7942 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M47476 7942 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M47536 7942 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M1738 7933 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M34538 7933 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M37818 7933 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M41098 7933 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M44378 7933 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47658 7933 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1250 7810 c-14 -10 -207 -139 -430 -286 -353 -232 -468 -310 -410
-279 37 21 859 562 875 576 17 17 -10 8 -35 -11z"/>
<path d="M28236 7821 c15 -14 837 -555 874 -576 55 -30 -42 37 -290 201 -157
103 -352 232 -433 286 -132 87 -180 116 -151 89z"/>
<path d="M34050 7810 c-14 -10 -207 -139 -430 -286 -353 -232 -468 -310 -410
-279 37 21 859 562 875 576 17 17 -10 8 -35 -11z"/>
<path d="M34796 7821 c15 -14 837 -555 874 -576 55 -30 -42 37 -290 201 -157
103 -352 232 -433 286 -132 87 -180 116 -151 89z"/>
<path d="M37330 7810 c-14 -10 -207 -139 -430 -286 -353 -232 -468 -310 -410
-279 37 21 859 562 875 576 17 17 -10 8 -35 -11z"/>
<path d="M38076 7821 c15 -14 837 -555 874 -576 55 -30 -42 37 -290 201 -157
103 -352 232 -433 286 -132 87 -180 116 -151 89z"/>
<path d="M40610 7810 c-14 -10 -207 -139 -430 -286 -353 -232 -468 -310 -410
-279 37 21 859 562 875 576 17 17 -10 8 -35 -11z"/>
<path d="M41356 7821 c15 -14 837 -555 874 -576 55 -30 -42 37 -290 201 -157
103 -352 232 -433 286 -132 87 -180 116 -151 89z"/>
<path d="M43890 7810 c-14 -10 -207 -139 -430 -286 -353 -232 -468 -310 -410
-279 37 21 859 562 875 576 17 17 -10 8 -35 -11z"/>
<path d="M44636 7821 c15 -14 837 -555 874 -576 55 -30 -42 37 -290 201 -157
103 -352 232 -433 286 -132 87 -180 116 -151 89z"/>
<path d="M47170 7810 c-14 -10 -207 -139 -430 -286 -353 -232 -468 -310 -410
-279 37 21 859 562 875 576 17 17 -10 8 -35 -11z"/>
<path d="M47915 7822 c18 -17 408 -272 412 -269 4 4 -392 269 -411 276 -7 2
-8 0 -1 -7z"/>
<path d="M32339 7693 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M26948 7451 c-260 -172 -351 -236 -298 -206 34 19 591 384 605 396
39 36 -51 -20 -307 -190z"/>
<path d="M32075 7452 c8 -8 272 -182 313 -206 6 -4 12 -5 12 -3 0 5 -308 209
-325 216 -7 2 -7 0 0 -7z"/>
<path d="M28 7043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M26015 7040 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M26268 7043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M29295 7040 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M29548 7043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M32575 7040 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M32828 7043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M35855 7040 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M36108 7043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39135 7040 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M39388 7043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42415 7040 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M42668 7043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M45695 7040 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M45948 7043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M204 6968 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41 -12
14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M26444 6968 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M29724 6968 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M33004 6968 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M36284 6968 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M39564 6968 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M42844 6968 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M46124 6968 c-4 -7 -4 -10 1 -6 4 4 19 -1 32 -12 15 -11 31 -16 41
-12 14 5 12 8 -8 10 -14 2 -32 10 -42 19 -13 12 -17 12 -24 1z"/>
<path d="M25 6949 c-21 -5 -24 -7 -10 -9 58 -5 77 -5 82 3 2 4 11 3 19 -4 11
-9 18 -9 26 -1 7 7 16 8 23 2 6 -5 16 -5 25 2 12 8 12 9 -2 4 -10 -3 -20 -1
-24 5 -4 7 -10 6 -18 0 -7 -6 -15 -8 -19 -5 -8 9 -67 10 -102 3z"/>
<path d="M25954 6945 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M26121 6950 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M29234 6945 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M29401 6950 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M32514 6945 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M32681 6950 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M35794 6945 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M35961 6950 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M39074 6945 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M39241 6950 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M42354 6945 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M42521 6950 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M45634 6945 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M45801 6950 c-8 -4 -21 -6 -30 -3 -13 4 -14 3 -2 -5 9 -7 21 -7 31
-2 11 6 21 5 29 -3 9 -9 16 -9 32 1 11 7 25 10 31 6 15 -10 119 -11 125 -1 3
4 11 3 19 -4 10 -8 18 -8 27 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 12 10 -2 5
-10 -3 -20 -1 -24 5 -4 7 -10 6 -18 0 -7 -6 -16 -8 -20 -4 -7 8 -126 6 -134
-2 -3 -3 -11 0 -18 6 -9 7 -18 6 -32 -2 -15 -10 -24 -10 -34 -1 -8 6 -19 7
-27 2z"/>
<path d="M36 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M26156 6872 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M26216 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M26276 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M29436 6872 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M29496 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M29556 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M32716 6872 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M32776 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M32836 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M35996 6872 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M36056 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M36116 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M39276 6872 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M39336 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M39396 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M42556 6872 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M42616 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M42676 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M45836 6872 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M45896 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M45956 6872 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M98 6863 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M26338 6863 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M29618 6863 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M32898 6863 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M36178 6863 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39458 6863 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42738 6863 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M46018 6863 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M400 6706 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2 -5
10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M23360 6706 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2
-5 10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M25739 6647 c-208 -140 -749 -496 -769 -507 -12 -6 -20 -14 -17 -16
5 -5 178 107 665 430 194 129 232 156 219 156 -2 0 -46 -29 -98 -63z"/>
<path d="M26640 6706 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2
-5 10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M29019 6647 c-208 -140 -749 -496 -769 -507 -12 -6 -20 -14 -17 -16
5 -5 178 107 665 430 194 129 232 156 219 156 -2 0 -46 -29 -98 -63z"/>
<path d="M29920 6706 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2
-5 10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M32299 6647 c-208 -140 -749 -496 -769 -507 -12 -6 -20 -14 -17 -16
5 -5 178 107 665 430 194 129 232 156 219 156 -2 0 -46 -29 -98 -63z"/>
<path d="M33200 6706 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2
-5 10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M35579 6647 c-208 -140 -749 -496 -769 -507 -12 -6 -20 -14 -17 -16
5 -5 178 107 665 430 194 129 232 156 219 156 -2 0 -46 -29 -98 -63z"/>
<path d="M36480 6706 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2
-5 10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M38859 6647 c-208 -140 -749 -496 -769 -507 -12 -6 -20 -14 -17 -16
5 -5 178 107 665 430 194 129 232 156 219 156 -2 0 -46 -29 -98 -63z"/>
<path d="M39760 6706 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2
-5 10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M42139 6647 c-208 -140 -749 -496 -769 -507 -12 -6 -20 -14 -17 -16
5 -5 178 107 665 430 194 129 232 156 219 156 -2 0 -46 -29 -98 -63z"/>
<path d="M43040 6706 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2
-5 10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M45419 6647 c-208 -140 -749 -496 -769 -507 -12 -6 -20 -14 -17 -16
5 -5 178 107 665 430 194 129 232 156 219 156 -2 0 -46 -29 -98 -63z"/>
<path d="M46320 6706 c0 -5 224 -155 664 -443 120 -79 220 -142 223 -139 3 2
-5 10 -17 16 -19 10 -523 341 -760 500 -100 67 -110 73 -110 66z"/>
<path d="M48118 6263 c-114 -76 -205 -139 -203 -141 4 -4 415 266 415 273 0 8
4 11 -212 -132z"/>
<path d="M1379 5953 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M21059 5953 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M24339 5953 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M27619 5953 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M30899 5953 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M34179 5953 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M37459 5953 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M40739 5953 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M44019 5953 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M47299 5953 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M1670 5940 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M1730 5940 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M21350 5940 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M21410 5940 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M24630 5940 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M24690 5940 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M27910 5940 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M27970 5940 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M31190 5940 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M31250 5940 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M34470 5940 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M34530 5940 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M37750 5940 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M37810 5940 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M41030 5940 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M41090 5940 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M44310 5940 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M44370 5940 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M47590 5940 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M47650 5940 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M1905 5860 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M21585 5860 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M24865 5860 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M28145 5860 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M31425 5860 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M34705 5860 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M37985 5860 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M41265 5860 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M44545 5860 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M47825 5860 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M1438 5838 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22 57
-20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M1859 5847 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45 16
-20 15 -24 16 -14 4z"/>
<path d="M21118 5838 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22 57
-20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M21539 5847 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45
16 -20 15 -24 16 -14 4z"/>
<path d="M24398 5838 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22 57
-20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M24819 5847 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45
16 -20 15 -24 16 -14 4z"/>
<path d="M27678 5838 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22 57
-20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M28099 5847 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45
16 -20 15 -24 16 -14 4z"/>
<path d="M30958 5838 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22 57
-20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M31379 5847 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45
16 -20 15 -24 16 -14 4z"/>
<path d="M34238 5838 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22 57
-20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M34659 5847 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45
16 -20 15 -24 16 -14 4z"/>
<path d="M37518 5838 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22 57
-20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M37939 5847 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45
16 -20 15 -24 16 -14 4z"/>
<path d="M40798 5838 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22 57
-20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M41219 5847 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45
16 -20 15 -24 16 -14 4z"/>
<path d="M44078 5838 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22 57
-20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M44499 5847 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45
16 -20 15 -24 16 -14 4z"/>
<path d="M47358 5838 c-22 -22 -56 -23 -80 -1 -22 20 -24 11 -2 -11 21 -22 57
-20 85 3 13 11 22 21 19 23 -3 3 -13 -4 -22 -14z"/>
<path d="M47779 5847 c22 -27 45 -37 62 -25 11 8 11 9 -3 5 -9 -3 -29 4 -45
16 -20 15 -24 16 -14 4z"/>
<path d="M1497 5823 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M1583 5833 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8 18
-2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M1679 5829 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1 4
7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M21177 5823 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M21263 5833 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8 18
-2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M21359 5829 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1 4
7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M24457 5823 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M24543 5833 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8 18
-2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M24639 5829 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1 4
7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M27737 5823 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M27823 5833 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8 18
-2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M27919 5829 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1 4
7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M31017 5823 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M31103 5833 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8 18
-2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M31199 5829 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1 4
7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M34297 5823 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M34383 5833 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8 18
-2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M34479 5829 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1 4
7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M37577 5823 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M37663 5833 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8 18
-2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M37759 5829 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1 4
7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M40857 5823 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M40943 5833 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8 18
-2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M41039 5829 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1 4
7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M44137 5823 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M44223 5833 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8 18
-2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M44319 5829 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1 4
7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M47417 5823 c10 -8 21 -9 26 -4 5 5 17 7 26 4 9 -4 13 -3 9 1 -4 5
-23 9 -43 10 -31 1 -34 0 -18 -11z"/>
<path d="M47503 5833 c-7 -3 -13 -9 -13 -15 0 -7 4 -7 13 -1 6 6 27 9 45 8 18
-2 31 -1 28 2 -7 8 -57 11 -73 6z"/>
<path d="M47599 5829 c-12 -9 -12 -10 1 -6 8 2 23 0 32 -4 10 -6 19 -5 23 1 4
7 12 7 25 0 13 -7 21 -7 25 0 5 7 11 8 19 1 8 -7 17 -6 26 1 12 8 12 9 -2 4
-10 -3 -19 -2 -22 2 -5 9 -64 8 -72 -1 -4 -3 -14 -2 -23 3 -11 5 -23 5 -32 -1z"/>
<path d="M1556 5752 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M21236 5752 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M24516 5752 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M27796 5752 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M31076 5752 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M34356 5752 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M37636 5752 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M40916 5752 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M44196 5752 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M47476 5752 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M1738 5743 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M21418 5743 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M24698 5743 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M27978 5743 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M31258 5743 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M34538 5743 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M37818 5743 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M41098 5743 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M44378 5743 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47658 5743 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1073 5502 c-114 -76 -267 -177 -339 -224 -299 -197 -345 -228 -337
-228 5 0 45 23 89 52 171 111 790 521 799 529 31 29 -28 -7 -212 -129z"/>
<path d="M1995 5633 c6 -6 170 -116 365 -245 475 -314 512 -338 524 -338 6 0
2 6 -9 12 -11 6 -198 129 -415 273 -392 259 -484 318 -465 298z"/>
<path d="M18395 5633 c6 -6 170 -116 365 -245 475 -314 512 -338 524 -338 6 0
2 6 -9 12 -11 6 -198 129 -415 273 -392 259 -484 318 -465 298z"/>
<path d="M20753 5502 c-114 -76 -267 -177 -339 -224 -299 -197 -345 -228 -337
-228 5 0 45 23 89 52 171 111 790 521 799 529 31 29 -28 -7 -212 -129z"/>
<path d="M21675 5633 c6 -6 170 -116 365 -245 475 -314 512 -338 524 -338 6 0
2 6 -9 12 -11 6 -198 129 -415 273 -392 259 -484 318 -465 298z"/>
<path d="M24033 5502 c-114 -76 -267 -177 -339 -224 -299 -197 -345 -228 -337
-228 5 0 45 23 89 52 171 111 790 521 799 529 31 29 -28 -7 -212 -129z"/>
<path d="M24955 5633 c6 -6 170 -116 365 -245 475 -314 512 -338 524 -338 6 0
2 6 -9 12 -11 6 -198 129 -415 273 -392 259 -484 318 -465 298z"/>
<path d="M27313 5502 c-114 -76 -267 -177 -339 -224 -299 -197 -345 -228 -337
-228 5 0 45 23 89 52 171 111 790 521 799 529 31 29 -28 -7 -212 -129z"/>
<path d="M28235 5633 c6 -6 170 -116 365 -245 475 -314 512 -338 524 -338 6 0
2 6 -9 12 -11 6 -198 129 -415 273 -392 259 -484 318 -465 298z"/>
<path d="M30593 5502 c-114 -76 -267 -177 -339 -224 -299 -197 -345 -228 -337
-228 5 0 45 23 89 52 171 111 790 521 799 529 31 29 -28 -7 -212 -129z"/>
<path d="M31515 5633 c6 -6 170 -116 365 -245 475 -314 512 -338 524 -338 6 0
2 6 -9 12 -11 6 -198 129 -415 273 -392 259 -484 318 -465 298z"/>
<path d="M33873 5502 c-114 -76 -267 -177 -339 -224 -299 -197 -345 -228 -337
-228 5 0 45 23 89 52 171 111 790 521 799 529 31 29 -28 -7 -212 -129z"/>
<path d="M34795 5633 c6 -6 170 -116 365 -245 475 -314 512 -338 524 -338 6 0
2 6 -9 12 -11 6 -198 129 -415 273 -392 259 -484 318 -465 298z"/>
<path d="M37153 5502 c-114 -76 -267 -177 -339 -224 -299 -197 -345 -228 -337
-228 5 0 45 23 89 52 171 111 790 521 799 529 31 29 -28 -7 -212 -129z"/>
<path d="M38075 5633 c6 -6 170 -116 365 -245 475 -314 512 -338 524 -338 6 0
2 6 -9 12 -11 6 -198 129 -415 273 -392 259 -484 318 -465 298z"/>
<path d="M40433 5502 c-114 -76 -267 -177 -339 -224 -299 -197 -345 -228 -337
-228 5 0 45 23 89 52 171 111 790 521 799 529 31 29 -28 -7 -212 -129z"/>
<path d="M41355 5633 c6 -6 170 -116 365 -245 475 -314 512 -338 524 -338 6 0
2 6 -9 12 -11 6 -198 129 -415 273 -392 259 -484 318 -465 298z"/>
<path d="M43713 5502 c-114 -76 -267 -177 -339 -224 -299 -197 -345 -228 -337
-228 5 0 45 23 89 52 171 111 790 521 799 529 31 29 -28 -7 -212 -129z"/>
<path d="M44635 5633 c6 -6 170 -116 365 -245 475 -314 512 -338 524 -338 6 0
2 6 -9 12 -11 6 -198 129 -415 273 -392 259 -484 318 -465 298z"/>
<path d="M46993 5502 c-114 -76 -267 -177 -339 -224 -299 -197 -345 -228 -337
-228 5 0 45 23 89 52 171 111 790 521 799 529 31 29 -28 -7 -212 -129z"/>
<path d="M47915 5633 c10 -10 376 -252 405 -268 44 -23 -22 24 -170 122 -172
114 -252 164 -235 146z"/>
<path d="M3019 4873 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M6299 4873 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M19419 4873 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M22699 4873 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M25979 4873 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M29259 4873 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M32539 4873 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M35819 4873 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M39099 4873 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M42379 4873 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M45659 4873 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M270 4795 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20 -6z"/>
<path d="M3550 4795 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20 -6z"/>
<path d="M19950 4795 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20
-6z"/>
<path d="M23230 4795 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20
-6z"/>
<path d="M26510 4795 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20
-6z"/>
<path d="M29790 4795 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20
-6z"/>
<path d="M33070 4795 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20
-6z"/>
<path d="M36350 4795 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20
-6z"/>
<path d="M39630 4795 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20
-6z"/>
<path d="M42910 4795 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20
-6z"/>
<path d="M46190 4795 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20
-6z"/>
<path d="M220 4774 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7 -43
10 -24 24 -38 27 -20 4z"/>
<path d="M3500 4774 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7
-43 10 -24 24 -38 27 -20 4z"/>
<path d="M19900 4774 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7
-43 10 -24 24 -38 27 -20 4z"/>
<path d="M23180 4774 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7
-43 10 -24 24 -38 27 -20 4z"/>
<path d="M26460 4774 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7
-43 10 -24 24 -38 27 -20 4z"/>
<path d="M29740 4774 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7
-43 10 -24 24 -38 27 -20 4z"/>
<path d="M33020 4774 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7
-43 10 -24 24 -38 27 -20 4z"/>
<path d="M36300 4774 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7
-43 10 -24 24 -38 27 -20 4z"/>
<path d="M39580 4774 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7
-43 10 -24 24 -38 27 -20 4z"/>
<path d="M42860 4774 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7
-43 10 -24 24 -38 27 -20 4z"/>
<path d="M46140 4774 c24 -28 46 -34 66 -18 18 14 18 15 -3 4 -18 -8 -26 -7
-43 10 -24 24 -38 27 -20 4z"/>
<path d="M2980 4771 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M6260 4771 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M12919 4763 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M19380 4771 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M22660 4771 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M25940 4771 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M29220 4771 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M32500 4771 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M35780 4771 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M39060 4771 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M42340 4771 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M45620 4771 c0 -13 33 -31 57 -31 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -59 -14 -77 5 -9 8 -16 11 -16 5z"/>
<path d="M42 4757 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10 -8
17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27 2
-11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M3129 4758 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M3224 4758 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M3322 4757 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10
-8 17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27
2 -11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M6409 4758 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M6504 4758 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M6602 4757 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10
-8 17 -8 25 0 7 7 16 8 23 2 6 -5 16 -5 25 2 12 8 12 9 -2 4 -10 -3 -20 -1
-24 5 -4 6 -11 6 -20 -2 -11 -9 -17 -9 -28 0 -10 8 -16 9 -21 1 -4 -7 -12 -7
-25 0 -12 7 -21 6 -28 -3z"/>
<path d="M19529 4758 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M19624 4758 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M19722 4757 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10
-8 17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27
2 -11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M22809 4758 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M22904 4758 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M23002 4757 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10
-8 17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27
2 -11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M26089 4758 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M26184 4758 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M26282 4757 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10
-8 17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27
2 -11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M29369 4758 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M29464 4758 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M29562 4757 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10
-8 17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27
2 -11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M32649 4758 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M32744 4758 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M32842 4757 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10
-8 17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27
2 -11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M35929 4758 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M36024 4758 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M36122 4757 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10
-8 17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27
2 -11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M39209 4758 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M39304 4758 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M39402 4757 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10
-8 17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27
2 -11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M42489 4758 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M42584 4758 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M42682 4757 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10
-8 17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27
2 -11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M45769 4758 c11 -15 41 -15 41 -1 0 3 -6 3 -14 0 -7 -3 -20 0 -27 6
-11 10 -11 9 0 -5z"/>
<path d="M45864 4758 c-4 -7 -3 -8 5 -4 6 4 17 3 24 -3 9 -7 17 -7 27 1 12 8
12 9 -2 4 -10 -3 -20 -1 -23 4 -8 13 -22 12 -31 -2z"/>
<path d="M45962 4757 c-8 -9 -3 -12 18 -12 16 0 32 3 36 7 4 4 13 3 21 -4 10
-8 17 -8 25 0 9 9 15 9 25 0 11 -9 17 -8 26 3 7 8 8 11 3 7 -5 -4 -17 -3 -27
2 -11 7 -20 7 -24 0 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0 -4 -7 -12 -7 -25 0
-12 7 -21 6 -28 -3z"/>
<path d="M12840 4750 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20
-4z"/>
<path d="M3196 4682 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M3256 4682 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M6476 4682 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M6536 4682 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M19596 4682 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M19656 4682 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M22876 4682 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M22936 4682 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M26156 4682 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M26216 4682 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M29436 4682 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M29496 4682 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M32716 4682 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M32776 4682 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M35996 4682 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M36056 4682 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M39276 4682 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M39336 4682 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M42556 4682 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M42616 4682 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M45836 4682 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M45896 4682 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M98 4673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3378 4673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6658 4673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M19778 4673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M23058 4673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M26338 4673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M29618 4673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M32898 4673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M36178 4673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39458 4673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42738 4673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M46018 4673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M595 4383 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 78 -57 194 -134z"/>
<path d="M2495 4269 c-506 -334 -504 -333 -500 -337 3 -3 239 151 689 449 115
77 205 139 200 139 -5 0 -180 -113 -389 -251z"/>
<path d="M3875 4383 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 79 -57 194 -134z"/>
<path d="M5775 4269 c-506 -334 -504 -333 -500 -337 3 -3 239 151 689 449 115
77 205 139 200 139 -5 0 -180 -113 -389 -251z"/>
<path d="M7155 4383 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 79 -57 194 -134z"/>
<path d="M12335 4269 c-506 -334 -504 -333 -500 -337 3 -3 239 151 689 449
115 77 205 139 200 139 -5 0 -180 -113 -389 -251z"/>
<path d="M18895 4269 c-506 -334 -504 -333 -500 -337 3 -3 239 151 689 449
115 77 205 139 200 139 -5 0 -180 -113 -389 -251z"/>
<path d="M20275 4383 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 79 -57 194 -134z"/>
<path d="M22175 4269 c-506 -334 -504 -333 -500 -337 3 -3 239 151 689 449
115 77 205 139 200 139 -5 0 -180 -113 -389 -251z"/>
<path d="M23555 4383 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 79 -57 194 -134z"/>
<path d="M25455 4269 c-506 -334 -504 -333 -500 -337 3 -3 239 151 689 449
115 77 205 139 200 139 -5 0 -180 -113 -389 -251z"/>
<path d="M26835 4383 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 79 -57 194 -134z"/>
<path d="M28735 4269 c-506 -334 -504 -333 -500 -337 3 -3 239 151 689 449
115 77 205 139 200 139 -5 0 -180 -113 -389 -251z"/>
<path d="M30115 4383 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 79 -57 194 -134z"/>
<path d="M32015 4269 c-506 -334 -504 -333 -500 -337 3 -3 239 151 689 449
115 77 205 139 200 139 -5 0 -180 -113 -389 -251z"/>
<path d="M33395 4383 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 79 -57 194 -134z"/>
<path d="M35295 4269 c-506 -334 -504 -333 -500 -337 3 -3 239 151 689 449
115 77 205 139 200 139 -5 0 -180 -113 -389 -251z"/>
<path d="M36675 4383 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 79 -57 194 -134z"/>
<path d="M38575 4269 c-506 -334 -504 -333 -500 -337 3 -3 239 151 689 449
115 77 205 139 200 139 -5 0 -180 -113 -389 -251z"/>
<path d="M39955 4383 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 79 -57 194 -134z"/>
<path d="M41855 4269 c-506 -334 -504 -333 -500 -337 3 -3 239 151 689 449
115 77 205 139 200 139 -5 0 -180 -113 -389 -251z"/>
<path d="M43235 4383 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 79 -57 194 -134z"/>
<path d="M45135 4269 c-506 -334 -504 -333 -500 -337 3 -3 239 151 689 449
115 77 205 139 200 139 -5 0 -180 -113 -389 -251z"/>
<path d="M46515 4383 c397 -265 687 -454 690 -451 4 4 6 3 -494 333 -206 136
-381 249 -390 252 -9 3 79 -57 194 -134z"/>
<path d="M48220 4140 c-58 -39 -151 -100 -207 -137 -56 -37 -101 -69 -99 -71
4 -4 416 266 416 273 0 8 1 8 -110 -65z"/>
<path d="M1380 3765 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M4660 3765 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M7940 3765 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M11220 3765 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M17780 3765 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M21060 3765 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M24340 3765 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M27620 3765 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M30900 3765 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M34180 3765 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M37460 3765 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M40740 3765 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M44020 3765 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M47300 3765 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M1670 3750 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M4950 3750 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M8230 3750 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M11510 3750 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M18070 3750 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M21350 3750 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M24630 3750 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M27910 3750 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M31190 3750 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M34470 3750 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M37750 3750 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M41030 3750 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M44310 3750 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M47590 3750 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M1910 3675 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M5190 3675 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M8470 3675 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M11750 3675 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M18310 3675 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M21590 3675 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M24870 3675 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M28150 3675 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M31430 3675 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M34710 3675 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M37990 3675 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M41270 3675 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M44550 3675 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M47830 3675 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M1844 3658 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M5124 3658 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M8404 3658 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M11684 3658 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M18244 3658 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M21524 3658 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M24804 3658 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M28084 3658 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M31364 3658 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M34644 3658 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M37924 3658 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M41204 3658 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M44484 3658 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M47764 3658 c-4 -7 -3 -10 1 -5 5 4 17 0 27 -10 10 -9 20 -14 22 -12
2 2 -6 12 -19 22 -18 13 -25 14 -31 5z"/>
<path d="M1340 3652 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M4620 3652 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M7900 3652 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M11180 3652 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M17740 3652 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M21020 3652 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M24300 3652 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M27580 3652 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M30860 3652 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M34140 3652 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M37420 3652 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M40700 3652 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M43980 3652 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M47260 3652 c0 -14 32 -32 57 -32 11 0 28 7 39 16 18 15 18 15 -3 5
-31 -15 -54 -14 -75 6 -10 9 -18 11 -18 5z"/>
<path d="M1480 3643 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M1686 3641 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36 1
6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M1729 3632 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0 8
7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7 -22
5 -31 -8z"/>
<path d="M4760 3643 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M4966 3641 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36 1
6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M5009 3632 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0 8
7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7 -22
5 -31 -8z"/>
<path d="M8040 3643 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M8246 3641 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36 1
6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M8289 3632 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0 8
7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7 -22
5 -31 -8z"/>
<path d="M11320 3643 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M11526 3641 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M11569 3632 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M17880 3643 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M18086 3641 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M18129 3632 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M21160 3643 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M21366 3641 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M21409 3632 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M24440 3643 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M24646 3641 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M24689 3632 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M27720 3643 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M27926 3641 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M27969 3632 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M31000 3643 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M31206 3641 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M31249 3632 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M34280 3643 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M34486 3641 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M34529 3632 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M37560 3643 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M37766 3641 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M37809 3632 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M40840 3643 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M41046 3641 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M41089 3632 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M44120 3643 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M44326 3641 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M44369 3632 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M47400 3643 c0 -15 31 -26 43 -14 6 6 17 7 27 1 9 -5 22 -5 30 0 7 4
20 6 29 3 13 -4 14 -3 2 5 -9 6 -21 7 -31 2 -9 -5 -22 -5 -30 0 -8 5 -21 5
-30 0 -11 -6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M47606 3641 c-3 -4 -18 -7 -33 -5 -27 4 -28 3 -3 -5 14 -4 30 -4 36
1 6 4 15 4 19 0 5 -4 5 -1 1 6 -8 14 -13 15 -20 3z"/>
<path d="M47649 3632 c-12 -15 -12 -16 2 -5 11 9 18 10 27 1 8 -8 15 -8 25 0
8 7 18 8 22 4 5 -4 5 -1 0 6 -5 10 -10 11 -18 3 -6 -6 -16 -7 -27 -1 -13 7
-22 5 -31 -8z"/>
<path d="M1556 3562 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M1676 3562 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M4836 3562 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M4956 3562 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M8116 3562 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M8236 3562 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M11396 3562 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M11516 3562 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M17956 3562 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M18076 3562 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M21236 3562 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M21356 3562 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M24516 3562 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M24636 3562 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M27796 3562 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M27916 3562 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M31076 3562 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M31196 3562 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M34356 3562 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M34476 3562 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M37636 3562 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M37756 3562 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M40916 3562 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M41036 3562 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M44196 3562 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M44316 3562 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M47476 3562 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M47596 3562 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M1738 3553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5018 3553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8298 3553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M11578 3553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M18138 3553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M21418 3553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M24698 3553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M27978 3553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M31258 3553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M34538 3553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M37818 3553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M41098 3553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M44378 3553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47658 3553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1194 3392 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M1990 3447 c0 -3 84 -60 188 -127 103 -68 204 -135 225 -149 157
-106 427 -284 452 -297 65 -35 -3 12 -300 208 -170 113 -359 237 -418 276
-113 75 -147 96 -147 89z"/>
<path d="M4474 3392 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M5270 3447 c0 -3 84 -60 188 -127 103 -68 204 -135 225 -149 157
-106 427 -284 452 -297 65 -35 -3 12 -300 208 -170 113 -359 237 -418 276
-113 75 -147 96 -147 89z"/>
<path d="M7754 3392 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M8550 3447 c0 -3 84 -60 188 -127 103 -68 204 -135 225 -149 157
-106 427 -284 452 -297 65 -35 -3 12 -300 208 -170 113 -359 237 -418 276
-113 75 -147 96 -147 89z"/>
<path d="M11034 3392 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M11830 3447 c0 -3 84 -60 188 -127 103 -68 204 -135 225 -149 157
-106 427 -284 452 -297 65 -35 -3 12 -300 208 -170 113 -359 237 -418 276
-113 75 -147 96 -147 89z"/>
<path d="M14314 3392 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M15110 3446 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M17594 3392 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M18390 3447 c0 -3 84 -60 188 -127 103 -68 204 -135 225 -149 157
-106 427 -284 452 -297 65 -35 -3 12 -300 208 -170 113 -359 237 -418 276
-113 75 -147 96 -147 89z"/>
<path d="M20874 3392 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M21670 3447 c0 -3 84 -60 188 -127 103 -68 204 -135 225 -149 157
-106 427 -284 452 -297 65 -35 -3 12 -300 208 -170 113 -359 237 -418 276
-113 75 -147 96 -147 89z"/>
<path d="M24154 3392 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M24950 3447 c0 -3 84 -60 188 -127 103 -68 204 -135 225 -149 157
-106 427 -284 452 -297 65 -35 -3 12 -300 208 -170 113 -359 237 -418 276
-113 75 -147 96 -147 89z"/>
<path d="M27434 3392 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M28230 3447 c0 -3 84 -60 188 -127 103 -68 204 -135 225 -149 157
-106 427 -284 452 -297 65 -35 -3 12 -300 208 -170 113 -359 237 -418 276
-113 75 -147 96 -147 89z"/>
<path d="M30714 3392 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M31510 3447 c0 -3 84 -60 188 -127 103 -68 204 -135 225 -149 157
-106 427 -284 452 -297 65 -35 -3 12 -300 208 -170 113 -359 237 -418 276
-113 75 -147 96 -147 89z"/>
<path d="M33994 3392 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M34790 3447 c0 -3 84 -60 188 -127 103 -68 204 -135 225 -149 157
-106 427 -284 452 -297 65 -35 -3 12 -300 208 -170 113 -359 237 -418 276
-113 75 -147 96 -147 89z"/>
<path d="M37274 3392 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M38070 3447 c0 -3 84 -60 188 -127 103 -68 204 -135 225 -149 157
-106 427 -284 452 -297 65 -35 -3 12 -300 208 -170 113 -359 237 -418 276
-113 75 -147 96 -147 89z"/>
<path d="M40554 3392 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M41350 3447 c0 -3 84 -60 188 -127 103 -68 204 -135 225 -149 157
-106 427 -284 452 -297 65 -35 -3 12 -300 208 -170 113 -359 237 -418 276
-113 75 -147 96 -147 89z"/>
<path d="M43834 3392 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M44630 3447 c0 -3 84 -60 188 -127 103 -68 204 -135 225 -149 157
-106 427 -284 452 -297 65 -35 -3 12 -300 208 -170 113 -359 237 -418 276
-113 75 -147 96 -147 89z"/>
<path d="M47114 3392 c-294 -193 -781 -516 -789 -524 -27 -28 189 111 472 303
21 14 122 81 226 149 166 109 196 130 184 130 -2 0 -44 -26 -93 -58z"/>
<path d="M47910 3447 c0 -4 328 -221 395 -261 79 -48 -8 14 -165 118 -173 115
-230 150 -230 143z"/>
<path d="M15351 3285 c3 -2 36 -24 74 -49 39 -25 90 -59 115 -76 86 -60 420
-279 443 -291 54 -28 -19 23 -311 215 -267 177 -344 224 -321 201z"/>
<path d="M28 2663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3308 2663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6588 2663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9868 2663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M13148 2663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M16428 2663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M19708 2663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M22988 2663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M26268 2663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M29548 2663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M32828 2663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M36108 2663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39388 2663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42668 2663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M45948 2663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M286 2575 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14 0z"/>
<path d="M3566 2575 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14 0z"/>
<path d="M6846 2575 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14 0z"/>
<path d="M10126 2575 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M13406 2575 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M16686 2575 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M19966 2575 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M23246 2575 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M26526 2575 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M29806 2575 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M33086 2575 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M36366 2575 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M39646 2575 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M42926 2575 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M46206 2575 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
<path d="M97 2573 c-3 -5 -27 -8 -54 -7 -31 2 -41 0 -28 -5 23 -9 72 -8 82 2
3 4 12 2 20 -5 10 -8 17 -8 25 0 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10 9 12
-5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -11 -9 -17 -9 -28 0 -8 7 -17 8
-19 4z"/>
<path d="M237 2569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M2994 2565 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M3132 2565 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M3376 2573 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M3517 2569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M6274 2565 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M6412 2565 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M6656 2573 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M6797 2569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M9554 2565 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M9692 2565 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M9936 2573 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M10077 2569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M12834 2565 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M12972 2565 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M13216 2573 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M13357 2569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M16114 2565 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M16252 2565 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M16496 2573 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M16637 2569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M19394 2565 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M19532 2565 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M19776 2573 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M19917 2569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M22674 2565 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M22812 2565 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M23056 2573 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M23197 2569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M25954 2565 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M26092 2565 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M26336 2573 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M26477 2569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M29234 2565 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M29372 2565 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M29616 2573 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M29757 2569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M32514 2565 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M32652 2565 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M32896 2573 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M33037 2569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M35794 2565 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M35932 2565 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M36176 2573 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M36317 2569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M39074 2565 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M39212 2565 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M39456 2573 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M39597 2569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M42354 2565 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M42492 2565 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M42736 2573 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M42877 2569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M45634 2565 c25 -19 57 -19 82 0 18 14 17 14 -9 3 -22 -9 -36 -9 -60
0 -29 10 -30 10 -13 -3z"/>
<path d="M45772 2565 c14 -15 20 -16 32 -6 10 8 16 9 21 1 9 -14 18 -13 41 6
18 14 18 15 -4 4 -16 -8 -27 -8 -35 -1 -8 6 -18 6 -27 1 -9 -5 -20 -4 -30 3
-10 7 -10 5 2 -8z"/>
<path d="M46016 2573 c-3 -4 -33 -6 -66 -6 -34 0 -58 -2 -55 -5 8 -9 116 -8
122 1 3 4 11 3 19 -4 11 -9 18 -9 26 -1 9 9 15 9 25 0 10 -8 17 -8 26 2 10 10
9 12 -5 7 -10 -3 -20 -2 -24 4 -4 6 -11 6 -20 -2 -10 -8 -18 -9 -27 0 -8 6
-17 8 -21 4z"/>
<path d="M46157 2569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M36 2492 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M3196 2492 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M3316 2492 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M6476 2492 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M6596 2492 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M9756 2492 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M9876 2492 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M13036 2492 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M13156 2492 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M16316 2492 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M16436 2492 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M19596 2492 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M19716 2492 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M22876 2492 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M22996 2492 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M26156 2492 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M26276 2492 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M29436 2492 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M29556 2492 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M32716 2492 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M32836 2492 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M35996 2492 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M36116 2492 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M39276 2492 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M39396 2492 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M42556 2492 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M42676 2492 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M45836 2492 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M45956 2492 c-3 -4 4 -9 15 -9 23 -2 25 3 4 10 -8 4 -16 3 -19 -1z"/>
<path d="M98 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3378 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6658 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9938 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M13218 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M16498 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M19778 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M23058 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M26338 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M29618 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M32898 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M36178 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39458 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42738 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M46018 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M400 2326 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103 -68
190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M2465 2059 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M3680 2326 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M5745 2059 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M6960 2326 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M9025 2059 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M10240 2326 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M12305 2059 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M13520 2326 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M15585 2059 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M16800 2326 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M18865 2059 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M20080 2326 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M22145 2059 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M23360 2326 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M25425 2059 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M26640 2326 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M28705 2059 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M29920 2326 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M31985 2059 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M33200 2326 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M35265 2059 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M36480 2326 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M38545 2059 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M39760 2326 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M41825 2059 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M43040 2326 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M45105 2059 c-509 -336 -475 -313 -470 -317 2 -3 89 52 192 120 103
69 302 200 441 292 217 144 264 177 250 176 -2 0 -187 -122 -413 -271z"/>
<path d="M46320 2326 c0 -3 114 -80 253 -172 138 -92 337 -223 440 -292 103
-68 190 -123 192 -120 5 4 37 -18 -460 310 -454 300 -425 281 -425 274z"/>
<path d="M48118 1883 c-114 -76 -205 -139 -203 -142 5 -4 415 267 415 274 0 8
1 9 -212 -132z"/>
<path d="M1379 1573 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M4659 1573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M7939 1573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M11219 1573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M14499 1573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M17779 1573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M21059 1573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M24339 1573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M27619 1573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M30899 1573 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M34179 1573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M37459 1573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M40739 1573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M44019 1573 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M47299 1573 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M1670 1560 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M4950 1560 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M8230 1560 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M11510 1560 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M14790 1560 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M18070 1560 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M21350 1560 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M24630 1560 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M27910 1560 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M31190 1560 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M34470 1560 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M37750 1560 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M41030 1560 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M44310 1560 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M47590 1560 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M1865 1460 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20 -27
20 -3 0 2 -9 12 -20z"/>
<path d="M5145 1460 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20 -27
20 -3 0 2 -9 12 -20z"/>
<path d="M8425 1460 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20 -27
20 -3 0 2 -9 12 -20z"/>
<path d="M11705 1460 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M14985 1460 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M18265 1460 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M21545 1460 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M24825 1460 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M28105 1460 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M31385 1460 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M34665 1460 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M37945 1460 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M41225 1460 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M44505 1460 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M47785 1460 c10 -11 22 -20 27 -20 4 0 -1 9 -12 20 -11 11 -23 20
-27 20 -3 0 2 -9 12 -20z"/>
<path d="M1427 1449 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M1480 1453 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M1654 1446 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M4707 1449 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M4760 1453 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M4934 1446 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M7987 1449 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M8040 1453 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M8214 1446 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M11267 1449 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M11320 1453 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M11494 1446 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M14547 1449 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M14600 1453 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M14774 1446 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M17827 1449 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M17880 1453 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M18054 1446 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M21107 1449 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M21160 1453 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M21334 1446 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M24387 1449 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M24440 1453 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M24614 1446 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M27667 1449 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M27720 1453 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M27894 1446 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M30947 1449 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M31000 1453 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M31174 1446 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M34227 1449 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M34280 1453 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M34454 1446 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M37507 1449 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M37560 1453 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M37734 1446 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M40787 1449 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M40840 1453 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M41014 1446 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M44067 1449 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M44120 1453 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M44294 1446 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M47347 1449 c-11 -6 -29 -9 -43 -6 -13 2 -21 0 -18 -4 8 -14 48 -10
70 6 22 17 17 19 -9 4z"/>
<path d="M47400 1453 c0 -6 6 -13 13 -15 17 -6 83 -2 96 6 6 4 20 2 31 -4 11
-6 20 -8 20 -6 0 14 -41 26 -58 17 -10 -5 -24 -6 -32 -1 -8 5 -21 5 -30 0 -11
-6 -21 -5 -28 2 -8 8 -12 9 -12 1z"/>
<path d="M47574 1446 c13 -11 23 -13 30 -6 6 6 14 6 23 -2 10 -8 17 -8 25 0 8
8 15 9 25 1 9 -8 17 -8 26 0 8 6 17 7 23 1 6 -6 15 -5 24 1 13 9 13 10 -1 6
-9 -3 -21 -1 -27 5 -6 6 -12 6 -16 -1 -5 -7 -13 -8 -25 -2 -10 6 -23 6 -31 1
-9 -5 -19 -5 -26 1 -8 7 -14 6 -19 -1 -4 -7 -13 -7 -28 1 -21 10 -21 10 -3 -5z"/>
<path d="M1676 1372 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M4956 1372 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M8236 1372 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M11516 1372 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M14796 1372 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M18076 1372 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M21356 1372 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M24636 1372 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M27916 1372 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M31196 1372 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M34476 1372 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M37756 1372 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M41036 1372 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M44316 1372 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M47596 1372 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6
-4 -9 -8z"/>
<path d="M1738 1363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5018 1363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8298 1363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M11578 1363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M14858 1363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M18138 1363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M21418 1363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M24698 1363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M27978 1363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M31258 1363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M34538 1363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M37818 1363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M41098 1363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M44378 1363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M47658 1363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M842 971 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560 40
37 -67 -31 -443 -280z"/>
<path d="M1996 1251 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283 -384
254 -471 309 -436 277z"/>
<path d="M4122 971 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560 40
37 -67 -31 -443 -280z"/>
<path d="M5276 1251 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283 -384
254 -471 309 -436 277z"/>
<path d="M7402 971 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560 40
37 -67 -31 -443 -280z"/>
<path d="M8556 1251 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283 -384
254 -471 309 -436 277z"/>
<path d="M10682 971 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560 40
37 -67 -31 -443 -280z"/>
<path d="M11836 1251 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283 -384
254 -471 309 -436 277z"/>
<path d="M13962 971 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560 40
37 -67 -31 -443 -280z"/>
<path d="M15116 1251 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283 -384
254 -471 309 -436 277z"/>
<path d="M17242 971 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560 40
37 -67 -31 -443 -280z"/>
<path d="M18396 1251 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283 -384
254 -471 309 -436 277z"/>
<path d="M20522 971 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560 40
37 -67 -31 -443 -280z"/>
<path d="M21676 1251 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283 -384
254 -471 309 -436 277z"/>
<path d="M23802 971 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560 40
37 -67 -31 -443 -280z"/>
<path d="M24956 1251 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283 -384
254 -471 309 -436 277z"/>
<path d="M27082 971 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560 40
37 -67 -31 -443 -280z"/>
<path d="M28236 1251 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283 -384
254 -471 309 -436 277z"/>
<path d="M30362 971 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560 40
37 -67 -31 -443 -280z"/>
<path d="M31516 1251 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283 -384
254 -471 309 -436 277z"/>
<path d="M33642 971 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560 40
37 -67 -31 -443 -280z"/>
<path d="M34796 1251 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283 -384
254 -471 309 -436 277z"/>
<path d="M36922 971 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560 40
37 -67 -31 -443 -280z"/>
<path d="M38076 1251 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283 -384
254 -471 309 -436 277z"/>
<path d="M40202 971 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560 40
37 -67 -31 -443 -280z"/>
<path d="M41356 1251 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283 -384
254 -471 309 -436 277z"/>
<path d="M43482 971 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560 40
37 -67 -31 -443 -280z"/>
<path d="M44636 1251 c12 -11 798 -530 849 -560 108 -65 -19 22 -413 283 -384
254 -471 309 -436 277z"/>
<path d="M46762 971 c-398 -265 -510 -342 -407 -280 52 31 837 549 850 560 40
37 -67 -31 -443 -280z"/>
<path d="M47916 1251 c9 -9 375 -249 404 -266 50 -28 -30 29 -202 144 -175
116 -233 151 -202 122z"/>
<path d="M28 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3050 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M3308 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6330 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6588 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9610 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M9868 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M12890 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M13148 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M16170 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M16428 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M19450 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M19708 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M22730 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M22988 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M26010 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M26268 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M29290 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M29548 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M32570 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M32828 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M35850 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M36108 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39130 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M39388 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42410 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M42668 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M45690 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M45948 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M265 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3205 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3545 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M6485 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M6825 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M9765 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M10105 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M13045 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M13385 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M16325 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M16665 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M19605 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M19945 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M22885 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M23225 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M26165 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M26505 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M29445 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M29785 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M32725 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M33065 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M36005 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M36345 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M39285 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M39625 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M42565 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M42905 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M45845 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M46185 410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M225 390 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M3505 390 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M6785 390 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M10065 390 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M13345 390 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M16625 390 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M19905 390 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M23185 390 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M26465 390 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M29745 390 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M33025 390 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M36305 390 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M39585 390 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M42865 390 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M46145 390 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M45 380 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 9 7
16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2 4 -6
14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10 8 -16
9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M3160 380 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3 10
6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1 5
-9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M3325 380 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 9
7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2 4
-6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10 8
-16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M6440 380 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3 10
6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1 5
-9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M6605 380 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 9
7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2 4
-6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10 8
-16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M9720 380 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3 10
6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1 5
-9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M9885 380 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 9
7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2 4
-6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10 8
-16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M13000 380 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3
10 6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M13165 380 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 9
7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2 4
-6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10 8
-16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M16280 380 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3
10 6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M16445 380 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 9
7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2 4
-6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10 8
-16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M19560 380 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3
10 6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M19725 380 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 9
7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2 4
-6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10 8
-16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M22840 380 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3
10 6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M23005 380 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 9
7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2 4
-6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10 8
-16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M26120 380 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3
10 6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M26285 380 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 9
7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2 4
-6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10 8
-16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M29400 380 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3
10 6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M29565 380 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 9
7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2 4
-6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10 8
-16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M32680 380 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3
10 6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M32845 380 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 9
7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2 4
-6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10 8
-16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M35960 380 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3
10 6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M36125 380 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 9
7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2 4
-6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10 8
-16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M39240 380 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3
10 6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M39405 380 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 9
7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2 4
-6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10 8
-16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M42520 380 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3
10 6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M42685 380 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 9
7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2 4
-6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10 8
-16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M45800 380 c-8 -5 -18 -6 -24 -3 -5 3 -6 1 -2 -5 5 -8 13 -9 25 -3
10 6 23 6 31 1 8 -5 22 -4 33 1 12 7 22 7 30 0 9 -7 17 -6 27 1 13 8 12 9 -1
5 -9 -3 -21 -1 -27 5 -7 7 -16 7 -28 0 -11 -6 -25 -7 -34 -2 -9 5 -22 5 -30 0z"/>
<path d="M45965 380 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 9
7 16 7 24 -1 9 -9 15 -9 24 0 8 8 15 9 25 1 9 -8 17 -8 27 0 9 8 16 8 20 2 4
-6 14 -7 24 -4 14 6 13 8 -8 13 -14 4 -31 2 -37 -3 -9 -6 -18 -5 -27 2 -10 8
-16 9 -21 1 -4 -7 -12 -7 -25 0 -13 7 -21 7 -25 0z"/>
<path d="M265 370 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M3000 370 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20 -4z"/>
<path d="M3545 370 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M6280 370 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20 -4z"/>
<path d="M6825 370 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M9560 370 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20 -4z"/>
<path d="M10105 370 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M12840 370 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20 -4z"/>
<path d="M13385 370 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M16120 370 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20 -4z"/>
<path d="M16665 370 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M19400 370 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20 -4z"/>
<path d="M19945 370 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M22680 370 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20 -4z"/>
<path d="M23225 370 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M25960 370 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20 -4z"/>
<path d="M26505 370 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M29240 370 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20 -4z"/>
<path d="M29785 370 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M32520 370 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20 -4z"/>
<path d="M33065 370 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M35800 370 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20 -4z"/>
<path d="M36345 370 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M39080 370 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20 -4z"/>
<path d="M39625 370 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M42360 370 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20 -4z"/>
<path d="M42905 370 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M45640 370 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20 -4z"/>
<path d="M46185 370 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M36 302 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4 -9
-8z"/>
<path d="M3196 302 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M3316 302 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M6476 302 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M6596 302 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M9756 302 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M9876 302 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M13036 302 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M13156 302 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M16316 302 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M16436 302 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M19596 302 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M19716 302 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M22876 302 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M22996 302 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M26156 302 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M26276 302 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M29436 302 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M29556 302 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M32716 302 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M32836 302 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M35996 302 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M36116 302 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M39276 302 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"/>
<path d="M39396 302 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M42556 302 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -7 10 -21 10 -28 0z"/>
<path d="M42676 302 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M45836 302 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -7 10 -21 10 -28 0z"/>
<path d="M45956 302 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M98 293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3378 293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6658 293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9938 293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M13218 293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M16498 293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M19778 293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M23058 293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M26338 293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M29618 293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M32898 293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M36178 293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M39458 293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M42738 293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M46018 293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M400 136 c0 -7 195 -136 206 -136 8 0 -103 78 -168 118 -21 13 -38
21 -38 18z"/>
<path d="M2773 73 c-56 -38 -100 -70 -98 -72 4 -4 205 127 205 134 0 9 -4 6
-107 -62z"/>
<path d="M3680 136 c0 -7 195 -136 206 -136 8 0 -103 78 -168 118 -21 13 -38
21 -38 18z"/>
<path d="M6053 73 c-56 -38 -100 -70 -98 -72 4 -4 205 127 205 134 0 9 -4 6
-107 -62z"/>
<path d="M6960 136 c0 -7 195 -136 206 -136 8 0 -103 78 -168 118 -21 13 -38
21 -38 18z"/>
<path d="M9333 73 c-56 -38 -100 -70 -98 -72 4 -4 205 127 205 134 0 9 -4 6
-107 -62z"/>
<path d="M10240 136 c0 -7 195 -136 206 -136 8 0 -103 78 -168 118 -21 13 -38
21 -38 18z"/>
<path d="M12613 73 c-56 -38 -100 -70 -98 -72 4 -4 205 127 205 134 0 9 -4 6
-107 -62z"/>
<path d="M13520 136 c0 -7 195 -136 206 -136 8 0 -103 78 -168 118 -21 13 -38
21 -38 18z"/>
<path d="M15893 73 c-56 -38 -100 -70 -98 -72 4 -4 205 127 205 134 0 9 -4 6
-107 -62z"/>
<path d="M16800 136 c0 -7 195 -136 206 -136 8 0 -103 78 -168 118 -21 13 -38
21 -38 18z"/>
<path d="M19173 73 c-56 -38 -100 -70 -98 -72 4 -4 205 127 205 134 0 9 -4 6
-107 -62z"/>
<path d="M20080 136 c0 -7 195 -136 206 -136 8 0 -103 78 -168 118 -21 13 -38
21 -38 18z"/>
<path d="M22453 73 c-56 -38 -100 -70 -98 -72 4 -4 205 127 205 134 0 9 -4 6
-107 -62z"/>
<path d="M23360 136 c0 -7 195 -136 206 -136 8 0 -103 78 -168 118 -21 13 -38
21 -38 18z"/>
<path d="M25733 73 c-56 -38 -100 -70 -98 -72 4 -4 205 127 205 134 0 9 -4 6
-107 -62z"/>
<path d="M26640 136 c0 -7 195 -136 206 -136 8 0 -103 78 -168 118 -21 13 -38
21 -38 18z"/>
<path d="M29013 73 c-56 -38 -100 -70 -98 -72 4 -4 205 127 205 134 0 9 -4 6
-107 -62z"/>
<path d="M29920 136 c0 -7 195 -136 206 -136 8 0 -103 78 -168 118 -21 13 -38
21 -38 18z"/>
<path d="M32293 73 c-56 -38 -100 -70 -98 -72 4 -4 205 127 205 134 0 9 -4 6
-107 -62z"/>
<path d="M33200 136 c0 -7 195 -136 206 -136 8 0 -103 78 -168 118 -21 13 -38
21 -38 18z"/>
<path d="M35573 73 c-56 -38 -100 -70 -98 -72 4 -4 205 127 205 134 0 9 -4 6
-107 -62z"/>
<path d="M36480 136 c0 -7 195 -136 206 -136 8 0 -103 78 -168 118 -21 13 -38
21 -38 18z"/>
<path d="M38853 73 c-56 -38 -100 -70 -98 -72 4 -4 205 127 205 134 0 9 -4 6
-107 -62z"/>
<path d="M39760 136 c0 -7 195 -136 206 -136 8 0 -103 78 -168 118 -21 13 -38
21 -38 18z"/>
<path d="M42133 73 c-56 -38 -100 -70 -98 -72 4 -4 205 127 205 134 0 9 -4 6
-107 -62z"/>
<path d="M43040 136 c0 -7 195 -136 206 -136 8 0 -103 78 -168 118 -21 13 -38
21 -38 18z"/>
<path d="M45413 73 c-56 -38 -100 -70 -98 -72 4 -4 205 127 205 134 0 9 -4 6
-107 -62z"/>
<path d="M46320 136 c0 -7 195 -136 206 -136 8 0 -103 78 -168 118 -21 13 -38
21 -38 18z"/>
</g>
`]
